(function(e, a) { for(var i in a) e[i] = a[i]; }(window, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/load.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/Base64/base64.js":
/***/ (function(module, exports, __webpack_require__) {

;(function () {

  var object =  true ? exports : typeof self != 'undefined' ? self : // #8: web workers
  $.global; // #31: ExtendScript

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function InvalidCharacterError(message) {
    this.message = message;
  }
  InvalidCharacterError.prototype = new Error();
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa || (object.btoa = function (input) {
    var str = String(input);
    for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars, output = '';
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
      charCode = str.charCodeAt(idx += 3 / 4);
      if (charCode > 0xFF) {
        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
      }
      block = block << 8 | charCode;
    }
    return output;
  });

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob || (object.atob = function (input) {
    var str = String(input).replace(/[=]+$/, ''); // #31: ExtendScript bad parse of /=
    if (str.length % 4 == 1) {
      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
    // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  });
})();

/***/ }),

/***/ "./node_modules/beaver-logger/client/builders.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return payloadBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return metaBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trackingBuilders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return headerBuilders; });
/* harmony export (immutable) */ __webpack_exports__["c"] = addPayloadBuilder;
/* harmony export (immutable) */ __webpack_exports__["b"] = addMetaBuilder;
/* harmony export (immutable) */ __webpack_exports__["d"] = addTrackingBuilder;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHeaderBuilder;

var payloadBuilders = [];
var metaBuilders = [];
var trackingBuilders = [];
var headerBuilders = [];

function addPayloadBuilder(builder) {
    payloadBuilders.push(builder);
}

function addMetaBuilder(builder) {
    metaBuilders.push(builder);
}

function addTrackingBuilder(builder) {
    trackingBuilders.push(builder);
}

function addHeaderBuilder(builder) {
    headerBuilders.push(builder);
}

/***/ }),

/***/ "./node_modules/beaver-logger/client/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logLevels; });

var config = {

    uri: '',
    prefix: '',

    initial_state_name: 'init',

    flushInterval: 10 * 60 * 1000,
    debounceInterval: 10,

    sizeLimit: 300,

    // Supress `console.log`s when `true`
    // Recommended for production usage
    silent: false,

    heartbeat: true,
    heartbeatConsoleLog: true,
    heartbeatInterval: 5000,
    heartbeatTooBusy: false,
    heartbeatTooBusyThreshold: 10000,

    logLevel: 'warn',

    autoLog: ['warn', 'error'],

    logUnload: true,
    logPerformance: true
};

var logLevels = ['error', 'warn', 'info', 'debug'];

/***/ }),

/***/ "./node_modules/beaver-logger/client/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/beaver-logger/client/interface.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["addMetaBuilder"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["addPayloadBuilder"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["addTrackingBuilder"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["config"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["debug"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["error"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["flush"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["getTransport"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["immediateFlush"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["info"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["init"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["logLevels"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["prefix"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["setTransport"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["track"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["warn"]; });



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),

/***/ "./node_modules/beaver-logger/client/init.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performance__ = __webpack_require__("./node_modules/beaver-logger/client/performance.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js");






var initiated = false;

function init(conf) {
    Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */], conf || {});

    if (initiated) {
        return;
    }

    initiated = true;

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].logPerformance) {
        Object(__WEBPACK_IMPORTED_MODULE_2__performance__["b" /* initPerformance */])();
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeat) {
        Object(__WEBPACK_IMPORTED_MODULE_2__performance__["a" /* initHeartBeat */])();
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].logUnload) {
        window.addEventListener('beforeunload', function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["g" /* info */])('window_beforeunload');
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["f" /* immediateFlush */])({ fireAndForget: true });
        });

        window.addEventListener('unload', function () {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["g" /* info */])('window_unload');
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["f" /* immediateFlush */])({ fireAndForget: true });
        });
    }

    if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].flushInterval) {
        setInterval(__WEBPACK_IMPORTED_MODULE_3__logger__["d" /* flush */], __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].flushInterval);
    }

    if (window.beaverLogQueue) {
        window.beaverLogQueue.forEach(function (payload) {
            Object(__WEBPACK_IMPORTED_MODULE_3__logger__["h" /* log */])(payload.level, payload.event, payload);
        });
        delete window.beaverLogQueue;
    }
}

/***/ }),

/***/ "./node_modules/beaver-logger/client/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "track", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "tracking", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "print", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "immediateFlush", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "log", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "debug", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "info", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "error", function() { return __WEBPACK_IMPORTED_MODULE_0__logger__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__("./node_modules/beaver-logger/client/init.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__init__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitions__ = __webpack_require__("./node_modules/beaver-logger/client/transitions.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "endTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return __WEBPACK_IMPORTED_MODULE_2__transitions__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "payloadBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "metaBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "trackingBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "headerBuilders", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addPayloadBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addMetaBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addTrackingBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addHeaderBuilder", function() { return __WEBPACK_IMPORTED_MODULE_3__builders__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_4__config__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "logLevels", function() { return __WEBPACK_IMPORTED_MODULE_4__config__["b"]; });







/***/ }),

/***/ "./node_modules/beaver-logger/client/logger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tracking; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getTransport;
/* harmony export (immutable) */ __webpack_exports__["k"] = setTransport;
/* harmony export (immutable) */ __webpack_exports__["j"] = print;
/* harmony export (immutable) */ __webpack_exports__["f"] = immediateFlush;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _flush; });
/* harmony export (immutable) */ __webpack_exports__["h"] = log;
/* harmony export (immutable) */ __webpack_exports__["i"] = prefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = debug;
/* harmony export (immutable) */ __webpack_exports__["g"] = info;
/* harmony export (immutable) */ __webpack_exports__["n"] = warn;
/* harmony export (immutable) */ __webpack_exports__["c"] = error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





var buffer = [];
var tracking = [];

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
    ['log', 'info', 'warn', 'error'].forEach(function (method) {
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}

var transport = function transport(headers, data, options) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* ajax */])('post', __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].uri, headers, data, options);
};

function getTransport() {
    return transport;
}

function setTransport(newTransport) {
    transport = newTransport;
}

var loaded = false;

setTimeout(function () {
    loaded = true;
}, 1);

function print(level, event, payload) {

    if (!loaded) {
        return setTimeout(function () {
            return print(level, event, payload);
        }, 1);
    }

    if (!window.console || !window.console.log) {
        return;
    }

    var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].logLevel;

    if (__WEBPACK_IMPORTED_MODULE_2__config__["b" /* logLevels */].indexOf(level) > __WEBPACK_IMPORTED_MODULE_2__config__["b" /* logLevels */].indexOf(logLevel)) {
        return;
    }

    payload = payload || {};

    var args = [event];

    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIE */])()) {
        payload = JSON.stringify(payload);
    }

    args.push(payload);

    if (payload.error || payload.warning) {
        args.push('\n\n', payload.error || payload.warning);
    }

    try {
        if (window.console[level] && window.console[level].apply) {
            window.console[level].apply(window.console, args);
        } else if (window.console.log && window.console.log.apply) {
            window.console.log.apply(window.console, args);
        }
    } catch (err) {
        // pass
    }
}

function immediateFlush() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$fireAndForget = _ref.fireAndForget,
        fireAndForget = _ref$fireAndForget === undefined ? false : _ref$fireAndForget;

    if (!__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].uri) {
        return;
    }

    var hasBuffer = buffer.length;
    var hasTracking = tracking.length;

    if (!hasBuffer && !hasTracking) {
        return;
    }

    var meta = {};

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1__builders__["f" /* metaBuilders */], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var builder = _ref2;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(meta, builder(meta), false);
        } catch (err) {
            console.error('Error in custom meta builder:', err.stack || err.toString());
        }
    }

    var headers = {};

    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1__builders__["e" /* headerBuilders */], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
        }

        var _builder = _ref3;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(headers, _builder(headers), false);
        } catch (err) {
            console.error('Error in custom header builder:', err.stack || err.toString());
        }
    }

    var events = buffer;

    var req = transport(headers, {
        events: events,
        meta: meta,
        tracking: tracking
    }, {
        fireAndForget: fireAndForget
    });

    buffer = [];
    tracking = [];

    return req;
}

var _flush = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* promiseDebounce */])(immediateFlush, __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].debounceInterval);


function enqueue(level, event, payload) {

    buffer.push({
        level: level,
        event: event,
        payload: payload
    });

    if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].autoLog.indexOf(level) > -1) {
        _flush();
    }
}

function log(level, event, payload) {

    if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].prefix) {
        event = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].prefix + '_' + event;
    }

    payload = payload || {};

    if (typeof payload === 'string') {
        payload = {
            message: payload
        };
    } else if (payload instanceof Error) {
        payload = {
            error: payload.stack || payload.toString()
        };
    }

    try {
        JSON.stringify(payload);
    } catch (err) {
        return;
    }

    payload.timestamp = Date.now();

    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1__builders__["g" /* payloadBuilders */], _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref4 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref4 = _i3.value;
        }

        var builder = _ref4;

        try {
            Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(payload, builder(payload), false);
        } catch (err) {
            console.error('Error in custom payload builder:', err.stack || err.toString());
        }
    }

    if (!__WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].silent) {
        print(level, event, payload);
    }

    if (buffer.length === __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].sizeLimit) {
        enqueue('info', 'logger_max_buffer_length');
    } else if (buffer.length < __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].sizeLimit) {
        enqueue(level, event, payload);
    }
}

function prefix(name) {

    return {
        debug: function debug(event, payload) {
            return log('debug', name + '_' + event, payload);
        },
        info: function info(event, payload) {
            return log('info', name + '_' + event, payload);
        },
        warn: function warn(event, payload) {
            return log('warn', name + '_' + event, payload);
        },
        error: function error(event, payload) {
            return log('error', name + '_' + event, payload);
        },
        track: function track(payload) {
            return _track(payload);
        },
        flush: function flush() {
            return _flush();
        }
    };
}

function debug(event, payload) {
    return log('debug', event, payload);
}

function info(event, payload) {
    return log('info', event, payload);
}

function warn(event, payload) {
    return log('warn', event, payload);
}

function error(event, payload) {
    return log('error', event, payload);
}

function _track(payload) {
    if (payload) {

        try {
            JSON.stringify(payload);
        } catch (err) {
            return;
        }

        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1__builders__["h" /* trackingBuilders */], _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref5 = _iterator4[_i4++];
            } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref5 = _i4.value;
            }

            var builder = _ref5;

            try {
                Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* extend */])(payload, builder(payload), false);
            } catch (err) {
                console.error('Error in custom tracking builder:', err.stack || err.toString());
            }
        }

        print('debug', 'tracking', payload);

        tracking.push(payload);
    }
}

/***/ }),

/***/ "./node_modules/beaver-logger/client/performance.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = now;
/* harmony export (immutable) */ __webpack_exports__["d"] = reqStartElapsed;
/* unused harmony export clientTimer */
/* unused harmony export reqTimer */
/* harmony export (immutable) */ __webpack_exports__["a"] = initHeartBeat;
/* harmony export (immutable) */ __webpack_exports__["b"] = initPerformance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js");






var enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1000 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0;

function now() {
    if (enablePerformance) {
        return performance.now();
    } else {
        return Date.now();
    }
}

function timer(startTime) {
    startTime = startTime !== undefined ? startTime : now();

    return {
        startTime: startTime,

        elapsed: function elapsed() {
            return parseInt(now() - startTime, 10);
        },
        reset: function reset() {
            startTime = now();
        }
    };
}

function reqStartElapsed() {
    if (enablePerformance) {
        var timing = window.performance.timing;
        return parseInt(timing.connectEnd - timing.navigationStart, 10);
    }
}

var clientTimer = timer();
var reqTimer = timer(reqStartElapsed());

function initHeartBeat() {

    var heartBeatTimer = timer();
    var heartbeatCount = 0;

    Object(__WEBPACK_IMPORTED_MODULE_3__util__["e" /* safeInterval */])(function () {

        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatMaxThreshold && heartbeatCount > __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatMaxThreshold) {
            return;
        }

        heartbeatCount += 1;

        var elapsed = heartBeatTimer.elapsed();
        var lag = elapsed - __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatInterval;

        var heartbeatPayload = {
            count: heartbeatCount,
            elapsed: elapsed
        };

        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatTooBusy) {
            heartbeatPayload.lag = lag;

            if (lag >= __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatTooBusyThreshold) {
                Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('toobusy', heartbeatPayload, {
                    noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatConsoleLog
                });
            }
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('heartbeat', heartbeatPayload, {
            noConsole: !__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatConsoleLog
        });
    }, __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].heartbeatInterval);
}

function initPerformance() {

    if (!enablePerformance) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('no_performance_data');
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__builders__["c" /* addPayloadBuilder */])(function () {

        var payload = {};

        payload.client_elapsed = clientTimer.elapsed();

        if (enablePerformance) {
            payload.req_elapsed = reqTimer.elapsed();
        }

        return payload;
    });

    __WEBPACK_IMPORTED_MODULE_3__util__["g" /* windowReady */].then(function () {

        var keys = ['connectEnd', 'connectStart', 'domComplete', 'domContentLoadedEventEnd', 'domContentLoadedEventStart', 'domInteractive', 'domLoading', 'domainLookupEnd', 'domainLookupStart', 'fetchStart', 'loadEventEnd', 'loadEventStart', 'navigationStart', 'redirectEnd', 'redirectStart', 'requestStart', 'responseEnd', 'responseStart', 'secureConnectionStart', 'unloadEventEnd', 'unloadEventStart'];

        var timing = {};

        keys.forEach(function (key) {
            timing[key] = parseInt(window.performance.timing[key], 10) || 0;
        });

        var offset = timing.connectEnd - timing.navigationStart;

        if (timing.connectEnd) {
            Object.keys(timing).forEach(function (name) {
                var time = timing[name];
                if (time) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('timing_' + name, {
                        client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                        req_elapsed: parseInt(time - timing.connectEnd, 10)
                    });
                }
            });
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('timing', timing);
        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('memory', window.performance.memory);
        Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])('navigation', window.performance.navigation);

        if (window.performance.getEntries) {
            window.performance.getEntries().forEach(function (resource) {
                if (['link', 'script', 'img', 'css'].indexOf(resource.initiatorType) > -1) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])(resource.initiatorType, resource);
                }
            });
        }
    });
}

/***/ }),

/***/ "./node_modules/beaver-logger/client/transitions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = startTransition;
/* harmony export (immutable) */ __webpack_exports__["a"] = endTransition;
/* harmony export (immutable) */ __webpack_exports__["c"] = transition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__performance__ = __webpack_require__("./node_modules/beaver-logger/client/performance.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__("./node_modules/beaver-logger/client/logger.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__builders__ = __webpack_require__("./node_modules/beaver-logger/client/builders.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/beaver-logger/client/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./node_modules/beaver-logger/client/config.js");







var windowID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();
var pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();

var currentState = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].initial_state_name;
var startTime = void 0;

function startTransition() {
    startTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__["c" /* now */])();
}

function endTransition(toState) {
    startTime = startTime || Object(__WEBPACK_IMPORTED_MODULE_0__performance__["d" /* reqStartElapsed */])();

    var currentTime = Object(__WEBPACK_IMPORTED_MODULE_0__performance__["c" /* now */])();
    var elapsedTime = void 0;

    if (startTime !== undefined) {
        elapsedTime = parseInt(currentTime - startTime, 0);
    }

    var transitionName = 'transition_' + currentState + '_to_' + toState;

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["g" /* info */])(transitionName, {
        duration: elapsedTime
    });

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["l" /* track */])({
        transition: transitionName,
        transition_time: elapsedTime
    });

    Object(__WEBPACK_IMPORTED_MODULE_1__logger__["f" /* immediateFlush */])();

    startTime = currentTime;
    currentState = toState;
    pageID = Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* uniqueID */])();
}

function transition(toState) {
    startTransition();
    endTransition(toState);
}

Object(__WEBPACK_IMPORTED_MODULE_2__builders__["c" /* addPayloadBuilder */])(function () {
    return {
        windowID: windowID,
        pageID: pageID
    };
});

Object(__WEBPACK_IMPORTED_MODULE_2__builders__["b" /* addMetaBuilder */])(function () {
    return {
        state: 'ui_' + currentState
    };
});

/***/ }),

/***/ "./node_modules/beaver-logger/client/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* unused harmony export isSameProtocol */
/* unused harmony export isSameDomain */
/* harmony export (immutable) */ __webpack_exports__["a"] = ajax;
/* harmony export (immutable) */ __webpack_exports__["d"] = promiseDebounce;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return windowReady; });
/* harmony export (immutable) */ __webpack_exports__["e"] = safeInterval;
/* harmony export (immutable) */ __webpack_exports__["f"] = uniqueID;
/* harmony export (immutable) */ __webpack_exports__["c"] = isIE;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");



function extend(dest, src) {
    var over = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    dest = dest || {};
    src = src || {};

    for (var i in src) {
        if (src.hasOwnProperty(i)) {
            if (over || !dest.hasOwnProperty(i)) {
                dest[i] = src[i];
            }
        }
    }

    return dest;
}

function isSameProtocol(url) {
    return window.location.protocol === url.split('/')[0];
}

function isSameDomain(url) {
    var match = url.match(/https?:\/\/[^/]+/);

    if (!match) {
        return true;
    }

    return match[0] === window.location.protocol + '//' + window.location.host;
}

function ajax(method, url) {
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
        _ref$fireAndForget = _ref.fireAndForget,
        fireAndForget = _ref$fireAndForget === undefined ? false : _ref$fireAndForget;

    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        var XRequest = window.XMLHttpRequest || window.ActiveXObject;

        if (window.XDomainRequest && !isSameDomain(url)) {

            if (!isSameProtocol(url)) {
                return resolve();
            }

            XRequest = window.XDomainRequest;
        }

        var req = new XRequest('MSXML2.XMLHTTP.3.0');
        req.open(method.toUpperCase(), url, true);

        if (typeof req.setRequestHeader === 'function') {
            req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            req.setRequestHeader('Content-type', 'application/json');

            for (var headerName in headers) {
                if (headers.hasOwnProperty(headerName)) {
                    req.setRequestHeader(headerName, headers[headerName]);
                }
            }
        }

        if (fireAndForget) {
            resolve();
        } else {
            req.onreadystatechange = function () {
                if (req.readyState > 3) {
                    resolve();
                }
            };
        }

        req.send(JSON.stringify(data).replace(/&/g, '%26'));
    });
}

function promiseDebounce(method, interval) {

    var debounce = {};

    return function () {
        var args = arguments;

        if (debounce.timeout) {
            clearTimeout(debounce.timeout);
            delete debounce.timeout;
        }

        debounce.timeout = setTimeout(function () {

            var resolver = debounce.resolver;
            var rejector = debounce.rejector;

            delete debounce.promise;
            delete debounce.resolver;
            delete debounce.rejector;
            delete debounce.timeout;

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {
                return method.apply(null, args);
            }).then(resolver, rejector);
        }, interval);

        debounce.promise = debounce.promise || new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolver, rejector) {
            debounce.resolver = resolver;
            debounce.rejector = rejector;
        });

        return debounce.promise;
    };
}

var windowReady = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
    // guard document, and window.addEventListener for JSC (react-native)
    if (typeof document !== 'undefined' && document.readyState === 'complete') {
        resolve();
    }

    if (window.addEventListener) {
        window.addEventListener('load', resolve);
    }
});

function safeInterval(method, time) {

    var timeout = void 0;

    function loop() {
        timeout = setTimeout(function () {
            method();
            loop();
        }, time);
    }

    loop();

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

function uniqueID() {
    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

function isIE() {
    return Boolean(window.document.documentMode);
}

/***/ }),

/***/ "./node_modules/bowser/bowser.min.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */
!function (e, t, n) {
  typeof module != "undefined" && module.exports ? module.exports = n() :  true ? __webpack_require__("./node_modules/webpack/buildin/amd-define.js")(t, n) : e[t] = n();
}(this, "bowser", function () {
  function t(t) {
    function n(e) {
      var n = t.match(e);return n && n.length > 1 && n[1] || "";
    }function r(e) {
      var n = t.match(e);return n && n.length > 1 && n[2] || "";
    }function N(e) {
      switch (e) {case "NT":
          return "NT";case "XP":
          return "XP";case "NT 5.0":
          return "2000";case "NT 5.1":
          return "XP";case "NT 5.2":
          return "2003";case "NT 6.0":
          return "Vista";case "NT 6.1":
          return "7";case "NT 6.2":
          return "8";case "NT 6.3":
          return "8.1";case "NT 10.0":
          return "10";default:
          return undefined;}
    }var i = n(/(ipod|iphone|ipad)/i).toLowerCase(),
        s = /like android/i.test(t),
        o = !s && /android/i.test(t),
        u = /nexus\s*[0-6]\s*/i.test(t),
        a = !u && /nexus\s*[0-9]+/i.test(t),
        f = /CrOS/.test(t),
        l = /silk/i.test(t),
        c = /sailfish/i.test(t),
        h = /tizen/i.test(t),
        p = /(web|hpw)os/i.test(t),
        d = /windows phone/i.test(t),
        v = /SamsungBrowser/i.test(t),
        m = !d && /windows/i.test(t),
        g = !i && !l && /macintosh/i.test(t),
        y = !o && !c && !h && !p && /linux/i.test(t),
        b = r(/edg([ea]|ios)\/(\d+(\.\d+)?)/i),
        w = n(/version\/(\d+(\.\d+)?)/i),
        E = /tablet/i.test(t) && !/tablet pc/i.test(t),
        S = !E && /[^-]mobi/i.test(t),
        x = /xbox/i.test(t),
        T;/opera/i.test(t) ? T = { name: "Opera", opera: e, version: w || n(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i) } : /opr\/|opios/i.test(t) ? T = { name: "Opera", opera: e, version: n(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || w } : /SamsungBrowser/i.test(t) ? T = { name: "Samsung Internet for Android", samsungBrowser: e, version: w || n(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i) } : /coast/i.test(t) ? T = { name: "Opera Coast", coast: e, version: w || n(/(?:coast)[\s\/](\d+(\.\d+)?)/i) } : /yabrowser/i.test(t) ? T = { name: "Yandex Browser", yandexbrowser: e, version: w || n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i) } : /ucbrowser/i.test(t) ? T = { name: "UC Browser", ucbrowser: e, version: n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i) } : /mxios/i.test(t) ? T = { name: "Maxthon", maxthon: e, version: n(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i) } : /epiphany/i.test(t) ? T = { name: "Epiphany", epiphany: e, version: n(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i) } : /puffin/i.test(t) ? T = { name: "Puffin", puffin: e, version: n(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i) } : /sleipnir/i.test(t) ? T = { name: "Sleipnir", sleipnir: e, version: n(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i) } : /k-meleon/i.test(t) ? T = { name: "K-Meleon", kMeleon: e, version: n(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i) } : d ? (T = { name: "Windows Phone", osname: "Windows Phone", windowsphone: e }, b ? (T.msedge = e, T.version = b) : (T.msie = e, T.version = n(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? T = { name: "Internet Explorer", msie: e, version: n(/(?:msie |rv:)(\d+(\.\d+)?)/i) } : f ? T = { name: "Chrome", osname: "Chrome OS", chromeos: e, chromeBook: e, chrome: e, version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) } : /edg([ea]|ios)/i.test(t) ? T = { name: "Microsoft Edge", msedge: e, version: b } : /vivaldi/i.test(t) ? T = { name: "Vivaldi", vivaldi: e, version: n(/vivaldi\/(\d+(\.\d+)?)/i) || w } : c ? T = { name: "Sailfish", osname: "Sailfish OS", sailfish: e, version: n(/sailfish\s?browser\/(\d+(\.\d+)?)/i) } : /seamonkey\//i.test(t) ? T = { name: "SeaMonkey", seamonkey: e, version: n(/seamonkey\/(\d+(\.\d+)?)/i) } : /firefox|iceweasel|fxios/i.test(t) ? (T = { name: "Firefox", firefox: e, version: n(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i) }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (T.firefoxos = e, T.osname = "Firefox OS")) : l ? T = { name: "Amazon Silk", silk: e, version: n(/silk\/(\d+(\.\d+)?)/i) } : /phantom/i.test(t) ? T = { name: "PhantomJS", phantom: e, version: n(/phantomjs\/(\d+(\.\d+)?)/i) } : /slimerjs/i.test(t) ? T = { name: "SlimerJS", slimer: e, version: n(/slimerjs\/(\d+(\.\d+)?)/i) } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? T = { name: "BlackBerry", osname: "BlackBerry OS", blackberry: e, version: w || n(/blackberry[\d]+\/(\d+(\.\d+)?)/i) } : p ? (T = { name: "WebOS", osname: "WebOS", webos: e, version: w || n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i) }, /touchpad\//i.test(t) && (T.touchpad = e)) : /bada/i.test(t) ? T = { name: "Bada", osname: "Bada", bada: e, version: n(/dolfin\/(\d+(\.\d+)?)/i) } : h ? T = { name: "Tizen", osname: "Tizen", tizen: e, version: n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || w } : /qupzilla/i.test(t) ? T = { name: "QupZilla", qupzilla: e, version: n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || w } : /chromium/i.test(t) ? T = { name: "Chromium", chromium: e, version: n(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || w } : /chrome|crios|crmo/i.test(t) ? T = { name: "Chrome", chrome: e, version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i) } : o ? T = { name: "Android", version: w } : /safari|applewebkit/i.test(t) ? (T = { name: "Safari", safari: e }, w && (T.version = w)) : i ? (T = { name: i == "iphone" ? "iPhone" : i == "ipad" ? "iPad" : "iPod" }, w && (T.version = w)) : /googlebot/i.test(t) ? T = { name: "Googlebot", googlebot: e, version: n(/googlebot\/(\d+(\.\d+))/i) || w } : T = { name: n(/^(.*)\/(.*) /), version: r(/^(.*)\/(.*) /) }, !T.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (T.name = T.name || "Blink", T.blink = e) : (T.name = T.name || "Webkit", T.webkit = e), !T.version && w && (T.version = w)) : !T.opera && /gecko\//i.test(t) && (T.name = T.name || "Gecko", T.gecko = e, T.version = T.version || n(/gecko\/(\d+(\.\d+)?)/i)), !T.windowsphone && (o || T.silk) ? (T.android = e, T.osname = "Android") : !T.windowsphone && i ? (T[i] = e, T.ios = e, T.osname = "iOS") : g ? (T.mac = e, T.osname = "macOS") : x ? (T.xbox = e, T.osname = "Xbox") : m ? (T.windows = e, T.osname = "Windows") : y && (T.linux = e, T.osname = "Linux");var C = "";T.windows ? C = N(n(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : T.windowsphone ? C = n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : T.mac ? (C = n(/Mac OS X (\d+([_\.\s]\d+)*)/i), C = C.replace(/[_\s]/g, ".")) : i ? (C = n(/os (\d+([_\s]\d+)*) like mac os x/i), C = C.replace(/[_\s]/g, ".")) : o ? C = n(/android[ \/-](\d+(\.\d+)*)/i) : T.webos ? C = n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : T.blackberry ? C = n(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : T.bada ? C = n(/bada\/(\d+(\.\d+)*)/i) : T.tizen && (C = n(/tizen[\/\s](\d+(\.\d+)*)/i)), C && (T.osversion = C);var k = !T.windows && C.split(".")[0];if (E || a || i == "ipad" || o && (k == 3 || k >= 4 && !S) || T.silk) T.tablet = e;else if (S || i == "iphone" || i == "ipod" || o || u || T.blackberry || T.webos || T.bada) T.mobile = e;return T.msedge || T.msie && T.version >= 10 || T.yandexbrowser && T.version >= 15 || T.vivaldi && T.version >= 1 || T.chrome && T.version >= 20 || T.samsungBrowser && T.version >= 4 || T.firefox && T.version >= 20 || T.safari && T.version >= 6 || T.opera && T.version >= 10 || T.ios && T.osversion && T.osversion.split(".")[0] >= 6 || T.blackberry && T.version >= 10.1 || T.chromium && T.version >= 20 ? T.a = e : T.msie && T.version < 10 || T.chrome && T.version < 20 || T.firefox && T.version < 20 || T.safari && T.version < 6 || T.opera && T.version < 10 || T.ios && T.osversion && T.osversion.split(".")[0] < 6 || T.chromium && T.version < 20 ? T.c = e : T.x = e, T;
  }function r(e) {
    return e.split(".").length;
  }function i(e, t) {
    var n = [],
        r;if (Array.prototype.map) return Array.prototype.map.call(e, t);for (r = 0; r < e.length; r++) {
      n.push(t(e[r]));
    }return n;
  }function s(e) {
    var t = Math.max(r(e[0]), r(e[1])),
        n = i(e, function (e) {
      var n = t - r(e);return e += new Array(n + 1).join(".0"), i(e.split("."), function (e) {
        return new Array(20 - e.length).join("0") + e;
      }).reverse();
    });while (--t >= 0) {
      if (n[0][t] > n[1][t]) return 1;if (n[0][t] !== n[1][t]) return -1;if (t === 0) return 0;
    }
  }function o(e, r, i) {
    var o = n;typeof r == "string" && (i = r, r = void 0), r === void 0 && (r = !1), i && (o = t(i));var u = "" + o.version;for (var a in e) {
      if (e.hasOwnProperty(a) && o[a]) {
        if (typeof e[a] != "string") throw new Error("Browser version in the minVersion map should be a string: " + a + ": " + String(e));return s([u, e[a]]) < 0;
      }
    }return r;
  }function u(e, t, n) {
    return !o(e, t, n);
  }var e = !0,
      n = t(typeof navigator != "undefined" ? navigator.userAgent || "" : "");return n.test = function (e) {
    for (var t = 0; t < e.length; ++t) {
      var r = e[t];if (typeof r == "string" && r in n) return !0;
    }return !1;
  }, n.isUnsupportedBrowser = o, n.compareVersions = s, n.check = u, n._detect = t, n.detect = t, n;
});

/***/ }),

/***/ "./node_modules/braintree-paypal-client-config/dist/braintree-paypal-client-config.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (root, factory) {
    "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.btppClientConfig = factory() : root.btppClientConfig = factory();
}("undefined" != typeof self ? self : this, function () {
    return function (modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        var installedModules = {};
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function (exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.n = function (module) {
            var getter = module && module.__esModule ? function () {
                return module["default"];
            } : function () {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function (object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = "./src/index.js");
    }({
        "./src/config.js": function srcConfigJs(module, __webpack_exports__, __webpack_require__) {
            "use strict";

            function get(key, def) {
                return __WEBPACK_IMPORTED_MODULE_0__store__.a.has(key) ? __WEBPACK_IMPORTED_MODULE_0__store__.a.get(key) : def;
            }
            function set(key, value) {
                __WEBPACK_IMPORTED_MODULE_0__store__.a.set(key, value);
                if (listeners[key]) for (var _iterator = listeners[key], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var listener = _ref;
                    listener(value);
                }
                return value;
            }
            function get_or_set(key, value) {
                return __WEBPACK_IMPORTED_MODULE_0__store__.a.has(key) ? get(key) : set(key, value);
            }
            function on(key, handler) {
                listeners[key] = listeners[key] || [];
                listeners[key].push(handler);
                return {
                    cancel: function cancel() {
                        listeners[key].splice(listeners[key].indexOf(handler), 1);
                    }
                };
            }
            __webpack_exports__.a = get;
            __webpack_exports__.d = set;
            __webpack_exports__.b = get_or_set;
            __webpack_exports__.c = on;
            var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("./src/store.js"),
                listeners = {};
        },
        "./src/constants.js": function srcConstantsJs(module, __webpack_exports__, __webpack_require__) {
            "use strict";

            __webpack_require__.d(__webpack_exports__, "a", function () {
                return CONFIG_KEY;
            });
            __webpack_require__.d(__webpack_exports__, "d", function () {
                return STORE;
            });
            __webpack_require__.d(__webpack_exports__, "b", function () {
                return KEY;
            });
            __webpack_require__.d(__webpack_exports__, "c", function () {
                return PAYPAL_FUNDING;
            });
            var CONFIG_KEY = "__braintree_paypal_config__",
                STORE = {
                SESSIONSTORAGE: "sessionstorage",
                GLOBAL: "global"
            },
                KEY = {
                LOGGER_SESSION_ID: "logger_session_id",
                PAYPAL_FUNDING_DISALLOW: "paypal_funding_disallow"
            },
                PAYPAL_FUNDING = {
                PAYPAL: "paypal",
                VENMO: "venmo",
                CREDIT: "credit",
                CARD: "card",
                IDEAL: "ideal",
                ELV: "elv"
            };
        },
        "./src/index.js": function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
            "use strict";

            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: !0
            });
            var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config.js");
            __webpack_require__.d(__webpack_exports__, "get", function () {
                return __WEBPACK_IMPORTED_MODULE_0__config__.a;
            });
            __webpack_require__.d(__webpack_exports__, "set", function () {
                return __WEBPACK_IMPORTED_MODULE_0__config__.d;
            });
            __webpack_require__.d(__webpack_exports__, "get_or_set", function () {
                return __WEBPACK_IMPORTED_MODULE_0__config__.b;
            });
            __webpack_require__.d(__webpack_exports__, "on", function () {
                return __WEBPACK_IMPORTED_MODULE_0__config__.c;
            });
            var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/constants.js");
            __webpack_require__.d(__webpack_exports__, "CONFIG_KEY", function () {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.a;
            });
            __webpack_require__.d(__webpack_exports__, "STORE", function () {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.d;
            });
            __webpack_require__.d(__webpack_exports__, "KEY", function () {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.b;
            });
            __webpack_require__.d(__webpack_exports__, "PAYPAL_FUNDING", function () {
                return __WEBPACK_IMPORTED_MODULE_1__constants__.c;
            });
        },
        "./src/store.js": function srcStoreJs(module, __webpack_exports__, __webpack_require__) {
            "use strict";

            function _defineProperty(obj, key, value) {
                key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value;
                return obj;
            }
            __webpack_require__.d(__webpack_exports__, "a", function () {
                return store;
            });
            var _stores,
                __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/constants.js"),
                __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/util.js"),
                stores = (_stores = {}, _defineProperty(_stores, __WEBPACK_IMPORTED_MODULE_0__constants__.d.GLOBAL, {
                get: function get(key) {
                    return (window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {})[key];
                },
                set: function set(key, value) {
                    var storage = window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {};
                    storage[key] = value;
                    window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] = storage;
                    return value;
                },
                has: function has(key) {
                    return (window[__WEBPACK_IMPORTED_MODULE_0__constants__.a] || {}).hasOwnProperty(key);
                }
            }), _defineProperty(_stores, __WEBPACK_IMPORTED_MODULE_0__constants__.d.SESSIONSTORAGE, {
                get: function get(key) {
                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                    storage = storage ? JSON.parse(storage) : {};
                    return storage[key];
                },
                set: function set(key, value) {
                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                    storage = storage ? JSON.parse(storage) : {};
                    storage[key] = value;
                    window.sessionStorage.setItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a, JSON.stringify(storage));
                    return value;
                },
                has: function has(key) {
                    var storage = window.sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants__.a);
                    storage = storage ? JSON.parse(storage) : {};
                    return storage.hasOwnProperty(key);
                }
            }), _stores),
                store = Object(__WEBPACK_IMPORTED_MODULE_1__util__.a)() ? stores[__WEBPACK_IMPORTED_MODULE_0__constants__.d.SESSIONSTORAGE] : stores[__WEBPACK_IMPORTED_MODULE_0__constants__.d.GLOBAL];
        },
        "./src/util.js": function srcUtilJs(module, __webpack_exports__, __webpack_require__) {
            "use strict";

            function isSessionStorageEnabled() {
                try {
                    if (window.sessionStorage) {
                        var value = Math.random().toString();
                        window.sessionStorage.setItem("__test__sessionStorage__", value);
                        var result = window.sessionStorage.getItem("__test__sessionStorage__");
                        window.sessionStorage.removeItem("__test__sessionStorage__");
                        if (value === result) return !0;
                    }
                } catch (err) {}
                return !1;
            }
            __webpack_exports__.a = isSessionStorageEnabled;
        }
    });
});
//# sourceMappingURL=braintree-paypal-client-config.js.map
//# sourceMappingURL=braintree-paypal-client-config.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/braintree-paypal-client-config/index.js":
/***/ (function(module, exports, __webpack_require__) {



// $FlowFixMe
module.exports = __webpack_require__("./node_modules/braintree-paypal-client-config/dist/braintree-paypal-client-config.js"); // eslint-disable-line import/no-commonjs

/***/ }),

/***/ "./node_modules/cross-domain-safe-weakmap/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/interface.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["WeakMap"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),

/***/ "./node_modules/cross-domain-safe-weakmap/src/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__weakmap__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/weakmap.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WeakMap", function() { return __WEBPACK_IMPORTED_MODULE_0__weakmap__["a"]; });


/***/ }),

/***/ "./node_modules/cross-domain-safe-weakmap/src/native.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasNativeWeakMap;
function hasNativeWeakMap() {

    if (!window.WeakMap) {
        return false;
    }

    if (!window.Object.freeze) {
        return false;
    }

    try {

        var testWeakMap = new window.WeakMap();
        var testKey = {};
        var testValue = '__testvalue__';

        window.Object.freeze(testKey);

        testWeakMap.set(testKey, testValue);

        if (testWeakMap.get(testKey) === testValue) {
            return true;
        }

        return false;
    } catch (err) {

        return false;
    }
}

/***/ }),

/***/ "./node_modules/cross-domain-safe-weakmap/src/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = safeIndexOf;
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function safeIndexOf(collection, item) {
    for (var i = 0; i < collection.length; i++) {

        try {
            if (collection[i] === item) {
                return i;
            }
        } catch (err) {
            // pass
        }
    }

    return -1;
}

function noop() {
    // pass
}

/***/ }),

/***/ "./node_modules/cross-domain-safe-weakmap/src/weakmap.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CrossDomainSafeWeakMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__native__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/native.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/util.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var defineProperty = Object.defineProperty;
var counter = Date.now() % 1e9;

var CrossDomainSafeWeakMap = function () {
    function CrossDomainSafeWeakMap() {
        _classCallCheck(this, CrossDomainSafeWeakMap);

        counter += 1;
        this.name = '__weakmap_' + (Math.random() * 1e9 >>> 0) + '__' + counter; // eslint-disable-line

        if (Object(__WEBPACK_IMPORTED_MODULE_1__native__["a" /* hasNativeWeakMap */])()) {
            try {
                this.weakmap = new window.WeakMap();
            } catch (err) {
                // pass
            }
        }

        this.keys = [];
        this.values = [];
    }

    CrossDomainSafeWeakMap.prototype._cleanupClosedWindows = function _cleanupClosedWindows() {

        var weakmap = this.weakmap;
        var keys = this.keys;

        for (var i = 0; i < keys.length; i++) {
            var value = keys[i];

            if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["x" /* isWindow */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["y" /* isWindowClosed */])(value)) {

                if (weakmap) {
                    try {
                        weakmap['delete'](value);
                    } catch (err) {
                        // pass
                    }
                }

                keys.splice(i, 1);
                this.values.splice(i, 1);

                i -= 1;
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.isSafeToReadWrite = function isSafeToReadWrite(key) {

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["x" /* isWindow */])(key)) {
            return false;
        }

        try {
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* noop */])(key && key.self);
            Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* noop */])(key && key[this.name]);
        } catch (err) {
            return false;
        }

        return true;
    };

    CrossDomainSafeWeakMap.prototype.set = function set(key, value) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                weakmap.set(key, value);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var values = this.values;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index === -1) {
                keys.push(key);
                values.push(value);
            } else {
                values[index] = value;
            }
        } else {

            var name = this.name;
            var entry = key[name];

            if (entry && entry[0] === key) {
                entry[1] = value;
            } else {
                defineProperty(key, name, {
                    value: [key, value],
                    writable: true
                });
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.get = function get(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                if (weakmap.has(key)) {
                    return weakmap.get(key);
                }
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index === -1) {
                return;
            }

            return this.values[index];
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                return entry[1];
            }
        }
    };

    CrossDomainSafeWeakMap.prototype['delete'] = function _delete(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                weakmap['delete'](key);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var keys = this.keys;
            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(keys, key);

            if (index !== -1) {
                keys.splice(index, 1);
                this.values.splice(index, 1);
            }
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                entry[0] = entry[1] = undefined;
            }
        }
    };

    CrossDomainSafeWeakMap.prototype.has = function has(key) {

        if (!key) {
            throw new Error('WeakMap expected key');
        }

        var weakmap = this.weakmap;

        if (weakmap) {
            try {
                return weakmap.has(key);
            } catch (err) {
                delete this.weakmap;
            }
        }

        if (!this.isSafeToReadWrite(key)) {

            this._cleanupClosedWindows();

            var index = Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* safeIndexOf */])(this.keys, key);
            return index !== -1;
        } else {

            var entry = key[this.name];

            if (entry && entry[0] === key) {
                return true;
            }

            return false;
        }
    };

    return CrossDomainSafeWeakMap;
}();

/***/ }),

/***/ "./node_modules/cross-domain-utils/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["q"] = isFileProtocol;
/* unused harmony export isAboutProtocol */
/* harmony export (immutable) */ __webpack_exports__["l"] = getParent;
/* harmony export (immutable) */ __webpack_exports__["k"] = getOpener;
/* unused harmony export canReadFromWindow */
/* harmony export (immutable) */ __webpack_exports__["b"] = getActualDomain;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDomain;
/* unused harmony export isBlankDomain */
/* harmony export (immutable) */ __webpack_exports__["o"] = isActuallySameDomain;
/* harmony export (immutable) */ __webpack_exports__["u"] = isSameDomain;
/* unused harmony export getParents */
/* unused harmony export isAncestorParent */
/* harmony export (immutable) */ __webpack_exports__["i"] = getFrames;
/* unused harmony export getAllChildFrames */
/* harmony export (immutable) */ __webpack_exports__["m"] = getTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllFramesInWindow;
/* harmony export (immutable) */ __webpack_exports__["w"] = isTop;
/* unused harmony export isFrameWindowClosed */
/* harmony export (immutable) */ __webpack_exports__["y"] = isWindowClosed;
/* harmony export (immutable) */ __webpack_exports__["z"] = linkFrameWindow;
/* harmony export (immutable) */ __webpack_exports__["n"] = getUserAgent;
/* harmony export (immutable) */ __webpack_exports__["h"] = getFrameByName;
/* unused harmony export findChildFrameByName */
/* harmony export (immutable) */ __webpack_exports__["a"] = findFrameByName;
/* unused harmony export isParent */
/* harmony export (immutable) */ __webpack_exports__["s"] = isOpener;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAncestor;
/* unused harmony export getAncestors */
/* harmony export (immutable) */ __webpack_exports__["p"] = isAncestor;
/* harmony export (immutable) */ __webpack_exports__["t"] = isPopup;
/* harmony export (immutable) */ __webpack_exports__["r"] = isIframe;
/* unused harmony export isFullpage */
/* harmony export (immutable) */ __webpack_exports__["e"] = getDistanceFromTop;
/* unused harmony export getNthParent */
/* harmony export (immutable) */ __webpack_exports__["j"] = getNthParentFromTop;
/* harmony export (immutable) */ __webpack_exports__["v"] = isSameTopWindow;
/* harmony export (immutable) */ __webpack_exports__["A"] = matchDomain;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDomainFromUrl;
/* harmony export (immutable) */ __webpack_exports__["B"] = onCloseWindow;
/* harmony export (immutable) */ __webpack_exports__["x"] = isWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/cross-domain-utils/src/util.js");


var CONSTANTS = {
    MOCK_PROTOCOL: 'mock:',
    FILE_PROTOCOL: 'file:',
    ABOUT_PROTOCOL: 'about:',
    WILDCARD: '*'
};

var IE_WIN_ACCESS_ERROR = 'Call was rejected by callee.\r\n';

function isFileProtocol() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

    return win.location.protocol === CONSTANTS.FILE_PROTOCOL;
}

function isAboutProtocol() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

    return win.location.protocol === CONSTANTS.ABOUT_PROTOCOL;
}

function getParent(win) {

    if (!win) {
        return;
    }

    try {
        if (win.parent && win.parent !== win) {
            return win.parent;
        }
    } catch (err) {
        return;
    }
}

function getOpener(win) {

    if (!win) {
        return;
    }

    // Make sure we're not actually an iframe which has had window.open() called on us
    if (getParent(win)) {
        return;
    }

    try {
        return win.opener;
    } catch (err) {
        return;
    }
}

function canReadFromWindow(win) {
    try {
        // $FlowFixMe
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(win && win.location && win.location.href);
        return true;
    } catch (err) {
        // pass
    }

    return false;
}

function getActualDomain(win) {

    var location = win.location;

    if (!location) {
        throw new Error('Can not read window location');
    }

    var protocol = location.protocol;

    if (!protocol) {
        throw new Error('Can not read window protocol');
    }

    if (protocol === CONSTANTS.FILE_PROTOCOL) {
        return CONSTANTS.FILE_PROTOCOL + '//';
    }

    if (protocol === CONSTANTS.ABOUT_PROTOCOL) {

        var parent = getParent(win);
        if (parent && canReadFromWindow(win)) {
            // $FlowFixMe
            return getActualDomain(parent);
        }

        return CONSTANTS.ABOUT_PROTOCOL + '//';
    }

    var host = location.host;

    if (!host) {
        throw new Error('Can not read window host');
    }

    return protocol + '//' + host;
}

function getDomain(win) {

    win = win || window;

    var domain = getActualDomain(win);

    if (domain && win.mockDomain && win.mockDomain.indexOf(CONSTANTS.MOCK_PROTOCOL) === 0) {
        return win.mockDomain;
    }

    return domain;
}

function isBlankDomain(win) {
    try {
        if (!win.location.href) {
            return true;
        }

        if (win.location.href === 'about:blank') {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function isActuallySameDomain(win) {

    try {
        if (win === window) {
            return true;
        }
    } catch (err) {
        // pass
    }

    try {
        var desc = Object.getOwnPropertyDescriptor(win, 'location');

        if (desc && desc.enumerable === false) {
            return false;
        }
    } catch (err) {
        // pass
    }

    try {
        // $FlowFixMe
        if (isAboutProtocol(win) && canReadFromWindow(win)) {
            return true;
        }
    } catch (err) {
        // pass
    }

    try {
        // $FlowFixMe
        if (getActualDomain(win) === getActualDomain(window)) {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function isSameDomain(win) {

    if (!isActuallySameDomain(win)) {
        return false;
    }

    try {

        if (win === window) {
            return true;
        }

        // $FlowFixMe
        if (isAboutProtocol(win) && canReadFromWindow(win)) {
            return true;
        }

        // $FlowFixMe
        if (getDomain(window) === getDomain(win)) {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function getParents(win) {

    var result = [];

    try {

        while (win.parent !== win) {
            result.push(win.parent);
            win = win.parent;
        }
    } catch (err) {
        // pass
    }

    return result;
}

function isAncestorParent(parent, child) {

    if (!parent || !child) {
        return false;
    }

    var childParent = getParent(child);

    if (childParent) {
        return childParent === parent;
    }

    if (getParents(child).indexOf(parent) !== -1) {
        return true;
    }

    return false;
}

function getFrames(win) {

    var result = [];

    var frames = void 0;

    try {
        frames = win.frames;
    } catch (err) {
        frames = win;
    }

    var len = void 0;

    try {
        len = frames.length;
    } catch (err) {
        // pass
    }

    if (len === 0) {
        return result;
    }

    if (len) {
        for (var i = 0; i < len; i++) {

            var frame = void 0;

            try {
                frame = frames[i];
            } catch (err) {
                continue;
            }

            result.push(frame);
        }

        return result;
    }

    for (var _i = 0; _i < 100; _i++) {
        var _frame = void 0;

        try {
            _frame = frames[_i];
        } catch (err) {
            return result;
        }

        if (!_frame) {
            return result;
        }

        result.push(_frame);
    }

    return result;
}

function getAllChildFrames(win) {

    var result = [];

    for (var _iterator = getFrames(win), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i2 >= _iterator.length) break;
            _ref = _iterator[_i2++];
        } else {
            _i2 = _iterator.next();
            if (_i2.done) break;
            _ref = _i2.value;
        }

        var frame = _ref;

        result.push(frame);

        for (var _iterator2 = getAllChildFrames(frame), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i3 >= _iterator2.length) break;
                _ref2 = _iterator2[_i3++];
            } else {
                _i3 = _iterator2.next();
                if (_i3.done) break;
                _ref2 = _i3.value;
            }

            var childFrame = _ref2;

            result.push(childFrame);
        }
    }

    return result;
}

function getTop(win) {

    if (!win) {
        return;
    }

    try {
        if (win.top) {
            return win.top;
        }
    } catch (err) {
        // pass
    }

    if (getParent(win) === win) {
        return win;
    }

    try {
        if (isAncestorParent(window, win) && window.top) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    try {
        if (isAncestorParent(win, window) && window.top) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    for (var _iterator3 = getAllChildFrames(win), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i4 >= _iterator3.length) break;
            _ref3 = _iterator3[_i4++];
        } else {
            _i4 = _iterator3.next();
            if (_i4.done) break;
            _ref3 = _i4.value;
        }

        var frame = _ref3;

        try {
            if (frame.top) {
                return frame.top;
            }
        } catch (err) {
            // pass
        }

        if (getParent(frame) === frame) {
            return frame;
        }
    }
}

function getAllFramesInWindow(win) {
    var top = getTop(win);
    // $FlowFixMe
    return getAllChildFrames(top).concat(top);
}

function isTop(win) {
    return win === getTop(win);
}

function isFrameWindowClosed(frame) {

    if (!frame.contentWindow) {
        return true;
    }

    if (!frame.parentNode) {
        return true;
    }

    var doc = frame.ownerDocument;

    if (doc && doc.body && !doc.body.contains(frame)) {
        return true;
    }

    return false;
}

function safeIndexOf(collection, item) {
    for (var i = 0; i < collection.length; i++) {

        try {
            if (collection[i] === item) {
                return i;
            }
        } catch (err) {
            // pass
        }
    }

    return -1;
}

var iframeWindows = [];
var iframeFrames = [];

function isWindowClosed(win) {
    var allowMock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


    try {
        if (win === window) {
            return false;
        }
    } catch (err) {
        return true;
    }

    try {
        if (!win) {
            return true;
        }
    } catch (err) {
        return true;
    }

    try {
        if (win.closed) {
            return true;
        }
    } catch (err) {

        // I love you so much IE

        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return false;
        }

        return true;
    }

    if (allowMock && isSameDomain(win)) {
        try {
            if (win.mockclosed) {
                return true;
            }
        } catch (err) {
            // pass
        }
    }

    // Mobile safari

    try {
        if (!win.parent || !win.top) {
            return true;
        }
    } catch (err) {}
    // pass


    // Yes, this actually happens in IE. win === win errors out when the window
    // is from an iframe, and the iframe was removed from the page.

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(win === win); // eslint-disable-line no-self-compare
    } catch (err) {
        return true;
    }

    // IE orphaned frame

    var iframeIndex = safeIndexOf(iframeWindows, win);

    if (iframeIndex !== -1) {
        var frame = iframeFrames[iframeIndex];

        if (frame && isFrameWindowClosed(frame)) {
            return true;
        }
    }

    return false;
}

function cleanIframes() {

    for (var i = 0; i < iframeFrames.length; i++) {
        if (isFrameWindowClosed(iframeFrames[i])) {
            iframeFrames.splice(i, 1);
            iframeWindows.splice(i, 1);
        }
    }

    for (var _i5 = 0; _i5 < iframeWindows.length; _i5++) {
        if (isWindowClosed(iframeWindows[_i5])) {
            iframeFrames.splice(_i5, 1);
            iframeWindows.splice(_i5, 1);
        }
    }
}

function linkFrameWindow(frame) {

    cleanIframes();

    if (frame && frame.contentWindow) {
        try {
            iframeWindows.push(frame.contentWindow);
            iframeFrames.push(frame);
        } catch (err) {
            // pass
        }
    }
}

function getUserAgent(win) {
    win = win || window;
    return win.navigator.mockUserAgent || win.navigator.userAgent;
}

function getFrameByName(win, name) {

    var winFrames = getFrames(win);

    for (var _iterator4 = winFrames, _isArray4 = Array.isArray(_iterator4), _i6 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
            if (_i6 >= _iterator4.length) break;
            _ref4 = _iterator4[_i6++];
        } else {
            _i6 = _iterator4.next();
            if (_i6.done) break;
            _ref4 = _i6.value;
        }

        var childFrame = _ref4;

        try {
            if (isSameDomain(childFrame) && childFrame.name === name && winFrames.indexOf(childFrame) !== -1) {
                return childFrame;
            }
        } catch (err) {
            // pass
        }
    }

    try {
        // $FlowFixMe
        if (winFrames.indexOf(win.frames[name]) !== -1) {
            // $FlowFixMe
            return win.frames[name];
        }
    } catch (err) {
        // pass
    }

    try {
        if (winFrames.indexOf(win[name]) !== -1) {
            return win[name];
        }
    } catch (err) {
        // pass
    }
}

function findChildFrameByName(win, name) {

    var frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    for (var _iterator5 = getFrames(win), _isArray5 = Array.isArray(_iterator5), _i7 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
            if (_i7 >= _iterator5.length) break;
            _ref5 = _iterator5[_i7++];
        } else {
            _i7 = _iterator5.next();
            if (_i7.done) break;
            _ref5 = _i7.value;
        }

        var childFrame = _ref5;

        var namedFrame = findChildFrameByName(childFrame, name);

        if (namedFrame) {
            return namedFrame;
        }
    }
}

function findFrameByName(win, name) {

    var frame = void 0;

    frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    var top = getTop(win) || win;

    return findChildFrameByName(top, name);
}

function isParent(win, frame) {

    var frameParent = getParent(frame);

    if (frameParent) {
        return frameParent === win;
    }

    for (var _iterator6 = getFrames(win), _isArray6 = Array.isArray(_iterator6), _i8 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray6) {
            if (_i8 >= _iterator6.length) break;
            _ref6 = _iterator6[_i8++];
        } else {
            _i8 = _iterator6.next();
            if (_i8.done) break;
            _ref6 = _i8.value;
        }

        var childFrame = _ref6;

        if (childFrame === frame) {
            return true;
        }
    }

    return false;
}

function isOpener(parent, child) {

    return parent === getOpener(child);
}

function getAncestor(win) {
    win = win || window;

    var opener = getOpener(win);

    if (opener) {
        return opener;
    }

    var parent = getParent(win);

    if (parent) {
        return parent;
    }
}

function getAncestors(win) {

    var results = [];

    var ancestor = win;

    while (ancestor) {
        ancestor = getAncestor(ancestor);
        if (ancestor) {
            results.push(ancestor);
        }
    }

    return results;
}

function isAncestor(parent, child) {

    var actualParent = getAncestor(child);

    if (actualParent) {
        if (actualParent === parent) {
            return true;
        }

        return false;
    }

    if (child === parent) {
        return false;
    }

    if (getTop(child) === child) {
        return false;
    }

    for (var _iterator7 = getFrames(parent), _isArray7 = Array.isArray(_iterator7), _i9 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
            if (_i9 >= _iterator7.length) break;
            _ref7 = _iterator7[_i9++];
        } else {
            _i9 = _iterator7.next();
            if (_i9.done) break;
            _ref7 = _i9.value;
        }

        var frame = _ref7;

        if (frame === child) {
            return true;
        }
    }

    return false;
}

function isPopup() {
    return Boolean(getOpener(window));
}

function isIframe() {
    return Boolean(getParent(window));
}

function isFullpage() {
    return Boolean(!isIframe() && !isPopup());
}

function anyMatch(collection1, collection2) {

    for (var _iterator8 = collection1, _isArray8 = Array.isArray(_iterator8), _i10 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
            if (_i10 >= _iterator8.length) break;
            _ref8 = _iterator8[_i10++];
        } else {
            _i10 = _iterator8.next();
            if (_i10.done) break;
            _ref8 = _i10.value;
        }

        var item1 = _ref8;

        for (var _iterator9 = collection2, _isArray9 = Array.isArray(_iterator9), _i11 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
            var _ref9;

            if (_isArray9) {
                if (_i11 >= _iterator9.length) break;
                _ref9 = _iterator9[_i11++];
            } else {
                _i11 = _iterator9.next();
                if (_i11.done) break;
                _ref9 = _i11.value;
            }

            var item2 = _ref9;

            if (item1 === item2) {
                return true;
            }
        }
    }

    return false;
}

function getDistanceFromTop() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

    var distance = 0;
    var parent = win;

    while (parent) {
        parent = getParent(parent);
        if (parent) {
            distance += 1;
        }
    }

    return distance;
}

function getNthParent(win) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var parent = win;

    for (var i = 0; i < n; i++) {
        if (!parent) {
            return;
        }

        parent = getParent(parent);
    }

    return parent;
}

function getNthParentFromTop(win) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return getNthParent(win, getDistanceFromTop(win) - n);
}

function isSameTopWindow(win1, win2) {

    var top1 = getTop(win1) || win1;
    var top2 = getTop(win2) || win2;

    try {
        if (top1 && top2) {
            if (top1 === top2) {
                return true;
            }

            return false;
        }
    } catch (err) {
        // pass
    }

    var allFrames1 = getAllFramesInWindow(win1);
    var allFrames2 = getAllFramesInWindow(win2);

    if (anyMatch(allFrames1, allFrames2)) {
        return true;
    }

    var opener1 = getOpener(top1);
    var opener2 = getOpener(top2);

    if (opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2)) {
        return false;
    }

    if (opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1)) {
        return false;
    }

    return false;
}

function matchDomain(pattern, origin) {

    if (typeof pattern === 'string') {

        if (typeof origin === 'string') {
            return pattern === CONSTANTS.WILDCARD || origin === pattern;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return false;
        }

        if (Array.isArray(origin)) {
            return false;
        }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(pattern)) {

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return pattern.toString() === origin.toString();
        }

        if (Array.isArray(origin)) {
            return false;
        }

        // $FlowFixMe
        return Boolean(origin.match(pattern));
    }

    if (Array.isArray(pattern)) {

        if (Array.isArray(origin)) {
            return JSON.stringify(pattern) === JSON.stringify(origin);
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* isRegex */])(origin)) {
            return false;
        }

        return pattern.some(function (subpattern) {
            return matchDomain(subpattern, origin);
        });
    }

    return false;
}

function getDomainFromUrl(url) {

    var domain = void 0;

    if (url.match(/^(https?|mock|file):\/\//)) {
        domain = url;
    } else {
        return getDomain();
    }

    domain = domain.split('/').slice(0, 3).join('/');

    return domain;
}

function onCloseWindow(win, callback) {
    var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
    var maxtime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;


    var timeout = void 0;

    var check = function check() {

        if (isWindowClosed(win)) {

            if (timeout) {
                clearTimeout(timeout);
            }

            return callback();
        }

        if (maxtime <= 0) {
            clearTimeout(timeout);
        } else {
            maxtime -= delay;
            timeout = setTimeout(check, delay);
        }
    };

    check();

    return {
        cancel: function cancel() {
            if (timeout) {
                clearTimeout(timeout);
            }
        }
    };
}

function isWindow(obj) {

    try {
        if (obj === window) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (Object.prototype.toString.call(obj) === '[object Window]') {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (window.Window && obj instanceof window.Window) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.self === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.parent === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        if (obj && obj.top === obj) {
            return true;
        }
    } catch (err) {
        if (err && err.message === IE_WIN_ACCESS_ERROR) {
            return true;
        }
    }

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(obj === obj); // eslint-disable-line no-self-compare
    } catch (err) {
        return true;
    }

    try {
        Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* noop */])(obj && obj.__cross_domain_utils_window_check__);
    } catch (err) {
        return true;
    }

    return false;
}

/***/ }),

/***/ "./node_modules/cross-domain-utils/src/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRegex;
/* harmony export (immutable) */ __webpack_exports__["b"] = noop;
function isRegex(item) {
    return Object.prototype.toString.call(item) === '[object RegExp]';
}

function noop() {
    // pass
}

/***/ }),

/***/ "./node_modules/hi-base32/src/base32.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * [hi-base32]{@link https://github.com/emn178/hi-base32}
 *
 * @version 0.3.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2017
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var root = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' ? window : {};
  var NODE_JS = !root.HI_BASE32_NO_NODE_JS && (typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  }
  var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && ( false ? 'undefined' : _typeof(module)) === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__("./node_modules/webpack/buildin/amd-options.js");
  var BASE32_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'.split('');
  var BASE32_DECODE_CHAR = {
    'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8,
    'J': 9, 'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16,
    'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24,
    'Z': 25, '2': 26, '3': 27, '4': 28, '5': 29, '6': 30, '7': 31
  };

  var blocks = [0, 0, 0, 0, 0, 0, 0, 0];

  var toUtf8String = function toUtf8String(bytes) {
    var str = '',
        length = bytes.length,
        i = 0,
        followingChars = 0,
        b,
        c;
    while (i < length) {
      b = bytes[i++];
      if (b <= 0x7F) {
        str += String.fromCharCode(b);
        continue;
      } else if (b > 0xBF && b <= 0xDF) {
        c = b & 0x1F;
        followingChars = 1;
      } else if (b <= 0xEF) {
        c = b & 0x0F;
        followingChars = 2;
      } else if (b <= 0xF7) {
        c = b & 0x07;
        followingChars = 3;
      } else {
        throw 'not a UTF-8 string';
      }

      for (var j = 0; j < followingChars; ++j) {
        b = bytes[i++];
        if (b < 0x80 || b > 0xBF) {
          throw 'not a UTF-8 string';
        }
        c <<= 6;
        c += b & 0x3F;
      }
      if (c >= 0xD800 && c <= 0xDFFF) {
        throw 'not a UTF-8 string';
      }
      if (c > 0x10FFFF) {
        throw 'not a UTF-8 string';
      }

      if (c <= 0xFFFF) {
        str += String.fromCharCode(c);
      } else {
        c -= 0x10000;
        str += String.fromCharCode((c >> 10) + 0xD800);
        str += String.fromCharCode((c & 0x3FF) + 0xDC00);
      }
    }
    return str;
  };

  var decodeAsBytes = function decodeAsBytes(base32Str) {
    base32Str = base32Str.replace(/=/g, '');
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        bytes = [],
        index = 0,
        length = base32Str.length;

    // 4 char to 3 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
      bytes[index++] = (v7 << 5 | v8) & 255;
    }

    // remain bytes
    var remain = length - count;
    if (remain === 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
    } else if (remain === 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
    } else if (remain === 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
    } else if (remain === 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
    }
    return bytes;
  };

  var encodeAscii = function encodeAscii(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = str.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i++);
      v5 = str.charCodeAt(i++);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain === 1) {
      v1 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain === 2) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain === 3) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain === 4) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encodeUtf8 = function encodeUtf8(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        code,
        end = false,
        base32Str = '',
        index = 0,
        i,
        start = 0,
        bytes = 0,
        length = str.length;
    do {
      blocks[0] = blocks[5];
      blocks[1] = blocks[6];
      blocks[2] = blocks[7];
      for (i = start; index < length && i < 5; ++index) {
        code = str.charCodeAt(index);
        if (code < 0x80) {
          blocks[i++] = code;
        } else if (code < 0x800) {
          blocks[i++] = 0xc0 | code >> 6;
          blocks[i++] = 0x80 | code & 0x3f;
        } else if (code < 0xd800 || code >= 0xe000) {
          blocks[i++] = 0xe0 | code >> 12;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        } else {
          code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++index) & 0x3ff);
          blocks[i++] = 0xf0 | code >> 18;
          blocks[i++] = 0x80 | code >> 12 & 0x3f;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        }
      }
      bytes += i - start;
      start = i - 5;
      if (index === length) {
        ++index;
      }
      if (index > length && i < 6) {
        end = true;
      }
      v1 = blocks[0];
      if (i > 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        v5 = blocks[4];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
      } else if (i === 1) {
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
      } else if (i === 2) {
        v2 = blocks[1];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
      } else if (i === 3) {
        v2 = blocks[1];
        v3 = blocks[2];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
      } else if (i === 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
      }
    } while (!end);
    return base32Str;
  };

  var encodeBytes = function encodeBytes(bytes) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = bytes.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i++];
      v5 = bytes[i++];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain === 1) {
      v1 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain === 2) {
      v1 = bytes[i++];
      v2 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain === 3) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain === 4) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encode = function encode(input, asciiOnly) {
    var notString = typeof input !== 'string';
    if (notString && input.constructor === ArrayBuffer) {
      input = new Uint8Array(input);
    }
    if (notString) {
      return encodeBytes(input);
    } else if (asciiOnly) {
      return encodeAscii(input);
    } else {
      return encodeUtf8(input);
    }
  };

  var decode = function decode(base32Str, asciiOnly) {
    if (!asciiOnly) {
      return toUtf8String(decodeAsBytes(base32Str));
    }
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        str = '',
        length = base32Str.indexOf('=');
    if (length === -1) {
      length = base32Str.length;
    }

    // 8 char to 5 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
    }

    // remain bytes
    var remain = length - count;
    if (remain === 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
    } else if (remain === 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
    } else if (remain === 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
    } else if (remain === 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
    }
    return str;
  };

  var exports = {
    encode: encode,
    decode: decode
  };
  decode.asBytes = decodeAsBytes;

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.base32 = exports;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/process/browser.js"), __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/post-robot/src/bridge/bridge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");







/*
    HERE BE DRAGONS

    Warning: this file may look weird. Why save the tunnel window in an Object
    by ID, then look it up later, rather than just using the reference from the closure scope?

    The reason is, that ends up meaning the garbage collector can never get its hands
    on a closed window, since our closure has continued access to it -- and post-robot
    has no good way to know whether to clean up the function with the closure scope.

    If you're editing this file, be sure to run significant memory / GC tests afterwards.
*/

__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows = __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows || {};
__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindowId = 0;

function deleteTunnelWindow(id) {

    try {
        if (__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows[id]) {
            delete __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows[id].source;
        }
    } catch (err) {
        // pass
    }

    delete __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows[id];
}

function cleanTunnelWindows() {
    var tunnelWindows = __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows;

    for (var _iterator = Object.keys(tunnelWindows), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;

        var tunnelWindow = tunnelWindows[key];

        try {
            Object(__WEBPACK_IMPORTED_MODULE_3__lib__["j" /* noop */])(tunnelWindow.source);
        } catch (err) {
            deleteTunnelWindow(key);
            continue;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(tunnelWindow.source)) {
            deleteTunnelWindow(key);
        }
    }
}

function addTunnelWindow(_ref2) {
    var name = _ref2.name,
        source = _ref2.source,
        canary = _ref2.canary,
        sendMessage = _ref2.sendMessage;

    cleanTunnelWindows();
    __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindowId += 1;
    __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows[__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindowId] = { name: name, source: source, canary: canary, sendMessage: sendMessage };
    return __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindowId;
}

function getTunnelWindow(id) {
    return __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].tunnelWindows[id];
}

__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].openTunnelToParent = function openTunnelToParent(_ref3) {
    var name = _ref3.name,
        source = _ref3.source,
        canary = _ref3.canary,
        sendMessage = _ref3.sendMessage;


    var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["l" /* getParent */])(window);

    if (!parentWindow) {
        throw new Error('No parent window found to open tunnel to');
    }

    var id = addTunnelWindow({ name: name, source: source, canary: canary, sendMessage: sendMessage });

    return __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].send(parentWindow, __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.OPEN_TUNNEL, {

        name: name,

        sendMessage: function sendMessage() {

            var tunnelWindow = getTunnelWindow(id);

            try {
                // IE gets antsy if you try to even reference a closed window
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__["j" /* noop */])(tunnelWindow && tunnelWindow.source);
            } catch (err) {
                deleteTunnelWindow(id);
                return;
            }

            if (!tunnelWindow || !tunnelWindow.source || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(tunnelWindow.source)) {
                return;
            }

            try {
                tunnelWindow.canary();
            } catch (err) {
                return;
            }

            tunnelWindow.sendMessage.apply(this, arguments);
        }
    }, { domain: __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD });
};

/***/ }),

/***/ "./node_modules/post-robot/src/bridge/child.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openTunnelToOpener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js");








var awaitRemoteBridgeForWindow = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* weakMapMemoize */])(function (win) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["i" /* getFrames */])(win), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var _frame = _ref;

            try {
                // $FlowFixMe
                if (_frame && _frame !== window && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["u" /* isSameDomain */])(_frame) && _frame[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT]) {
                    return _frame;
                }
            } catch (err) {
                continue;
            }
        }

        try {
            var frame = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["h" /* getFrameByName */])(win, Object(__WEBPACK_IMPORTED_MODULE_5__common__["c" /* getBridgeName */])(Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["f" /* getDomain */])()));

            if (!frame) {
                return;
            }

            // $FlowFixMe
            if (Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["u" /* isSameDomain */])(frame) && frame[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT]) {
                return frame;
            }

            return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

                var interval = void 0;
                var timeout = void 0;

                interval = setInterval(function () {
                    // $FlowFixMe
                    if (frame && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["u" /* isSameDomain */])(frame) && frame[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT]) {
                        clearInterval(interval);
                        clearTimeout(timeout);
                        return resolve(frame);
                    }
                }, 100);

                timeout = setTimeout(function () {
                    clearInterval(interval);
                    return resolve();
                }, 2000);
            });
        } catch (err) {
            return;
        }
    });
});

function openTunnelToOpener() {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        var opener = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["k" /* getOpener */])(window);

        if (!opener) {
            return;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__common__["e" /* needsBridge */])({ win: opener })) {
            return;
        }

        Object(__WEBPACK_IMPORTED_MODULE_5__common__["j" /* registerRemoteWindow */])(opener);

        return awaitRemoteBridgeForWindow(opener).then(function (bridge) {

            if (!bridge) {
                return Object(__WEBPACK_IMPORTED_MODULE_5__common__["k" /* rejectRemoteSendMessage */])(opener, new Error('Can not register with opener: no bridge found in opener'));
            }

            if (!window.name) {
                return Object(__WEBPACK_IMPORTED_MODULE_5__common__["k" /* rejectRemoteSendMessage */])(opener, new Error('Can not register with opener: window does not have a name'));
            }

            return bridge[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT].openTunnelToParent({

                name: window.name,

                source: window,

                canary: function canary() {
                    // pass
                },
                sendMessage: function sendMessage(message) {

                    try {
                        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["j" /* noop */])(window);
                    } catch (err) {
                        return;
                    }

                    if (!window || window.closed) {
                        return;
                    }

                    try {
                        __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].receiveMessage({
                            data: message,
                            origin: this.origin,
                            source: this.source
                        });
                    } catch (err) {
                        __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].reject(err);
                    }
                }
            }).then(function (_ref2) {
                var source = _ref2.source,
                    origin = _ref2.origin,
                    data = _ref2.data;


                if (source !== opener) {
                    throw new Error('Source does not match opener');
                }

                Object(__WEBPACK_IMPORTED_MODULE_5__common__["i" /* registerRemoteSendMessage */])(source, origin, data.sendMessage);
            })['catch'](function (err) {

                Object(__WEBPACK_IMPORTED_MODULE_5__common__["k" /* rejectRemoteSendMessage */])(opener, err);
                throw err;
            });
        });
    });
}

/***/ }),

/***/ "./node_modules/post-robot/src/bridge/common.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = needsBridgeForBrowser;
/* harmony export (immutable) */ __webpack_exports__["h"] = needsBridgeForWin;
/* harmony export (immutable) */ __webpack_exports__["g"] = needsBridgeForDomain;
/* harmony export (immutable) */ __webpack_exports__["e"] = needsBridge;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBridgeName;
/* harmony export (immutable) */ __webpack_exports__["d"] = isBridge;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return documentBodyReady; });
/* harmony export (immutable) */ __webpack_exports__["j"] = registerRemoteWindow;
/* harmony export (immutable) */ __webpack_exports__["b"] = findRemoteWindow;
/* harmony export (immutable) */ __webpack_exports__["i"] = registerRemoteSendMessage;
/* harmony export (immutable) */ __webpack_exports__["k"] = rejectRemoteSendMessage;
/* harmony export (immutable) */ __webpack_exports__["l"] = sendBridgeMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");







function needsBridgeForBrowser() {

    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["n" /* getUserAgent */])(window).match(/MSIE|trident|edge\/12|edge\/13/i)) {
        return true;
    }

    if (!__WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].ALLOW_POSTMESSAGE_POPUP) {
        return true;
    }

    return false;
}

function needsBridgeForWin(win) {

    if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* isSameTopWindow */])(window, win)) {
        return true;
    }

    return false;
}

function needsBridgeForDomain(domain, win) {

    if (domain) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])() !== Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(domain)) {
            return true;
        }
    } else if (win) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {
            return true;
        }
    }

    return false;
}

function needsBridge(_ref) {
    var win = _ref.win,
        domain = _ref.domain;


    if (!needsBridgeForBrowser()) {
        return false;
    }

    if (domain && !needsBridgeForDomain(domain, win)) {
        return false;
    }

    if (win && !needsBridgeForWin(win)) {
        return false;
    }

    return true;
}

function getBridgeName(domain) {

    domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(domain);

    var sanitizedDomain = domain.replace(/[^a-zA-Z0-9]+/g, '_');

    var id = __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].BRIDGE_NAME_PREFIX + '_' + sanitizedDomain;

    return id;
}

function isBridge() {
    return Boolean(window.name && window.name === getBridgeName(Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])()));
}

var documentBodyReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

    if (window.document && window.document.body) {
        return resolve(window.document.body);
    }

    var interval = setInterval(function () {
        if (window.document && window.document.body) {
            clearInterval(interval);
            return resolve(window.document.body);
        }
    }, 10);
});

__WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].remoteWindows = __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].remoteWindows || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function registerRemoteWindow(win) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].BRIDGE_TIMEOUT;

    __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].remoteWindows.set(win, { sendMessagePromise: new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]() });
}

function findRemoteWindow(win) {
    return __WEBPACK_IMPORTED_MODULE_4__global__["a" /* global */].remoteWindows.get(win);
}

function registerRemoteSendMessage(win, domain, sendMessage) {

    var remoteWindow = findRemoteWindow(win);

    if (!remoteWindow) {
        throw new Error('Window not found to register sendMessage to');
    }

    var sendMessageWrapper = function sendMessageWrapper(remoteWin, message, remoteDomain) {

        if (remoteWin !== win) {
            throw new Error('Remote window does not match window');
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["A" /* matchDomain */])(remoteDomain, domain)) {
            throw new Error('Remote domain ' + remoteDomain + ' does not match domain ' + domain);
        }

        sendMessage(message);
    };

    remoteWindow.sendMessagePromise.resolve(sendMessageWrapper);
    remoteWindow.sendMessagePromise = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(sendMessageWrapper);
}

function rejectRemoteSendMessage(win, err) {

    var remoteWindow = findRemoteWindow(win);

    if (!remoteWindow) {
        throw new Error('Window not found on which to reject sendMessage');
    }

    remoteWindow.sendMessagePromise.asyncReject(err);
}

function sendBridgeMessage(win, message, domain) {

    var messagingChild = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["s" /* isOpener */])(window, win);
    var messagingParent = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["s" /* isOpener */])(win, window);

    if (!messagingChild && !messagingParent) {
        throw new Error('Can only send messages to and from parent and popup windows');
    }

    var remoteWindow = findRemoteWindow(win);

    if (!remoteWindow) {
        throw new Error('Window not found to send message to');
    }

    return remoteWindow.sendMessagePromise.then(function (sendMessage) {
        return sendMessage(win, message, domain);
    });
}

/***/ }),

/***/ "./node_modules/post-robot/src/bridge/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bridge__ = __webpack_require__("./node_modules/post-robot/src/bridge/bridge.js");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__child__ = __webpack_require__("./node_modules/post-robot/src/bridge/child.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() { return __WEBPACK_IMPORTED_MODULE_1__child__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "needsBridge", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getBridgeName", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isBridge", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "documentBodyReady", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerRemoteWindow", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "findRemoteWindow", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "registerRemoteSendMessage", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rejectRemoteSendMessage", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendBridgeMessage", function() { return __WEBPACK_IMPORTED_MODULE_2__common__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parent__ = __webpack_require__("./node_modules/post-robot/src/bridge/parent.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "hasBridge", function() { return __WEBPACK_IMPORTED_MODULE_3__parent__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "openBridge", function() { return __WEBPACK_IMPORTED_MODULE_3__parent__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "linkUrl", function() { return __WEBPACK_IMPORTED_MODULE_3__parent__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "destroyBridges", function() { return __WEBPACK_IMPORTED_MODULE_3__parent__["a"]; });





/***/ }),

/***/ "./node_modules/post-robot/src/bridge/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("./node_modules/post-robot/src/bridge/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "openBridge", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["openBridge"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkUrl", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["linkUrl"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isBridge", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["isBridge"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "needsBridge", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["needsBridge"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["needsBridgeForBrowser"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasBridge", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["hasBridge"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["needsBridgeForWin"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["needsBridgeForDomain"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["openTunnelToOpener"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "destroyBridges", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["destroyBridges"]; });


/***/ }),

/***/ "./node_modules/post-robot/src/bridge/parent.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasBridge;
/* harmony export (immutable) */ __webpack_exports__["d"] = openBridge;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = destroyBridges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__("./node_modules/post-robot/src/bridge/common.js");










__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges || {};
__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames || {};

__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByWin = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByWin || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();
__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName || {};

function listenForRegister(source, domain) {
    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].on(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.OPEN_TUNNEL, { window: source, domain: domain }, function (_ref) {
        var origin = _ref.origin,
            data = _ref.data;


        if (origin !== domain) {
            throw new Error('Domain ' + domain + ' does not match origin ' + origin);
        }

        if (!data.name) {
            throw new Error('Register window expected to be passed window name');
        }

        if (!data.sendMessage) {
            throw new Error('Register window expected to be passed sendMessage method');
        }

        if (!__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name]) {
            throw new Error('Window with name ' + data.name + ' does not exist, or was not opened by this window');
        }

        if (!__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name].domain) {
            throw new Error('We do not have a registered domain for window ' + data.name);
        }

        if (__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name].domain !== origin) {
            throw new Error('Message origin ' + origin + ' does not matched registered window origin ' + __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name].domain);
        }

        Object(__WEBPACK_IMPORTED_MODULE_6__common__["i" /* registerRemoteSendMessage */])(__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name].win, domain, data.sendMessage);

        return {
            sendMessage: function sendMessage(message) {

                if (!window || window.closed) {
                    return;
                }

                var winDetails = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[data.name];

                if (!winDetails) {
                    return;
                }

                try {
                    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].receiveMessage({
                        data: message,
                        origin: winDetails.domain,
                        source: winDetails.win
                    });
                } catch (err) {
                    __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].reject(err);
                }
            }
        };
    });
}

function openBridgeFrame(name, url) {

    __WEBPACK_IMPORTED_MODULE_4__lib__["i" /* log */].debug('Opening bridge:', name, url);

    var iframe = document.createElement('iframe');

    iframe.setAttribute('name', name);
    iframe.setAttribute('id', name);

    iframe.setAttribute('style', 'display: none; margin: 0; padding: 0; border: 0px none; overflow: hidden;');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('border', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('allowTransparency', 'true');

    iframe.setAttribute('tabindex', '-1');
    iframe.setAttribute('hidden', 'true');
    iframe.setAttribute('title', '');
    iframe.setAttribute('role', 'presentation');

    iframe.src = url;

    return iframe;
}

function hasBridge(url, domain) {
    domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);
    return Boolean(__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges[domain]);
}

function openBridge(url, domain) {

    domain = domain || Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);

    if (__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges[domain]) {
        return __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges[domain];
    }

    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges[domain] = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])() === domain) {
            throw new Error('Can not open bridge on the same domain as current domain: ' + domain);
        }

        var name = Object(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* getBridgeName */])(domain);
        var frame = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["h" /* getFrameByName */])(window, name);

        if (frame) {
            throw new Error('Frame with name ' + name + ' already exists on page');
        }

        var iframe = openBridgeFrame(name, url);
        __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames[domain] = iframe;

        return __WEBPACK_IMPORTED_MODULE_6__common__["a" /* documentBodyReady */].then(function (body) {

            body.appendChild(iframe);

            var bridge = iframe.contentWindow;

            listenForRegister(bridge, domain);

            return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

                iframe.onload = resolve;
                iframe.onerror = reject;
            }).then(function () {

                return Object(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* onWindowReady */])(bridge, __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].BRIDGE_TIMEOUT, 'Bridge ' + url);
            }).then(function () {

                return bridge;
            });
        });
    });

    return __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges[domain];
}

var windowOpen = window.open;

window.open = function (url, name, options, last) {

    var domain = url;

    if (url && url.indexOf(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].MOCK_PROTOCOL) === 0) {
        var _url$split = url.split('|');

        domain = _url$split[0];
        url = _url$split[1];
    }

    if (domain) {
        domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(domain);
    }

    var win = windowOpen.call(this, url, name, options, last);

    if (!win) {
        return win;
    }

    if (url) {
        Object(__WEBPACK_IMPORTED_MODULE_6__common__["j" /* registerRemoteWindow */])(win);
    }

    for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var winName = _ref2;

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[winName].win)) {
            delete __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[winName];
        }
    }

    if (name && win) {
        var winOptions = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByWin.get(win) || __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[name] || {};

        winOptions.name = winOptions.name || name;
        winOptions.win = winOptions.win || win;
        winOptions.domain = winOptions.domain || domain;

        __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByWin.set(win, winOptions);
        __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByName[name] = winOptions;
    }

    return win;
};

function linkUrl(win, url) {

    var winOptions = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].popupWindowsByWin.get(win);

    if (winOptions) {
        winOptions.domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);
        Object(__WEBPACK_IMPORTED_MODULE_6__common__["j" /* registerRemoteWindow */])(win);
    }
}

function destroyBridges() {
    for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
        }

        var domain = _ref3;

        var frame = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames[domain];
        if (frame.parentNode) {
            frame.parentNode.removeChild(frame);
        }
    }
    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridgeFrames = {};
    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].bridges = {};
}

/***/ }),

/***/ "./node_modules/post-robot/src/clean.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cleanUpWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");


function cleanUpWindow(win) {

    // global.tunnelWindows
    // global.bridges
    // global.popupWindowsByName
    // global.responseListeners
    // global.requestListeners

    var requestPromises = __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].requestPromises.get(win);

    if (requestPromises) {
        for (var _iterator = requestPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var promise = _ref;

            promise.reject(new Error('No response from window - cleaned up'));
        }
    }

    if (__WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].popupWindowsByWin) {
        __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].popupWindowsByWin['delete'](win);
    }

    if (__WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].remoteWindows) {
        __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].remoteWindows['delete'](win);
    }

    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].requestPromises['delete'](win);
    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].methods['delete'](win);
    __WEBPACK_IMPORTED_MODULE_0__global__["a" /* global */].readyPromises['delete'](win);
}

/***/ }),

/***/ "./node_modules/post-robot/src/compat/ie.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = emulateIERestrictions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");




function emulateIERestrictions(sourceWindow, targetWindow) {
    if (!__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].ALLOW_POSTMESSAGE_POPUP) {

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["v" /* isSameTopWindow */])(sourceWindow, targetWindow) === false) {
            throw new Error('Can not send and receive post messages between two different windows (disabled to emulate IE)');
        }
    }
}

/***/ }),

/***/ "./node_modules/post-robot/src/compat/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ie__ = __webpack_require__("./node_modules/post-robot/src/compat/ie.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "emulateIERestrictions", function() { return __WEBPACK_IMPORTED_MODULE_0__ie__["a"]; });


/***/ }),

/***/ "./node_modules/post-robot/src/conf/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./node_modules/post-robot/src/conf/constants.js");
var _ALLOWED_POST_MESSAGE;



var CONFIG = {

    ALLOW_POSTMESSAGE_POPUP: '__ALLOW_POSTMESSAGE_POPUP__' in window ? window.__ALLOW_POSTMESSAGE_POPUP__ : true,

    LOG_LEVEL: 'info',

    BRIDGE_TIMEOUT: 5000,
    CHILD_WINDOW_TIMEOUT: 5000,

    ACK_TIMEOUT: window.navigator.userAgent.match(/MSIE/i) !== -1 && !false ? 2000 : 1000,
    RES_TIMEOUT:  false ? 2000 : Infinity,

    LOG_TO_PAGE: false,

    ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.POST_MESSAGE] = true, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.BRIDGE] = true, _ALLOWED_POST_MESSAGE[__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].SEND_STRATEGIES.GLOBAL] = true, _ALLOWED_POST_MESSAGE),

    ALLOW_SAME_ORIGIN: false
};

if (window.location.href.indexOf(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
    CONFIG.ALLOW_POSTMESSAGE_POPUP = true;
}

/***/ }),

/***/ "./node_modules/post-robot/src/conf/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSTANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST_MESSAGE_NAMES_LIST; });
var CONSTANTS = {

    POST_MESSAGE_TYPE: {
        REQUEST: 'postrobot_message_request',
        RESPONSE: 'postrobot_message_response',
        ACK: 'postrobot_message_ack'
    },

    POST_MESSAGE_ACK: {
        SUCCESS: 'success',
        ERROR: 'error'
    },

    POST_MESSAGE_NAMES: {
        METHOD: 'postrobot_method',
        READY: 'postrobot_ready',
        OPEN_TUNNEL: 'postrobot_open_tunnel'
    },

    WINDOW_TYPES: {
        FULLPAGE: 'fullpage',
        POPUP: 'popup',
        IFRAME: 'iframe'
    },

    WINDOW_PROPS: {
        POSTROBOT: '__postRobot__'
    },

    SERIALIZATION_TYPES: {
        METHOD: 'postrobot_method',
        ERROR: 'postrobot_error',
        PROMISE: 'postrobot_promise',
        ZALGO_PROMISE: 'postrobot_zalgo_promise',
        REGEX: 'regex'
    },

    SEND_STRATEGIES: {
        POST_MESSAGE: 'postrobot_post_message',
        BRIDGE: 'postrobot_bridge',
        GLOBAL: 'postrobot_global'
    },

    MOCK_PROTOCOL: 'mock:',
    FILE_PROTOCOL: 'file:',

    BRIDGE_NAME_PREFIX: '__postrobot_bridge__',
    POSTROBOT_PROXY: '__postrobot_proxy__',

    WILDCARD: '*'
};

var POST_MESSAGE_NAMES_LIST = Object.keys(CONSTANTS.POST_MESSAGE_NAMES).map(function (key) {
    return CONSTANTS.POST_MESSAGE_NAMES[key];
});

/***/ }),

/***/ "./node_modules/post-robot/src/conf/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./node_modules/post-robot/src/conf/config.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./node_modules/post-robot/src/conf/constants.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["b"]; });



/***/ }),

/***/ "./node_modules/post-robot/src/drivers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__receive__ = __webpack_require__("./node_modules/post-robot/src/drivers/receive/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__receive__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__receive__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__send__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__send__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listeners__ = __webpack_require__("./node_modules/post-robot/src/drivers/listeners.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__listeners__["g"]; });




/***/ }),

/***/ "./node_modules/post-robot/src/drivers/listeners.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetListeners */
/* harmony export (immutable) */ __webpack_exports__["b"] = addResponseListener;
/* harmony export (immutable) */ __webpack_exports__["e"] = getResponseListener;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteResponseListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = markResponseListenerErrored;
/* harmony export (immutable) */ __webpack_exports__["f"] = isResponseListenerErrored;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRequestListener;
/* harmony export (immutable) */ __webpack_exports__["a"] = addRequestListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");








function resetListeners() {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners = {};
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners = {};
}

__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners || {};
__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners || {};
__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD || new function WindowWildcard() {/* pass */}();

__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners || {};

var __DOMAIN_REGEX__ = '__domain_regex__';

function addResponseListener(hash, listener) {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash] = listener;
}

function getResponseListener(hash) {
    return __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash];
}

function deleteResponseListener(hash) {
    delete __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].responseListeners[hash];
}

function markResponseListenerErrored(hash) {
    __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners[hash] = true;
}

function isResponseListenerErrored(hash) {
    return Boolean(__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].erroredResponseListeners[hash]);
}

function getRequestListener(_ref) {
    var name = _ref.name,
        win = _ref.win,
        domain = _ref.domain;


    if (win === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        win = null;
    }

    if (domain === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        domain = null;
    }

    if (!name) {
        throw new Error('Name required to get request listener');
    }

    var nameListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners[name];

    if (!nameListeners) {
        return;
    }

    var _arr = [win, __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD];
    for (var _i = 0; _i < _arr.length; _i++) {
        var winQualifier = _arr[_i];

        var winListeners = winQualifier && nameListeners.get(winQualifier);

        if (!winListeners) {
            continue;
        }

        if (domain && typeof domain === 'string') {
            if (winListeners[domain]) {
                return winListeners[domain];
            }

            if (winListeners[__DOMAIN_REGEX__]) {
                for (var _iterator = winListeners[__DOMAIN_REGEX__], _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref3;

                    if (_isArray) {
                        if (_i2 >= _iterator.length) break;
                        _ref3 = _iterator[_i2++];
                    } else {
                        _i2 = _iterator.next();
                        if (_i2.done) break;
                        _ref3 = _i2.value;
                    }

                    var _ref4 = _ref3;
                    var regex = _ref4.regex,
                        listener = _ref4.listener;

                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["A" /* matchDomain */])(regex, domain)) {
                        return listener;
                    }
                }
            }
        }

        if (winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD]) {
            return winListeners[__WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD];
        }
    }
}

function addRequestListener(_ref5, listener) {
    var name = _ref5.name,
        win = _ref5.win,
        domain = _ref5.domain;


    if (!name || typeof name !== 'string') {
        throw new Error('Name required to add request listener');
    }

    if (Array.isArray(win)) {
        var listenersCollection = [];

        for (var _iterator2 = win, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref6;

            if (_isArray2) {
                if (_i3 >= _iterator2.length) break;
                _ref6 = _iterator2[_i3++];
            } else {
                _i3 = _iterator2.next();
                if (_i3.done) break;
                _ref6 = _i3.value;
            }

            var item = _ref6;

            listenersCollection.push(addRequestListener({ name: name, domain: domain, win: item }, listener));
        }

        return {
            cancel: function cancel() {
                for (var _iterator3 = listenersCollection, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                    var _ref7;

                    if (_isArray3) {
                        if (_i4 >= _iterator3.length) break;
                        _ref7 = _iterator3[_i4++];
                    } else {
                        _i4 = _iterator3.next();
                        if (_i4.done) break;
                        _ref7 = _i4.value;
                    }

                    var cancelListener = _ref7;

                    cancelListener.cancel();
                }
            }
        };
    }

    if (Array.isArray(domain)) {
        var _listenersCollection = [];

        for (var _iterator4 = domain, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref8;

            if (_isArray4) {
                if (_i5 >= _iterator4.length) break;
                _ref8 = _iterator4[_i5++];
            } else {
                _i5 = _iterator4.next();
                if (_i5.done) break;
                _ref8 = _i5.value;
            }

            var _item = _ref8;

            _listenersCollection.push(addRequestListener({ name: name, win: win, domain: _item }, listener));
        }

        return {
            cancel: function cancel() {
                for (var _iterator5 = _listenersCollection, _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
                    var _ref9;

                    if (_isArray5) {
                        if (_i6 >= _iterator5.length) break;
                        _ref9 = _iterator5[_i6++];
                    } else {
                        _i6 = _iterator5.next();
                        if (_i6.done) break;
                        _ref9 = _i6.value;
                    }

                    var cancelListener = _ref9;

                    cancelListener.cancel();
                }
            }
        };
    }

    var existingListener = getRequestListener({ name: name, win: win, domain: domain });

    if (!win || win === __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD) {
        win = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD;
    }

    domain = domain || __WEBPACK_IMPORTED_MODULE_5__conf__["b" /* CONSTANTS */].WILDCARD;

    if (existingListener) {
        if (win && domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain.toString() + ' for ' + (win === __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window');
        } else if (win) {
            throw new Error('Request listener already exists for ' + name + ' for ' + (win === __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].WINDOW_WILDCARD ? 'wildcard' : 'specified') + ' window');
        } else if (domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain.toString());
        } else {
            throw new Error('Request listener already exists for ' + name);
        }
    }

    var requestListeners = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].requestListeners;

    var nameListeners = requestListeners[name];

    if (!nameListeners) {
        nameListeners = new __WEBPACK_IMPORTED_MODULE_1_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();
        requestListeners[name] = nameListeners;
    }

    var winListeners = nameListeners.get(win);

    if (!winListeners) {
        winListeners = {};
        nameListeners.set(win, winListeners);
    }

    var strDomain = domain.toString();

    var regexListeners = winListeners[__DOMAIN_REGEX__];
    var regexListener = void 0;

    if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* isRegex */])(domain)) {

        if (!regexListeners) {
            regexListeners = [];
            winListeners[__DOMAIN_REGEX__] = regexListeners;
        }

        regexListener = { regex: domain, listener: listener };

        regexListeners.push(regexListener);
    } else {
        winListeners[strDomain] = listener;
    }

    return {
        cancel: function cancel() {
            if (!winListeners) {
                return;
            }

            delete winListeners[strDomain];

            if (win && Object.keys(winListeners).length === 0) {
                nameListeners['delete'](win);
            }

            if (regexListener) {
                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
            }
        }
    };
}

/***/ }),

/***/ "./node_modules/post-robot/src/drivers/receive/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export receiveMessage */
/* harmony export (immutable) */ __webpack_exports__["b"] = messageListener;
/* harmony export (immutable) */ __webpack_exports__["a"] = listenForMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__("./node_modules/post-robot/src/drivers/receive/types.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages = __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages || [];

function parseMessage(message) {

    var parsedMessage = void 0;

    try {
        parsedMessage = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["f" /* jsonParse */])(message);
    } catch (err) {
        return;
    }

    if (!parsedMessage) {
        return;
    }

    if ((typeof parsedMessage === 'undefined' ? 'undefined' : _typeof(parsedMessage)) !== 'object' || parsedMessage === null) {
        return;
    }

    parsedMessage = parsedMessage[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT];

    if (!parsedMessage || (typeof parsedMessage === 'undefined' ? 'undefined' : _typeof(parsedMessage)) !== 'object' || parsedMessage === null) {
        return;
    }

    if (!parsedMessage.type || typeof parsedMessage.type !== 'string') {
        return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_4__types__["a" /* RECEIVE_MESSAGE_TYPES */][parsedMessage.type]) {
        return;
    }

    return parsedMessage;
}

function receiveMessage(event) {

    if (!window || window.closed) {
        throw new Error('Message recieved in closed window');
    }

    try {
        if (!event.source) {
            return;
        }
    } catch (err) {
        return;
    }

    var source = event.source,
        origin = event.origin,
        data = event.data;


    var message = parseMessage(data);

    if (!message) {
        return;
    }

    if (!message.sourceDomain || typeof message.sourceDomain !== 'string') {
        throw new Error('Expected message to have sourceDomain');
    }

    if (message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].MOCK_PROTOCOL) === 0 || message.sourceDomain.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
        origin = message.sourceDomain;
    }

    if (__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages.indexOf(message.id) === -1) {
        __WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receivedMessages.push(message.id);
    } else {
        return;
    }

    var level = void 0;

    if (__WEBPACK_IMPORTED_MODULE_1__conf__["c" /* POST_MESSAGE_NAMES_LIST */].indexOf(message.name) !== -1 || message.type === __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK) {
        level = 'debug';
    } else if (message.ack === 'error') {
        level = 'error';
    } else {
        level = 'info';
    }

    __WEBPACK_IMPORTED_MODULE_2__lib__["i" /* log */].logLevel(level, ['\n\n\t', '#receive', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', origin, '\n\n', message]);

    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["y" /* isWindowClosed */])(source)) {
        __WEBPACK_IMPORTED_MODULE_2__lib__["i" /* log */].debug('Source window is closed - can not send ' + message.type + ' ' + message.name);
        return;
    }

    if (message.data) {
        message.data = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* deserializeMethods */])(source, origin, message.data);
    }

    __WEBPACK_IMPORTED_MODULE_4__types__["a" /* RECEIVE_MESSAGE_TYPES */][message.type](source, origin, message);
}

function messageListener(event) {

    try {
        event.source; // eslint-disable-line
    } catch (err) {
        return;
    }

    // $FlowFixMe
    var messageEvent = {
        source: event.source || event.sourceElement,
        origin: event.origin || event.originalEvent && event.originalEvent.origin,
        data: event.data
    };

    if (true) {
        try {
            __webpack_require__("./node_modules/post-robot/src/compat/index.js").emulateIERestrictions(messageEvent.source, window);
        } catch (err) {
            return;
        }
    }

    receiveMessage(messageEvent);
}

function listenForMessages() {
    Object(__WEBPACK_IMPORTED_MODULE_2__lib__["a" /* addEventListener */])(window, 'message', messageListener);
}

__WEBPACK_IMPORTED_MODULE_3__global__["a" /* global */].receiveMessage = receiveMessage;

/***/ }),

/***/ "./node_modules/post-robot/src/drivers/receive/types.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_MESSAGE_TYPES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__send__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__listeners__ = __webpack_require__("./node_modules/post-robot/src/drivers/listeners.js");
var _RECEIVE_MESSAGE_TYPE;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var RECEIVE_MESSAGE_TYPES = (_RECEIVE_MESSAGE_TYPE = {}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK] = function (source, origin, message) {

    if (Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["f" /* isResponseListenerErrored */])(message.hash)) {
        return;
    }

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["e" /* getResponseListener */])(message.hash);

    if (!options) {
        throw new Error('No handler found for post message ack for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["A" /* matchDomain */])(options.domain, origin)) {
        throw new Error('Ack origin ' + origin + ' does not match domain ' + options.domain.toString());
    }

    options.ack = true;
}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.REQUEST] = function (source, origin, message) {

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["d" /* getRequestListener */])({ name: message.name, win: source, domain: origin });

    function respond(data) {

        if (message.fireAndForget || Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["y" /* isWindowClosed */])(source)) {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_4__send__["a" /* sendMessage */])(source, _extends({
            target: message.originalSource,
            hash: message.hash,
            name: message.name
        }, data), origin);
    }

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([respond({
        type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK
    }), __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!options) {
            throw new Error('No handler found for post message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["A" /* matchDomain */])(options.domain, origin)) {
            throw new Error('Request origin ' + origin + ' does not match domain ' + options.domain.toString());
        }

        var data = message.data;

        return options.handler({ source: source, origin: origin, data: data });
    }).then(function (data) {

        return respond({
            type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE,
            ack: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.SUCCESS,
            data: data
        });
    }, function (err) {

        var error = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err).replace(/^Error: /, '');
        // $FlowFixMe
        var code = err.code;

        return respond({
            type: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE,
            ack: __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.ERROR,
            error: error,
            code: code
        });
    })]).then(__WEBPACK_IMPORTED_MODULE_3__lib__["j" /* noop */])['catch'](function (err) {

        if (options && options.handleError) {
            return options.handleError(err);
        } else {
            __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].error(Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err));
        }
    });
}, _RECEIVE_MESSAGE_TYPE[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.RESPONSE] = function (source, origin, message) {

    if (Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["f" /* isResponseListenerErrored */])(message.hash)) {
        return;
    }

    var options = Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["e" /* getResponseListener */])(message.hash);

    if (!options) {
        throw new Error('No handler found for post message response for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["A" /* matchDomain */])(options.domain, origin)) {
        throw new Error('Response origin ' + origin + ' does not match domain ' + options.domain);
    }

    Object(__WEBPACK_IMPORTED_MODULE_5__listeners__["c" /* deleteResponseListener */])(message.hash);

    if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.ERROR) {
        var err = new Error(message.error);
        if (message.code) {
            // $FlowFixMe
            err.code = message.code;
        }
        return options.respond(err, null);
    } else if (message.ack === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_ACK.SUCCESS) {
        var data = message.data || message.response;

        return options.respond(null, { source: source, origin: origin, data: data });
    }
}, _RECEIVE_MESSAGE_TYPE);

/***/ }),

/***/ "./node_modules/post-robot/src/drivers/send/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__strategies__ = __webpack_require__("./node_modules/post-robot/src/drivers/send/strategies.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function buildMessage(win, message) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    var id = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["p" /* uniqueID */])();
    var type = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getWindowType */])();
    var sourceDomain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window);

    return _extends({}, message, options, {
        sourceDomain: sourceDomain,
        id: message.id || id,
        windowType: type
    });
}

function sendMessage(win, message, domain) {
    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        var _jsonStringify;

        message = buildMessage(win, message, {
            data: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["n" /* serializeMethods */])(win, domain, message.data),
            domain: domain
        });

        var level = void 0;

        if (__WEBPACK_IMPORTED_MODULE_2__conf__["c" /* POST_MESSAGE_NAMES_LIST */].indexOf(message.name) !== -1 || message.type === __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.ACK) {
            level = 'debug';
        } else if (message.ack === 'error') {
            level = 'error';
        } else {
            level = 'info';
        }

        __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].logLevel(level, ['\n\n\t', '#send', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', domain || __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WILDCARD, '\n\n', message]);

        if (win === window && !__WEBPACK_IMPORTED_MODULE_2__conf__["a" /* CONFIG */].ALLOW_SAME_ORIGIN) {
            throw new Error('Attemping to send message to self');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {
            throw new Error('Window is closed');
        }

        __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].debug('Running send message strategies', message);

        var messages = [];

        var serializedMessage = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["g" /* jsonStringify */])((_jsonStringify = {}, _jsonStringify[__WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] = message, _jsonStringify), null, 2);

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].map(Object.keys(__WEBPACK_IMPORTED_MODULE_4__strategies__["a" /* SEND_MESSAGE_STRATEGIES */]), function (strategyName) {

            return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                if (!__WEBPACK_IMPORTED_MODULE_2__conf__["a" /* CONFIG */].ALLOWED_POST_MESSAGE_METHODS[strategyName]) {
                    throw new Error('Strategy disallowed: ' + strategyName);
                }

                return __WEBPACK_IMPORTED_MODULE_4__strategies__["a" /* SEND_MESSAGE_STRATEGIES */][strategyName](win, serializedMessage, domain);
            }).then(function () {
                messages.push(strategyName + ': success');
                return true;
            }, function (err) {
                messages.push(strategyName + ': ' + Object(__WEBPACK_IMPORTED_MODULE_3__lib__["o" /* stringifyError */])(err) + '\n');
                return false;
            });
        }).then(function (results) {

            var success = results.some(Boolean);
            var status = message.type + ' ' + message.name + ' ' + (success ? 'success' : 'error') + ':\n  - ' + messages.join('\n  - ') + '\n';

            __WEBPACK_IMPORTED_MODULE_3__lib__["i" /* log */].debug(status);

            if (!success) {
                throw new Error(status);
            }
        });
    });
}

/***/ }),

/***/ "./node_modules/post-robot/src/drivers/send/strategies.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEND_MESSAGE_STRATEGIES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");




var SEND_MESSAGE_STRATEGIES = {};

SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].SEND_STRATEGIES.POST_MESSAGE] = function (win, serializedMessage, domain) {

    if (true) {
        try {
            __webpack_require__("./node_modules/post-robot/src/compat/index.js").emulateIERestrictions(window, win);
        } catch (err) {
            return;
        }
    }

    var domains = void 0;

    if (Array.isArray(domain)) {
        domains = domain;
    } else if (domain) {
        domains = [domain];
    } else {
        domains = [__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD];
    }

    domains = domains.map(function (dom) {

        if (dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].MOCK_PROTOCOL) === 0) {

            if (window.location.protocol === __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) {
                return __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD;
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["o" /* isActuallySameDomain */])(win)) {
                throw new Error('Attempting to send messsage to mock domain ' + dom + ', but window is actually cross-domain');
            }

            // $FlowFixMe
            return Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["b" /* getActualDomain */])(win);
        }

        if (dom.indexOf(__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].FILE_PROTOCOL) === 0) {
            return __WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WILDCARD;
        }

        return dom;
    });

    domains.forEach(function (dom) {
        return win.postMessage(serializedMessage, dom);
    });
};

if (true) {
    var _require = __webpack_require__("./node_modules/post-robot/src/bridge/index.js"),
        sendBridgeMessage = _require.sendBridgeMessage,
        needsBridgeForBrowser = _require.needsBridgeForBrowser,
        isBridge = _require.isBridge;

    SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].SEND_STRATEGIES.BRIDGE] = function (win, serializedMessage, domain) {

        if (!needsBridgeForBrowser() && !isBridge()) {
            return;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {
            throw new Error('Post message through bridge disabled between same domain windows');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["v" /* isSameTopWindow */])(window, win) !== false) {
            throw new Error('Can only use bridge to communicate between two different windows, not between frames');
        }

        return sendBridgeMessage(win, serializedMessage, domain);
    };

    SEND_MESSAGE_STRATEGIES[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].SEND_STRATEGIES.GLOBAL] = function (win, serializedMessage, domain) {

        if (!needsBridgeForBrowser()) {
            return;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {
            throw new Error('Post message through global disabled between different domain windows');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["v" /* isSameTopWindow */])(window, win) !== false) {
            throw new Error('Can only use global to communicate between two different windows, not between frames');
        }

        // $FlowFixMe
        var foreignGlobal = win[__WEBPACK_IMPORTED_MODULE_1__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT];

        if (!foreignGlobal) {
            throw new Error('Can not find postRobot global on foreign window');
        }

        return foreignGlobal.receiveMessage({
            source: window,
            origin: Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(),
            data: serializedMessage
        });
    };
}

/***/ }),

/***/ "./node_modules/post-robot/src/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");


var global = window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] = window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT] || {};

// Backwards compatibility

global.registerSelf = function () {
    // pass
};

/***/ }),

/***/ "./node_modules/post-robot/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/post-robot/src/interface.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["cleanUpWindow"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Promise"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "bridge", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["bridge"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["init"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parent", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["parent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "send", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["send"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["request"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendToParent", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["sendToParent"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "client", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["client"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "on", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["on"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listen", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["listen"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["once"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listener", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["listener"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONFIG"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONSTANTS"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disable", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["disable"]; });


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),

/***/ "./node_modules/post-robot/src/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bridge", function() { return bridge; });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__public__ = __webpack_require__("./node_modules/post-robot/src/public/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bridge_interface__ = __webpack_require__("./node_modules/post-robot/src/bridge/interface.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parent", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "send", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sendToParent", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "client", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "on", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listen", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "once", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "listener", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONFIG", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "disable", function() { return __WEBPACK_IMPORTED_MODULE_3__public__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clean__ = __webpack_require__("./node_modules/post-robot/src/clean.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cleanUpWindow", function() { return __WEBPACK_IMPORTED_MODULE_5__clean__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_6_zalgo_promise_src__["a"]; });





///////////////////////////

/////////




var bridge =  true ? __WEBPACK_IMPORTED_MODULE_4__bridge_interface__ : null;

function init() {
    if (!__WEBPACK_IMPORTED_MODULE_2__global__["a" /* global */].initialized) {
        Object(__WEBPACK_IMPORTED_MODULE_1__drivers__["d" /* listenForMessages */])();

        if (true) {
            __webpack_require__("./node_modules/post-robot/src/bridge/index.js").openTunnelToOpener();
        }

        Object(__WEBPACK_IMPORTED_MODULE_0__lib__["d" /* initOnReady */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__lib__["h" /* listenForMethods */])({ on: __WEBPACK_IMPORTED_MODULE_3__public__["g" /* on */], send: __WEBPACK_IMPORTED_MODULE_3__public__["k" /* send */] });
    }

    __WEBPACK_IMPORTED_MODULE_2__global__["a" /* global */].initialized = true;
}

init();

/***/ }),

/***/ "./node_modules/post-robot/src/lib/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__util__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serialize__ = __webpack_require__("./node_modules/post-robot/src/lib/serialize.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__serialize__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ready__ = __webpack_require__("./node_modules/post-robot/src/lib/ready.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__ready__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__ready__["b"]; });





/***/ }),

/***/ "./node_modules/post-robot/src/lib/log.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return log; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var LOG_LEVELS = ['debug', 'info', 'warn', 'error'];

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
    ['log', 'info', 'warn', 'error'].forEach(function (method) {
        // $FlowFixMe
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}

var log = {
    clearLogs: function clearLogs() {

        if (window.console && window.console.clear) {
            window.console.clear();
        }

        if (__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_TO_PAGE) {
            var container = document.getElementById('postRobotLogs');

            if (container && container.parentNode) {
                container.parentNode.removeChild(container);
            }
        }
    },
    writeToPage: function writeToPage(level, args) {
        setTimeout(function () {
            var container = document.getElementById('postRobotLogs');

            if (!container) {
                container = document.createElement('div');
                container.id = 'postRobotLogs';
                container.style.cssText = 'width: 800px; font-family: monospace; white-space: pre-wrap;';
                if (document.body) {
                    document.body.appendChild(container);
                }
            }

            var el = document.createElement('div');

            var date = new Date().toString().split(' ')[4];

            var payload = Array.prototype.slice.call(args).map(function (item) {
                if (typeof item === 'string') {
                    return item;
                }
                if (!item) {
                    return Object.prototype.toString.call(item);
                }
                var json = void 0;
                try {
                    json = Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* jsonStringify */])(item, null, 2);
                } catch (e) {
                    json = '[object]';
                }

                return '\n\n' + json + '\n\n';
            }).join(' ');

            var msg = date + ' ' + level + ' ' + payload;
            el.innerHTML = msg;

            var color = {
                log: '#ddd',
                warn: 'orange',
                error: 'red',
                info: 'blue',
                debug: '#aaa'
            }[level];

            el.style.cssText = 'margin-top: 10px; color: ' + color + ';';

            if (!container.childNodes.length) {
                container.appendChild(el);
            } else {
                container.insertBefore(el, container.childNodes[0]);
            }
        });
    },
    logLevel: function logLevel(level, args) {
        setTimeout(function () {
            try {
                var logLevel = window.LOG_LEVEL || __WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_LEVEL;

                if (LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(logLevel)) {
                    return;
                }

                args = Array.prototype.slice.call(args);

                args.unshift('' + window.location.host + window.location.pathname);
                args.unshift('::');
                args.unshift('' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* getWindowType */])().toLowerCase());
                args.unshift('[post-robot]');

                if (__WEBPACK_IMPORTED_MODULE_1__conf__["a" /* CONFIG */].LOG_TO_PAGE) {
                    log.writeToPage(level, args);
                }

                if (!window.console) {
                    return;
                }

                if (!window.console[level]) {
                    level = 'log';
                }

                if (!window.console[level]) {
                    return;
                }

                window.console[level].apply(window.console, args);
            } catch (err) {
                // pass
            }
        }, 1);
    },
    debug: function debug() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        log.logLevel('debug', args);
    },
    info: function info() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        log.logLevel('info', args);
    },
    warn: function warn() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        log.logLevel('warn', args);
    },
    error: function error() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
        }

        log.logLevel('error', args);
    }
};

/***/ }),

/***/ "./node_modules/post-robot/src/lib/ready.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initOnReady;
/* harmony export (immutable) */ __webpack_exports__["b"] = onWindowReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");









__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function initOnReady() {

    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].on(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.READY, { domain: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD }, function (event) {

        var win = event.source;
        var promise = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises.get(win);

        if (promise) {
            promise.resolve(event);
        } else {
            promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]().resolve(event);
            __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises.set(win, promise);
        }
    });

    var parent = Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["d" /* getAncestor */])();

    if (parent) {
        __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].send(parent, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.READY, {}, { domain: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD, timeout: Infinity })['catch'](function (err) {
            __WEBPACK_IMPORTED_MODULE_4__log__["a" /* log */].debug(Object(__WEBPACK_IMPORTED_MODULE_6__util__["j" /* stringifyError */])(err));
        });
    }
}

function onWindowReady(win) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Window';


    var promise = __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises.get(win);

    if (promise) {
        return promise;
    }

    promise = new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]();
    __WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].readyPromises.set(win, promise);

    if (timeout !== -1) {
        setTimeout(function () {
            return promise.reject(new Error(name + ' did not load after ' + timeout + 'ms'));
        }, timeout);
    }

    return promise;
}

/***/ }),

/***/ "./node_modules/post-robot/src/lib/serialize.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listenForMethods; });
/* unused harmony export serializeMethod */
/* harmony export (immutable) */ __webpack_exports__["c"] = serializeMethods;
/* unused harmony export deserializeMethod */
/* unused harmony export deserializeError */
/* unused harmony export deserializeZalgoPromise */
/* unused harmony export deserializePromise */
/* unused harmony export deserializeRegex */
/* harmony export (immutable) */ __webpack_exports__["a"] = deserializeMethods;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./node_modules/post-robot/src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__log__ = __webpack_require__("./node_modules/post-robot/src/lib/log.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










__WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].methods = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].methods || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

var listenForMethods = Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* once */])(function () {
    __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].on(__WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.METHOD, { origin: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD }, function (_ref) {
        var source = _ref.source,
            origin = _ref.origin,
            data = _ref.data;


        var methods = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].methods.get(source);

        if (!methods) {
            throw new Error('Could not find any methods this window has privileges to call');
        }

        var meth = methods[data.id];

        if (!meth) {
            throw new Error('Could not find method with id: ' + data.id);
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["A" /* matchDomain */])(meth.domain, origin)) {
            throw new Error('Method domain ' + meth.domain + ' does not match origin ' + origin);
        }

        __WEBPACK_IMPORTED_MODULE_5__log__["a" /* log */].debug('Call local method', data.name, data.args);

        return __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return meth.method.apply({ source: source, origin: origin, data: data }, data.args);
        }).then(function (result) {

            return {
                result: result,
                id: data.id,
                name: data.name
            };
        });
    });
});

function isSerialized(item, type) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && item.__type__ === type;
}

function serializeMethod(destination, domain, method, name) {

    var id = Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* uniqueID */])();

    var methods = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].methods.get(destination);

    if (!methods) {
        methods = {};
        __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].methods.set(destination, methods);
    }

    methods[id] = { domain: domain, method: method };

    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.METHOD,
        __id__: id,
        __name__: name
    };
}

function serializeError(err) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ERROR,
        __message__: Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* stringifyError */])(err),
        // $FlowFixMe
        __code__: err.code
    };
}

function serializePromise(destination, domain, promise, name) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.PROMISE,
        __then__: serializeMethod(destination, domain, function (resolve, reject) {
            return promise.then(resolve, reject);
        }, name + '.then')
    };
}

function serializeZalgoPromise(destination, domain, promise, name) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ZALGO_PROMISE,
        __then__: serializeMethod(destination, domain, function (resolve, reject) {
            return promise.then(resolve, reject);
        }, name + '.then')
    };
}

function serializeRegex(regex) {
    return {
        __type__: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.REGEX,
        __source__: regex.source
    };
}

function serializeMethods(destination, domain, obj) {

    return Object(__WEBPACK_IMPORTED_MODULE_4__util__["h" /* replaceObject */])({ obj: obj }, function (item, key) {
        if (typeof item === 'function') {
            return serializeMethod(destination, domain, item, key.toString());
        }

        if (item instanceof Error) {
            return serializeError(item);
        }

        if (window.Promise && item instanceof window.Promise) {
            return serializePromise(destination, domain, item, key.toString());
        }

        if (__WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */].isPromise(item)) {
            // $FlowFixMe
            return serializeZalgoPromise(destination, domain, item, key.toString());
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* isRegex */])(item)) {
            // $FlowFixMe
            return serializeRegex(item);
        }
    }).obj;
}

function deserializeMethod(source, origin, obj) {

    function wrapper() {
        var args = Array.prototype.slice.call(arguments);
        __WEBPACK_IMPORTED_MODULE_5__log__["a" /* log */].debug('Call foreign method', obj.__name__, args);
        return __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].send(source, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_NAMES.METHOD, {
            id: obj.__id__,
            name: obj.__name__,
            args: args

        }, { domain: origin, timeout: Infinity }).then(function (_ref2) {
            var data = _ref2.data;


            __WEBPACK_IMPORTED_MODULE_5__log__["a" /* log */].debug('Got foreign method result', obj.__name__, data.result);
            return data.result;
        }, function (err) {
            __WEBPACK_IMPORTED_MODULE_5__log__["a" /* log */].debug('Got foreign method error', Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* stringifyError */])(err));
            throw err;
        });
    }

    wrapper.__name__ = obj.__name__;
    wrapper.__xdomain__ = true;

    wrapper.source = source;
    wrapper.origin = origin;

    return wrapper;
}

function deserializeError(source, origin, obj) {
    var err = new Error(obj.__message__);
    if (obj.__code__) {
        // $FlowFixMe
        err.code = obj.__code__;
    }
    return err;
}

function deserializeZalgoPromise(source, origin, prom) {
    return new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
    });
}

function deserializePromise(source, origin, prom) {
    if (!window.Promise) {
        return deserializeZalgoPromise(source, origin, prom);
    }

    return new window.Promise(function (resolve, reject) {
        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
    });
}

function deserializeRegex(source, origin, item) {
    return new RegExp(item.__source__);
}

function deserializeMethods(source, origin, obj) {

    return Object(__WEBPACK_IMPORTED_MODULE_4__util__["h" /* replaceObject */])({ obj: obj }, function (item, key) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) !== 'object' || item === null) {
            return;
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.METHOD)) {
            return deserializeMethod(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ERROR)) {
            return deserializeError(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.PROMISE)) {
            return deserializePromise(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.ZALGO_PROMISE)) {
            return deserializeZalgoPromise(source, origin, item);
        }

        if (isSerialized(item, __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].SERIALIZATION_TYPES.REGEX)) {
            return deserializeRegex(source, origin, item);
        }
    }).obj;
}

/***/ }),

/***/ "./node_modules/post-robot/src/lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = stringifyError;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return once; });
/* harmony export (immutable) */ __webpack_exports__["f"] = noop;
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListener;
/* harmony export (immutable) */ __webpack_exports__["k"] = uniqueID;
/* unused harmony export eachArray */
/* unused harmony export eachObject */
/* unused harmony export each */
/* harmony export (immutable) */ __webpack_exports__["h"] = replaceObject;
/* harmony export (immutable) */ __webpack_exports__["i"] = safeInterval;
/* harmony export (immutable) */ __webpack_exports__["c"] = isRegex;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return weakMapMemoize; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getWindowType;
/* harmony export (immutable) */ __webpack_exports__["e"] = jsonStringify;
/* harmony export (immutable) */ __webpack_exports__["d"] = jsonParse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





function stringifyError(err) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;


    if (level >= 3) {
        return 'stringifyError stack overflow';
    }

    try {
        if (!err) {
            return '<unknown error: ' + Object.prototype.toString.call(err) + '>';
        }

        if (typeof err === 'string') {
            return err;
        }

        if (err instanceof Error) {
            var stack = err && err.stack;
            var message = err && err.message;

            if (stack && message) {
                if (stack.indexOf(message) !== -1) {
                    return stack;
                } else {
                    return message + '\n' + stack;
                }
            } else if (stack) {
                return stack;
            } else if (message) {
                return message;
            }
        }

        if (typeof err.toString === 'function') {
            return err.toString();
        }

        return Object.prototype.toString.call(err);
    } catch (newErr) {
        return 'Error while stringifying error: ' + stringifyError(newErr, level + 1);
    }
}

// eslint-disable-next-line flowtype/no-weak-types
var once = function once(method) {
    if (!method) {
        return method;
    }
    var called = false;
    return function onceWrapper() {
        if (!called) {
            called = true;
            return method.apply(this, arguments);
        }
    };
};

function noop() {
    // pass
}

function addEventListener(obj, event, handler) {
    if (obj.addEventListener) {
        obj.addEventListener(event, handler);
    } else {
        obj.attachEvent('on' + event, handler);
    }

    return {
        cancel: function cancel() {
            if (obj.removeEventListener) {
                obj.removeEventListener(event, handler);
            } else {
                obj.detachEvent('on' + event, handler);
            }
        }
    };
}

function uniqueID() {

    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

function eachArray(item, callback) {
    for (var i = 0; i < item.length; i++) {
        callback(item[i], i);
    }
}

function eachObject(item, callback) {
    for (var _key in item) {
        if (item.hasOwnProperty(_key)) {
            callback(item[_key], _key);
        }
    }
}

function each(item, callback) {
    if (Array.isArray(item)) {
        eachArray(item, callback);
    } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
        eachObject(item, callback);
    }
}

function replaceObject(item, callback) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;


    if (depth >= 100) {
        throw new Error('Self-referential object passed, or object contained too many layers');
    }

    var newobj = void 0;

    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && !Array.isArray(item)) {
        newobj = {};
    } else if (Array.isArray(item)) {
        newobj = [];
    } else {
        throw new Error('Invalid type: ' + (typeof item === 'undefined' ? 'undefined' : _typeof(item)));
    }

    each(item, function (childItem, key) {

        var result = callback(childItem, key);

        if (typeof result !== 'undefined') {
            // $FlowFixMe
            newobj[key] = result;
        } else if ((typeof childItem === 'undefined' ? 'undefined' : _typeof(childItem)) === 'object' && childItem !== null) {
            // $FlowFixMe
            newobj[key] = replaceObject(childItem, callback, depth + 1);
        } else {
            // $FlowFixMe
            newobj[key] = childItem;
        }
    });

    // $FlowFixMe
    return newobj;
}

function safeInterval(method, time) {
    var timeout = void 0;

    function runInterval() {
        timeout = setTimeout(runInterval, time);
        method.call();
    }

    timeout = setTimeout(runInterval, time);

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

function isRegex(item) {
    return Object.prototype.toString.call(item) === '[object RegExp]';
}

// eslint-disable-next-line flowtype/no-weak-types
var weakMapMemoize = function weakMapMemoize(method) {

    var weakmap = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

    // eslint-disable-next-line flowtype/no-weak-types
    return function (arg) {
        var result = weakmap.get(arg);

        if (typeof result !== 'undefined') {
            return result;
        }

        result = method.call(this, arg);

        if (typeof result !== 'undefined') {
            weakmap.set(arg, result);
        }

        return result;
    };
};

function getWindowType() {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["t" /* isPopup */])()) {
        return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.POPUP;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["r" /* isIframe */])()) {
        return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.IFRAME;
    }
    return __WEBPACK_IMPORTED_MODULE_2__conf__["b" /* CONSTANTS */].WINDOW_TYPES.FULLPAGE;
}

function jsonStringify(obj, replacer, indent) {

    var objectToJSON = void 0;
    var arrayToJSON = void 0;

    try {
        if (JSON.stringify({}) !== '{}') {
            // $FlowFixMe
            objectToJSON = Object.prototype.toJSON;
            // $FlowFixMe
            delete Object.prototype.toJSON;
        }

        if (JSON.stringify({}) !== '{}') {
            throw new Error('Can not correctly serialize JSON objects');
        }

        if (JSON.stringify([]) !== '[]') {
            // $FlowFixMe
            arrayToJSON = Array.prototype.toJSON;
            // $FlowFixMe
            delete Array.prototype.toJSON;
        }

        if (JSON.stringify([]) !== '[]') {
            throw new Error('Can not correctly serialize JSON objects');
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    var result = JSON.stringify.call(this, obj, replacer, indent);

    try {
        if (objectToJSON) {
            // $FlowFixMe
            Object.prototype.toJSON = objectToJSON; // eslint-disable-line
        }

        if (arrayToJSON) {
            // $FlowFixMe
            Array.prototype.toJSON = arrayToJSON; // eslint-disable-line
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    return result;
}

function jsonParse(item) {
    return JSON.parse(item);
}

/***/ }),

/***/ "./node_modules/post-robot/src/public/client.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _send; });
/* harmony export (immutable) */ __webpack_exports__["b"] = request;
/* harmony export (immutable) */ __webpack_exports__["d"] = sendToParent;
/* harmony export (immutable) */ __webpack_exports__["a"] = client;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");











__WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises || new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function request(options) {

    var prom = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!options.name) {
            throw new Error('Expected options.name');
        }

        var name = options.name;
        var targetWindow = void 0;
        var domain = void 0;

        if (typeof options.window === 'string') {
            var el = document.getElementById(options.window);

            if (!el) {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be a valid element id');
            }

            if (el.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be an iframe');
            }

            if (!el.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            // $FlowFixMe
            targetWindow = el.contentWindow;
        } else if (options.window instanceof HTMLIFrameElement) {

            if (options.window.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + Object.prototype.toString.call(options.window) + ' to be an iframe');
            }

            if (options.window && !options.window.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            if (options.window && options.window.contentWindow) {
                // $FlowFixMe
                targetWindow = options.window.contentWindow;
            }
        } else {
            targetWindow = options.window;
        }

        if (!targetWindow) {
            throw new Error('Expected options.window to be a window object, iframe, or iframe element id.');
        }

        var win = targetWindow;

        domain = options.domain || __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].WILDCARD;

        var hash = options.name + '_' + Object(__WEBPACK_IMPORTED_MODULE_5__lib__["p" /* uniqueID */])();

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {
            throw new Error('Target window is closed');
        }

        var hasResult = false;

        var requestPromises = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises.get(win);

        if (!requestPromises) {
            requestPromises = [];
            __WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].requestPromises.set(win, requestPromises);
        }

        var requestPromise = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["p" /* isAncestor */])(window, win)) {
                return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* onWindowReady */])(win, options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].CHILD_WINDOW_TIMEOUT));
            }
        }).then(function () {

            return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

                var responseListener = void 0;

                if (!options.fireAndForget) {
                    responseListener = {
                        name: name,
                        window: win,
                        domain: domain,
                        respond: function respond(err, result) {
                            if (!err) {
                                hasResult = true;
                                requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                            }

                            if (err) {
                                reject(err);
                            } else {
                                resolve(result);
                            }
                        }
                    };

                    Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["b" /* addResponseListener */])(hash, responseListener);
                }

                Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["g" /* sendMessage */])(win, {
                    type: __WEBPACK_IMPORTED_MODULE_3__conf__["b" /* CONSTANTS */].POST_MESSAGE_TYPE.REQUEST,
                    hash: hash,
                    name: name,
                    data: options.data,
                    fireAndForget: options.fireAndForget
                }, domain)['catch'](reject);

                if (options.fireAndForget) {
                    return resolve();
                }

                var ackTimeout = __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].ACK_TIMEOUT;
                var resTimeout = options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].RES_TIMEOUT;

                var cycleTime = 100;

                var cycle = function cycle() {

                    if (hasResult) {
                        return;
                    }

                    if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {

                        if (!responseListener.ack) {
                            return reject(new Error('Window closed for ' + name + ' before ack'));
                        }

                        return reject(new Error('Window closed for ' + name + ' before response'));
                    }

                    ackTimeout -= cycleTime;
                    resTimeout -= cycleTime;

                    var hasAck = responseListener.ack;

                    if (hasAck) {

                        if (resTimeout === Infinity) {
                            return;
                        }

                        cycleTime = Math.min(resTimeout, 2000);
                    } else if (ackTimeout <= 0) {
                        return reject(new Error('No ack for postMessage ' + name + ' in ' + Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])() + ' in ' + __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].ACK_TIMEOUT + 'ms'));
                    } else if (resTimeout <= 0) {
                        return reject(new Error('No response for postMessage ' + name + ' in ' + Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])() + ' in ' + (options.timeout || __WEBPACK_IMPORTED_MODULE_3__conf__["a" /* CONFIG */].RES_TIMEOUT) + 'ms'));
                    }

                    setTimeout(cycle, cycleTime);
                };

                setTimeout(cycle, cycleTime);
            });
        });

        requestPromise['catch'](function () {
            Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["e" /* markResponseListenerErrored */])(hash);
            Object(__WEBPACK_IMPORTED_MODULE_4__drivers__["c" /* deleteResponseListener */])(hash);
        });

        requestPromises.push(requestPromise);

        return requestPromise;
    });

    return prom;
}

function _send(window, name, data, options) {

    options = options || {};
    options.window = window;
    options.name = name;
    options.data = data;

    return request(options);
}

function sendToParent(name, data, options) {

    var win = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["d" /* getAncestor */])();

    if (!win) {
        return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
            return reject(new Error('Window does not have a parent'));
        });
    }

    return _send(win, name, data, options);
}

function client() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    if (!options.window) {
        throw new Error('Expected options.window');
    }

    var win = options.window;

    return {
        send: function send(name, data) {
            return _send(win, name, data, options);
        }
    };
}

__WEBPACK_IMPORTED_MODULE_6__global__["a" /* global */].send = _send;

/***/ }),

/***/ "./node_modules/post-robot/src/public/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = disable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__conf__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__conf__["b"]; });





function disable() {
    delete window[__WEBPACK_IMPORTED_MODULE_0__conf__["b" /* CONSTANTS */].WINDOW_PROPS.POSTROBOT];
    window.removeEventListener('message', __WEBPACK_IMPORTED_MODULE_1__drivers__["f" /* messageListener */]);
}

/***/ }),

/***/ "./node_modules/post-robot/src/public/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("./node_modules/post-robot/src/public/client.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__client__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__server__ = __webpack_require__("./node_modules/post-robot/src/public/server.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__server__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./node_modules/post-robot/src/public/config.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__config__["c"]; });






var parent = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["d" /* getAncestor */])();

/***/ }),

/***/ "./node_modules/post-robot/src/public/server.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _on; });
/* harmony export (immutable) */ __webpack_exports__["a"] = listen;
/* harmony export (immutable) */ __webpack_exports__["d"] = once;
/* harmony export (immutable) */ __webpack_exports__["b"] = listener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/post-robot/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drivers__ = __webpack_require__("./node_modules/post-robot/src/drivers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__conf__ = __webpack_require__("./node_modules/post-robot/src/conf/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global__ = __webpack_require__("./node_modules/post-robot/src/global.js");


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










function listen(options) {

    if (!options.name) {
        throw new Error('Expected options.name');
    }

    if (!options.handler) {
        throw new Error('Expected options.handler');
    }

    var name = options.name;
    var win = options.window;
    var domain = options.domain;

    var listenerOptions = {
        handler: options.handler,
        handleError: options.errorHandler || function (err) {
            throw err;
        },
        window: win,
        domain: domain || __WEBPACK_IMPORTED_MODULE_4__conf__["b" /* CONSTANTS */].WILDCARD,
        name: name
    };

    var requestListener = Object(__WEBPACK_IMPORTED_MODULE_3__drivers__["a" /* addRequestListener */])({ name: name, win: win, domain: domain }, listenerOptions);

    if (options.once) {
        var _handler = listenerOptions.handler;
        listenerOptions.handler = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["l" /* once */])(function () {
            requestListener.cancel();
            return _handler.apply(this, arguments);
        });
    }

    if (listenerOptions.window && options.errorOnClose) {
        var interval = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* safeInterval */])(function () {
            if (win && (typeof win === 'undefined' ? 'undefined' : _typeof(win)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {
                interval.cancel();
                listenerOptions.handleError(new Error('Post message target window is closed'));
            }
        }, 50);
    }

    return {
        cancel: function cancel() {
            requestListener.cancel();
        }
    };
}

function _on(name, options, handler) {

    if (typeof options === 'function') {
        handler = options;
        options = {};
    }

    options = options || {};

    options.name = name;
    options.handler = handler || options.handler;

    return listen(options);
}

function once(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var handler = arguments[2];


    if (typeof options === 'function') {
        handler = options;
        options = {};
    }

    options = options || {};
    handler = handler || options.handler;
    var errorHandler = options.errorHandler;

    var promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        options = options || {};

        options.name = name;
        options.once = true;

        options.handler = function (event) {
            resolve(event);
            if (handler) {
                return handler(event);
            }
        };

        options.errorHandler = function (err) {
            reject(err);
            if (errorHandler) {
                return errorHandler(err);
            }
        };
    });

    var onceListener = listen(options);
    promise.cancel = onceListener.cancel;

    return promise;
}

function listener() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    return {
        on: function on(name, handler) {
            return _on(name, options, handler);
        }
    };
}

__WEBPACK_IMPORTED_MODULE_5__global__["a" /* global */].on = _on;

/***/ }),

/***/ "./node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./node_modules/webpack/buildin/amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "./node_modules/xcomponent/node_modules/hi-base32/src/base32.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*
 * hi-base32 v0.1.1
 * https://github.com/emn178/hi-base32
 *
 * Copyright 2015, emn178@gmail.com
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */
;(function (root, undefined) {
  'use strict';

  var NODE_JS = typeof module != 'undefined';
  if (NODE_JS) {
    root = global;
  }

  var BASE32_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'.split('');
  var BASE32_DECODE_CHAR = {
    'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8,
    'J': 9, 'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16,
    'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24,
    'Z': 25, '2': 26, '3': 27, '4': 28, '5': 29, '6': 30, '7': 31
  };

  var blocks = [0, 0, 0, 0, 0, 0, 0, 0];

  var toUtf8String = function toUtf8String(bytes) {
    var str = '',
        length = bytes.length,
        i = 0,
        followingChars = 0,
        b,
        c;
    while (i < length) {
      b = bytes[i++];
      if (b <= 0x7F) {
        str += String.fromCharCode(b);
        continue;
      } else if (b > 0xBF && b <= 0xDF) {
        c = b & 0x1F;
        followingChars = 1;
      } else if (b <= 0xEF) {
        c = b & 0x0F;
        followingChars = 2;
      } else if (b <= 0xF7) {
        c = b & 0x07;
        followingChars = 3;
      } else {
        throw 'not a UTF-8 string';
      }

      for (var j = 0; j < followingChars; ++j) {
        b = bytes[i++];
        if (b < 0x80 || b > 0xBF) {
          throw 'not a UTF-8 string';
        }
        c <<= 6;
        c += b & 0x3F;
      }
      if (c >= 0xD800 && c <= 0xDFFF) {
        throw 'not a UTF-8 string';
      }
      if (c > 0x10FFFF) {
        throw 'not a UTF-8 string';
      }

      if (c <= 0xFFFF) {
        str += String.fromCharCode(c);
      } else {
        c -= 0x10000;
        str += String.fromCharCode((c >> 10) + 0xD800);
        str += String.fromCharCode((c & 0x3FF) + 0xDC00);
      }
    }
    return str;
  };

  var decodeAsBytes = function decodeAsBytes(base32Str) {
    base32Str = base32Str.replace(/=/g, '');
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        bytes = [],
        index = 0,
        length = base32Str.length;

    // 4 char to 3 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
      bytes[index++] = (v7 << 5 | v8) & 255;
    }

    // remain bytes
    var remain = length - count;
    if (remain == 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
    } else if (remain == 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
    } else if (remain == 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
    } else if (remain == 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      bytes[index++] = (v1 << 3 | v2 >>> 2) & 255;
      bytes[index++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
      bytes[index++] = (v4 << 4 | v5 >>> 1) & 255;
      bytes[index++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
    }
    return bytes;
  };

  var encodeAscii = function encodeAscii(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = str.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i++);
      v5 = str.charCodeAt(i++);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain == 1) {
      v1 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain == 2) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain == 3) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain == 4) {
      v1 = str.charCodeAt(i++);
      v2 = str.charCodeAt(i++);
      v3 = str.charCodeAt(i++);
      v4 = str.charCodeAt(i);
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encodeUtf8 = function encodeUtf8(str) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        code,
        end = false,
        base32Str = '',
        index = 0,
        i,
        start = 0,
        bytes = 0,
        length = str.length;
    do {
      blocks[0] = blocks[5];
      blocks[1] = blocks[6];
      blocks[2] = blocks[7];
      for (i = start; index < length && i < 5; ++index) {
        code = str.charCodeAt(index);
        if (code < 0x80) {
          blocks[i++] = code;
        } else if (code < 0x800) {
          blocks[i++] = 0xc0 | code >> 6;
          blocks[i++] = 0x80 | code & 0x3f;
        } else if (code < 0xd800 || code >= 0xe000) {
          blocks[i++] = 0xe0 | code >> 12;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        } else {
          code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++index) & 0x3ff);
          blocks[i++] = 0xf0 | code >> 18;
          blocks[i++] = 0x80 | code >> 12 & 0x3f;
          blocks[i++] = 0x80 | code >> 6 & 0x3f;
          blocks[i++] = 0x80 | code & 0x3f;
        }
      }
      bytes += i - start;
      start = i - 5;
      if (index == length) {
        ++index;
      }
      if (index > length && i < 6) {
        end = true;
      }
      v1 = blocks[0];
      if (i > 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        v5 = blocks[4];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
      } else if (i == 1) {
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
      } else if (i == 2) {
        v2 = blocks[1];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
      } else if (i == 3) {
        v2 = blocks[1];
        v3 = blocks[2];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
      } else if (i == 4) {
        v2 = blocks[1];
        v3 = blocks[2];
        v4 = blocks[3];
        base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
      }
    } while (!end);
    return base32Str;
  };

  var encodeBytes = function encodeBytes(bytes) {
    var v1,
        v2,
        v3,
        v4,
        v5,
        base32Str = '',
        length = bytes.length;
    for (var i = 0, count = parseInt(length / 5) * 5; i < count;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i++];
      v5 = bytes[i++];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
    }

    // remain char
    var remain = length - count;
    if (remain == 1) {
      v1 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + '======';
    } else if (remain == 2) {
      v1 = bytes[i++];
      v2 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + '====';
    } else if (remain == 3) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + '===';
    } else if (remain == 4) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      v4 = bytes[i];
      base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + '=';
    }
    return base32Str;
  };

  var encode = function encode(input, asciiOnly) {
    var notString = typeof input != 'string';
    if (notString && input.constructor == ArrayBuffer) {
      input = new Uint8Array(input);
    }
    if (notString) {
      return encodeBytes(input);
    } else if (asciiOnly) {
      return encodeAscii(input);
    } else {
      return encodeUtf8(input);
    }
  };

  var decode = function decode(base32Str, asciiOnly) {
    if (!asciiOnly) {
      return toUtf8String(decodeAsBytes(base32Str));
    }
    var v1,
        v2,
        v3,
        v4,
        v5,
        v6,
        v7,
        v8,
        str = '',
        length = base32Str.indexOf('=');
    if (length == -1) {
      length = base32Str.length;
    }

    // 8 char to 5 bytes
    for (var i = 0, count = length >> 3 << 3; i < count;) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
    }

    // remain bytes
    var remain = length - count;
    if (remain == 2) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
    } else if (remain == 4) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
    } else if (remain == 5) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
    } else if (remain == 7) {
      v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
      str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
    }
    return str;
  };

  decode.asBytes = decodeAsBytes;
  var exports = {
    encode: encode,
    decode: decode
  };
  if (root.HI_BASE32_TEST) {
    exports.toUtf8String = toUtf8String;
  }

  if (!root.HI_BASE32_TEST && NODE_JS) {
    module.exports = exports;
  } else if (root) {
    root.base32 = exports;
  }
})(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/xcomponent/src/component/base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







function cleanup(obj) {

    var tasks = [];
    var cleaned = false;

    return {
        set: function set(name, item) {

            if (cleaned) {
                return item;
            }

            obj[name] = item;
            this.register(function () {
                delete obj[name];
            });
            return item;
        },
        register: function register(name, method) {

            if (typeof name === 'function') {
                method = name;
                name = '<anonymous-cleanup-handler>';
            }

            if (typeof method !== 'function') {
                throw new Error('Expected to be passed function to clean.register');
            }

            if (cleaned) {
                method();
                return;
            }

            tasks.push({
                complete: false,

                name: name,

                run: function run() {

                    if (this.complete) {
                        return;
                    }

                    this.complete = true;

                    if (method) {
                        method();
                    }
                }
            });
        },
        hasTasks: function hasTasks() {
            return Boolean(tasks.filter(function (item) {
                return !item.complete;
            }).length);
        },
        all: function all() {
            var results = [];

            cleaned = true;

            while (tasks.length) {
                results.push(tasks.pop().run());
            }

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(function () {/* pass */});
        },
        run: function run(name) {
            var results = [];

            for (var _iterator = tasks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var item = _ref;

                if (item.name === name) {
                    results.push(item.run());
                }
            }

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(function () {
                return;
            });
        }
    };
}

/*  Base Component
    --------------

    Methods that are common between child and parent components, but are not generic or uncoupled enough to live in
    a separate library.
*/

var BaseComponent = function () {
    function BaseComponent() {
        _classCallCheck(this, BaseComponent);

        this.clean = cleanup(this);
        this.event = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["s" /* eventEmitter */])();
    }

    BaseComponent.prototype.addProp = function addProp(options, name, def) {
        Object(__WEBPACK_IMPORTED_MODULE_2__lib__["g" /* copyProp */])(options, this, name, def);
    };

    BaseComponent.prototype.on = function on(eventName, handler) {
        return this.event.on(eventName, handler);
    };

    BaseComponent.prototype.listeners = function listeners() {
        throw new Error('Expected listeners to be implemented');
    };

    BaseComponent.prototype.error = function error(err) {
        throw new Error('Expected error to be implemented - got ' + Object(__WEBPACK_IMPORTED_MODULE_2__lib__["X" /* stringifyError */])(err));
    };

    /*  Listen
        ------
         Listen for any post messages defined in this.listeners(). All (most) of our communication is done via
        post-messages, so this sets up an easy way to create a collection of listeners in one go.
         All post-messaging is done using post-robot.
    */

    BaseComponent.prototype.listen = function listen(win, domain) {
        var _this = this;

        if (!win) {
            throw this.component.createError('window to listen to not set');
        }

        if (!domain) {
            throw new Error('Must pass domain to listen to');
        }

        if (!this.listeners) {
            return;
        }

        var listeners = this.listeners();

        var _loop = function _loop() {
            if (_isArray2) {
                if (_i2 >= _iterator2.length) return 'break';
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) return 'break';
                _ref2 = _i2.value;
            }

            var listenerName = _ref2;


            var name = listenerName.replace(/^xcomponent_/, '');

            var listener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["on"])(listenerName, { window: win, domain: domain, errorHandler: function errorHandler(err) {
                    _this.error(err);
                } }, function (_ref3) {
                var source = _ref3.source,
                    data = _ref3.data;

                _this.component.log('listener_' + name);
                return listeners[listenerName].call(_this, source, data);
            });

            var errorListener = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["on"])(listenerName, { window: win, errorHandler: function errorHandler(err) {
                    _this.error(err);
                } }, function (_ref4) {
                var origin = _ref4.origin,
                    data = _ref4.data;

                _this.component.logError('unexpected_listener_' + name, { origin: origin, domain: domain.toString() });
                _this.error(new Error('Unexpected ' + name + ' message from domain ' + origin + ' -- expected message from ' + domain.toString()));
            });

            _this.clean.register(function () {
                listener.cancel();
                errorListener.cancel();
            });
        };

        for (var _iterator2 = Object.keys(listeners), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            var _ret = _loop();

            if (_ret === 'break') break;
        }
    };

    return BaseComponent;
}();

/***/ }),

/***/ "./node_modules/xcomponent/src/component/child/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__props__ = __webpack_require__("./node_modules/xcomponent/src/component/child/props.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














/*  Child Component
    ---------------

    This is the portion of code which runs inside the frame or popup window containing the component's implementation.

    When the component author calls myComponent.attach(), it creates a new instance of ChildComponent, which is then
    responsible for managing the state and messaging back up to the parent, and providing props for the component to
    utilize.
*/

var ChildComponent = function (_BaseComponent) {
    _inherits(ChildComponent, _BaseComponent);

    function ChildComponent(component) {
        _classCallCheck(this, ChildComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;

        if (!_this.hasValidParentDomain()) {
            _this.error(new __WEBPACK_IMPORTED_MODULE_9__error__["c" /* RenderError */]('Can not be rendered by domain: ' + _this.getParentDomain()));
            return _possibleConstructorReturn(_this);
        }

        _this.sendLogsToOpener();

        _this.component.log('construct_child');

        // The child can specify some default props if none are passed from the parent. This often makes integrations
        // a little more seamless, as applicaiton code can call props.foo() without worrying about whether the parent
        // has provided them or not, and fall-back to some default behavior.

        _this.onPropHandlers = [];

        _this.component.xchild = _this;
        _this.setProps(_this.getInitialProps(), Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])());

        // update logLevel with prop.logLevel to override defaultLogLevel configured when creating component

        if (_this.props.logLevel) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["S" /* setLogLevel */])(_this.props.logLevel);
        }

        _this.component.log('init_child');

        _this.setWindows();

        _this.listenForResize();

        // Send an init message to our parent. This gives us an initial set of data to use that we can use to function.
        //
        // For example:
        //
        // - What context are we
        // - What props has the parent specified

        _this.onInit = _this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].INIT, {

            exports: _this.exports()

        }).then(function (_ref) {
            var origin = _ref.origin,
                data = _ref.data;


            _this.context = data.context;
            _this.setProps(data.props, origin);

            _this.watchForResize();

            return _this;
        })['catch'](function (err) {

            _this.error(err);
            throw err;
        });
        return _this;
    }

    ChildComponent.prototype.listenForResize = function listenForResize() {
        var _this2 = this;

        this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ONRESIZE, {}, { fireAndForget: true });
        window.addEventListener('resize', function () {
            _this2.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ONRESIZE, {}, { fireAndForget: true });
        });
    };

    ChildComponent.prototype.hasValidParentDomain = function hasValidParentDomain() {
        return Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["A" /* matchDomain */])(this.component.allowedParentDomains, this.getParentDomain());
    };

    ChildComponent.prototype.init = function init() {
        return this.onInit;
    };

    ChildComponent.prototype.getParentDomain = function getParentDomain() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])();
    };

    ChildComponent.prototype.onProps = function onProps(handler) {
        this.onPropHandlers.push(handler);
    };

    ChildComponent.prototype.getParentComponentWindow = function getParentComponentWindow() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();
    };

    ChildComponent.prototype.getParentRenderWindow = function getParentRenderWindow() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["e" /* getParentRenderWindow */])();
    };

    ChildComponent.prototype.getInitialProps = function getInitialProps() {
        var _this3 = this;

        var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__["b" /* getComponentMeta */])();

        var props = componentMeta.props;

        if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].RAW) {
            props = props.value;
        } else if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID) {

            var parentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

            if (!Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["u" /* isSameDomain */])(parentComponentWindow)) {

                if (window.location.protocol === 'file:') {
                    throw new Error('Can not get props from file:// domain');
                }

                throw new Error('Parent component window is on a different domain - expected ' + Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["f" /* getDomain */])() + ' - can not retrieve props');
            }

            var global = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* globalFor */])(parentComponentWindow);

            if (!global) {
                throw new Error('Can not find global for parent component - can not retrieve props');
            }

            props = global.props[componentMeta.uid];
        } else {
            throw new Error('Unrecognized props type: ' + props.type);
        }

        if (!props) {
            throw new Error('Initial props not found');
        }

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["k" /* deserializeFunctions */])(props, function (_ref2) {
            var fullKey = _ref2.fullKey,
                self = _ref2.self,
                args = _ref2.args;

            return _this3.onInit.then(function () {
                var func = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["v" /* get */])(_this3.props, fullKey);

                if (typeof func !== 'function') {
                    throw new Error('Expected ' + (typeof func === 'undefined' ? 'undefined' : _typeof(func)) + ' to be function');
                }

                return func.apply(self, args);
            });
        });
    };

    ChildComponent.prototype.setProps = function setProps(props, origin) {
        var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        // $FlowFixMe
        this.props = this.props || {};
        var normalizedProps = Object(__WEBPACK_IMPORTED_MODULE_8__props__["a" /* normalizeChildProps */])(this.component, props, origin, required);
        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["t" /* extend */])(this.props, normalizedProps);
        window.xprops = this.props;
        this.component.xprops = this.props;
        for (var _iterator = this.onPropHandlers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref3 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref3 = _i.value;
            }

            var handler = _ref3;

            handler.call(this, this.props);
        }
    };

    /*  Send to Parent
        --------------
         Send a post message to our parent window.
    */

    ChildComponent.prototype.sendToParent = function sendToParent(name) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

        if (!parentWindow) {
            throw new Error('Can not find parent component window to message');
        }

        this.component.log('send_to_parent_' + name);

        return Object(__WEBPACK_IMPORTED_MODULE_2_post_robot_src__["send"])(parentWindow, name, data, _extends({ domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])() }, options));
    };

    /*  Set Windows
        -----------
         Determine the parent window, and the parent component window. Note -- these may be different, if we were
        rendered using renderTo.
    */

    ChildComponent.prototype.setWindows = function setWindows() {

        // Ensure we do not try to .attach() multiple times for the same component on the same page

        if (window.__activeXComponent__) {
            throw this.component.createError('Can not attach multiple components to the same window');
        }

        window.__activeXComponent__ = this;

        // Get the direct parent window

        if (!Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])()) {
            throw this.component.createError('Can not find parent window');
        }

        var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_5__window__["b" /* getComponentMeta */])();

        if (componentMeta.tag !== this.component.tag) {
            throw this.component.createError('Parent is ' + componentMeta.tag + ' - can not attach ' + this.component.tag);
        }

        // Note -- getting references to other windows is probably one of the hardest things to do. There's basically
        // only a few ways of doing it:
        //
        // - The window is a direct parent, in which case you can use window.parent or window.opener
        // - The window is an iframe owned by you or one of your parents, in which case you can use window.frames
        // - The window sent you a post-message, in which case you can use event.source
        //
        // If we didn't rely on winProps.parent here from the window name, we'd have to relay all of our messages through
        // our actual parent. Which is no fun at all, and pretty error prone even with the help of post-robot. So this
        // is the lesser of two evils until browsers give us something like getWindowByName(...)

        // If the parent window closes, we need to close ourselves. There's no point continuing to run our component
        // if there's no parent to message to.

        this.watchForClose();
    };

    ChildComponent.prototype.sendLogsToOpener = function sendLogsToOpener() {
        if (false) {
            try {
                var opener = getOpener(window);

                if (!opener || !window.console) {
                    return;
                }

                // $FlowFixMe

                var _loop = function _loop() {
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) return 'break';
                        _ref4 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) return 'break';
                        _ref4 = _i2.value;
                    }

                    var frame = _ref4;


                    if (!isSameDomain(frame) || !frame.console || frame === window) {
                        return 'continue';
                    }

                    var _arr = ['log', 'debug', 'info', 'warn', 'error'];

                    var _loop3 = function _loop3() {
                        var level = _arr[_i3];
                        var original = window.console[level];

                        if (!original) {
                            return 'continue';
                        }

                        try {

                            window.console[level] = function () {

                                try {
                                    if (frame) {
                                        // $FlowFixMe
                                        return frame.console[level].apply(frame.console, arguments);
                                    }
                                } catch (err3) {
                                    // pass
                                }

                                return original.apply(this, arguments);
                            };
                        } catch (err2) {
                            // pass
                        }
                    };

                    for (var _i3 = 0; _i3 < _arr.length; _i3++) {
                        var _ret2 = _loop3();

                        if (_ret2 === 'continue') continue;
                    }

                    return {
                        v: void 0
                    };
                };

                _loop2: for (var _iterator2 = getAllFramesInWindow(opener), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref4;

                    var _ret = _loop();

                    switch (_ret) {
                        case 'break':
                            break _loop2;

                        case 'continue':
                            continue;

                        default:
                            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
                    }
                }
            } catch (err) {
                // pass
            }
        }
    };

    ChildComponent.prototype.watchForClose = function watchForClose() {
        var _this4 = this;

        window.addEventListener('unload', function () {
            return _this4.checkClose();
        });
    };

    ChildComponent.prototype.enableAutoResize = function enableAutoResize() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref5$width = _ref5.width,
            width = _ref5$width === undefined ? true : _ref5$width,
            _ref5$height = _ref5.height,
            height = _ref5$height === undefined ? true : _ref5$height;

        this.autoResize = { width: width, height: height };
        this.watchForResize();
    };

    ChildComponent.prototype.getAutoResize = function getAutoResize() {

        var width = false;
        var height = false;

        var autoResize = this.autoResize || this.component.autoResize;

        if ((typeof autoResize === 'undefined' ? 'undefined' : _typeof(autoResize)) === 'object') {
            width = Boolean(autoResize.width);
            height = Boolean(autoResize.height);
        } else if (autoResize) {
            width = true;
            height = true;
        }

        var element = void 0;

        if (autoResize.element) {
            element = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["x" /* getElement */])(autoResize.element);
        } else if (window.navigator.userAgent.match(/MSIE (9|10)\./)) {
            element = document.body;
        } else {
            element = document.documentElement;
        }

        // $FlowFixMe
        return { width: width, height: height, element: element };
    };

    ChildComponent.prototype.watchForResize = function watchForResize() {
        var _this5 = this;

        var _getAutoResize = this.getAutoResize(),
            width = _getAutoResize.width,
            height = _getAutoResize.height,
            element = _getAutoResize.element;

        if (!width && !height) {
            return;
        }

        if (this.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
            return;
        }

        if (this.watchingForResize) {
            return;
        }

        this.watchingForResize = true;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            return __WEBPACK_IMPORTED_MODULE_6__lib__["n" /* documentReady */];
        }).then(function () {

            // $FlowFixMe
            if (!Object(__WEBPACK_IMPORTED_MODULE_6__lib__["m" /* dimensionsMatchViewport */])(element, { width: width, height: height })) {
                // $FlowFixMe
                return _this5.resizeToElement(element, { width: width, height: height });
            }
        }).then(function () {

            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* cycle */])(function () {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["K" /* onDimensionsChange */])(element, { width: width, height: height }).then(function (dimensions) {
                    // $FlowFixMe
                    return _this5.resizeToElement(element, { width: width, height: height });
                });
            });
        });
    };

    ChildComponent.prototype.exports = function exports() {

        var self = this;

        return {
            updateProps: function updateProps(props) {
                var _this6 = this;

                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return self.setProps(props, _this6.origin, false);
                });
            },
            close: function close() {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return self.destroy();
                });
            }
        };
    };

    /*  Resize
        ------
         Resize the child window. Must be done on a user action like a click if we're in a popup
    */

    ChildComponent.prototype.resize = function resize(width, height) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {

            _this7.component.log('resize', { width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(width), height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(height) });

            if (_this7.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
                return;
            }

            return _this7.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].RESIZE, { width: width, height: height }).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
        });
    };

    ChildComponent.prototype.resizeToElement = function resizeToElement(el, _ref6) {
        var _this8 = this;

        var width = _ref6.width,
            height = _ref6.height;


        var history = [];

        var resize = function resize() {
            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                // $FlowFixMe
                var tracker = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["Z" /* trackDimensions */])(el, { width: width, height: height });

                var _tracker$check = tracker.check(),
                    dimensions = _tracker$check.dimensions;

                for (var _iterator3 = history, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                    var _ref7;

                    if (_isArray3) {
                        if (_i4 >= _iterator3.length) break;
                        _ref7 = _iterator3[_i4++];
                    } else {
                        _i4 = _iterator3.next();
                        if (_i4.done) break;
                        _ref7 = _i4.value;
                    }

                    var size = _ref7;


                    var widthMatch = !width || size.width === dimensions.width;
                    var heightMatch = !height || size.height === dimensions.height;

                    if (widthMatch && heightMatch) {
                        return;
                    }
                }

                history.push({ width: dimensions.width, height: dimensions.height });

                return _this8.resize(width ? dimensions.width : null, height ? dimensions.height : null).then(function () {

                    if (tracker.check().changed) {
                        return resize();
                    }
                });
            });
        };

        return resize();
    };

    /*  Hide
        ----
         Hide the window and any parent template
    */

    ChildComponent.prototype.hide = function hide() {
        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].HIDE).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ChildComponent.prototype.show = function show() {
        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].SHOW).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ChildComponent.prototype.userClose = function userClose() {
        return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].USER_CLOSED);
    };

    /*  Close
        -----
         Close the child window
    */

    ChildComponent.prototype.close = function close() {
        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].CHILD_CALL;


        this.component.log('close_child');

        // Ask our parent window to close us

        this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CLOSE, { reason: reason });
    };

    ChildComponent.prototype.checkClose = function checkClose() {
        this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CHECK_CLOSE, {}, { fireAndForget: true });
    };

    ChildComponent.prototype.destroy = function destroy() {
        __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */]().then(function () {
            window.close();
        });
    };

    /*  Focus
        -----
         Focus the child window. Must be done on a user action like a click
    */

    ChildComponent.prototype.focus = function focus() {
        this.component.log('focus');

        window.focus();
    };

    /*  Error
        -----
         Send an error back to the parent
    */

    ChildComponent.prototype.error = function error(err) {

        var stringifiedError = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["X" /* stringifyError */])(err);

        this.component.logError('error', { error: stringifiedError });

        return this.sendToParent(__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ERROR, {
            error: stringifiedError
        }).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    return ChildComponent;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseComponent */]);

if (true) {

    if (Object(__WEBPACK_IMPORTED_MODULE_5__window__["g" /* isXComponentWindow */])() && window.console) {
        (function () {
            var logLevels = __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["l" /* logLevels */];

            var _loop4 = function _loop4() {
                if (_isArray4) {
                    if (_i5 >= _iterator4.length) return 'break';
                    _ref8 = _iterator4[_i5++];
                } else {
                    _i5 = _iterator4.next();
                    if (_i5.done) return 'break';
                    _ref8 = _i5.value;
                }

                var level = _ref8;


                try {

                    var _original = window.console[level];

                    if (!_original || !_original.apply) {
                        return 'continue';
                    }

                    window.console[level] = function () {
                        try {
                            var logLevel = window.LOG_LEVEL;

                            if (!logLevel || logLevels.indexOf(logLevel) === -1) {
                                return _original.apply(this, arguments);
                            }

                            if (logLevels.indexOf(level) > logLevels.indexOf(logLevel)) {
                                return;
                            }

                            return _original.apply(this, arguments);
                        } catch (err2) {
                            // pass
                        }
                    };

                    if (level === 'info') {
                        window.console.log = window.console[level];
                    }
                } catch (err) {
                    // pass
                }
            };

            _loop5: for (var _iterator4 = logLevels, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref8;

                var _ret4 = _loop4();

                switch (_ret4) {
                    case 'break':
                        break _loop5;

                    case 'continue':
                        continue;}
            }
        })();
    }
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/child/props.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeChildProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeChildProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");


function normalizeChildProp(component, props, key, value) {

    var prop = component.getProp(key);

    if (!prop) {
        if (component.looseProps) {
            return value;
        } else {
            return;
        }
    }

    if (typeof prop.childDecorate === 'function') {
        value = prop.childDecorate(value);
    }

    return value;
}

function normalizeChildProps(component, props, origin) {
    var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


    var result = {};

    for (var _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var _key = _ref;


        var prop = component.getProp(_key);
        var value = props[_key];

        if (prop && prop.sameDomain && origin !== Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window)) {
            continue;
        }

        result[_key] = normalizeChildProp(component, props, _key, value);

        if (prop && prop.alias && !result[prop.alias]) {
            result[prop.alias] = value;
        }
    }

    if (required) {
        for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var key = _ref2;

            if (!props.hasOwnProperty(key)) {
                result[key] = normalizeChildProp(component, props, key, props[key]);
            }
        }
    }

    // $FlowFixMe
    return result;
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child__ = __webpack_require__("./node_modules/xcomponent/src/component/child/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__delegate__ = __webpack_require__("./node_modules/xcomponent/src/component/delegate/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__props__ = __webpack_require__("./node_modules/xcomponent/src/component/component/props.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__("./node_modules/xcomponent/src/component/component/validate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__templates__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__drivers__ = __webpack_require__("./node_modules/xcomponent/src/drivers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}


















/*  Component
    ---------

    This is the spec for the component. The idea is, when I call xcomponent.create(), it will create a new instance
    of Component with the blueprint needed to set up ParentComponents and ChildComponents.

    This is the one portion of code which is required by -- and shared to -- both the parent and child windows, and
    contains all of the configuration needed for them to set themselves up.
*/

var Component = (_class = function (_BaseComponent) {
    _inherits(Component, _BaseComponent);

    function Component(options) {
        _classCallCheck(this, Component);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        Object(__WEBPACK_IMPORTED_MODULE_10__validate__["a" /* validate */])(options);

        // The tag name of the component. Used by some drivers (e.g. angular) to turn the component into an html element,
        // e.g. <my-component>

        _this.addProp(options, 'tag');

        _this.addProp(options, 'defaultLogLevel', 'info');

        _this.addProp(options, 'allowedParentDomains', __WEBPACK_IMPORTED_MODULE_9__constants__["WILDCARD"]);

        // initially set log level to default log level configured when creating component
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["S" /* setLogLevel */])(_this.defaultLogLevel);

        if (Component.components[_this.tag]) {
            throw new Error('Can not register multiple components with the same tag');
        }

        // Name of the component, used for logging. Auto-generated from the tag name by default.

        _this.addProp(options, 'name', _this.tag.replace(/-/g, '_'));

        // A json based spec describing what kind of props the component accepts. This is used to validate any props before
        // they are passed down to the child.

        _this.builtinProps = Object(__WEBPACK_IMPORTED_MODULE_7__props__["a" /* getInternalProps */])();
        _this.props = options.props || {};

        if (!options.props) {
            _this.looseProps = true;
        }

        // The dimensions of the component, e.g. { width: '300px', height: '150px' }

        _this.addProp(options, 'dimensions');
        _this.addProp(options, 'scrolling');

        _this.addProp(options, 'version', 'latest');

        // The default environment we should render to if none is specified in the parent

        _this.addProp(options, 'defaultEnv');

        // A mapping of env->url, used to determine which url to load for which env

        _this.addProp(options, 'buildUrl');

        _this.addProp(options, 'url');
        _this.addProp(options, 'domain');

        _this.addProp(options, 'bridgeUrl');
        _this.addProp(options, 'bridgeDomain');

        _this.addProp(options, 'attributes', {});

        // A url to use by default to render the component, if not using envs


        // The allowed contexts. For example { iframe: true, popup: false }

        _this.addProp(options, 'contexts', { iframe: true, popup: false });

        // The default context to render to

        _this.addProp(options, 'defaultContext');

        // Auto Resize option

        _this.addProp(options, 'autoResize', false);

        // Templates and styles for the parent page and the initial rendering of the component

        _this.addProp(options, 'containerTemplate', __WEBPACK_IMPORTED_MODULE_11__templates__["a" /* defaultContainerTemplate */]);
        _this.addProp(options, 'prerenderTemplate', __WEBPACK_IMPORTED_MODULE_11__templates__["b" /* defaultPrerenderTemplate */]);

        // Validation

        _this.addProp(options, 'validate');

        // Security

        _this.addProp(options, 'unsafeRenderTo', false);

        // A mapping of tag->component so we can reference components by string tag name

        Component.components[_this.tag] = _this;

        // Register all of the drivers for instantiating components. The model used is -- there's a standard javascript
        // way of rendering a component, then each other technology (e.g. react) needs to hook into that interface.
        // This makes us a little more pluggable and loosely coupled.
        _this.registerDrivers();
        _this.registerChild();
        _this.listenDelegate();
        return _this;
    }

    Component.prototype.getPropNames = function getPropNames() {
        var props = Object.keys(this.props);

        for (var _iterator = Object.keys(this.builtinProps), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;

            if (props.indexOf(key) === -1) {
                props.push(key);
            }
        }

        return props;
    };

    Component.prototype.getProp = function getProp(name) {
        // $FlowFixMe
        return this.props[name] || this.builtinProps[name];
    };

    Component.prototype.registerDrivers = function registerDrivers() {
        this.driverCache = {};

        for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_12__drivers__), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var driverName = _ref2;

            if (driverName.indexOf('_') === 0) {
                continue;
            }

            var driver = __WEBPACK_IMPORTED_MODULE_12__drivers__[driverName];
            var glob = driver.global();
            if (glob) {
                this.driver(driverName, glob);
            }
        }
    };

    Component.prototype.driver = function driver(name, dep) {
        if (!__WEBPACK_IMPORTED_MODULE_12__drivers__[name]) {
            throw new Error('Could not find driver for framework: ' + name);
        }

        if (!this.driverCache[name]) {
            this.driverCache[name] = __WEBPACK_IMPORTED_MODULE_12__drivers__[name].register(this, dep);
        }

        return this.driverCache[name];
    };

    Component.prototype.registerChild = function registerChild() {
        var _this2 = this;

        if (Object(__WEBPACK_IMPORTED_MODULE_8__window__["g" /* isXComponentWindow */])()) {
            __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                var componentMeta = Object(__WEBPACK_IMPORTED_MODULE_8__window__["b" /* getComponentMeta */])();

                if (componentMeta.tag === _this2.tag) {
                    window.xchild = new __WEBPACK_IMPORTED_MODULE_4__child__["a" /* ChildComponent */](_this2);
                    window.xprops = window.xchild.props;
                }
            });
        }
    };

    Component.prototype.listenDelegate = function listenDelegate() {
        var _this3 = this;

        Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["on"])(__WEBPACK_IMPORTED_MODULE_9__constants__["POST_MESSAGE"].ALLOW_DELEGATE + '_' + this.name, function (_ref3) {
            var source = _ref3.source,
                origin = _ref3.origin,
                data = _ref3.data;

            return true;
        });

        Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["on"])(__WEBPACK_IMPORTED_MODULE_9__constants__["POST_MESSAGE"].DELEGATE + '_' + this.name, function (_ref4) {
            var source = _ref4.source,
                origin = _ref4.origin,
                data = _ref4.data;


            var domain = _this3.getDomain(null, data.env || _this3.defaultEnv);

            if (!domain) {
                throw new Error('Could not determine domain to allow remote render');
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["A" /* matchDomain */])(domain, origin)) {
                throw new Error('Can not render from ' + origin + ' - expected ' + domain.toString());
            }

            var delegate = _this3.delegate(source, data.options);

            return {
                overrides: delegate.getOverrides(data.context),
                destroy: function destroy() {
                    return delegate.destroy();
                }
            };
        });
    };

    Component.prototype.canRenderTo = function canRenderTo(win) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["send"])(win, __WEBPACK_IMPORTED_MODULE_9__constants__["POST_MESSAGE"].ALLOW_DELEGATE + '_' + this.name).then(function (_ref5) {
            var data = _ref5.data;

            return data;
        })['catch'](function () {
            return false;
        });
    };

    Component.prototype.getValidDomain = function getValidDomain(url) {

        if (!url) {
            return;
        }

        var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);

        if (typeof this.domain === 'string' && domain === this.domain) {
            return domain;
        }

        if (this.domain && _typeof(this.domain) === 'object') {
            for (var _iterator3 = Object.keys(this.domain), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref6;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref6 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref6 = _i3.value;
                }

                var env = _ref6;


                if (env === 'test') {
                    continue;
                }

                if (domain === this.domain[env]) {
                    return domain;
                }
            }
        }
    };

    Component.prototype.getDomain = function getDomain(url, env) {

        var domain = this.getForEnv(this.domain, env);

        if (domain) {
            return domain;
        }

        domain = this.getValidDomain(url);

        if (domain) {
            return domain;
        }

        // $FlowFixMe
        var envUrl = this.getForEnv(this.url, env);

        if (envUrl) {
            // $FlowFixMe
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(envUrl);
        }

        if (url) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(url);
        }
    };

    Component.prototype.getBridgeUrl = function getBridgeUrl(env) {
        // $FlowFixMe
        return this.getForEnv(this.bridgeUrl, env);
    };

    Component.prototype.getForEnv = function getForEnv(item, env) {

        if (!item) {
            return;
        }

        if (typeof item === 'string' || item instanceof RegExp) {
            return item;
        }

        if (!env) {
            env = this.defaultEnv;
        }

        if (!env) {
            return;
        }

        if (env && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item[env]) {
            return item[env];
        }
    };

    Component.prototype.getBridgeDomain = function getBridgeDomain(env) {

        // $FlowFixMe
        var bridgeDomain = this.getForEnv(this.bridgeDomain, env);

        if (bridgeDomain) {
            // $FlowFixMe
            return bridgeDomain;
        }

        var bridgeUrl = this.getBridgeUrl(env);

        if (bridgeUrl) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["g" /* getDomainFromUrl */])(bridgeUrl);
        }
    };

    Component.prototype.getUrl = function getUrl(env, props) {

        // $FlowFixMe
        var url = this.getForEnv(this.url, env);

        if (url) {
            return url;
        }

        if (this.buildUrl) {
            return this.buildUrl(props);
        }
    };

    Component.prototype.isXComponent = function isXComponent() {
        return Object(__WEBPACK_IMPORTED_MODULE_8__window__["g" /* isXComponentWindow */])();
    };

    Component.prototype.isChild = function isChild() {
        return Object(__WEBPACK_IMPORTED_MODULE_8__window__["g" /* isXComponentWindow */])() && window.xprops && Object(__WEBPACK_IMPORTED_MODULE_8__window__["b" /* getComponentMeta */])().tag === this.tag;
    };

    Component.prototype.createError = function createError(message, tag) {
        return new Error('[' + (tag || this.tag) + '] ' + message);
    };

    /*  Init
        ----
         Shortcut to instantiate a component on a parent page, with props
    */

    Component.prototype.init = function init(props, context, element) {
        return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](this, this.getRenderContext(context, element), { props: props });
    };

    Component.prototype.delegate = function delegate(source, options) {
        return new __WEBPACK_IMPORTED_MODULE_6__delegate__["a" /* DelegateComponent */](this, source, options);
    };

    Component.prototype.validateRenderContext = function validateRenderContext(context, element) {
        if (context && !this.contexts[context]) {
            throw new Error('[' + this.tag + '] Can not render to ' + context);
        }

        if (!element && context === __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME) {
            throw new Error('[' + this.tag + '] Context type ' + __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME + ' requires an element selector');
        }
    };

    Component.prototype.getDefaultContext = function getDefaultContext() {
        if (this.defaultContext) {
            return this.defaultContext;
        } else if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME]) {
            return __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME;
        } else if (this.contexts[__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP]) {
            return __WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP;
        }

        throw new Error('Can not determine default context');
    };

    Component.prototype.getRenderContext = function getRenderContext(context, element) {
        context = context || this.getDefaultContext();
        this.validateRenderContext(context, element);
        return context;
    };

    /*  Render
        ------
         Shortcut to render a parent component
    */

    Component.prototype.render = function render(props, element) {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this4, _this4.getRenderContext(null, element), { props: props }).render(element);
        });
    };

    Component.prototype.renderIframe = function renderIframe(props, element) {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this5, _this5.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME, element), { props: props }).render(element);
        });
    };

    Component.prototype.renderPopup = function renderPopup(props) {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this6, _this6.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP), { props: props }).render();
        });
    };

    Component.prototype.renderTo = function renderTo(win, props, element) {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this7, _this7.getRenderContext(null, element), { props: props }).renderTo(win, element);
        });
    };

    Component.prototype.renderIframeTo = function renderIframeTo(win, props, element) {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this8, _this8.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].IFRAME, element), { props: props }).renderTo(win, element);
        });
    };

    Component.prototype.renderPopupTo = function renderPopupTo(win, props) {
        var _this9 = this;

        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](_this9, _this9.getRenderContext(__WEBPACK_IMPORTED_MODULE_9__constants__["CONTEXT_TYPES"].POPUP), { props: props }).renderTo(win);
        });
    };

    Component.prototype.prerender = function prerender(props, element) {
        var instance = new __WEBPACK_IMPORTED_MODULE_5__parent__["a" /* ParentComponent */](this, this.getRenderContext(null, element), { props: props });
        instance.prefetch();

        return {
            render: function render(innerProps, innerElement) {
                if (innerProps) {
                    instance.updateProps(innerProps);
                }

                return instance.render(innerElement);
            },
            renderTo: function renderTo(win, innerProps, innerElement) {
                if (innerProps) {
                    instance.updateProps(innerProps);
                }

                return instance.renderTo(win, innerElement);
            },


            get html() {
                return instance.html;
            },

            set html(value) {
                instance.html = value;
            }
        };
    };

    /*  Log
        ---
         Log an event using the component name
    */

    Component.prototype.log = function log(event) {
        var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["C" /* info */])(this.name, event, payload);
    };

    /*  Log Warning
        -----------
         Log a warning
    */

    Component.prototype.logWarning = function logWarning(event, payload) {
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["_1" /* warn */])(this.name, event, payload);
    };

    /*  Log Error
        ---------
         Log an error
    */

    Component.prototype.logError = function logError(event, payload) {
        Object(__WEBPACK_IMPORTED_MODULE_13__lib__["r" /* error */])(this.name, event, payload);
    };

    Component.getByTag = function getByTag(tag) {
        return Component.components[tag];
    };

    return Component;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseComponent */]), (_applyDecoratedDescriptor(_class.prototype, 'getPropNames', [__WEBPACK_IMPORTED_MODULE_13__lib__["G" /* memoize */]], Object.getOwnPropertyDescriptor(_class.prototype, 'getPropNames'), _class.prototype)), _class);
Component.components = {};

/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/props.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInternalProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");




/*  Internal Props
    --------------

    We define and use certain props by default, for configuration and events that are used at the framework level.
    These follow the same format as regular props, and are classed as reserved words that may not be overriden by users.
*/

function getInternalProps() {
    return {

        // The desired env in which the component is being rendered. Used to determine the correct url

        env: {
            type: 'string',
            required: false,
            queryParam: true,
            def: function def() {
                return this.defaultEnv;
            }
        },

        uid: {
            type: 'string',
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_1__lib__["_0" /* uniqueID */])();
            },

            queryParam: true
        },

        logLevel: {
            type: 'string',
            required: false,
            queryParam: true,
            def: function def() {
                return this.defaultLogLevel;
            }
        },

        // A custom url to use to render the component

        url: {
            type: 'string',
            required: false,
            promise: true,
            sendToChild: false
        },

        version: {
            type: 'string',
            required: false,
            queryParam: true,
            def: function def(component) {
                return this.version;
            }
        },

        // A millisecond timeout before onTimeout is called

        timeout: {
            type: 'number',
            required: false,
            sendToChild: false
        },

        onDisplay: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            memoize: true,
            sendToChild: false
        },

        onEnter: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            sendToChild: false
        },

        // When we get an INIT message from the child

        onRender: {
            type: 'function',
            required: false,
            noop: true,
            promisify: true,
            sendToChild: false
        },

        // When the user closes the component.

        onClose: {
            type: 'function',
            required: false,
            noop: true,
            once: true,
            promisify: true,
            sendToChild: false
        },

        // When we time-out before getting an INIT message from the child. Defaults to onError if no handler passed.

        onTimeout: {
            type: 'function',
            required: false,
            memoize: true,
            promisify: true,
            sendToChild: false,
            def: function def() {
                return function (err) {
                    if (this.props.onError) {
                        return this.props.onError(err);
                    }
                    throw err;
                };
            }
        },

        // When the component ePperiences an error

        onError: {
            type: 'function',
            required: false,
            promisify: true,
            sendToChild: true,
            once: true
        }
    };
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/templates/component.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultPrerenderTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");

/* @jsx jsxDom */



function defaultPrerenderTemplate(_ref) {
    var jsxDom = _ref.jsxDom;

    return jsxDom(
        "html",
        null,
        jsxDom(
            "head",
            null,
            jsxDom(
                "style",
                null,
                "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    "
            )
        ),
        jsxDom(
            "body",
            null,
            jsxDom(
                "div",
                { "class": "spinner" },
                jsxDom("div", { id: "loader", "class": "loader" })
            )
        )
    );
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/templates/container.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultContainerTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");

/* @jsx jsxDom */



function defaultContainerTemplate(_ref) {
    var id = _ref.id,
        tag = _ref.tag,
        context = _ref.context,
        CLASS = _ref.CLASS,
        outlet = _ref.outlet,
        jsxDom = _ref.jsxDom,
        _ref$dimensions = _ref.dimensions,
        width = _ref$dimensions.width,
        height = _ref$dimensions.height;


    return jsxDom(
        'div',
        { id: id, 'class': CLASS.XCOMPONENT + ' ' + CLASS.XCOMPONENT + '-tag-' + tag + ' ' + CLASS.XCOMPONENT + '-context-' + context },
        jsxDom(
            'style',
            null,
            '\n                    #' + id + ', #' + id + ' > .' + CLASS.OUTLET + ' {\n                        width: ' + width + ';\n                        height: ' + height + ';\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.VISIBLE + ' {\n                        opacity: 1;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.INVISIBLE + ' {\n                        opacity: 0;\n                    }\n                '
        ),
        outlet
    );
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/templates/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/container.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/templates/component.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__component__["a"]; });



/***/ }),

/***/ "./node_modules/xcomponent/src/component/component/validate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function validatePropDefinitions(options) {

    if (options.props && !(_typeof(options.props) === 'object')) {
        throw new Error('Expected options.props to be an object');
    }

    if (options.props) {
        for (var _iterator = Object.keys(options.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;


            // $FlowFixMe
            var prop = options.props[key];

            if (!prop || !((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object')) {
                throw new Error('Expected options.props.' + key + ' to be an object');
            }

            if (!prop.type) {
                throw new Error('Expected prop.type');
            }

            if (__WEBPACK_IMPORTED_MODULE_0__constants__["PROP_TYPES_LIST"].indexOf(prop.type) === -1) {
                throw new Error('Expected prop.type to be one of ' + __WEBPACK_IMPORTED_MODULE_0__constants__["PROP_TYPES_LIST"].join(', '));
            }

            if (prop.required && prop.def) {
                throw new Error('Required prop can not have a default value');
            }
        }
    }
}

function validate(options) {
    // eslint-ignore-line

    if (!options) {
        throw new Error('Expected options to be passed');
    }

    if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) {
        throw new Error('Invalid options.tag: ' + options.tag);
    }

    validatePropDefinitions(options);

    if (options.dimensions) {
        if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["E" /* isPx */])(options.dimensions.width) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["D" /* isPerc */])(options.dimensions.width)) {
            throw new Error('Expected options.dimensions.width to be a px or % string value');
        }

        if (options.dimensions && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["E" /* isPx */])(options.dimensions.height) && !Object(__WEBPACK_IMPORTED_MODULE_1__lib__["D" /* isPerc */])(options.dimensions.height)) {
            throw new Error('Expected options.dimensions.height to be a px or % string value');
        }
    }

    if (options.contexts) {

        if (options.contexts.popup && !true) {
            throw new Error('Popups not supported in this build -- please use the full xcomponent.js build');
        }

        var anyEnabled = false;

        for (var _iterator2 = Object.keys(options.contexts), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var context = _ref2;


            if (__WEBPACK_IMPORTED_MODULE_0__constants__["CONTEXT_TYPES_LIST"].indexOf(context) === -1) {
                throw new Error('Unsupported context type: ' + context);
            }

            if (options.contexts && options.contexts[context] || options.contexts && options.contexts[context] === undefined) {
                anyEnabled = true;
            }
        }

        if (!anyEnabled) {
            throw new Error('No context type is enabled');
        }
    }

    if (options.defaultContext) {
        if (__WEBPACK_IMPORTED_MODULE_0__constants__["CONTEXT_TYPES_LIST"].indexOf(options.defaultContext) === -1) {
            throw new Error('Unsupported context type: ' + (options.defaultContext || 'unknown'));
        }

        if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) {
            throw new Error('Disallowed default context type: ' + (options.defaultContext || 'unknown'));
        }
    }

    if (!options.url && !options.buildUrl) {
        throw new Error('Expected options.url to be passed');
    }

    if (options.url && options.buildUrl) {
        throw new Error('Can not pass options.url and options.buildUrl');
    }

    if (options.defaultEnv) {
        if (typeof options.defaultEnv !== 'string') {
            throw new Error('Expected options.defaultEnv to be a string');
        }

        if (!options.buildUrl && _typeof(options.url) !== 'object') {
            throw new Error('Expected options.url to be an object mapping env->url');
        }

        if (options.url && _typeof(options.url) === 'object' && !options.url[options.defaultEnv]) {
            throw new Error('No url found for default env: ' + options.defaultEnv);
        }
    }

    if (options.url && _typeof(options.url) === 'object') {

        if (!options.defaultEnv) {
            throw new Error('Must pass options.defaultEnv with env->url mapping');
        }

        for (var _iterator3 = Object.keys(options.url), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var env = _ref3;

            if (!options.url[env]) {
                throw new Error('No url specified for env: ' + env);
            }
        }
    }

    if (options.prerenderTemplate && typeof options.prerenderTemplate !== 'function') {
        throw new Error('Expected options.prerenderTemplate to be a function');
    }

    if (options.containerTemplate && typeof options.containerTemplate !== 'function') {
        throw new Error('Expected options.containerTemplate to be a function');
    }
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/delegate/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DelegateComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parent_drivers__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/drivers.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DelegateComponent = function (_BaseComponent) {
    _inherits(DelegateComponent, _BaseComponent);

    function DelegateComponent(component, source, options) {
        _classCallCheck(this, DelegateComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;
        _this.clean.set('source', source);

        _this.context = options.context;

        _this.props = {
            uid: options.props.uid,
            dimensions: options.props.dimensions,
            onClose: options.props.onClose,
            onDisplay: options.props.onDisplay
        };

        for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var propName = _ref;

            // $FlowFixMe
            var prop = _this.component.getProp(propName);

            if (prop.allowDelegate) {
                _this.props[propName] = options.props[propName];
            }
        }

        _this.focus = function () {
            if (_this.driver.openOnFocus) {
                try {
                    var win = window.open('', _this.childWindowName);
                    if (win) {
                        win.focus();
                    }
                } catch (err) {
                    // pass
                }
            }
            return options.overrides.focus.call(_this);
        };

        _this.clean.register('destroyFocusOverride', function () {
            // $FlowFixMe
            _this.focus = function () {};
        });

        _this.userClose = options.overrides.userClose;
        _this.getDomain = options.overrides.getDomain;
        _this.error = options.overrides.error;
        _this.on = options.overrides.on;

        var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][options.context].delegateOverrides;

        for (var _iterator2 = Object.keys(delegateOverrides), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var key = _ref2;

            // $FlowFixMe
            _this[key] = __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype[key];
        }

        _this.childWindowName = options.childWindowName;

        __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype.registerActiveComponent.call(_this);

        _this.watchForClose();
        return _this;
    }

    DelegateComponent.prototype.watchForClose = function watchForClose() {
        var _this2 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["B" /* onCloseWindow */])(this.source, function () {
            return _this2.destroy();
        }, 3000);
        this.clean.register('destroyCloseWindowListener', closeWindowListener.cancel);
    };

    DelegateComponent.prototype.getOverrides = function getOverrides(context) {

        var delegateOverrides = __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][context].delegateOverrides;

        var overrides = {};

        var self = this;

        var _loop = function _loop() {
            if (_isArray3) {
                if (_i3 >= _iterator3.length) return 'break';
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) return 'break';
                _ref3 = _i3.value;
            }

            var key = _ref3;

            overrides[key] = function () {
                // $FlowFixMe
                return __WEBPACK_IMPORTED_MODULE_3__parent__["a" /* ParentComponent */].prototype[key].apply(self, arguments);
            };
        };

        for (var _iterator3 = Object.keys(delegateOverrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            var _ret = _loop();

            if (_ret === 'break') break;
        }

        return overrides;
    };

    DelegateComponent.prototype.destroy = function destroy() {
        return this.clean.all();
    };

    _createClass(DelegateComponent, [{
        key: 'driver',
        get: function get() {

            if (!this.context) {
                throw new Error('Context not set');
            }

            return __WEBPACK_IMPORTED_MODULE_4__parent_drivers__["a" /* RENDER_DRIVERS */][this.context];
        }
    }]);

    return DelegateComponent;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseComponent */]);

/***/ }),

/***/ "./node_modules/xcomponent/src/component/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__child__ = __webpack_require__("./node_modules/xcomponent/src/component/child/index.js");
/* unused harmony namespace reexport */




/***/ }),

/***/ "./node_modules/xcomponent/src/component/parent/drivers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RENDER_DRIVERS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









/*  Render Drivers
    --------------

    There are various differences in how we treat:

    - Opening frames and windows
    - Rendering up to the parent
    - Resizing
    - etc.

    based on the context we're rendering to.

    These render drivers split this functionality out in a driver pattern, so our component code doesn't bunch up into a
    series of if-popup-then-else-if-iframe code.
*/

var RENDER_DRIVERS = {};

// Iframe context is rendered inline on the page, without any kind of parent template. It's the one context that is designed
// to feel like a native element on the page.

RENDER_DRIVERS[__WEBPACK_IMPORTED_MODULE_4__constants__["CONTEXT_TYPES"].IFRAME] = {

    focusable: false,
    renderedIntoContainerTemplate: true,
    allowResize: true,
    openOnClick: false,
    openOnFocus: false,
    needsBridge: false,

    open: function open(url) {
        var _this = this;

        var attributes = this.component.attributes.iframe || {};

        this.iframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["B" /* iframe */])({
            url: url,
            attributes: _extends({
                name: this.childWindowName,
                title: this.component.name,
                scrolling: this.component.scrolling ? 'yes' : 'no'
            }, attributes),
            'class': [__WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].COMPONENT_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE]
        }, this.element);

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["f" /* awaitFrameWindow */])(this.iframe).then(function (frameWindow) {

            _this.window = frameWindow;

            var detectClose = function detectClose() {
                __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return _this.props.onClose(__WEBPACK_IMPORTED_MODULE_4__constants__["CLOSE_REASONS"].CLOSE_DETECTED);
                })['finally'](function () {
                    return _this.destroy();
                });
            };

            var iframeWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["_2" /* watchElementForClose */])(_this.iframe, detectClose);
            var elementWatcher = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["_2" /* watchElementForClose */])(_this.element, detectClose);

            _this.clean.register('destroyWindow', function () {

                iframeWatcher.cancel();
                elementWatcher.cancel();

                Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["cleanUpWindow"])(_this.window);

                delete _this.window;

                if (_this.iframe) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this.iframe);
                    delete _this.iframe;
                }
            });
        });
    },
    openPrerender: function openPrerender() {
        var _this2 = this;

        var attributes = this.component.attributes.iframe || {};

        this.prerenderIframe = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["B" /* iframe */])({
            attributes: _extends({
                name: '__prerender__' + this.childWindowName,
                scrolling: this.component.scrolling ? 'yes' : 'no'
            }, attributes),
            'class': [__WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].PRERENDER_FRAME, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE]
        }, this.element);

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["f" /* awaitFrameWindow */])(this.prerenderIframe).then(function (prerenderFrameWindow) {

            _this2.prerenderWindow = prerenderFrameWindow;

            _this2.clean.register('destroyPrerender', function () {

                if (_this2.prerenderIframe) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this2.prerenderIframe);
                    delete _this2.prerenderIframe;
                }
            });
        });
    },
    switchPrerender: function switchPrerender() {
        var _this3 = this;

        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["a" /* addClass */])(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE);
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* removeClass */])(this.prerenderIframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE);

        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["a" /* addClass */])(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].VISIBLE);
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* removeClass */])(this.iframe, __WEBPACK_IMPORTED_MODULE_4__constants__["CLASS_NAMES"].INVISIBLE);

        setTimeout(function () {
            if (_this3.prerenderIframe) {
                Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* destroyElement */])(_this3.prerenderIframe);
            }
        }, 1000);
    },


    delegateOverrides: {

        openContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        destroyComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        destroyContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        cancelContainerEvents: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        createPrerenderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        elementReady: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        showContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        showComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hideContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hideComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hide: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        show: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        resize: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        loadUrl: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        hijackSubmit: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        openPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
        switchPrerender: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

        renderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
        openContainerFrame: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
        getOutlet: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,

        open: function open(original, override) {
            return function () {
                var _this4 = this;

                return override.apply(this, arguments).then(function () {
                    _this4.clean.set('window', Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["a" /* findFrameByName */])(Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])(), _this4.childWindowName));

                    if (!_this4.window) {
                        throw new Error('Unable to find parent component iframe window');
                    }
                });
            };
        }
    },

    resize: function resize(width, height) {

        if (width) {
            this.container.style.width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* toCSS */])(width);
            this.element.style.width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* toCSS */])(width);
        }

        if (height) {
            this.container.style.height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* toCSS */])(height);
            this.element.style.height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* toCSS */])(height);
        }
    },
    show: function show() {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["V" /* showElement */])(this.element);
    },
    hide: function hide() {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["A" /* hideElement */])(this.element);
    },
    loadUrl: function loadUrl(url) {
        this.iframe.setAttribute('src', url);
    }
};

if (true) {

    // Popup context opens up a centered popup window on the page.

    RENDER_DRIVERS[__WEBPACK_IMPORTED_MODULE_4__constants__["CONTEXT_TYPES"].POPUP] = {

        focusable: true,
        renderedIntoContainerTemplate: false,
        allowResize: false,
        openOnClick: true,
        openOnFocus: true,
        needsBridge: true,

        open: function open() {
            var _this5 = this;

            var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                var _ref = _this5.component.dimensions || {},
                    _ref$width = _ref.width,
                    width = _ref$width === undefined ? __WEBPACK_IMPORTED_MODULE_4__constants__["DEFAULT_DIMENSIONS"].WIDTH : _ref$width,
                    _ref$height = _ref.height,
                    height = _ref$height === undefined ? __WEBPACK_IMPORTED_MODULE_4__constants__["DEFAULT_DIMENSIONS"].HEIGHT : _ref$height;

                width = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["J" /* normalizeDimension */])(width, window.outerWidth);
                height = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["J" /* normalizeDimension */])(height, window.outerWidth);

                var _getPosition = Object(__WEBPACK_IMPORTED_MODULE_5__window__["f" /* getPosition */])({ width: width, height: height }),
                    x = _getPosition.x,
                    y = _getPosition.y;

                var attributes = _this5.component.attributes.popup || {};

                _this5.window = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["M" /* popup */])(url || '', _extends({
                    name: _this5.childWindowName,
                    width: width,
                    height: height,
                    top: y,
                    left: x,
                    status: 1,
                    toolbar: 0,
                    menubar: 0,
                    resizable: 1,
                    scrollbars: 1
                }, attributes));

                _this5.prerenderWindow = _this5.window;

                _this5.clean.register('destroyWindow', function () {
                    if (_this5.window) {
                        _this5.window.close();
                        Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["cleanUpWindow"])(_this5.window);
                        delete _this5.window;
                        delete _this5.prerenderWindow;
                    }
                });

                _this5.resize(width, height);
            });
        },
        openPrerender: function openPrerender() {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {});
        },
        resize: function resize(width, height) {},
        hide: function hide() {
            throw new Error('Can not hide popup');
        },
        show: function show() {
            throw new Error('Can not show popup');
        },


        delegateOverrides: {

            openContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
            destroyContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

            elementReady: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

            showContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
            showComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
            hideContainer: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
            hideComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

            hide: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,
            show: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

            cancelContainerEvents: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_DELEGATE,

            open: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            loadUrl: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            createPrerenderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            destroyComponent: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            resize: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            renderTemplate: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            openContainerFrame: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL,
            getOutlet: __WEBPACK_IMPORTED_MODULE_4__constants__["DELEGATE"].CALL_ORIGINAL
        },

        loadUrl: function loadUrl(url) {

            if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["u" /* isSameDomain */])(this.window)) {
                try {
                    if (this.window.location && this.window.location.replace) {
                        this.window.location.replace(url);
                        return;
                    }
                } catch (err) {
                    // pass
                }
            }

            this.window.location = url;
        }
    };
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/parent/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParentComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__("./node_modules/xcomponent/src/component/base.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__window__ = __webpack_require__("./node_modules/xcomponent/src/component/window.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__drivers__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/drivers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validate__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/validate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__props__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/props.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}


















__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props = __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props || {};
__WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows = __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows || {};

/*  Parent Component
    ----------------

    This manages the state of the component on the parent window side - i.e. the window the component is being rendered into.

    It handles opening the necessary windows/iframes, launching the component's url, and listening for messages back from the component.
*/

var ParentComponent = (_class = function (_BaseComponent) {
    _inherits(ParentComponent, _BaseComponent);

    function ParentComponent(component, context, _ref) {
        var props = _ref.props;

        _classCallCheck(this, ParentComponent);

        var _this = _possibleConstructorReturn(this, _BaseComponent.call(this));

        _this.component = component;

        _this.validateParentDomain();

        _this.context = context;
        _this.setProps(props);

        if (_this.props.logLevel) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["S" /* setLogLevel */])(_this.props.logLevel);
        }

        _this.childWindowName = _this.buildChildWindowName({ renderTo: window });

        _this.registerActiveComponent();

        // Options passed during renderTo. We would not ordinarily expect a user to pass these, since we depend on
        // them only when we're trying to render from a sibling to a sibling

        _this.component.log('construct_parent');

        _this.watchForUnload();

        _this.onInit = new __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]();

        _this.onInit['catch'](function (err) {
            return _this.error(err);
        });
        return _this;
    }

    ParentComponent.prototype.render = function render(element) {
        var _this2 = this;

        var loadUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        return this.tryInit(function () {

            _this2.component.log('render_' + _this2.context, { context: _this2.context, element: element, loadUrl: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(loadUrl) });

            var tasks = {};

            tasks.onRender = _this2.props.onRender();

            tasks.getDomain = _this2.getDomain();

            tasks.elementReady = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                if (element) {
                    return _this2.elementReady(element);
                }
            });

            tasks.openContainer = tasks.elementReady.then(function () {
                return _this2.openContainer(element);
            });

            tasks.showContainer = tasks.openContainer.then(function () {
                return _this2.showContainer();
            });

            tasks.openPrerender = tasks.openContainer.then(function () {
                return _this2.openPrerender();
            });

            tasks.switchPrerender = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.openPrerender, _this2.onInit]).then(function () {
                return _this2.switchPrerender();
            });

            tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then(function () {
                return _this2.open();
            });

            tasks.listen = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.getDomain, tasks.open]).then(function (_ref2) {
                var domain = _ref2[0];

                _this2.listen(_this2.window, domain);
            });

            tasks.watchForClose = tasks.open.then(function () {
                return _this2.watchForClose();
            });

            tasks.linkDomain = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.getDomain, tasks.open]).then(function (_ref3) {
                var domain = _ref3[0];

                if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"] && typeof domain === 'string') {
                    return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].linkUrl(_this2.window, domain);
                }
            });

            if (!_this2.html) {
                tasks.createPrerenderTemplate = tasks.openPrerender.then(function () {
                    return _this2.createPrerenderTemplate();
                });

                tasks.showComponent = tasks.createPrerenderTemplate.then(function () {
                    return _this2.showComponent();
                });
            }

            tasks.openBridge = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.getDomain, tasks.open]).then(function (_ref4) {
                var domain = _ref4[0];

                return _this2.openBridge(typeof domain === 'string' ? domain : null);
            });

            if (_this2.html) {
                tasks.loadHTML = tasks.open.then(function () {
                    return _this2.loadHTML();
                });
            } else if (loadUrl) {
                tasks.buildUrl = _this2.buildUrl();

                tasks.loadUrl = __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate]).then(function (_ref5) {
                    var url = _ref5[0];

                    return _this2.loadUrl(url);
                });

                tasks.runTimeout = tasks.loadUrl.then(function () {
                    return _this2.runTimeout();
                });
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].hash(tasks);
        }).then(function () {
            return _this2.props.onEnter();
        });
    };

    ParentComponent.prototype.getOutlet = function getOutlet() {
        var outlet = document.createElement('div');
        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* addClass */])(outlet, __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"].OUTLET);
        return outlet;
    };

    ParentComponent.prototype.validateParentDomain = function validateParentDomain() {
        var domain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])();
        if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["A" /* matchDomain */])(this.component.allowedParentDomains, domain)) {
            throw new __WEBPACK_IMPORTED_MODULE_11__error__["c" /* RenderError */]('Can not be rendered by domain: ' + domain);
        }
    };

    ParentComponent.prototype.renderTo = function renderTo(win, element) {
        var _this3 = this;

        return this.tryInit(function () {

            if (win === window) {
                return _this3.render(element);
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["v" /* isSameTopWindow */])(window, win)) {
                throw new Error('Can only renderTo an adjacent frame');
            }

            if (element && typeof element !== 'string') {
                throw new Error('Element passed to renderTo must be a string selector, got ' + (typeof element === 'undefined' ? 'undefined' : _typeof(element)) + ' ' + element);
            }

            _this3.checkAllowRenderTo(win);

            _this3.component.log('render_' + _this3.context + '_to_win', { element: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(element), context: _this3.context });

            _this3.childWindowName = _this3.buildChildWindowName({ renderTo: win });

            _this3.delegate(win);

            return _this3.render(element);
        });
    };

    ParentComponent.prototype.prefetch = function prefetch() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this4.html = _this4.buildUrl().then(function (url) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* prefetchPage */])(url).then(function (html) {

                    var host = '' + url.split('/').slice(0, 3).join('/');
                    var uri = '/' + url.split('/').slice(3).join('/');

                    return '\n                        <base href="' + host + '">\n\n                        ' + html + '\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, \'\', \'' + uri + '\');\n                            }\n                        </script>\n                    ';
                });
            });
        });
    };

    ParentComponent.prototype.loadHTML = function loadHTML() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!_this5.html) {
                throw new Error('Html not prefetched');
            }

            return _this5.html.then(function (html) {
                // $FlowFixMe
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_4" /* writeToWindow */])(_this5.window, html);
            });
        });
    };

    ParentComponent.prototype.checkAllowRenderTo = function checkAllowRenderTo(win) {

        if (!win) {
            throw this.component.createError('Must pass window to renderTo');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {
            return;
        }

        var origin = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])();
        var domain = this.component.getDomain(null, this.props.env);

        if (!domain) {
            throw new Error('Could not determine domain to allow remote render');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["A" /* matchDomain */])(domain, origin)) {
            return;
        }

        throw new Error('Can not render remotely to ' + domain.toString() + ' - can only render to ' + origin);
    };

    ParentComponent.prototype.registerActiveComponent = function registerActiveComponent() {
        var _this6 = this;

        ParentComponent.activeComponents.push(this);

        this.clean.register(function () {
            ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
        });
    };

    ParentComponent.prototype.getComponentParentRef = function getComponentParentRef() {
        var renderToWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;


        if (this.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP) {
            return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].OPENER };
        }

        if (renderToWindow === window) {

            if (Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["w" /* isTop */])(window)) {
                return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].TOP };
            }

            return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].PARENT, distance: Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["e" /* getDistanceFromTop */])(window) };
        }

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_0" /* uniqueID */])();
        __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid] = window;

        this.clean.register(function () {
            delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid];
        });

        return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].GLOBAL, uid: uid };
    };

    ParentComponent.prototype.getRenderParentRef = function getRenderParentRef() {
        var renderToWindow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;


        if (renderToWindow === window) {
            return this.getComponentParentRef(renderToWindow);
        }

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_0" /* uniqueID */])();
        __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid] = renderToWindow;

        this.clean.register(function () {
            delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].windows[uid];
        });

        return { ref: __WEBPACK_IMPORTED_MODULE_7__constants__["WINDOW_REFERENCES"].GLOBAL, uid: uid };
    };

    ParentComponent.prototype.buildChildWindowName = function buildChildWindowName() {
        var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref6$renderTo = _ref6.renderTo,
            renderTo = _ref6$renderTo === undefined ? window : _ref6$renderTo;

        var sameDomain = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["u" /* isSameDomain */])(renderTo);

        var uid = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_0" /* uniqueID */])();
        var tag = this.component.tag;
        var sProps = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* serializeFunctions */])(this.getPropsForChild());

        var componentParent = this.getComponentParentRef(renderTo);
        var renderParent = this.getRenderParentRef(renderTo);

        var secureProps = !sameDomain && !this.component.unsafeRenderTo;

        var props = secureProps ? { type: __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID, uid: uid } : { type: __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].RAW, value: sProps };

        if (props.type === __WEBPACK_IMPORTED_MODULE_7__constants__["INITIAL_PROPS"].UID) {
            __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props[uid] = sProps;

            this.clean.register(function () {
                delete __WEBPACK_IMPORTED_MODULE_6__lib__["y" /* global */].props[uid];
            });
        }

        return Object(__WEBPACK_IMPORTED_MODULE_5__window__["a" /* buildChildWindowName */])(this.component.name, this.component.version, { uid: uid, tag: tag, componentParent: componentParent, renderParent: renderParent, props: props });
    };

    /*  Send to Parent
        --------------
         Send a post message to our parent window.
    */

    ParentComponent.prototype.sendToParent = function sendToParent(name, data) {
        var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])();

        if (!parentWindow) {
            throw new Error('Can not find parent component window to message');
        }

        this.component.log('send_to_parent_' + name);

        return Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["send"])(Object(__WEBPACK_IMPORTED_MODULE_5__window__["c" /* getParentComponentWindow */])(), name, data, { domain: Object(__WEBPACK_IMPORTED_MODULE_5__window__["d" /* getParentDomain */])() });
    };

    /*  Set Props
        ---------
         Normalize props and generate the url we'll use to render the component
    */

    ParentComponent.prototype.setProps = function setProps(props) {
        var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


        Object(__WEBPACK_IMPORTED_MODULE_9__validate__["a" /* validateProps */])(this.component, props, required);
        if (this.component.validate) {
            this.component.validate(this.component, props);
        }

        // $FlowFixMe
        this.props = this.props || {};

        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["t" /* extend */])(this.props, Object(__WEBPACK_IMPORTED_MODULE_10__props__["a" /* normalizeProps */])(this.component, this, props));
    };

    /*  Build Url
        ---------
         We build the props we're passed into the initial url. This means the component server-side can start rendering
        itself based on whatever props the merchant provides.
    */

    ParentComponent.prototype.buildUrl = function buildUrl() {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([this.props.url, Object(__WEBPACK_IMPORTED_MODULE_10__props__["b" /* propsToQuery */])(_extends({}, this.component.props, this.component.builtinProps), this.props)]).then(function (_ref7) {
            var url = _ref7[0],
                query = _ref7[1];


            // Do not extend the url if it is for a different domain

            if (url && !_this7.component.getValidDomain(url)) {
                return url;
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                return url || _this7.component.getUrl(_this7.props.env, _this7.props);
            }).then(function (finalUrl) {

                query[__WEBPACK_IMPORTED_MODULE_7__constants__["XCOMPONENT"]] = '1';
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["u" /* extendUrl */])(finalUrl, { query: query });
            });
        });
    };

    ParentComponent.prototype.getDomain = function getDomain() {
        var _this8 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return _this8.props.url;
        }).then(function (url) {

            var domain = _this8.component.getDomain(url, _this8.props.env);

            if (domain) {
                return domain;
            }

            if (_this8.component.buildUrl) {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                    return _this8.component.buildUrl(_this8.props);
                }).then(function (builtUrl) {
                    return _this8.component.getDomain(builtUrl, _this8.props.env);
                });
            }
        }).then(function (domain) {

            if (!domain) {
                throw new Error('Could not determine domain');
            }

            return domain;
        });
    };

    ParentComponent.prototype.getPropsForChild = function getPropsForChild() {

        var result = {};

        for (var _iterator = Object.keys(this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref8;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref8 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref8 = _i.value;
            }

            var key = _ref8;

            var prop = this.component.getProp(key);

            if (!prop || prop.sendToChild !== false) {
                result[key] = this.props[key];
            }
        }

        // $FlowFixMe
        return result;
    };

    /*  Update Props
        ------------
         Send new props down to the child
    */

    ParentComponent.prototype.updateProps = function updateProps(props) {
        var _this9 = this;

        this.setProps(props, false);

        return this.onInit.then(function () {
            if (_this9.childExports) {
                return _this9.childExports.updateProps(_this9.getPropsForChild());
            } else {
                throw new Error('Child exports were not available');
            }
        });
    };

    ParentComponent.prototype.openBridge = function openBridge(domain) {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"] || !_this10.driver.needsBridge) {
                return;
            }

            var needsBridgeParams = { win: _this10.window };
            if (domain) {
                needsBridgeParams.domain = domain;
            }

            var needsBridge = __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].needsBridge(needsBridgeParams);

            var bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);

            if (!bridgeUrl) {

                if (needsBridge && domain && !__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].hasBridge(domain, domain)) {
                    throw new Error('Bridge url needed to render ' + _this10.context);
                }

                return;
            }

            bridgeUrl = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["u" /* extendUrl */])(bridgeUrl, { query: { version: _this10.component.version } });

            var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);

            if (!bridgeDomain) {
                throw new Error('Can not determine domain for bridge');
            }

            if (needsBridge) {
                return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].openBridge(bridgeUrl, bridgeDomain).then(function (result) {
                    if (result) {
                        return result;
                    }
                });
            }
        });
    };

    /*  Open
        ----
         Open a new window in the desired context
    */

    ParentComponent.prototype.open = function open() {
        var _this11 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this11.component.log('open_' + _this11.context, { windowName: _this11.childWindowName });
            return _this11.driver.open.call(_this11);
        });
    };

    ParentComponent.prototype.openPrerender = function openPrerender() {
        var _this12 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this12.component.prerenderTemplate) {
                return _this12.driver.openPrerender.call(_this12);
            }
        });
    };

    ParentComponent.prototype.switchPrerender = function switchPrerender() {
        var _this13 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this13.prerenderWindow && _this13.driver.switchPrerender) {
                return _this13.driver.switchPrerender.call(_this13);
            }
        });
    };

    ParentComponent.prototype.elementReady = function elementReady(element) {
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["p" /* elementReady */])(element).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    ParentComponent.prototype.delegate = function delegate(win) {
        var _this14 = this;

        this.component.log('delegate_' + this.context);

        var props = {
            uid: this.props.uid,
            dimensions: this.props.dimensions,
            onClose: this.props.onClose,
            onDisplay: this.props.onDisplay
        };

        for (var _iterator2 = this.component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref9;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref9 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref9 = _i2.value;
            }

            var propName = _ref9;

            var prop = this.component.getProp(propName);

            if (prop.allowDelegate) {
                props[propName] = this.props[propName];
            }
        }

        var delegate = Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["send"])(win, __WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].DELEGATE + '_' + this.component.name, {

            context: this.context,
            env: this.props.env,

            options: {

                context: this.context,

                childWindowName: this.childWindowName,

                props: props,

                overrides: {
                    focus: function focus() {
                        return _this14.focus();
                    },
                    userClose: function userClose() {
                        return _this14.userClose();
                    },
                    getDomain: function getDomain() {
                        return _this14.getDomain();
                    },

                    error: function error(err) {
                        return _this14.error(err);
                    },
                    on: function on(eventName, handler) {
                        return _this14.on(eventName, handler);
                    }
                }
            }

        }).then(function (_ref10) {
            var data = _ref10.data;


            _this14.clean.register(data.destroy);
            return data;
        })['catch'](function (err) {

            throw new Error('Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["X" /* stringifyError */])(err));
        });

        var overrides = this.driver.delegateOverrides;

        var _loop = function _loop() {
            if (_isArray3) {
                if (_i3 >= _iterator3.length) return 'break';
                _ref11 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) return 'break';
                _ref11 = _i3.value;
            }

            var key = _ref11;

            var val = overrides[key];

            if (val === __WEBPACK_IMPORTED_MODULE_7__constants__["DELEGATE"].CALL_ORIGINAL) {
                return 'continue';
            }

            // $FlowFixMe
            var original = _this14[key];

            // $FlowFixMe
            _this14[key] = function () {
                var _this15 = this,
                    _arguments = arguments;

                return delegate.then(function (data) {

                    var override = data.overrides[key];

                    if (val === __WEBPACK_IMPORTED_MODULE_7__constants__["DELEGATE"].CALL_DELEGATE) {
                        return override.apply(_this15, _arguments);
                    }

                    if (typeof val === 'function') {
                        return val(original, override).apply(_this15, _arguments);
                    }

                    throw new Error('Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method');
                });
            };
        };

        _loop2: for (var _iterator3 = Object.keys(overrides), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref11;

            var _ret = _loop();

            switch (_ret) {
                case 'break':
                    break _loop2;

                case 'continue':
                    continue;}
        }
    };

    /*  Watch For Close
        ---------------
         Watch for the child window closing, so we can cleanup.
        Also watch for this window changing location, so we can close the component.
    */

    ParentComponent.prototype.watchForClose = function watchForClose() {
        var _this16 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["B" /* onCloseWindow */])(this.window, function () {
            _this16.component.log('detect_close_child');

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                return _this16.props.onClose(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].CLOSE_DETECTED);
            })['finally'](function () {
                return _this16.destroy();
            });
        }, 3000);

        this.clean.register('destroyCloseWindowListener', closeWindowListener.cancel);
    };

    ParentComponent.prototype.watchForUnload = function watchForUnload() {
        var _this17 = this;

        // Our child has no way of knowing if we navigated off the page. So we have to listen for unload
        // and close the child manually if that happens.

        var onunload = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["L" /* once */])(function () {
            _this17.component.log('navigate_away');
            __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */]();
            _this17.destroyComponent();
        });

        var unloadWindowListener = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* addEventListener */])(window, 'unload', onunload);

        this.clean.register('destroyUnloadWindowListener', unloadWindowListener.cancel);
    };

    /*  Load Url
        --------
         Load url into the child window. This is separated out because it's quite common for us to have situations
        where opening the child window and loading the url happen at different points.
    */

    ParentComponent.prototype.loadUrl = function loadUrl(url) {
        var _this18 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this18.component.log('load_url');

            if (window.location.href.split('#')[0] === url.split('#')[0]) {
                var _query;

                url = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["u" /* extendUrl */])(url, {
                    query: (_query = {}, _query[Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_0" /* uniqueID */])()] = '1', _query)
                });
            }

            return _this18.driver.loadUrl.call(_this18, url);
        });
    };

    ParentComponent.prototype.hijack = function hijack(targetElement) {
        targetElement.target = this.childWindowName;
    };

    /*  Run Timeout
        -----------
         Set a timeout on the initial render, and call this.props.onTimeout if we don't get an init call in time.
    */

    ParentComponent.prototype.runTimeout = function runTimeout() {
        var _this19 = this;

        if (this.props.timeout) {
            this.timeout = setTimeout(function () {

                _this19.component.log('timed_out', { timeout: _this19.props.timeout });

                var error = _this19.component.createError('Loading component timed out after ' + _this19.props.timeout + ' milliseconds');

                _this19.onInit.reject(error);
                _this19.props.onTimeout(error);
            }, this.props.timeout);

            this.clean.register(function () {
                clearTimeout(_this19.timeout);
                delete _this19.timeout;
            });
        }
    };

    /*  Listeners
        ---------
         Post-robot listeners to the child component window
    */

    ParentComponent.prototype.listeners = function listeners() {
        var _ref12;

        return _ref12 = {}, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].INIT] = function (source, data) {

            this.childExports = data.exports;

            this.onInit.resolve(this);

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            return {
                props: this.getPropsForChild(),
                context: this.context
            };
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CLOSE] = function (source, data) {
            this.close(data.reason);
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].CHECK_CLOSE] = function (source, data) {
            this.checkClose();
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].RESIZE] = function (source, data) {
            var _this20 = this;

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                if (_this20.driver.allowResize) {
                    return _this20.resize(data.width, data.height);
                }
            });
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ONRESIZE] = function (source, data) {
            this.event.trigger('resize');
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].HIDE] = function (source, data) {
            this.hide();
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].SHOW] = function (source, data) {
            this.show();
        }, _ref12[__WEBPACK_IMPORTED_MODULE_7__constants__["POST_MESSAGE"].ERROR] = function (source, data) {
            this.error(new Error(data.error));
        }, _ref12;
    };

    /*  Resize
        ------
         Resize the child component window
    */

    ParentComponent.prototype.resize = function resize(width, height) {
        var _this21 = this;

        var _ref13 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            _ref13$waitForTransit = _ref13.waitForTransition,
            waitForTransition = _ref13$waitForTransit === undefined ? true : _ref13$waitForTransit;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this21.component.log('resize', { height: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(height), width: Object(__WEBPACK_IMPORTED_MODULE_6__lib__["W" /* stringify */])(width) });
            _this21.driver.resize.call(_this21, width, height);

            if (!waitForTransition) {
                return;
            }

            if (_this21.element || _this21.iframe) {

                var overflow = void 0;

                if (_this21.element) {
                    overflow = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["T" /* setOverflow */])(_this21.element, 'hidden');
                }

                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* elementStoppedMoving */])(_this21.element || _this21.iframe).then(function () {

                    if (overflow) {
                        overflow.reset();
                    }
                });
            }
        });
    };

    /*  Hide
        ----
         Hide the component and any parent template
    */

    ParentComponent.prototype.hide = function hide() {

        if (this.container) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(this.container);
        }

        return this.driver.hide.call(this);
    };

    ParentComponent.prototype.show = function show() {

        if (this.container) {
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["V" /* showElement */])(this.container);
        }

        return this.driver.show.call(this);
    };

    ParentComponent.prototype.checkClose = function checkClose() {
        var _this22 = this;

        var closeWindowListener = Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["B" /* onCloseWindow */])(this.window, function () {
            _this22.userClose();
        }, 50, 500);

        this.clean.register(closeWindowListener.cancel);
    };

    ParentComponent.prototype.userClose = function userClose() {
        return this.close(__WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].USER_CLOSED);
    };

    /*  Close
        -----
         Close the child component
    */

    ParentComponent.prototype.close = function close() {
        var _this23 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this23.component.log('close', { reason: reason });

            _this23.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this23.props.onClose(reason);
        }).then(function () {

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([_this23.closeComponent(), _this23.closeContainer()]);
        }).then(function () {

            return _this23.destroy();
        });
    };

    ParentComponent.prototype.closeContainer = function closeContainer() {
        var _this24 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this24.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this24.props.onClose(reason);
        }).then(function () {

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all([_this24.closeComponent(reason), _this24.hideContainer()]);
        }).then(function () {

            return _this24.destroyContainer();
        });
    };

    ParentComponent.prototype.destroyContainer = function destroyContainer() {
        var _this25 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            _this25.clean.run('destroyContainerEvents');
            _this25.clean.run('destroyContainerTemplate');
        });
    };

    ParentComponent.prototype.closeComponent = function closeComponent() {
        var _this26 = this;

        var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_7__constants__["CLOSE_REASONS"].PARENT_CALL;


        var win = this.window;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            return _this26.cancelContainerEvents();
        }).then(function () {

            _this26.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"].CLOSE);
            return _this26.props.onClose(reason);
        }).then(function () {

            return _this26.hideComponent();
        }).then(function () {

            return _this26.destroyComponent();
        }).then(function () {

            // IE in metro mode -- child window needs to close itself, or close will hang

            if (_this26.childExports && _this26.context === __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"].POPUP && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {
                _this26.childExports.close()['catch'](__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
            }
        });
    };

    ParentComponent.prototype.destroyComponent = function destroyComponent() {
        this.clean.run('destroyUnloadWindowListener');
        this.clean.run('destroyCloseWindowListener');
        this.clean.run('destroyContainerEvents');
        this.clean.run('destroyWindow');
    };

    ParentComponent.prototype.showContainer = function showContainer() {
        var _this27 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this27.props.onDisplay) {
                return _this27.props.onDisplay();
            }
        }).then(function () {
            if (_this27.container) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* showAndAnimate */])(_this27.container, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].SHOW_CONTAINER, _this27.clean.register);
            }
        });
    };

    ParentComponent.prototype.showComponent = function showComponent() {
        var _this28 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this28.props.onDisplay) {
                return _this28.props.onDisplay();
            }
        }).then(function () {
            if (_this28.element) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["U" /* showAndAnimate */])(_this28.element, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].SHOW_COMPONENT, _this28.clean.register);
            }
        });
    };

    ParentComponent.prototype.hideContainer = function hideContainer() {
        var _this29 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this29.container) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* animateAndHide */])(_this29.container, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].HIDE_CONTAINER, _this29.clean.register);
            } else {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }
        });
    };

    ParentComponent.prototype.hideComponent = function hideComponent() {
        var _this30 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this30.element) {
                return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* animateAndHide */])(_this30.element, __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"].HIDE_COMPONENT, _this30.clean.register);
            } else {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }
        });
    };

    /*  Focus
        -----
         Focus the child component window
    */

    ParentComponent.prototype.focus = function focus() {

        if (this.window && !Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["y" /* isWindowClosed */])(this.window)) {
            if (this.driver.openOnFocus) {
                try {
                    var win = window.open('', this.childWindowName);
                    win.focus();
                } catch (err) {
                    // pass
                }
            }

            this.component.log('focus');
            this.window.focus();
        } else {

            throw new Error('No window to focus');
        }
    };

    /*  Create Component Template
        -------------------------
         Creates an initial template and stylesheet which are loaded into the child window, to be displayed before the url is loaded
    */

    ParentComponent.prototype.createPrerenderTemplate = function createPrerenderTemplate() {
        var _this31 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (!_this31.component.prerenderTemplate) {
                return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
            }

            return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                if (_this31.prerenderIframe) {
                    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* awaitFrameLoad */])(_this31.prerenderIframe).then(function () {
                        return _this31.prerenderWindow;
                    });
                } else {
                    return _this31.prerenderWindow;
                }
            }).then(function (win) {

                var doc = void 0;

                try {
                    doc = win.document;
                } catch (err) {
                    return;
                }

                try {
                    Object(__WEBPACK_IMPORTED_MODULE_6__lib__["_3" /* writeElementToWindow */])(win, _this31.renderTemplate(_this31.component.prerenderTemplate, {
                        jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__["F" /* jsxDom */].bind(doc),
                        document: doc
                    }));
                } catch (err) {
                    return;
                }
            });
        });
    };

    /*  Create Parent Template
        ----------------------
         Create a template and stylesheet for the parent template behind the element
    */

    ParentComponent.prototype.renderTemplate = function renderTemplate(renderer) {
        var _this32 = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _ref14 = this.component.dimensions || {},
            _ref14$width = _ref14.width,
            width = _ref14$width === undefined ? __WEBPACK_IMPORTED_MODULE_7__constants__["DEFAULT_DIMENSIONS"].WIDTH + 'px' : _ref14$width,
            _ref14$height = _ref14.height,
            height = _ref14$height === undefined ? __WEBPACK_IMPORTED_MODULE_7__constants__["DEFAULT_DIMENSIONS"].HEIGHT + 'px' : _ref14$height;

        return renderer.call(this, _extends({
            id: __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"].XCOMPONENT + '-' + this.component.tag + '-' + this.props.uid,
            props: renderer.__xdomain__ ? null : this.props,
            tag: this.component.tag,
            context: this.context,
            outlet: this.getOutlet(),
            CLASS: __WEBPACK_IMPORTED_MODULE_7__constants__["CLASS_NAMES"],
            ANIMATION: __WEBPACK_IMPORTED_MODULE_7__constants__["ANIMATION_NAMES"],
            CONTEXT: __WEBPACK_IMPORTED_MODULE_7__constants__["CONTEXT_TYPES"],
            EVENT: __WEBPACK_IMPORTED_MODULE_7__constants__["EVENTS"],
            actions: {
                close: function close() {
                    return _this32.userClose();
                },
                focus: function focus() {
                    return _this32.focus();
                }
            },
            on: function on(eventName, handler) {
                return _this32.on(eventName, handler);
            },
            jsxDom: __WEBPACK_IMPORTED_MODULE_6__lib__["F" /* jsxDom */],
            document: document,
            dimensions: { width: width, height: height }
        }, options));
    };

    ParentComponent.prototype.openContainer = function openContainer(element) {
        var _this33 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            var el = void 0;

            if (element) {
                el = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["x" /* getElement */])(element);
            } else {
                el = document.body;
            }

            if (!el) {
                throw new Error('Could not find element to open container into');
            }

            if (!_this33.component.containerTemplate) {
                if (_this33.driver.renderedIntoContainerTemplate) {
                    throw new Error('containerTemplate needed to render ' + _this33.context);
                }

                return;
            }

            var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                container: el
            });

            _this33.container = container;
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.container);
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* appendChild */])(el, _this33.container);

            if (_this33.driver.renderedIntoContainerTemplate) {
                _this33.element = _this33.getOutlet();
                Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.element);

                if (!_this33.element) {
                    throw new Error('Could not find element to render component into');
                }

                Object(__WEBPACK_IMPORTED_MODULE_6__lib__["A" /* hideElement */])(_this33.element);
            }

            _this33.clean.register('destroyContainerTemplate', function () {

                if (_this33.container && _this33.container.parentNode) {
                    _this33.container.parentNode.removeChild(_this33.container);
                }

                delete _this33.container;
            });
        });
    };

    ParentComponent.prototype.cancelContainerEvents = function cancelContainerEvents() {
        this.clean.run('destroyContainerEvents');
    };

    /*  Destroy
        -------
         Close the component and clean up any listeners and state
    */

    ParentComponent.prototype.destroy = function destroy() {
        var _this34 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (_this34.clean.hasTasks()) {
                _this34.component.log('destroy');
                __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */]();
                return _this34.clean.all();
            }
        });
    };

    ParentComponent.prototype.tryInit = function tryInit(method) {
        var _this35 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method)['catch'](function (err) {
            _this35.onInit.reject(err);
        }).then(function () {
            return _this35.onInit;
        });
    };

    /*  Error
        -----
         Handle an error
    */

    ParentComponent.prototype.error = function error(err) {
        var _this36 = this;

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            _this36.handledErrors = _this36.handledErrors || [];

            if (_this36.handledErrors.indexOf(err) !== -1) {
                // $FlowFixMe
                return;
            }

            _this36.handledErrors.push(err);

            _this36.onInit.reject(err);

            return _this36.destroy();
        }).then(function () {

            if (_this36.props.onError) {
                return _this36.props.onError(err);
            }
        })['catch'](function (errErr) {

            throw new Error('An error was encountered while handling error:\n\n ' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["X" /* stringifyError */])(err) + '\n\n' + Object(__WEBPACK_IMPORTED_MODULE_6__lib__["X" /* stringifyError */])(errErr));
        }).then(function () {

            if (!_this36.props.onError) {
                throw err;
            }
        });
    };

    ParentComponent.destroyAll = function destroyAll() {
        var results = [];

        while (ParentComponent.activeComponents.length) {
            results.push(ParentComponent.activeComponents[0].destroy());
        }

        return __WEBPACK_IMPORTED_MODULE_3_zalgo_promise_src__["a" /* ZalgoPromise */].all(results).then(__WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]);
    };

    _createClass(ParentComponent, [{
        key: 'driver',
        get: function get() {

            if (!this.context) {
                throw new Error('Context not set');
            }

            return __WEBPACK_IMPORTED_MODULE_8__drivers__["a" /* RENDER_DRIVERS */][this.context];
        }
    }]);

    return ParentComponent;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseComponent */]), (_applyDecoratedDescriptor(_class.prototype, 'getOutlet', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'getOutlet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'prefetch', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'prefetch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadHTML', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'loadHTML'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'buildUrl', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'buildUrl'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'open', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'open'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openPrerender', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'openPrerender'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'switchPrerender', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'switchPrerender'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'close'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'closeContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'destroyContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'destroyContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'closeComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'showContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'showComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'hideContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hideComponent', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'hideComponent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createPrerenderTemplate', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'createPrerenderTemplate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openContainer', [__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoized */]], Object.getOwnPropertyDescriptor(_class.prototype, 'openContainer'), _class.prototype)), _class);
ParentComponent.activeComponents = [];

/***/ }),

/***/ "./node_modules/xcomponent/src/component/parent/props.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeProps;
/* harmony export (immutable) */ __webpack_exports__["b"] = propsToQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





function isDefined(value) {
    return value !== null && value !== undefined && value !== '';
}

/*  Normalize Prop
    --------------

    Turn prop into normalized value, using defaults, function options, etc.
*/

function normalizeProp(component, instance, props, key, value) {

    var prop = component.getProp(key);

    var resultValue = void 0;

    if (prop.value) {
        resultValue = prop.value;
    } else if (prop.def && (!props.hasOwnProperty(key) || !isDefined(value))) {
        resultValue = prop.def.call(component, props);
    } else {
        resultValue = value;
    }

    if (!resultValue && prop.alias && props[prop.alias]) {
        resultValue = props[prop.alias];
    }

    var decorated = false;

    if (prop.decorate && resultValue !== null && resultValue !== undefined) {
        resultValue = prop.decorate(resultValue, props);
        decorated = true;
    }

    if (prop.type === 'boolean') {
        // $FlowFixMe
        resultValue = Boolean(resultValue);
    } else if (prop.type === 'function') {

        if (!resultValue && prop.noop) {
            // $FlowFixMe
            resultValue = __WEBPACK_IMPORTED_MODULE_1__lib__["I" /* noop */];

            if (!decorated && prop.decorate) {
                resultValue = prop.decorate(resultValue, props);
            }
        }

        if (resultValue && typeof resultValue === 'function') {

            resultValue = resultValue.bind(instance);

            // If prop.denodeify is set, denodeify the function (accepts callback -> returns promise)

            if (prop.denodeify) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["j" /* denodeify */])(resultValue);
            }

            if (prop.promisify) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["O" /* promisify */])(resultValue);
            }

            // Wrap the function in order to log when it is called

            var original = resultValue;
            // $FlowFixMe
            resultValue = function resultValue() {
                component.log('call_prop_' + key);
                return original.apply(this, arguments);
            };

            // If prop.once is set, ensure the function can only be called once

            if (prop.once) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["L" /* once */])(resultValue);
            }

            // If prop.memoize is set, ensure the function is memoized (first return resultValue is cached and returned for any future calls)

            if (prop.memoize) {
                // $FlowFixMe
                resultValue = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["G" /* memoize */])(resultValue);
            }
        }
    } else if (prop.type === 'string') {
        // pass

    } else if (prop.type === 'object') {
        // pass

    } else if (prop.type === 'number') {
        if (resultValue !== undefined) {
            // $FlowFixMe
            resultValue = parseInt(resultValue, 10);
        }
    }

    // $FlowFixMe
    return resultValue;
}

/*  Normalize Props
    ---------------

    Turn props into normalized values, using defaults, function options, etc.
*/

function normalizeProps(component, instance, props) {
    var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


    var result = {};

    // $FlowFixMe
    props = props || {};

    for (var _iterator = Object.keys(props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;

        if (component.getPropNames().indexOf(key) !== -1) {
            // $FlowFixMe
            result[key] = normalizeProp(component, instance, props, key, props[key]);
        } else {
            result[key] = props[key];
        }
    }

    for (var _iterator2 = component.getPropNames(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var _key = _ref2;

        if (!props.hasOwnProperty(_key) && (!instance.props || !instance.props.hasOwnProperty(_key))) {

            // $FlowFixMe
            var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);

            if (normalizedProp !== undefined) {
                result[_key] = normalizedProp;
            }
        }
    }

    // $FlowFixMe
    return result;
}

/*  Props to Query
    --------------

    Turn props into an initial query string to open the component with

    string -> string
    bool   -> 1
    object -> json
    number -> string
*/

function getQueryParam(prop, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        if (typeof prop.queryParam === 'function') {
            return prop.queryParam(value);
        } else if (typeof prop.queryParam === 'string') {
            return prop.queryParam;
        } else {
            return key;
        }
    });
}

function getQueryValue(prop, key, value) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        if (typeof prop.queryValue === 'function') {
            return prop.queryValue(value);
        } else {
            return value;
        }
    });
}

function propsToQuery(propsDef, props) {

    var params = {};

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all(Object.keys(props).map(function (key) {

        var prop = propsDef[key];

        if (!prop) {
            return;
        }

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve().then(function () {

            var value = props[key];

            if (!value) {
                return;
            }

            if (!prop.queryParam) {
                return;
            }

            return value;
        }).then(function (value) {

            if (!value) {
                return;
            }

            __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([getQueryParam(prop, key, value), getQueryValue(prop, key, value)]).then(function (_ref3) {
                var queryParam = _ref3[0],
                    queryValue = _ref3[1];


                var result = void 0;

                if (typeof queryValue === 'boolean') {
                    result = '1';
                } else if (typeof queryValue === 'string') {
                    result = queryValue.toString();
                } else if (typeof queryValue === 'function') {
                    return;
                } else if ((typeof queryValue === 'undefined' ? 'undefined' : _typeof(queryValue)) === 'object' && queryValue !== null) {

                    if (prop.serialization === 'json') {
                        result = JSON.stringify(queryValue);
                    } else {
                        result = Object(__WEBPACK_IMPORTED_MODULE_1__lib__["o" /* dotify */])(queryValue, key);

                        for (var dotkey in result) {
                            params[dotkey] = result[dotkey];
                        }

                        return;
                    }
                } else if (typeof queryValue === 'number') {
                    result = queryValue.toString();
                }

                params[queryParam] = result;
            });
        });
    })).then(function () {
        return params;
    });
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/parent/validate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = validateProps;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function validateProp(prop, key, value, props) {
    var required = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;


    var hasProp = value !== null && value !== undefined && value !== '';

    if (!hasProp) {
        if (required && prop.required !== false && !prop.hasOwnProperty('def')) {
            throw new Error('Prop is required: ' + key);
        }

        return;
    }

    if (value && typeof value.then === 'function' && prop.promise) {
        return;
    }

    if (prop.type === 'function') {

        if (!(typeof value === 'function')) {
            throw new Error('Prop is not of type function: ' + key);
        }
    } else if (prop.type === 'string') {

        if (typeof value !== 'string') {
            throw new Error('Prop is not of type string: ' + key);
        }
    } else if (prop.type === 'object') {

        // Since we're sending everything by post-message, everything must be json serializable

        try {
            JSON.stringify(value);
        } catch (err) {
            throw new Error('Unable to serialize prop: ' + key);
        }
    } else if (prop.type === 'number') {

        if (isNaN(parseInt(value, 10))) {
            throw new Error('Prop is not a number: ' + key);
        }
    }

    if (typeof prop.validate === 'function' && value) {
        prop.validate(value, props);
    }
}

/*  Validate Props
    --------------

    Validate user-defined props. Users can pass props down from the parent into the child component, but first we
    double check the values are what we expect, based on the props spec defined in the original component.
*/

function validateProps(component, props) {
    var required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


    props = props || {};

    if (props.env && _typeof(component.url) === 'object' && !component.url[props.env]) {
        throw new Error('Invalid env: ' + props.env);
    }

    // Set aliases

    for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;


        // $FlowFixMe
        var prop = component.getProp(key);

        if (prop.alias && props.hasOwnProperty(prop.alias)) {

            var value = props[prop.alias];
            delete props[prop.alias];

            if (!props[key]) {
                props[key] = value;
            }
        }
    }

    // First make sure all of the props we were sent are actually valid prop names

    /*
     if (!component.looseProps) {
        for (let key of Object.keys(props)) {
            if (component.getPropNames().indexOf(key) === -1) {
                throw component.error(`Invalid prop: ${key}`);
            }
        }
    }
     */

    // Then loop over the props we expect, and make sure they're all present and valid

    for (var _iterator2 = Object.keys(props), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var _key = _ref2;


        // $FlowFixMe
        var _prop = component.getProp(_key);
        var _value = props[_key];

        if (_prop) {
            validateProp(_prop, _key, _value, props, required);
        }
    }

    for (var _iterator3 = component.getPropNames(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }

        var _key2 = _ref3;


        // $FlowFixMe
        var _prop2 = component.getProp(_key2);
        var _value2 = props[_key2];

        if (_prop2 && !props.hasOwnProperty(_key2)) {
            validateProp(_prop2, _key2, _value2, props, required);
        }
    }
}

/***/ }),

/***/ "./node_modules/xcomponent/src/component/window.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildChildWindowName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isXComponentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getComponentMeta; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getParentDomain;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getParentComponentWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getParentRenderWindow; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hi_base32__ = __webpack_require__("./node_modules/xcomponent/node_modules/hi-base32/src/base32.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hi_base32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hi_base32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");





function normalize(str) {
    return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, '').replace(/[^a-z0-9A-Z]+/g, '_');
}

/*  Build Child Window Name
    -----------------------

    Build a name for our child window. This should identify the following things to the child:

    - That the window was created by, and is owned by xcomponent
    - The name of the child's parent. This is so the child can identify which window created it, even when we do a
      renderTo, in which case the true parent may actually be a sibling frame in the window hierarchy

    We base64 encode the window name so IE doesn't die when it encounters any characters that it doesn't like.
*/

function buildChildWindowName(name, version) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    options.id = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["_0" /* uniqueID */])();
    options.domain = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["f" /* getDomain */])(window);

    var encodedName = normalize(name);
    var encodedVersion = normalize(version);
    var encodedOptions = __WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.encode(JSON.stringify(options)).replace(/\=/g, '').toLowerCase();

    if (!encodedName) {
        throw new Error('Invalid name: ' + name + ' - must contain alphanumeric characters');
    }

    if (!encodedVersion) {
        throw new Error('Invalid version: ' + version + ' - must contain alphanumeric characters');
    }

    return [__WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"], encodedName, encodedVersion, encodedOptions, ''].join('__');
}

var isXComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {
    if (!window.name) {
        return false;
    }

    var _window$name$split = window.name.split('__'),
        xcomp = _window$name$split[0];

    if (xcomp !== __WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"]) {
        return false;
    }

    return true;
});

/*  Parse Window Name
    -----------------

    The inverse of buildChildWindowName. Base64 decodes and json parses the window name to get the original props
    passed down, including the parent name. Only accepts window names built by xcomponent
*/

var getComponentMeta = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    if (!window.name) {
        throw new Error('Can not get component meta without window name');
    }

    var _window$name$split2 = window.name.split('__'),
        xcomp = _window$name$split2[0],
        name = _window$name$split2[1],
        version = _window$name$split2[2],
        encodedOptions = _window$name$split2[3];

    if (xcomp !== __WEBPACK_IMPORTED_MODULE_3__constants__["XCOMPONENT"]) {
        throw new Error('Window not rendered by xcomponent - got ' + xcomp);
    }

    var componentMeta = void 0;

    try {
        componentMeta = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_hi_base32___default.a.decode(encodedOptions.toUpperCase()));
    } catch (err) {
        throw new Error('Can not decode component-meta');
    }

    componentMeta.name = name;
    componentMeta.version = version.replace(/_/g, '.');

    return componentMeta;
});

function getParentDomain() {
    return getComponentMeta().domain; // How does this work for renderTo..?
}

function getWindowByRef(_ref) {
    var ref = _ref.ref,
        uid = _ref.uid,
        distance = _ref.distance;


    var result = void 0;

    if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].OPENER) {
        result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["k" /* getOpener */])(window);
    } else if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].TOP) {
        result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["m" /* getTop */])(window);
    } else if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].PARENT) {

        if (distance) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["j" /* getNthParentFromTop */])(window, distance);
        } else {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["l" /* getParent */])(window);
        }
    }

    if (ref === __WEBPACK_IMPORTED_MODULE_3__constants__["WINDOW_REFERENCES"].GLOBAL) {
        var ancestor = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["d" /* getAncestor */])(window);

        if (ancestor) {
            for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["c" /* getAllFramesInWindow */])(ancestor), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref2;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref2 = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref2 = _i.value;
                }

                var frame = _ref2;

                var global = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["z" /* globalFor */])(frame);

                if (global && global.windows && global.windows[uid]) {
                    result = global.windows[uid];
                    break;
                }
            }
        }
    }

    if (!result) {
        throw new Error('Unable to find window by ref');
    }

    return result;
}

/*  Get Parent Component Window
    ---------------------------

    Get the parent component window, which may be different from the actual parent window
*/

var getParentComponentWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    var componentMeta = getComponentMeta();

    if (!componentMeta) {
        throw new Error('Can not get parent component window - window not rendered by xcomponent');
    }

    return getWindowByRef(componentMeta.componentParent);
});

var getParentRenderWindow = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["G" /* memoize */])(function () {

    var componentMeta = getComponentMeta();

    if (!componentMeta) {
        throw new Error('Can not get parent component window - window not rendered by xcomponent');
    }

    return getWindowByRef(componentMeta.renderParent);
});

/*  Get Position
    ------------

    Calculate the position for the popup

    This is either
    - Specified by the user
    - The center of the screen

    I'd love to do this with pure css, but alas... popup windows :(
*/

function getPosition(_ref3) {
    var width = _ref3.width,
        height = _ref3.height;


    var x = 0;
    var y = 0;

    if (width) {
        if (window.outerWidth) {
            x = Math.round((window.outerWidth - width) / 2) + window.screenX;
        } else if (window.screen.width) {
            x = Math.round((window.screen.width - width) / 2);
        }
    }

    if (height) {
        if (window.outerHeight) {
            y = Math.round((window.outerHeight - height) / 2) + window.screenY;
        } else if (window.screen.height) {
            y = Math.round((window.screen.height - height) / 2);
        }
    }

    return { x: x, y: y };
}

/***/ }),

/***/ "./node_modules/xcomponent/src/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XCOMPONENT", function() { return XCOMPONENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__XCOMPONENT__", function() { return __XCOMPONENT__; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", function() { return POST_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPES", function() { return PROP_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", function() { return INITIAL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", function() { return WINDOW_REFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", function() { return PROP_TYPES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", function() { return CONTEXT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", function() { return CLASS_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENTS", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() { return ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", function() { return ANIMATION_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", function() { return EVENT_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", function() { return CLOSE_REASONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", function() { return CONTEXT_TYPES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELEGATE", function() { return DELEGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WILDCARD", function() { return WILDCARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", function() { return DEFAULT_DIMENSIONS; });
var XCOMPONENT = 'xcomponent';

var __XCOMPONENT__ = '__' + XCOMPONENT + '__';

var POST_MESSAGE = {
    INIT: XCOMPONENT + '_init',
    PROPS: XCOMPONENT + '_props',
    PROP_CALLBACK: XCOMPONENT + '_prop_callback',
    CLOSE: XCOMPONENT + '_close',
    CHECK_CLOSE: XCOMPONENT + '_check_close',
    REDIRECT: XCOMPONENT + '_redirect',
    RESIZE: XCOMPONENT + '_resize',
    ONRESIZE: XCOMPONENT + '_onresize',
    DELEGATE: XCOMPONENT + '_delegate',
    ALLOW_DELEGATE: XCOMPONENT + '_allow_delegate',
    ERROR: XCOMPONENT + '_error',
    HIDE: XCOMPONENT + '_hide',
    SHOW: XCOMPONENT + '_show'
};

var PROP_TYPES = {
    STRING: 'string',
    OBJECT: 'object',
    FUNCTION: 'function',
    BOOLEAN: 'boolean',
    NUMBER: 'number'
};

var INITIAL_PROPS = {
    RAW: 'raw',
    UID: 'uid'
};

var WINDOW_REFERENCES = {
    OPENER: 'opener',
    TOP: 'top',
    PARENT: 'parent',
    GLOBAL: 'global'
};

var PROP_TYPES_LIST = Object.keys(PROP_TYPES).map(function (key) {
    return PROP_TYPES[key];
});

var CONTEXT_TYPES = {
    IFRAME: 'iframe',
    POPUP: 'popup'
};

var CLASS_NAMES = {
    XCOMPONENT: '' + XCOMPONENT,
    OUTLET: XCOMPONENT + '-outlet',
    COMPONENT_FRAME: XCOMPONENT + '-component-frame',
    PRERENDER_FRAME: XCOMPONENT + '-prerender-frame',
    VISIBLE: XCOMPONENT + '-visible',
    INVISIBLE: XCOMPONENT + '-invisible'
};

var EVENTS = {
    CLOSE: XCOMPONENT + '-close'
};

var ATTRIBUTES = {
    IFRAME_PLACEHOLDER: 'data-xcomponent-' + XCOMPONENT + '-placeholder'
};

var ANIMATION_NAMES = {
    SHOW_CONTAINER: XCOMPONENT + '-show-container',
    SHOW_COMPONENT: XCOMPONENT + '-show-component',
    HIDE_CONTAINER: XCOMPONENT + '-hide-container',
    HIDE_COMPONENT: XCOMPONENT + '-hide-component'
};

var EVENT_NAMES = {
    CLICK: 'click'
};

var CLOSE_REASONS = {
    PARENT_CALL: 'parent_call',
    CHILD_CALL: 'child_call',
    CLOSE_DETECTED: 'close_detected',
    USER_CLOSED: 'user_closed',
    PARENT_CLOSE_DETECTED: 'parent_close_detected'
};

var CONTEXT_TYPES_LIST = Object.keys(CONTEXT_TYPES).map(function (key) {
    return CONTEXT_TYPES[key];
});

var DELEGATE = {
    CALL_ORIGINAL: 'call_original',
    CALL_DELEGATE: 'call_delegate'
};

var WILDCARD = '*';

var DEFAULT_DIMENSIONS = {
    WIDTH: 300,
    HEIGHT: 150
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/angular.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angular; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");



var angular = {
    global: function global() {
        return window.angular;
    },
    register: function register(component, ng) {

        var module = ng.module(component.tag, []).directive(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["i" /* dasherizeToCamel */])(component.tag), function () {

            var scope = {};

            for (var _iterator = component.getPropNames(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var key = _ref;

                scope[key] = '=';
            }

            if (component.looseProps) {
                scope.props = '=';
            }

            return {
                scope: scope,

                restrict: 'E',

                controller: ['$scope', '$element', function ($scope, $element) {

                    if (component.looseProps && !$scope.props) {
                        throw new Error('For angular bindings to work, prop definitions must be passed to xcomponent.create');
                    }

                    component.log('instantiate_angular_component');

                    function safeApply(fn) {
                        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                            try {
                                $scope.$apply();
                            } catch (err) {
                                console.warn('Error trying to scope.apply on prop function call:', err);
                            }
                        }
                    }

                    var getProps = function getProps() {

                        var scopeProps = void 0;

                        if ($scope.props) {
                            scopeProps = $scope.props;
                        } else {
                            scopeProps = {};
                            for (var _iterator2 = Object.keys(scope), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                                var _ref2;

                                if (_isArray2) {
                                    if (_i2 >= _iterator2.length) break;
                                    _ref2 = _iterator2[_i2++];
                                } else {
                                    _i2 = _iterator2.next();
                                    if (_i2.done) break;
                                    _ref2 = _i2.value;
                                }

                                var key = _ref2;

                                if ($scope[key] !== undefined) {
                                    scopeProps[key] = $scope[key];
                                }
                            }
                        }

                        scopeProps = Object(__WEBPACK_IMPORTED_MODULE_0__lib__["Q" /* replaceObject */])(scopeProps, function (value, key, fullKey) {
                            if (typeof value === 'function') {
                                return function () {
                                    var result = value.apply(this, arguments);
                                    safeApply();
                                    return result;
                                };
                            }
                        });

                        return scopeProps;
                    };

                    var parent = component.init(getProps(), null, $element[0]);
                    parent.render($element[0]);

                    $scope.$watch(function () {
                        parent.updateProps(getProps());
                    });
                }]
            };
        });

        return module;
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/angular2.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angular2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* eslint-disable new-cap, object-shorthand */

var angular2 = {
    global: function global() {},
    register: function register(xcomponent, _ref) {
        var AngularComponent = _ref.Component,
            NgModule = _ref.NgModule,
            ElementRef = _ref.ElementRef,
            NgZone = _ref.NgZone;


        xcomponent.log('initializing angular2 component');

        var getProps = function getProps(component) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__lib__["Q" /* replaceObject */])(_extends({}, component.internalProps, component.props), function (value, key, fullKey) {
                if (typeof value === 'function') {
                    return function () {
                        var _this = this,
                            _arguments = arguments;

                        return component.zone.run(function () {
                            return value.apply(_this, _arguments);
                        });
                    };
                }
            });
        };

        var ComponentInstance = AngularComponent({
            selector: xcomponent.tag,
            template: '<div></div>',
            inputs: ['props']
        }).Class({
            constructor: [ElementRef, NgZone, function (elementRef, zone) {
                this.elementRef = elementRef;
                this.zone = zone;
            }],
            ngOnInit: function ngOnInit() {
                var targetElement = this.elementRef.nativeElement;
                var parent = xcomponent.init(getProps(this), null, targetElement);
                parent.render(targetElement);
                this.parent = parent;
            },
            ngOnChanges: function ngOnChanges() {
                if (this.parent) {
                    this.parent.updateProps(getProps(this));
                }
            }
        });

        var ModuleInstance = NgModule({
            declarations: [ComponentInstance],
            exports: [ComponentInstance]
        }).Class({
            constructor: function constructor() {}
        });

        return ModuleInstance;
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/ember.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/glimmer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glimmer; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var glimmer = {
    global: function global() {},
    register: function register(component, GlimmerComponent) {
        return function (_GlimmerComponent) {
            _inherits(_class, _GlimmerComponent);

            function _class() {
                _classCallCheck(this, _class);

                return _possibleConstructorReturn(this, _GlimmerComponent.apply(this, arguments));
            }

            _class.prototype.didInsertElement = function didInsertElement() {
                component.render(_extends({}, this.args), this.element);
            };

            return _class;
        }(GlimmerComponent);
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__script__ = __webpack_require__("./node_modules/xcomponent/src/drivers/script.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "htmlComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__script__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react__ = __webpack_require__("./node_modules/xcomponent/src/drivers/react.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "react", function() { return __WEBPACK_IMPORTED_MODULE_1__react__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue__ = __webpack_require__("./node_modules/xcomponent/src/drivers/vue.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "vue", function() { return __WEBPACK_IMPORTED_MODULE_2__vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular__ = __webpack_require__("./node_modules/xcomponent/src/drivers/angular.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "angular", function() { return __WEBPACK_IMPORTED_MODULE_3__angular__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ember__ = __webpack_require__("./node_modules/xcomponent/src/drivers/ember.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ember___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ember__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_4__ember__) if(["htmlComponent","react","vue","angular","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_4__ember__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__glimmer__ = __webpack_require__("./node_modules/xcomponent/src/drivers/glimmer.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "glimmer", function() { return __WEBPACK_IMPORTED_MODULE_5__glimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular2__ = __webpack_require__("./node_modules/xcomponent/src/drivers/angular2.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "angular2", function() { return __WEBPACK_IMPORTED_MODULE_6__angular2__["a"]; });








/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/react.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return react; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var react = {
    global: function global() {
        if (window.React && window.ReactDOM) {
            return {
                React: window.React,
                ReactDOM: window.ReactDOM
            };
        }
    },
    register: function register(component, _ref) {
        var React = _ref.React,
            ReactDOM = _ref.ReactDOM;


        if (React.createClass) {

            // $FlowFixMe
            component.react = React.createClass({
                displayName: 'react',
                render: function render() {
                    return React.createElement('div', null);
                },
                componentDidMount: function componentDidMount() {
                    component.log('instantiate_react_component');

                    var el = ReactDOM.findDOMNode(this);

                    var parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props), null, el);

                    this.setState({ parent: parent });

                    parent.render(el);
                },
                componentDidUpdate: function componentDidUpdate() {

                    if (this.state && this.state.parent) {
                        this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props));
                    }
                }
            });
        } else {
            // $FlowFixMe
            component.react = function (_React$Component) {
                _inherits(_class, _React$Component);

                function _class() {
                    _classCallCheck(this, _class);

                    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
                }

                _class.prototype.render = function render() {
                    return React.createElement('div', null);
                };

                _class.prototype.componentDidMount = function componentDidMount() {
                    component.log('instantiate_react_component');

                    var el = ReactDOM.findDOMNode(this);

                    var parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props), null, el);

                    this.setState({ parent: parent });

                    parent.render(el);
                };

                _class.prototype.componentDidUpdate = function componentDidUpdate() {

                    if (this.state && this.state.parent) {
                        this.state.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.props));
                    }
                };

                return _class;
            }(React.Component);
        }

        return component.react;
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/script.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlComponent; });


var htmlComponent = {
    global: function global() {
        return window.document;
    },
    register: function register(component, document) {

        function render(element) {

            if (!element || !element.tagName || element.tagName.toLowerCase() !== 'script') {
                return;
            }

            if (!element.attributes.type || element.attributes.type.value !== 'application/x-component' || !element.parentNode) {
                return;
            }

            var tag = element.getAttribute('data-component');

            if (!tag || tag !== component.tag) {
                return;
            }

            component.log('instantiate_script_component_error');

            throw new Error('\n               \'x-component\' script type is no longer supported.  \n               Please migrate to another integration pattern.\n            ');
        }

        function scan() {
            var scriptTags = Array.prototype.slice.call(document.getElementsByTagName('script'));

            for (var _iterator = scriptTags, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var element = _ref;

                render(element);
            }
        }

        scan();
        document.addEventListener('DOMContentLoaded', scan);
        window.addEventListener('load', scan);

        document.addEventListener('DOMNodeInserted', function (event) {
            // $FlowFixMe
            render(event.target);
        });
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/drivers/vue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");



var vue = {
    global: function global() {},
    register: function register(component) {

        return {
            template: '<div></div>',

            inheritAttrs: false,

            mounted: function mounted() {
                var el = this.$el;

                // $FlowFixMe
                this.parent = component.init(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.$attrs), null, el);

                this.parent.render(el);
            },
            beforeUpdate: function beforeUpdate() {

                if (this.parent && this.$attrs) {
                    this.parent.updateProps(Object(__WEBPACK_IMPORTED_MODULE_0__lib__["t" /* extend */])({}, this.$attrs));
                }
            }
        };
    }
};

/***/ }),

/***/ "./node_modules/xcomponent/src/error.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = PopupOpenError;
/* harmony export (immutable) */ __webpack_exports__["a"] = IntegrationError;
/* harmony export (immutable) */ __webpack_exports__["c"] = RenderError;
function PopupOpenError(message) {
    this.message = message;
}

PopupOpenError.prototype = Object.create(Error.prototype);

function IntegrationError(message) {
    this.message = message;
}

IntegrationError.prototype = Object.create(Error.prototype);

function RenderError(message) {
    this.message = message;
}

RenderError.prototype = Object.create(Error.prototype);

/***/ }),

/***/ "./node_modules/xcomponent/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./node_modules/xcomponent/src/interface.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CONSTANTS"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["PopupOpenError"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["create"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["destroyAll"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),

/***/ "./node_modules/xcomponent/src/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (immutable) */ __webpack_exports__["getByTag"] = getByTag;
/* harmony export (immutable) */ __webpack_exports__["destroyAll"] = destroyAll;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postRobot", function() { return postRobot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONSTANTS", function() { return CONSTANTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./node_modules/xcomponent/src/component/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component_parent__ = __webpack_require__("./node_modules/xcomponent/src/component/parent/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentScriptDir", function() { return __WEBPACK_IMPORTED_MODULE_3__lib__["w"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IntegrationError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RenderError", function() { return __WEBPACK_IMPORTED_MODULE_5__error__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");





function create(options) {
    return new __WEBPACK_IMPORTED_MODULE_1__component__["a" /* Component */](options);
}

function getByTag(tag) {
    return __WEBPACK_IMPORTED_MODULE_1__component__["a" /* Component */].getByTag(tag);
}



function destroyAll() {
    return __WEBPACK_IMPORTED_MODULE_2__component_parent__["a" /* ParentComponent */].destroyAll();
}


var postRobot = __WEBPACK_IMPORTED_MODULE_4_post_robot_src__;





var CONSTANTS = __WEBPACK_IMPORTED_MODULE_6__constants__;

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/css.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPerc;
/* harmony export (immutable) */ __webpack_exports__["b"] = isPx;
/* unused harmony export toNum */
/* unused harmony export toPx */
/* harmony export (immutable) */ __webpack_exports__["d"] = toCSS;
/* unused harmony export percOf */
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeDimension;
function isPerc(str) {
    return typeof str === 'string' && /^[0-9]+%$/.test(str);
}

function isPx(str) {
    return typeof str === 'string' && /^[0-9]+px$/.test(str);
}

function toNum(val) {

    if (typeof val === 'number') {
        return val;
    }

    var match = val.match(/^([0-9]+)(px|%)$/);

    if (!match) {
        throw new Error('Could not match css value from ' + val);
    }

    return parseInt(match[1], 10);
}

function toPx(val) {
    return toNum(val) + 'px';
}

function toCSS(val) {

    if (typeof val === 'number') {
        return toPx(val);
    }

    return isPerc(val) ? val : toPx(val);
}

function percOf(num, perc) {
    return parseInt(num * toNum(perc) / 100, 10);
}

function normalizeDimension(dim, max) {
    if (typeof dim === 'number') {
        return dim;
    } else if (isPerc(dim)) {
        return percOf(max, dim);
    } else if (isPx(dim)) {
        return toNum(dim);
    } else {
        throw new Error('Can not normalize dimension: ' + dim);
    }
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/decorators.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoized;
/* unused harmony export promise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");


function memoized(target, name, descriptor) {
    var method = descriptor.value;

    descriptor.value = function memoizedFunction() {

        this.__memoized__ = this.__memoized__ || {};

        if (!this.__memoized__.hasOwnProperty(name)) {
            this.__memoized__[name] = method.apply(this, arguments);
        }

        return this.__memoized__[name];
    };

    descriptor.value.displayName = name + ':memoized';
}

function promise(target, name, descriptor) {
    var method = descriptor.value;

    descriptor.value = function promisifiedFunction() {
        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method, this, arguments);
    };

    descriptor.value.displayName = name + ':promisified';
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/dom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = appendChild;
/* unused harmony export querySelectorAll */
/* unused harmony export getElementSafe */
/* harmony export (immutable) */ __webpack_exports__["n"] = getElement;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return documentReady; });
/* unused harmony export isDocumentReady */
/* harmony export (immutable) */ __webpack_exports__["j"] = elementReady;
/* harmony export (immutable) */ __webpack_exports__["s"] = popup;
/* harmony export (immutable) */ __webpack_exports__["B"] = writeToWindow;
/* harmony export (immutable) */ __webpack_exports__["A"] = writeElementToWindow;
/* unused harmony export setStyle */
/* unused harmony export createElement */
/* harmony export (immutable) */ __webpack_exports__["e"] = awaitFrameLoad;
/* harmony export (immutable) */ __webpack_exports__["f"] = awaitFrameWindow;
/* harmony export (immutable) */ __webpack_exports__["p"] = iframe;
/* harmony export (immutable) */ __webpack_exports__["b"] = addEventListener;
/* unused harmony export scanForJavascript */
/* unused harmony export parseQuery */
/* unused harmony export getQueryParam */
/* unused harmony export formatQuery */
/* unused harmony export extendQuery */
/* harmony export (immutable) */ __webpack_exports__["l"] = extendUrl;
/* harmony export (immutable) */ __webpack_exports__["k"] = elementStoppedMoving;
/* unused harmony export getCurrentDimensions */
/* unused harmony export changeStyle */
/* harmony export (immutable) */ __webpack_exports__["v"] = setOverflow;
/* harmony export (immutable) */ __webpack_exports__["y"] = trackDimensions;
/* harmony export (immutable) */ __webpack_exports__["r"] = onDimensionsChange;
/* harmony export (immutable) */ __webpack_exports__["h"] = dimensionsMatchViewport;
/* unused harmony export bindEvents */
/* unused harmony export setVendorCSS */
/* unused harmony export animate */
/* unused harmony export makeElementVisible */
/* unused harmony export makeElementInvisible */
/* harmony export (immutable) */ __webpack_exports__["x"] = showElement;
/* harmony export (immutable) */ __webpack_exports__["o"] = hideElement;
/* harmony export (immutable) */ __webpack_exports__["g"] = destroyElement;
/* harmony export (immutable) */ __webpack_exports__["w"] = showAndAnimate;
/* harmony export (immutable) */ __webpack_exports__["c"] = animateAndHide;
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["u"] = removeClass;
/* harmony export (immutable) */ __webpack_exports__["m"] = getCurrentScriptDir;
/* unused harmony export getElementName */
/* unused harmony export isElementClosed */
/* harmony export (immutable) */ __webpack_exports__["z"] = watchElementForClose;
/* unused harmony export getHttpType */
/* unused harmony export getHTML */
/* unused harmony export getCSS */
/* unused harmony export getScript */
/* harmony export (immutable) */ __webpack_exports__["t"] = prefetchPage;
/* unused harmony export fixScripts */
/* harmony export (immutable) */ __webpack_exports__["q"] = jsxDom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fn__ = __webpack_require__("./node_modules/xcomponent/src/lib/fn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__("./node_modules/xcomponent/src/error.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









function appendChild(container, child) {
    container.appendChild(child);
}

function isElement(element) {

    if (element instanceof window.Element) {
        return true;
    }

    if (element !== null && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && element.nodeType === 1 && _typeof(element.style) === 'object' && _typeof(element.ownerDocument) === 'object') {
        return true;
    }

    return false;
}

function querySelectorAll(el, selector) {
    return Array.prototype.slice.call(el.querySelectorAll(selector));
}

/*  Get Element
    -----------

    Gets an element based on

    - Element id
    - CSS Query selector
*/

function getElementSafe(id) {

    if (isElement(id)) {
        // $FlowFixMe
        return id;
    }

    if (typeof id === 'string') {
        var element = document.getElementById(id);

        if (element) {
            return element;
        }

        if (document.querySelector) {
            element = document.querySelector(id);
        }

        if (element) {
            return element;
        }
    }
}

function getElement(id) {

    var element = getElementSafe(id);

    if (element) {
        return element;
    }

    throw new Error('Can not find element: ' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(id));
}

var documentReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

    if (window.document.readyState === 'complete') {
        return resolve(window.document);
    }

    var interval = setInterval(function () {
        if (window.document.readyState === 'complete') {
            clearInterval(interval);
            return resolve(window.document);
        }
    }, 10);
});

function isDocumentReady() {
    return window.document.readyState === 'complete';
}

function elementReady(id) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var name = Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(id);
        var el = getElementSafe(id);

        if (el) {
            return resolve(el);
        }

        if (isDocumentReady()) {
            return reject(new Error('Document is ready and element ' + name + ' does not exist'));
        }

        var interval = setInterval(function () {

            el = getElementSafe(id);

            if (el) {
                clearInterval(interval);
                return resolve(el);
            }

            if (isDocumentReady()) {
                clearInterval(interval);
                return reject(new Error('Document is ready and element ' + name + ' does not exist'));
            }
        }, 10);
    });
}

/*  Popup
    -----

    Open a popup window with the specified option map
*/

function popup(url, options) {

    var params = Object.keys(options).map(function (key) {
        if (options[key]) {
            return key + '=' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["k" /* stringify */])(options[key]);
        }
    }).filter(Boolean).join(',');

    var win = void 0;

    try {
        win = window.open(url, options.name, params, true);
    } catch (err) {
        throw new __WEBPACK_IMPORTED_MODULE_5__error__["b" /* PopupOpenError */]('Can not open popup window - ' + (err.stack || err.message));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["y" /* isWindowClosed */])(win)) {
        var err = new __WEBPACK_IMPORTED_MODULE_5__error__["b" /* PopupOpenError */]('Can not open popup window - blocked');
        throw err;
    }

    return win;
}

function writeToWindow(win, html) {
    try {
        win.document.open();
        win.document.write(html);
        win.document.close();
    } catch (err) {
        try {
            win.location = 'javascript: document.open(); document.write(' + JSON.stringify(html) + '); document.close();';
        } catch (err2) {
            // pass
        }
    }
}

function writeElementToWindow(win, el) {

    var tag = el.tagName.toLowerCase();

    if (tag !== 'html') {
        throw new Error('Expected element to be html, got ' + tag);
    }

    var documentElement = win.document.documentElement;

    while (documentElement.children && documentElement.children.length) {
        documentElement.removeChild(documentElement.children[0]);
    }

    while (el.children.length) {
        documentElement.appendChild(el.children[0]);
    }
}

function setStyle(el, styleText) {
    var doc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.document;

    if (el.styleSheet) {
        // $FlowFixMe
        el.styleSheet.cssText = styleText;
    } else {
        el.appendChild(doc.createTextNode(styleText));
    }
}

/*  Create Element
    --------------

    Create an element with style, html, classes, attributes etc. and append it to the specified container
*/

function createElement() {
    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = arguments[2];


    tag = tag.toLowerCase();
    var element = document.createElement(tag);

    if (options.style) {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* extend */])(element.style, options.style);
    }

    if (options['class']) {
        element.className = options['class'].join(' ');
    }

    if (options.attributes) {
        for (var _iterator = Object.keys(options.attributes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var key = _ref;

            element.setAttribute(key, options.attributes[key]);
        }
    }

    if (options.styleSheet) {
        setStyle(element, options.styleSheet);
    }

    if (container) {
        appendChild(container, element);
    }

    if (options.html) {
        if (tag === 'iframe') {
            if (!container || !element.contentWindow) {
                throw new Error('Iframe html can not be written unless container provided and iframe in DOM');
            }

            // $FlowFixMe
            writeToWindow(element.contentWindow, options.html);
        } else {
            element.innerHTML = options.html;
        }
    }

    return element;
}

var awaitFrameLoadPromises = new __WEBPACK_IMPORTED_MODULE_2_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function awaitFrameLoad(frame) {

    if (awaitFrameLoadPromises.has(frame)) {
        var _promise = awaitFrameLoadPromises.get(frame);
        if (_promise) {
            return _promise;
        }
    }

    var promise = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        frame.addEventListener('load', function () {
            Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["z" /* linkFrameWindow */])(frame);
            resolve(frame);
        });

        frame.addEventListener('error', function (err) {
            if (frame.contentWindow) {
                resolve(frame);
            } else {
                reject(err);
            }
        });
    });

    awaitFrameLoadPromises.set(frame, promise);

    return promise;
}

function awaitFrameWindow(frame) {

    if (frame.contentWindow) {
        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(frame.contentWindow);
    }

    return awaitFrameLoad(frame).then(function (loadedFrame) {

        if (!loadedFrame.contentWindow) {
            throw new Error('Could not find window in iframe');
        }

        return loadedFrame.contentWindow;
    });
}

/*  Iframe
    ------

    Open an iframe with the specified container, url, and option property map
*/

function iframe() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var container = arguments[1];


    var el = getElement(container);

    var attributes = options.attributes || {};
    var style = options.style || {};

    var frame = createElement('iframe', {
        attributes: _extends({
            frameBorder: '0',
            allowTransparency: 'true'
        }, attributes),
        style: _extends({
            backgroundColor: 'transparent'
        }, style),
        html: options.html,
        'class': options['class']
    });

    // $FlowFixMe
    awaitFrameLoad(frame);

    el.appendChild(frame);

    if (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) {
        frame.setAttribute('src', options.url || 'about:blank');
    }

    // $FlowFixMe
    return frame;
}

/*  Add Event Listener
    ------------------

    Add DOM Event listener with cancel
*/

function addEventListener(obj, event, handler) {
    obj.addEventListener(event, handler);
    return {
        cancel: function cancel() {
            obj.removeEventListener(event, handler);
        }
    };
}

/*  Scan For Javascript
    -------------------

    Check if the string contains anything which could conceivably be run as javascript if the string is set to innerHTML
*/

function scanForJavascript(str) {

    if (!str) {
        return str;
    }

    if (str.match(/<script|on\w+\s*=|javascript:|expression\s*\(|eval\(|new\s*Function/)) {
        throw new Error('HTML contains potential javascript: ' + str);
    }

    return str;
}

var parseQuery = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["c" /* memoize */])(function (queryString) {

    var params = {};

    if (!queryString) {
        return params;
    }

    if (queryString.indexOf('=') === -1) {
        throw new Error('Can not parse query string params: ' + queryString);
    }

    for (var _iterator2 = queryString.split('&'), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var pair = _ref2;

        pair = pair.split('=');

        if (pair[0] && pair[1]) {
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
    }

    return params;
});

function getQueryParam(name) {
    return parseQuery(window.location.search.slice(1))[name];
}

function formatQuery() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    return Object.keys(obj).filter(function (key) {
        return typeof obj[key] === 'string';
    }).map(function (key) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* urlEncode */])(key) + '=' + Object(__WEBPACK_IMPORTED_MODULE_4__util__["n" /* urlEncode */])(obj[key]);
    }).join('&');
}

function extendQuery(originalQuery) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    if (!props || !Object.keys(props).length) {
        return originalQuery;
    }

    return formatQuery(_extends({}, parseQuery(originalQuery), props));
}

function extendUrl(url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var query = options.query || {};
    var hash = options.hash || {};

    var originalUrl = void 0;
    var originalQuery = void 0;
    var originalHash = void 0;

    var _url$split = url.split('#');

    originalUrl = _url$split[0];
    originalHash = _url$split[1];

    var _originalUrl$split = originalUrl.split('?');

    originalUrl = _originalUrl$split[0];
    originalQuery = _originalUrl$split[1];


    var queryString = extendQuery(originalQuery, query);
    var hashString = extendQuery(originalHash, hash);

    if (queryString) {
        originalUrl = originalUrl + '?' + queryString;
    }

    if (hashString) {
        originalUrl = originalUrl + '#' + hashString;
    }

    return originalUrl;
}

function elementStoppedMoving(element) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        var el = getElement(element);

        var start = el.getBoundingClientRect();

        var interval = void 0;
        var timer = void 0;

        interval = setInterval(function () {
            var end = el.getBoundingClientRect();

            if (start.top === end.top && start.bottom === end.bottom && start.left === end.left && start.right === end.right && start.width === end.width && start.height === end.height) {
                clearTimeout(timer);
                clearInterval(interval);
                return resolve();
            }

            start = end;
        }, 50);

        timer = setTimeout(function () {
            clearInterval(interval);
            reject(new Error('Timed out waiting for element to stop animating after ' + timeout + 'ms'));
        }, timeout);
    });
}

function getCurrentDimensions(el) {
    return {
        width: el.offsetWidth,
        height: el.offsetHeight
    };
}

function changeStyle(el, styles) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        for (var _iterator3 = Object.keys(styles), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var key = _ref3;

            // $FlowFixMe
            el.style[key] = styles[key];
        }

        setTimeout(resolve, 1);
    });
}

function setOverflow(el) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
    var _el$style = el.style,
        overflow = _el$style.overflow,
        overflowX = _el$style.overflowX,
        overflowY = _el$style.overflowY;


    el.style.overflow = el.style.overflowX = el.style.overflowY = value;

    return {
        reset: function reset() {
            el.style.overflow = overflow;
            el.style.overflowX = overflowX;
            el.style.overflowY = overflowY;
        }
    };
}

function dimensionsDiff(one, two, _ref4) {
    var _ref4$width = _ref4.width,
        width = _ref4$width === undefined ? true : _ref4$width,
        _ref4$height = _ref4.height,
        height = _ref4$height === undefined ? true : _ref4$height,
        _ref4$threshold = _ref4.threshold,
        threshold = _ref4$threshold === undefined ? 0 : _ref4$threshold;


    if (width && Math.abs(one.width - two.width) > threshold) {
        return true;
    }

    if (height && Math.abs(one.height - two.height) > threshold) {
        return true;
    }

    return false;
}

function trackDimensions(el, _ref5) {
    var _ref5$width = _ref5.width,
        width = _ref5$width === undefined ? true : _ref5$width,
        _ref5$height = _ref5.height,
        height = _ref5$height === undefined ? true : _ref5$height,
        _ref5$threshold = _ref5.threshold,
        threshold = _ref5$threshold === undefined ? 0 : _ref5$threshold;


    var currentDimensions = getCurrentDimensions(el);

    return {
        check: function check() {
            var newDimensions = getCurrentDimensions(el);

            return {
                changed: dimensionsDiff(currentDimensions, newDimensions, { width: width, height: height, threshold: threshold }),
                dimensions: newDimensions
            };
        },
        reset: function reset() {
            currentDimensions = getCurrentDimensions(el);
        }
    };
}

function onDimensionsChange(el, _ref6) {
    var _ref6$width = _ref6.width,
        width = _ref6$width === undefined ? true : _ref6$width,
        _ref6$height = _ref6.height,
        height = _ref6$height === undefined ? true : _ref6$height,
        _ref6$delay = _ref6.delay,
        delay = _ref6$delay === undefined ? 50 : _ref6$delay,
        _ref6$threshold = _ref6.threshold,
        threshold = _ref6$threshold === undefined ? 0 : _ref6$threshold;


    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        var tracker = trackDimensions(el, { width: width, height: height, threshold: threshold });

        var interval = void 0;

        var resolver = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["a" /* debounce */])(function (dimensions) {
            clearInterval(interval);
            return resolve(dimensions);
        }, delay * 4);

        interval = setInterval(function () {
            var _tracker$check = tracker.check(),
                changed = _tracker$check.changed,
                dimensions = _tracker$check.dimensions;

            if (changed) {
                tracker.reset();
                return resolver(dimensions);
            }
        }, delay);

        function onWindowResize() {
            var _tracker$check2 = tracker.check(),
                changed = _tracker$check2.changed,
                dimensions = _tracker$check2.dimensions;

            if (changed) {
                tracker.reset();
                window.removeEventListener('resize', onWindowResize);
                resolver(dimensions);
            }
        }

        window.addEventListener('resize', onWindowResize);
    });
}

function dimensionsMatchViewport(el, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;


    var dimensions = getCurrentDimensions(el);

    if (width && dimensions.width !== window.innerWidth) {
        return false;
    }

    if (height && dimensions.height !== window.innerHeight) {
        return false;
    }

    return true;
}

function bindEvents(element, eventNames, handler) {

    handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(handler);

    for (var _iterator4 = eventNames, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref8 = _iterator4[_i4++];
        } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref8 = _i4.value;
        }

        var eventName = _ref8;

        element.addEventListener(eventName, handler);
    }

    return {
        cancel: Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(function () {
            for (var _iterator5 = eventNames, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
                var _ref9;

                if (_isArray5) {
                    if (_i5 >= _iterator5.length) break;
                    _ref9 = _iterator5[_i5++];
                } else {
                    _i5 = _iterator5.next();
                    if (_i5.done) break;
                    _ref9 = _i5.value;
                }

                var eventName = _ref9;

                element.removeEventListener(eventName, handler);
            }
        })
    };
}

var VENDOR_PREFIXES = ['webkit', 'moz', 'ms', 'o'];

function setVendorCSS(element, name, value) {

    // $FlowFixMe
    element.style[name] = value;

    var capitalizedName = Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* capitalizeFirstLetter */])(name);

    for (var _iterator6 = VENDOR_PREFIXES, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray6) {
            if (_i6 >= _iterator6.length) break;
            _ref10 = _iterator6[_i6++];
        } else {
            _i6 = _iterator6.next();
            if (_i6.done) break;
            _ref10 = _i6.value;
        }

        var prefix = _ref10;

        // $FlowFixMe
        element.style['' + prefix + capitalizedName] = value;
    }
}

var CSSRule = window.CSSRule;

var KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE;

function isValidAnimation(element, name) {

    var stylesheets = element.ownerDocument.styleSheets;

    try {
        for (var i = 0; i < stylesheets.length; i++) {

            // $FlowFixMe
            var cssRules = stylesheets[i].cssRules;

            if (!cssRules) {
                continue;
            }

            for (var j = 0; j < cssRules.length; j++) {

                var cssRule = cssRules[j];

                if (!cssRule) {
                    continue;
                }

                if (cssRule.type === KEYFRAMES_RULE && cssRule.name === name) {
                    return true;
                }
            }
        }
    } catch (err) {

        return false;
    }

    return false;
}

var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart', 'oAnimationStart', 'MSAnimationStart'];
var ANIMATION_END_EVENTS = ['animationend', 'webkitAnimationEnd', 'oAnimationEnd', 'MSAnimationEnd'];

function animate(element, name, clean) {
    var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var el = getElement(element);

        if (!el || !isValidAnimation(el, name)) {
            return resolve();
        }

        var hasStarted = false;

        var startTimeout = void 0;
        var endTimeout = void 0;
        var startEvent = void 0;
        var endEvent = void 0;

        function cleanUp() {
            setVendorCSS(el, 'animationName', '');
            clearTimeout(startTimeout);
            clearTimeout(endTimeout);
            startEvent.cancel();
            endEvent.cancel();
        }

        startEvent = bindEvents(el, ANIMATION_START_EVENTS, function (event) {

            if (event.target !== el || event.animationName !== name) {
                return;
            }

            clearTimeout(startTimeout);

            event.stopPropagation();

            startEvent.cancel();
            hasStarted = true;

            endTimeout = setTimeout(function () {
                cleanUp();
                resolve();
            }, timeout);
        });

        endEvent = bindEvents(el, ANIMATION_END_EVENTS, function (event) {

            if (event.target !== el || event.animationName !== name) {
                return;
            }

            cleanUp();

            if (typeof event.animationName === 'string' && event.animationName !== name) {
                return reject('Expected animation name to be ' + name + ', found ' + event.animationName);
            }

            return resolve();
        });

        setVendorCSS(el, 'animationName', name);

        startTimeout = setTimeout(function () {
            if (!hasStarted) {
                cleanUp();
                return resolve();
            }
        }, 200);

        if (clean) {
            clean(cleanUp);
        }
    });
}

var STYLE = {

    DISPLAY: {
        NONE: 'none',
        BLOCK: 'block'
    },

    VISIBILITY: {
        VISIBLE: 'visible',
        HIDDEN: 'hidden'
    },

    IMPORTANT: 'important'
};

function makeElementVisible(element) {
    element.style.setProperty('visibility', '');
}

function makeElementInvisible(element) {
    element.style.setProperty('visibility', STYLE.VISIBILITY.HIDDEN, STYLE.IMPORTANT);
}

function showElement(element) {
    element.style.setProperty('display', '');
}

function hideElement(element) {
    element.style.setProperty('display', STYLE.DISPLAY.NONE, STYLE.IMPORTANT);
}

function destroyElement(element) {
    if (element.parentNode) {
        element.parentNode.removeChild(element);
    }
}

function showAndAnimate(element, name, clean) {
    var animation = animate(element, name, clean);
    showElement(element);
    return animation;
}

function animateAndHide(element, name, clean) {
    return animate(element, name, clean).then(function () {
        hideElement(element);
    });
}

function addClass(element, name) {
    if (element.classList) {
        element.classList.add(name);
    } else if (element.className.split(/\s+/).indexOf(name) === -1) {
        element.className += ' ' + name;
    }
}

function removeClass(element, name) {
    if (element.classList) {
        element.classList.remove(name);
    } else if (element.className.split(/\s+/).indexOf(name) !== -1) {
        element.className = element.className.replace(name, '');
    }
}

function getCurrentScriptDir() {
    console.warn('Do not use xcomponent.getCurrentScriptDir() in production -- browser support is limited');

    if (document.currentScript) {
        return document.currentScript.src.split('/').slice(0, -1).join('/');
    }

    return '.';
}

function getElementName(element) {

    if (typeof element === 'string') {
        return element;
    }

    if (!element || !element.tagName) {
        return '<unknown>';
    }

    var name = element.tagName.toLowerCase();

    if (element.id) {
        name += '#' + element.id;
    } else if (element.className) {
        name += '.' + element.className.split(' ').join('.');
    }

    return name;
}

function isElementClosed(el) {
    if (!el || !el.parentNode) {
        return true;
    }
    return false;
}

function watchElementForClose(element, handler) {
    handler = Object(__WEBPACK_IMPORTED_MODULE_3__fn__["e" /* once */])(handler);

    var interval = void 0;

    if (isElementClosed(element)) {
        handler();
    } else {
        interval = Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* safeInterval */])(function () {
            if (isElementClosed(element)) {
                interval.cancel();
                handler();
            }
        }, 50);
    }

    return {
        cancel: function cancel() {
            if (interval) {
                interval.cancel();
            }
        }
    };
}

function getHttpType(contentType, url) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        var req = new window.XMLHttpRequest();

        req.open('GET', url);
        req.setRequestHeader('Accept', contentType);
        req.send(null);

        req.onload = function () {
            resolve(req.responseText);
        };

        req.onerror = function () {
            return reject(new Error('prefetch failed'));
        };
    });
}

function getHTML(url) {
    return getHttpType('text/html', url);
}

function getCSS(url) {
    return getHttpType('text/css', url);
}

function getScript(url) {
    return getHttpType('*/*', url);
}

function prefetchPage(url) {
    return getHTML(url);
}

var JSX_EVENTS = {
    onClick: 'click'
};

function fixScripts(el) {
    var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;

    for (var _iterator7 = querySelectorAll(el, 'script'), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref11;

        if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref11 = _iterator7[_i7++];
        } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref11 = _i7.value;
        }

        var script = _ref11;

        var newScript = doc.createElement('script');
        newScript.text = script.textContent;
        script.parentNode.replaceChild(newScript, script);
    }
}

function jsxDom(name, props, content) {

    name = name.toLowerCase();

    var doc = this && this.createElement ? this : window.document;

    var el = doc.createElement(name);

    for (var prop in props) {
        if (prop in JSX_EVENTS) {
            el.addEventListener(JSX_EVENTS[prop], props[prop]);
        } else if (prop === 'innerHTML') {
            el.innerHTML = props[prop];
            fixScripts(el, doc);
        } else {
            el.setAttribute(prop, props[prop]);
        }
    }

    if (name === 'style') {

        if (typeof content !== 'string') {
            throw new Error('Expected ' + name + ' tag content to be string, got ' + (typeof content === 'undefined' ? 'undefined' : _typeof(content)));
        }

        if (arguments.length > 3) {
            throw new Error('Expected only text content for ' + name + ' tag');
        }

        setStyle(el, content, doc);
    } else if (name === 'iframe') {

        if (arguments.length > 3) {
            throw new Error('Expected only single child node for iframe');
        }

        el.addEventListener('load', function () {
            var win = el.contentWindow;

            if (!win) {
                throw new Error('Expected frame to have contentWindow');
            }

            if (typeof content === 'string') {
                writeToWindow(win, content);
            } else {
                writeElementToWindow(win, content);
            }
        });
    } else if (name === 'script') {

        if (typeof content !== 'string') {
            throw new Error('Expected ' + name + ' tag content to be string, got ' + (typeof content === 'undefined' ? 'undefined' : _typeof(content)));
        }

        if (arguments.length > 3) {
            throw new Error('Expected only text content for ' + name + ' tag');
        }

        el.text = content;
    } else {
        for (var i = 2; i < arguments.length; i++) {
            if (typeof arguments[i] === 'string') {
                var textNode = document.createTextNode(arguments[i]);
                appendChild(el, textNode);
            } else {
                appendChild(el, arguments[i]);
            }
        }
    }

    return el;
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/fn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = noop;
/* harmony export (immutable) */ __webpack_exports__["e"] = once;
/* harmony export (immutable) */ __webpack_exports__["c"] = memoize;
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony export (immutable) */ __webpack_exports__["f"] = serializeFunctions;
/* harmony export (immutable) */ __webpack_exports__["b"] = deserializeFunctions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js");


/*  Noop
    ----

    Do nothing, zilch, nada, zip
*/

function noop() {}
// pass


/*  Once
    ----

    Create a wrapper function which only allows the inner function to run once, otherwise is a noop
*/

function once(method) {

    var called = false;
    var result = void 0;

    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        if (called) {
            return result;
        }

        called = true;
        result = method.apply(this, arguments);
        return result;
    };
}

/*  Memoize
    -------

    Create a wrapper function which caches the result of the first call, then for subsequent calls returns the cached value
*/

function memoize(method) {

    var results = {};

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var cacheKey = void 0;

        try {
            cacheKey = JSON.stringify(Array.prototype.slice.call(arguments), function (key, val) {

                if (typeof val === 'function') {
                    return 'xcomponent:memoize[' + Object(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* getObjectID */])(val) + ']';
                }

                return val;
            });
        } catch (err) {
            throw new Error('Arguments not serializable -- can not be used to memoize');
        }

        if (!results.hasOwnProperty(cacheKey)) {
            results[cacheKey] = method.apply(this, arguments);
        }

        return results[cacheKey];
    };
}

function debounce(method) {
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;


    var timeout = void 0;

    return function () {
        var _this = this,
            _arguments = arguments;

        clearTimeout(timeout);

        timeout = setTimeout(function () {
            return method.apply(_this, _arguments);
        }, time);
    };
}

function serializeFunctions(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* replaceObject */])(obj, function (value, key, fullKey) {
        if (typeof value === 'function') {
            return {
                __type__: '__function__'
            };
        }
    });
}

function deserializeFunctions(obj, handler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* replaceObject */])(obj, function (value, key, fullKey) {
        if (value && value.__type__ === '__function__') {
            return function () {
                return handler({ key: key, fullKey: fullKey, self: this, args: arguments });
            };
        }
    });
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = globalFor;
/* unused harmony export localGlobal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return global; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./node_modules/xcomponent/src/constants.js");



function globalFor(win) {

    if (!Object(__WEBPACK_IMPORTED_MODULE_0_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {
        return;
    }

    if (!win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]]) {
        win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]] = {};
    }

    return win[__WEBPACK_IMPORTED_MODULE_1__constants__["__XCOMPONENT__"]];
}

function localGlobal() {
    var global = globalFor(window);

    if (!global) {
        throw new Error('Could not get local global');
    }

    return global;
}

var global = localGlobal();

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__("./node_modules/xcomponent/src/lib/dom.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__dom__["B"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fn__ = __webpack_require__("./node_modules/xcomponent/src/lib/fn.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_1__fn__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__promise__ = __webpack_require__("./node_modules/xcomponent/src/lib/promise.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_2__promise__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./node_modules/xcomponent/src/lib/util.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_3__util__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css__ = __webpack_require__("./node_modules/xcomponent/src/lib/css.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_4__css__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__decorators__ = __webpack_require__("./node_modules/xcomponent/src/lib/decorators.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_5__decorators__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logger__ = __webpack_require__("./node_modules/xcomponent/src/lib/logger.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_6__logger__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global__ = __webpack_require__("./node_modules/xcomponent/src/lib/global.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_7__global__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_7__global__["b"]; });









/***/ }),

/***/ "./node_modules/xcomponent/src/lib/logger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setLogLevel;
/* harmony export (immutable) */ __webpack_exports__["b"] = info;
/* harmony export (immutable) */ __webpack_exports__["d"] = warn;
/* harmony export (immutable) */ __webpack_exports__["a"] = error;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");



function setLogLevel(logLevel) {
    if (__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["l" /* logLevels */].indexOf(logLevel) === -1) {
        throw new Error('Invalid logLevel: ' + logLevel);
    }
    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["d" /* config */].logLevel = logLevel;
    __WEBPACK_IMPORTED_MODULE_0_post_robot_src__["CONFIG"].LOG_LEVEL = logLevel;
    window.LOG_LEVEL = logLevel;
}

function info(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["j" /* info */]('xc_' + name + '_' + event, payload);
}

/*  Log Warning
    -----------

    Log a warning
*/

function warn(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */]('xc_' + name + '_' + event, payload);
}

/*  Log Error
    ---------

    Log an error
*/

function error(name, event) {
    var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["f" /* error */]('xc_' + name + '_' + event, payload);
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/promise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = denodeify;
/* harmony export (immutable) */ __webpack_exports__["c"] = promisify;
/* unused harmony export delay */
/* harmony export (immutable) */ __webpack_exports__["a"] = cycle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");


/*  DeNodeify
    ---------

    Turns a method from a function which accepts a callback, into a function which returns a promise.
*/

function denodeify(method) {

    return function () {

        var self = this;
        var args = Array.prototype.slice.call(arguments);

        if (args.length >= method.length) {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(method.apply(self, args));
        }

        return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
            args.push(function (err, result) {

                if (err && !(err instanceof Error)) {
                    throw new Error('Passed non-Error object in callback: [ ' + err + ' ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).');
                }

                return err ? reject(err) : resolve(result);
            });
            method.apply(self, args);
        });
    };
}

function promisify(method) {
    return function () {
        var _this = this,
            _arguments = arguments;

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            return method.apply(_this, _arguments);
        });
    };
}

function delay() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        setTimeout(resolve, time);
    });
}

function cycle(method) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](method).then(function () {
        return cycle(method);
    });
}

/***/ }),

/***/ "./node_modules/xcomponent/src/lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = urlEncode;
/* unused harmony export camelToDasherize */
/* harmony export (immutable) */ __webpack_exports__["c"] = dasherizeToCamel;
/* harmony export (immutable) */ __webpack_exports__["f"] = extend;
/* unused harmony export values */
/* harmony export (immutable) */ __webpack_exports__["m"] = uniqueID;
/* unused harmony export stringifyWithFunctions */
/* unused harmony export safeGet */
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalizeFirstLetter;
/* harmony export (immutable) */ __webpack_exports__["g"] = get;
/* harmony export (immutable) */ __webpack_exports__["j"] = safeInterval;
/* unused harmony export safeTimeout */
/* unused harmony export each */
/* harmony export (immutable) */ __webpack_exports__["i"] = replaceObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = copyProp;
/* harmony export (immutable) */ __webpack_exports__["d"] = dotify;
/* harmony export (immutable) */ __webpack_exports__["h"] = getObjectID;
/* unused harmony export regex */
/* unused harmony export regexAll */
/* unused harmony export count */
/* harmony export (immutable) */ __webpack_exports__["k"] = stringify;
/* harmony export (immutable) */ __webpack_exports__["l"] = stringifyError;
/* harmony export (immutable) */ __webpack_exports__["e"] = eventEmitter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__ = __webpack_require__("./node_modules/cross-domain-safe-weakmap/src/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/*  Url Encode
    ----------

    Replace ? and & with encoded values. Allows other values (to create more readable urls than encodeUriComponent)
*/

function urlEncode(str) {
    return str.replace(/\?/g, '%3F').replace(/\&/g, '%26').replace(/#/g, '%23').replace(/\+/g, '%2B');
}

/*  Camel To Dasherize
    ------------------

    Convert camelCaseText to dasherized-text
*/

function camelToDasherize(string) {
    return string.replace(/([A-Z])/g, function (g) {
        return '-' + g.toLowerCase();
    });
}

/*  Dasherize to Camel
    ------------------

    Convert dasherized-text to camelCaseText
*/

function dasherizeToCamel(string) {
    return string.replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}

/*  Extend
    ------

    Extend one object with another
*/

function extend(obj, source) {
    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

/*  Values
    ------

    Get all of the values from an object as an array
*/

function values(obj) {
    var results = [];

    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            results.push(obj[key]);
        }
    }

    return results;
}

/*  Unique ID
    ---------

    Generate a unique, random hex id
*/

function uniqueID() {

    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

/*  Stringify with Functions
    ------------------------

    JSON Stringify with added support for functions
*/

function stringifyWithFunctions(obj) {
    return JSON.stringify(obj, function (key, val) {
        if (typeof val === 'function') {
            return val.toString();
        }
        return val;
    });
}

/*  Safe Get
    --------

    Get a property without throwing error
*/

function safeGet(obj, prop) {

    var result = void 0;

    try {
        result = obj[prop];
    } catch (err) {
        // pass
    }

    return result;
}

/* Capitalize First Letter
   -----------------------
*/

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

/*  Get
    ---

    Recursively gets a deep path from an object, returning a default value if any level is not found
*/

function get(item, path, def) {

    if (!path) {
        return def;
    }

    var pathParts = path.split('.');

    // Loop through each section of our key path

    for (var i = 0; i < pathParts.length; i++) {

        // If we have an object, we can get the key

        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            item = item[pathParts[i]];

            // Otherwise, we should return the default (undefined if not provided)
        } else {
            return def;
        }
    }

    // If our final result is undefined, we should return the default

    return item === undefined ? def : item;
}

/*  Safe Interval
    -------------

    Implement setInterval using setTimeout, to avoid stacking up calls from setInterval
*/

function safeInterval(method, time) {

    var timeout = void 0;

    function runInterval() {
        timeout = setTimeout(runInterval, time);
        method.call();
    }

    timeout = setTimeout(runInterval, time);

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

/*  Safe Interval
    -------------

    Run timeouts at 100ms intervals so we can account for busy browsers
*/

function safeTimeout(method, time) {

    var interval = safeInterval(function () {
        time -= 100;
        if (time <= 0) {
            interval.cancel();
            method();
        }
    }, 100);
}

function each(item, callback) {

    if (!item) {
        return;
    }

    if (item instanceof Array) {
        var len = item.length;
        for (var i = 0; i < len; i++) {
            callback(item[i], i);
        }
    } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
        var keys = Object.keys(item);
        var _len = keys.length;
        for (var _i = 0; _i < _len; _i++) {
            var key = keys[_i];
            callback(item[key], key);
        }
    }
}

function replaceObject(obj, callback) {
    var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';


    var newobj = obj instanceof Array ? [] : {};

    each(obj, function (item, key) {

        var fullKey = parentKey ? parentKey + '.' + key : key;

        var result = callback(item, key, fullKey);

        if (result !== undefined) {
            newobj[key] = result;
        } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            newobj[key] = replaceObject(item, callback, fullKey);
        } else {
            newobj[key] = item;
        }
    });

    // $FlowFixMe
    return newobj;
}

function copyProp(source, target, name, def) {
    if (source.hasOwnProperty(name)) {
        var descriptor = Object.getOwnPropertyDescriptor(source, name);
        Object.defineProperty(target, name, descriptor);
    } else {
        target[name] = def;
    }
}

function dotify(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var newobj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    prefix = prefix ? prefix + '.' : prefix;
    for (var key in obj) {
        if (obj[key] === undefined || obj[key] === null || typeof obj[key] === 'function') {
            continue;
        } else if (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every(function (val) {
            return (typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object';
        })) {
            newobj['' + prefix + key] = obj[key].join(',');
        } else if (obj[key] && _typeof(obj[key]) === 'object') {
            newobj = dotify(obj[key], '' + prefix + key, newobj);
        } else {
            newobj['' + prefix + key] = obj[key].toString();
        }
    }
    return newobj;
}

var objectIDs = new __WEBPACK_IMPORTED_MODULE_0_cross_domain_safe_weakmap_src__["a" /* WeakMap */]();

function getObjectID(obj) {

    if (obj === null || obj === undefined || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' && typeof obj !== 'function') {
        throw new Error('Invalid object');
    }

    var uid = objectIDs.get(obj);

    if (!uid) {
        uid = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) + ':' + uniqueID();
        objectIDs.set(obj, uid);
    }

    return uid;
}

function regex(pattern, string) {
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;


    if (typeof pattern === 'string') {
        pattern = new RegExp(pattern);
    }

    var result = string.slice(start).match(pattern);

    if (!result) {
        return;
    }

    // $FlowFixMe
    var index = result.index;
    var match = result[0];

    return {
        text: match,
        groups: result.slice(1),
        start: start + index,
        end: start + index + match.length,
        length: match.length,

        replace: function replace(text) {

            if (!match) {
                return '';
            }

            return '' + match.slice(0, start + index) + text + match.slice(index + match.length);
        }
    };
}

function regexAll(pattern, string) {

    var matches = [];
    var start = 0;

    while (true) {
        var match = regex(pattern, string, start);

        if (!match) {
            break;
        }

        matches.push(match);
        start = match.end;
    }

    return matches;
}

function count(str, substr) {

    var startIndex = 0;
    var itemCount = 0;

    while (true) {
        var index = str.indexOf(substr, startIndex);

        if (index === -1) {
            break;
        }

        startIndex = index;
        itemCount += 1;
    }

    return itemCount;
}

function stringify(item) {
    if (typeof item === 'string') {
        return item;
    }

    if (item && typeof item.toString === 'function') {
        return item.toString();
    }

    return Object.prototype.toString.call(item);
}

function stringifyError(err) {
    if (err) {
        // $FlowFixMe
        var stack = err.stack,
            message = err.message;


        if (typeof stack === 'string') {
            return stack;
        }

        if (typeof message === 'string') {
            return message;
        }
    }

    return stringify(err);
}

function eventEmitter() {

    var triggered = {};
    var handlers = {};

    return {
        on: function on(eventName, handler) {

            var handlerList = handlers[eventName] = handlers[eventName] || [];

            handlerList.push(handler);

            var cancelled = false;

            return {
                cancel: function cancel() {
                    if (!cancelled) {
                        cancelled = true;
                        handlerList.splice(handlerList.indexOf(handler), 1);
                    }
                }
            };
        },
        once: function once(eventName, handler) {

            var listener = this.on(eventName, function () {
                listener.cancel();
                handler();
            });

            return listener;
        },
        trigger: function trigger(eventName) {

            var handlerList = handlers[eventName];

            if (handlerList) {
                for (var _iterator = handlerList, _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref;

                    if (_isArray) {
                        if (_i2 >= _iterator.length) break;
                        _ref = _iterator[_i2++];
                    } else {
                        _i2 = _iterator.next();
                        if (_i2.done) break;
                        _ref = _i2.value;
                    }

                    var _handler = _ref;

                    _handler();
                }
            }
        },
        triggerOnce: function triggerOnce(eventName) {

            if (triggered[eventName]) {
                return;
            }

            triggered[eventName] = true;
            this.trigger(eventName);
        }
    };
}

/***/ }),

/***/ "./node_modules/zalgo-promise/src/exceptions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatchPossiblyUnhandledError;
/* harmony export (immutable) */ __webpack_exports__["b"] = onPossiblyUnhandledException;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__("./node_modules/zalgo-promise/src/global.js");



function dispatchPossiblyUnhandledError(err) {

    if (Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().dispatchedErrors.indexOf(err) !== -1) {
        return;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().dispatchedErrors.push(err);

    setTimeout(function () {
        throw err;
    }, 1);

    for (var j = 0; j < Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().possiblyUnhandledPromiseHandlers.length; j++) {
        Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().possiblyUnhandledPromiseHandlers[j](err);
    }
}

function onPossiblyUnhandledException(handler) {
    Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().possiblyUnhandledPromiseHandlers.push(handler);

    return {
        cancel: function cancel() {
            Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().possiblyUnhandledPromiseHandlers.splice(Object(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* getGlobal */])().possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
        }
    };
}

/***/ }),

/***/ "./node_modules/zalgo-promise/src/global.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobal;
function getGlobal() {

    var glob = void 0;

    if (typeof window !== 'undefined') {
        glob = window;
    } else if (typeof global !== 'undefined') {
        glob = global;
    } else {
        throw new Error('Can not find global');
    }

    if (!glob.__zalgopromise__) {
        glob.__zalgopromise__ = {
            flushPromises: [],
            activeCount: 0,
            possiblyUnhandledPromiseHandlers: [],
            dispatchedErrors: []
        };
    }

    return glob.__zalgopromise__;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/zalgo-promise/src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise__ = __webpack_require__("./node_modules/zalgo-promise/src/promise.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__promise__["a"]; });


/***/ }),

/***/ "./node_modules/zalgo-promise/src/promise.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZalgoPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("./node_modules/zalgo-promise/src/utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exceptions__ = __webpack_require__("./node_modules/zalgo-promise/src/exceptions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global__ = __webpack_require__("./node_modules/zalgo-promise/src/global.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ZalgoPromise = function () {
    function ZalgoPromise(handler) {
        var _this = this;

        _classCallCheck(this, ZalgoPromise);

        this.resolved = false;
        this.rejected = false;
        this.errorHandled = false;

        this.handlers = [];

        if (handler) {

            var _result = void 0;
            var _error = void 0;
            var resolved = false;
            var rejected = false;
            var isAsync = false;

            try {
                handler(function (res) {
                    if (isAsync) {
                        _this.resolve(res);
                    } else {
                        resolved = true;
                        _result = res;
                    }
                }, function (err) {
                    if (isAsync) {
                        _this.reject(err);
                    } else {
                        rejected = true;
                        _error = err;
                    }
                });
            } catch (err) {
                this.reject(err);
                return;
            }

            isAsync = true;

            if (resolved) {
                // $FlowFixMe
                this.resolve(_result);
            } else if (rejected) {
                this.reject(_error);
            }
        }
    }

    ZalgoPromise.prototype.resolve = function resolve(result) {
        if (this.resolved || this.rejected) {
            return this;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(result)) {
            throw new Error('Can not resolve promise with another promise');
        }

        this.resolved = true;
        this.value = result;
        this.dispatch();

        return this;
    };

    ZalgoPromise.prototype.reject = function reject(error) {
        var _this2 = this;

        if (this.resolved || this.rejected) {
            return this;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(error)) {
            throw new Error('Can not reject promise with another promise');
        }

        if (!error) {
            var _err = error && typeof error.toString === 'function' ? error.toString() : Object.prototype.toString.call(error);
            error = new Error('Expected reject to be called with Error, got ' + _err);
        }

        this.rejected = true;
        this.error = error;

        if (!this.errorHandled) {
            setTimeout(function () {
                if (!_this2.errorHandled) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__["a" /* dispatchPossiblyUnhandledError */])(error);
                }
            }, 1);
        }

        this.dispatch();

        return this;
    };

    ZalgoPromise.prototype.asyncReject = function asyncReject(error) {
        this.errorHandled = true;
        this.reject(error);
    };

    ZalgoPromise.prototype.dispatch = function dispatch() {
        var _this3 = this;

        var dispatching = this.dispatching,
            resolved = this.resolved,
            rejected = this.rejected,
            handlers = this.handlers;


        if (dispatching) {
            return;
        }

        if (!resolved && !rejected) {
            return;
        }

        this.dispatching = true;
        Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().activeCount += 1;

        var _loop = function _loop(i) {
            var _handlers$i = handlers[i],
                onSuccess = _handlers$i.onSuccess,
                onError = _handlers$i.onError,
                promise = _handlers$i.promise;


            var result = void 0;

            if (resolved) {

                try {
                    result = onSuccess ? onSuccess(_this3.value) : _this3.value;
                } catch (err) {
                    promise.reject(err);
                    return 'continue';
                }
            } else if (rejected) {

                if (!onError) {
                    promise.reject(_this3.error);
                    return 'continue';
                }

                try {
                    result = onError(_this3.error);
                } catch (err) {
                    promise.reject(err);
                    return 'continue';
                }
            }

            if (result instanceof ZalgoPromise && (result.resolved || result.rejected)) {

                if (result.resolved) {
                    promise.resolve(result.value);
                } else {
                    promise.reject(result.error);
                }

                result.errorHandled = true;
            } else if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(result)) {

                if (result instanceof ZalgoPromise && (result.resolved || result.rejected)) {
                    if (result.resolved) {
                        promise.resolve(result.value);
                    } else {
                        promise.reject(result.error);
                    }
                } else {
                    // $FlowFixMe
                    result.then(function (res) {
                        promise.resolve(res);
                    }, function (err) {
                        promise.reject(err);
                    });
                }
            } else {

                promise.resolve(result);
            }
        };

        for (var i = 0; i < handlers.length; i++) {
            var _ret = _loop(i);

            if (_ret === 'continue') continue;
        }

        handlers.length = 0;
        this.dispatching = false;
        Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().activeCount -= 1;

        if (Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().activeCount === 0) {
            ZalgoPromise.flushQueue();
        }
    };

    ZalgoPromise.prototype.then = function then(onSuccess, onError) {

        if (onSuccess && typeof onSuccess !== 'function' && !onSuccess.call) {
            throw new Error('Promise.then expected a function for success handler');
        }

        if (onError && typeof onError !== 'function' && !onError.call) {
            throw new Error('Promise.then expected a function for error handler');
        }

        var promise = new ZalgoPromise();

        this.handlers.push({
            promise: promise,
            onSuccess: onSuccess,
            onError: onError
        });

        this.errorHandled = true;

        this.dispatch();

        return promise;
    };

    ZalgoPromise.prototype['catch'] = function _catch(onError) {
        return this.then(undefined, onError);
    };

    ZalgoPromise.prototype['finally'] = function _finally(handler) {
        return this.then(function (result) {
            return ZalgoPromise['try'](handler).then(function () {
                return result;
            });
        }, function (err) {
            return ZalgoPromise['try'](handler).then(function () {
                throw err;
            });
        });
    };

    ZalgoPromise.prototype.timeout = function timeout(time, err) {
        var _this4 = this;

        if (this.resolved || this.rejected) {
            return this;
        }

        var timeout = setTimeout(function () {

            if (_this4.resolved || _this4.rejected) {
                return;
            }

            _this4.reject(err || new Error('Promise timed out after ' + time + 'ms'));
        }, time);

        return this.then(function (result) {
            clearTimeout(timeout);
            return result;
        });
    };

    // $FlowFixMe


    ZalgoPromise.prototype.toPromise = function toPromise() {
        // $FlowFixMe
        if (typeof Promise === 'undefined') {
            throw new Error('Could not find Promise');
        }
        // $FlowFixMe
        return Promise.resolve(this);
    };

    ZalgoPromise.resolve = function resolve(value) {

        if (value instanceof ZalgoPromise) {
            return value;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(value)) {
            // $FlowFixMe
            return new ZalgoPromise(function (resolve, reject) {
                return value.then(resolve, reject);
            });
        }

        return new ZalgoPromise().resolve(value);
    };

    ZalgoPromise.reject = function reject(error) {
        return new ZalgoPromise().reject(error);
    };

    ZalgoPromise.all = function all(promises) {

        var promise = new ZalgoPromise();
        var count = promises.length;
        var results = [];

        if (!count) {
            promise.resolve(results);
            return promise;
        }

        var _loop2 = function _loop2(i) {
            var prom = promises[i];

            if (prom instanceof ZalgoPromise) {
                if (prom.resolved) {
                    results[i] = prom.value;
                    count -= 1;
                    return 'continue';
                }
            } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(prom)) {
                results[i] = prom;
                count -= 1;
                return 'continue';
            }

            ZalgoPromise.resolve(prom).then(function (result) {
                results[i] = result;
                count -= 1;
                if (count === 0) {
                    promise.resolve(results);
                }
            }, function (err) {
                promise.reject(err);
            });
        };

        for (var i = 0; i < promises.length; i++) {
            var _ret2 = _loop2(i);

            if (_ret2 === 'continue') continue;
        }

        if (count === 0) {
            promise.resolve(results);
        }

        return promise;
    };

    ZalgoPromise.hash = function hash(promises) {
        var result = {};

        return ZalgoPromise.all(Object.keys(promises).map(function (key) {
            return ZalgoPromise.resolve(promises[key]).then(function (value) {
                result[key] = value;
            });
        })).then(function () {
            return result;
        });
    };

    ZalgoPromise.map = function map(items, method) {
        // $FlowFixMe
        return ZalgoPromise.all(items.map(method));
    };

    ZalgoPromise.onPossiblyUnhandledException = function onPossiblyUnhandledException(handler) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__exceptions__["b" /* onPossiblyUnhandledException */])(handler);
    };

    ZalgoPromise['try'] = function _try(method, context, args) {

        var result = void 0;

        try {
            // $FlowFixMe
            result = method.apply(context, args || []);
        } catch (err) {
            return ZalgoPromise.reject(err);
        }

        return ZalgoPromise.resolve(result);
    };

    ZalgoPromise.delay = function delay(_delay) {
        return new ZalgoPromise(function (resolve) {
            setTimeout(resolve, _delay);
        });
    };

    ZalgoPromise.isPromise = function isPromise(value) {

        if (value && value instanceof ZalgoPromise) {
            return true;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isPromise */])(value);
    };

    ZalgoPromise.flush = function flush() {
        var promise = new ZalgoPromise();
        Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().flushPromises.push(promise);

        if (Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().activeCount === 0) {
            ZalgoPromise.flushQueue();
        }

        return promise;
    };

    ZalgoPromise.flushQueue = function flushQueue() {
        var promisesToFlush = Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().flushPromises;
        Object(__WEBPACK_IMPORTED_MODULE_2__global__["a" /* getGlobal */])().flushPromises = [];

        for (var _iterator = promisesToFlush, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var _promise = _ref;

            _promise.resolve();
        }
    };

    return ZalgoPromise;
}();



/***/ }),

/***/ "./node_modules/zalgo-promise/src/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;

function isPromise(item) {
    try {
        if (!item) {
            return false;
        }

        if (typeof Promise !== 'undefined' && item instanceof Promise) {
            return true;
        }

        if (typeof window !== 'undefined' && window.Window && item instanceof window.Window) {
            return false;
        }

        if (typeof window !== 'undefined' && window.constructor && item instanceof window.constructor) {
            return false;
        }

        var _toString = {}.toString;

        if (_toString) {
            var name = _toString.call(item);

            if (name === '[object Window]' || name === '[object global]' || name === '[object DOMWindow]') {
                return false;
            }
        }

        if (typeof item.then === 'function') {
            return true;
        }
    } catch (err) {
        return false;
    }

    return false;
}

/***/ }),

/***/ "./src/api/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rest__ = __webpack_require__("./src/api/rest.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__rest__["a"]; });


/***/ }),

/***/ "./src/api/rest.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBillingAgreement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Base64__ = __webpack_require__("./node_modules/Base64/base64.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./src/lib/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var proxyRest = {};

var createAccessToken = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoize */])(function (env, client) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_create_access_token');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (proxyRest.createAccessToken && !proxyRest.createAccessToken.source.closed) {
        return proxyRest.createAccessToken(env, client);
    }

    var basicAuth = Object(__WEBPACK_IMPORTED_MODULE_2_Base64__["btoa"])(clientID + ':');

    return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({

        method: 'post',
        url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].authApiUrls[env],
        headers: {
            Authorization: 'Basic ' + basicAuth
        },
        data: {
            grant_type: 'client_credentials'
        }

    }).then(function (res) {

        if (res && res.error === 'invalid_client') {
            throw new Error('Auth Api invalid ' + env + ' client id: ' + clientID + ':\n\n' + JSON.stringify(res, null, 4));
        }

        if (!res || !res.access_token) {
            throw new Error('Auth Api response error:\n\n' + JSON.stringify(res, null, 4));
        }

        return res.access_token;
    });
}, { time: 10 * 60 * 1000 });

var createExperienceProfile = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* memoize */])(function (env, client) {
    var experienceDetails = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_create_experience_profile');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (proxyRest.createExperienceProfile && !proxyRest.createExperienceProfile.source.closed) {
        return proxyRest.createExperienceProfile(env, client, experienceDetails);
    }

    experienceDetails.temporary = true;
    experienceDetails.name = experienceDetails.name ? experienceDetails.name + '_' + Math.random().toString() : Math.random().toString();

    return createAccessToken(env, client).then(function (accessToken) {

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'post',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].experienceApiUrls[env],
            headers: {
                Authorization: 'Bearer ' + accessToken
            },
            json: experienceDetails
        });
    }).then(function (res) {

        if (res && res.error) {
            throw new Error(res.error);
        }

        if (!res.id) {
            throw new Error('No id in experience profile response:\n\n' + JSON.stringify(res, null, 4));
        }

        return res.id;
    });
}, { time: 10 * 60 * 1000 });

function logPaymentResponse(res) {
    var _track;

    if (!res) {
        return;
    }

    var paymentToken = void 0;
    var paymentID = void 0;

    if (res.id) {
        paymentID = res.id;
    }

    if (res.links && res.links.length) {
        for (var i = 0; i < res.links.length; i++) {
            if (res.links[i].method === 'REDIRECT' && res.links[i].rel === 'approval_url') {
                var match = res.links[i].href.match(/token=((EC-)?[A-Z0-9]{17})/);
                if (match) {
                    paymentToken = match[1];
                }
            }
        }
    }

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].STATE.BUTTON, _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].TRANSITION.CREATE_PAYMENT, _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_5__config__["j" /* PAYMENT_TYPE */].PAY_ID], _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.PAY_ID] = paymentID, _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.TOKEN] = paymentToken, _track[__WEBPACK_IMPORTED_MODULE_5__config__["e" /* FPTI */].KEY.CONTEXT_ID] = paymentID, _track));
}

function getDefaultReturnUrl() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["q" /* isFileProtocol */])() ? 'https://www.paypal.com' : window.location.protocol + '//' + window.location.host;
}

function createPayment(env, client, paymentDetails) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_create_checkout_token');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    var payment = paymentDetails.payment,
        experience = paymentDetails.experience,
        meta = paymentDetails.meta;


    if (!payment) {
        throw new Error('Expected payment details to be passed');
    }

    if (proxyRest.createPayment && !proxyRest.createPayment.source.closed) {
        return proxyRest.createPayment(env, client, { payment: payment, experience: experience, meta: meta });
    }

    payment = _extends({}, payment);
    payment.intent = payment.intent || 'sale';
    payment.redirect_urls = payment.redirect_urls || {};
    payment.redirect_urls.return_url = payment.redirect_urls.return_url || getDefaultReturnUrl();
    payment.redirect_urls.cancel_url = payment.redirect_urls.cancel_url || getDefaultReturnUrl();
    payment.payer = payment.payer || {};
    payment.payer.payment_method = payment.payer.payment_method || 'paypal';

    return createAccessToken(env, client).then(function (accessToken) {

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            if (experience) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(createExperienceProfile(env, client, experience));
            }
        }).then(function (experienceID) {

            if (experienceID) {
                payment.experience_profile_id = experienceID;
            }

            var headers = {
                Authorization: 'Bearer ' + accessToken
            };

            if (meta && meta.partner_attribution_id) {
                headers['PayPal-Partner-Attribution-Id'] = meta.partner_attribution_id;
            }

            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
                method: 'post',
                url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].paymentApiUrls[env],
                headers: headers,
                json: payment
            });
        });
    }).then(function (res) {

        logPaymentResponse(res);

        if (res && res.id) {
            return res.id;
        }

        throw new Error('Payment Api response error:\n\n' + JSON.stringify(res, null, 4));
    });
}

function getPayment(env, client, paymentID) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_get_order');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (!paymentID) {
        throw new Error('Expected payment id');
    }

    if (proxyRest.getPayment && !proxyRest.getPayment.source.closed) {
        return proxyRest.getPayment(env, client, paymentID);
    }

    return createAccessToken(env, client).then(function (accessToken) {

        var headers = {
            Authorization: 'Bearer ' + accessToken
        };

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].paymentApiUrls[env] + '/' + paymentID,
            headers: headers
        });
    });
}

function executePayment(env, client, paymentID, payerID) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_get_order');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (!paymentID) {
        throw new Error('Expected payment id');
    }

    if (proxyRest.executePayment && !proxyRest.executePayment.source.closed) {
        return proxyRest.executePayment(env, client, paymentID);
    }

    return createAccessToken(env, client).then(function (accessToken) {

        var headers = {
            Authorization: 'Bearer ' + accessToken
        };

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'post',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].paymentApiUrls[env] + '/' + paymentID + '/execute',
            headers: headers,
            json: {
                payer_id: payerID
            }
        });
    });
}

function createOrder(env, client, paymentDetails) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_create_order_token');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    var order = paymentDetails.order,
        meta = paymentDetails.meta;


    if (!order) {
        throw new Error('Expected order details to be passed');
    }

    if (proxyRest.createOrder && !proxyRest.createOrder.source.closed) {
        return proxyRest.createOrder(env, client, { order: order, meta: meta });
    }

    order = _extends({}, order);
    order.intent = order.intent || 'CAPTURE';
    order.redirect_urls = order.redirect_urls || {};
    order.redirect_urls.return_url = order.redirect_urls.return_url || getDefaultReturnUrl();
    order.redirect_urls.cancel_url = order.redirect_urls.cancel_url || getDefaultReturnUrl();
    order.purchase_units = order.purchase_units || [];
    order.purchase_units[0] = order.purchase_units[0] || {};
    order.purchase_units.forEach(function (unit) {
        unit.reference_id = unit.reference_id || Math.random().toString();
    });

    return createAccessToken(env, client).then(function (accessToken) {

        var headers = {
            Authorization: 'Bearer ' + accessToken
        };

        if (meta && meta.partner_attribution_id) {
            headers['PayPal-Partner-Attribution-Id'] = meta.partner_attribution_id;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'post',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].orderApiUrls[env],
            headers: headers,
            json: order
        });
    }).then(function (res) {

        logPaymentResponse(res);

        if (res && res.id) {
            return res.id;
        }

        throw new Error('Payment Api response error:\n\n' + JSON.stringify(res, null, 4));
    });
}

function getOrder(env, client, orderID) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_get_order');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (!orderID) {
        throw new Error('Expected order id');
    }

    if (proxyRest.getOrder && !proxyRest.getOrder.source.closed) {
        return proxyRest.getOrder(env, client, orderID);
    }

    return createAccessToken(env, client).then(function (accessToken) {

        var headers = {
            Authorization: 'Bearer ' + accessToken
        };

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'get',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].orderApiUrls[env] + '/' + orderID,
            headers: headers
        });
    });
}

function captureOrder(env, client, orderID) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_get_order');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (!orderID) {
        throw new Error('Expected order id');
    }

    if (proxyRest.captureOrder && !proxyRest.captureOrder.source.closed) {
        return proxyRest.captureOrder(env, client, orderID);
    }

    return createAccessToken(env, client).then(function (accessToken) {

        var headers = {
            Authorization: 'Bearer ' + accessToken
        };

        return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
            method: 'post',
            url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].orderApiUrls[env] + '/' + orderID + '/capture',
            headers: headers,
            json: {
                is_final_capture: true
            }
        });
    });
}

function createBillingAgreement(env, client, billingDetails, experienceDetails) {

    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('rest_api_create_billing_token');

    env = env || __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].env;

    var clientID = client[env];

    if (!clientID) {
        throw new Error('Client ID not found for env: ' + env);
    }

    if (proxyRest.createBillingAgreement && !proxyRest.createBillingAgreement.source.closed) {
        return proxyRest.createBillingAgreement(env, client, billingDetails, experienceDetails);
    }

    billingDetails = _extends({}, billingDetails);
    billingDetails.plan = billingDetails.plan || {};
    billingDetails.plan.merchant_preferences = billingDetails.plan.merchant_preferences || {};
    billingDetails.plan.merchant_preferences.return_url = billingDetails.plan.merchant_preferences.return_url || getDefaultReturnUrl();
    billingDetails.plan.merchant_preferences.cancel_url = billingDetails.plan.merchant_preferences.cancel_url || getDefaultReturnUrl();
    billingDetails.payer = billingDetails.payer || {};
    billingDetails.payer.payment_method = billingDetails.payer.payment_method || 'paypal';

    return createAccessToken(env, client).then(function (accessToken) {

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            if (experienceDetails) {
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(createExperienceProfile(env, client, experienceDetails));
            }
        }).then(function (experienceID) {

            if (experienceID) {
                billingDetails.experience_profile_id = experienceID;
            }

            return Object(__WEBPACK_IMPORTED_MODULE_6__lib__["R" /* request */])({
                method: 'post',
                url: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].billingApiUrls[env],
                headers: {
                    Authorization: 'Bearer ' + accessToken
                },
                json: billingDetails
            });
        });
    }).then(function (res) {

        if (res && res.token_id) {
            return res.token_id;
        }

        throw new Error('Billing Api response error:\n\n' + JSON.stringify(res, null, 4));
    });
}

var rest = {
    payment: {
        create: createPayment,
        get: getPayment,
        execute: executePayment
    },
    order: {
        create: createOrder,
        get: getOrder,
        capture: captureOrder
    },
    billingAgreement: {
        create: createBillingAgreement
    },
    experience: {
        create: createExperienceProfile
    }
};

var PROXY_REST = 'proxy_rest';
var parentWin = Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["d" /* getAncestor */])();

Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["on"])(PROXY_REST, { domain: __WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].paypal_domain_regex }, function (_ref) {
    var data = _ref.data;

    proxyRest = data;
});

if (parentWin && Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* isPayPalDomain */])() && !Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["u" /* isSameDomain */])(parentWin)) {
    Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["send"])(parentWin, PROXY_REST, { createAccessToken: createAccessToken, createExperienceProfile: createExperienceProfile, createPayment: createPayment, getPayment: getPayment, executePayment: executePayment, createBillingAgreement: createBillingAgreement, createOrder: createOrder, getOrder: getOrder, captureOrder: captureOrder })['catch'](function () {
        // pass
    });
}

/***/ }),

/***/ "./src/compat/fallback.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onLegacyPaymentAuthorize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js");






function match(str, pattern) {
    var regmatch = str.match(pattern);
    if (regmatch) {
        return regmatch[1];
    }
}

var onAuthorize = void 0;

// Post-Bridge

if (Object(__WEBPACK_IMPORTED_MODULE_2__lib__["E" /* isPayPalDomain */])()) {
    Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["on"])('onLegacyPaymentAuthorize', { window: window.parent }, function (_ref) {
        var data = _ref.data;

        onAuthorize = data.method;
    });
}

// Button / Merchant

function onLegacyPaymentAuthorize(method) {
    onAuthorize = method;

    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
        if (__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["bridge"] && !Object(__WEBPACK_IMPORTED_MODULE_2__lib__["E" /* isPayPalDomain */])()) {
            return __WEBPACK_IMPORTED_MODULE_0_post_robot_src__["bridge"].openBridge(Object(__WEBPACK_IMPORTED_MODULE_2__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].postBridgeUrl, { version: Object(__WEBPACK_IMPORTED_MODULE_2__lib__["s" /* getScriptVersion */])() }), __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].postBridgeDomain).then(function (postBridge) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["send"])(postBridge, 'onLegacyPaymentAuthorize', { method: method }, { domain: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].paypalDomain }).then(__WEBPACK_IMPORTED_MODULE_2__lib__["I" /* noop */]);
            });
        }
    });
}

window.onLegacyPaymentAuthorize = onLegacyPaymentAuthorize;

// Post-Bridge / Button

window.watchForLegacyFallback = function (win) {
    var interval = setInterval(function () {
        try {
            var isLegacy = win.document.body.innerHTML.indexOf('merchantpaymentweb') !== -1 || win.document.body.innerHTML.indexOf('wapapp') !== -1;

            if (!isLegacy || win.ppxoWatching || win.closed) {
                return;
            }

            win.ppxoWatching = true;

            var XMLHttpRequestsend = win.XMLHttpRequest.prototype.send;

            win.XMLHttpRequest.prototype.send = function overrideXMLHttpRequestSend() {

                if (this._patched) {
                    return XMLHttpRequestsend.apply(this, arguments);
                }

                this._patched = true;

                var self = this;
                var onload = this.onload;

                function listener() {

                    if (self.readyState === self.DONE && self.status === 200 && self.responseText) {

                        try {
                            var response = JSON.parse(self.responseText.replace('while (1);', ''));

                            if (response.type === 'redirect' && response.url && onAuthorize) {

                                var url = response.url;

                                clearInterval(interval);
                                win.close();

                                onAuthorize({
                                    returnUrl: url,
                                    paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                                    billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                                    payerID: match(url, /PayerID=([A-Z0-9]+)/),
                                    paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
                                });

                                onAuthorize = null;

                                if (win.PAYPAL && win.PAYPAL.Checkout && win.PAYPAL.Checkout.XhrResponse && win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES) {
                                    Object.defineProperty(win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES, 'Redirect', {
                                        value: Math.random().toString()
                                    });
                                }

                                if (win.mob && win.mob.Xhr && win.mob.Xhr.prototype._xhrOnReady) {
                                    win.mob.Xhr.prototype._xhrOnReady = __WEBPACK_IMPORTED_MODULE_2__lib__["I" /* noop */];
                                }
                            }
                        } catch (err) {
                            return;
                        }
                    }

                    if (onload) {
                        return onload.apply(this, arguments);
                    }
                }

                if (this.onload !== listener) {

                    try {

                        delete this.onload;
                        this.onload = listener;

                        // $FlowFixMe
                        Object.defineProperty(this, 'onload', {
                            get: function get() {
                                return listener;
                            },
                            set: function set(handler) {
                                onload = handler;
                            }
                        });
                    } catch (err) {

                        // pass
                    }
                }

                return XMLHttpRequestsend.apply(this, arguments);
            };
        } catch (err) {
            // pass
        }
    }, 100);
};

window.onLegacyFallback = window.watchForLegacyFallback;

/***/ }),

/***/ "./src/compat/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fallback__ = __webpack_require__("./src/compat/fallback.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__fallback__["a"]; });


/***/ }),

/***/ "./src/components/button/braintree.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = awaitBraintreeClient;
/* harmony export (immutable) */ __webpack_exports__["b"] = mapPaymentToBraintree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function awaitBraintreeClient(braintree, auth) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(auth).then(function (authorization) {
        return braintree.client.create({ authorization: authorization });
    }).then(function (client) {
        return braintree.paypalCheckout.create({ client: client });
    });
}

var SUPPORTED_REST_FIELDS = {
    intent: 1,
    transactions: [{
        amount: {
            total: 1,
            currency: 1
        }
    }],
    payer: {
        external_selected_funding_instrument_type: 1,
        shipping_address: {
            line1: 1,
            line2: 1,
            city: 1,
            state: 1,
            postal_code: 1,
            country_code: 1,
            phone: 1,
            recipient_name: 1
        }
    },
    application_context: {
        brand_name: 1,
        shipping_preference: 1,
        landing_page: 1
    }
};

function validate(obj, supported, name) {

    var supportedKeys = Object.keys(supported);

    for (var _iterator = Object.keys(obj), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var key = _ref;


        if (supportedKeys.indexOf(key) === -1) {
            throw new Error('Unsupported REST key for Braintree: ' + name + '.' + key);
        }

        if (_typeof(obj[key]) === 'object') {
            validate(obj[key], supported[key], name + '.' + key);
        }
    }
}

function mapPaymentToBraintree(payment) {
    validate(payment, SUPPORTED_REST_FIELDS, 'payment');

    var btPayment = {};

    btPayment.intent = payment.intent || 'sale';
    btPayment.flow = 'checkout';
    btPayment.amount = payment.transactions[0].amount.total;
    btPayment.currency = payment.transactions[0].amount.currency;

    if (payment.payer) {
        if (payment.payer.external_selected_funding_instrument_type === 'CREDIT') {
            btPayment.offerCredit = true;
        }

        if (payment.payer.shipping_address) {
            btPayment.shippingAddressOverride = {
                line1: payment.payer.shipping_address.line1,
                line2: payment.payer.shipping_address.line2,
                city: payment.payer.shipping_address.city,
                state: payment.payer.shipping_address.state,
                postalCode: payment.payer.shipping_address.postal_code,
                countryCode: payment.payer.shipping_address.country_code,
                phone: payment.payer.shipping_address.phone,
                recipientName: payment.payer.shipping_address.recipient_name
            };
        }
    }

    if (payment.application_context) {
        btPayment.displayName = payment.application_context.brand_name;
        btPayment.landingPageType = payment.application_context.landing_page;

        if (payment.application_context) {
            if (payment.application_context.shipping_preference === 'NO_SHIPPING') {
                btPayment.enableShippingAddress = false;
            } else if (payment.application_context.shipping_preference === 'GET_FROM_FILE') {
                btPayment.enableShippingAddress = true;
                btPayment.shippingAddressEditable = true;
            } else if (payment.application_context.shipping_preference === 'SET_PROVIDED_ADDRESS') {
                btPayment.enableShippingAddress = true;
                btPayment.shippingAddressEditable = false;
            }
        }
    }

    return btPayment;
}

/***/ }),

/***/ "./src/components/button/component.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xcomponent_src_component_component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__ = __webpack_require__("./node_modules/braintree-paypal-client-config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkout__ = __webpack_require__("./src/components/checkout/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__("./src/api/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__experiments__ = __webpack_require__("./src/experiments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__ = __webpack_require__("./src/components/checkout/popupBridge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__checkout_util__ = __webpack_require__("./src/components/checkout/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__templates__ = __webpack_require__("./src/components/button/templates/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__templates_component_validate__ = __webpack_require__("./src/components/button/templates/component/validate.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__braintree__ = __webpack_require__("./src/components/button/braintree.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__templates_funding__ = __webpack_require__("./src/components/button/templates/funding.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__templates_config__ = __webpack_require__("./src/components/button/templates/config.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* @jsx jsxDom */
/* eslint max-lines: 0 */






















var Button = Object(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__["c" /* create */])({

    tag: 'paypal-button',
    name: 'ppbutton',

    buildUrl: function buildUrl(props) {
        var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

        return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].buttonUrls[env];
    },


    contexts: {
        iframe: true,
        popup: false
    },

    scrolling: false,

    containerTemplate: __WEBPACK_IMPORTED_MODULE_13__templates__["b" /* containerTemplate */],

    // eslint-disable-next-line no-unused-vars
    prerenderTemplate: function prerenderTemplate(_ref) {
        var _this = this;

        var props = _ref.props,
            jsxDom = _ref.jsxDom;


        var template = jsxDom('div', { innerHTML: Object(__WEBPACK_IMPORTED_MODULE_13__templates__["a" /* componentTemplate */])({ props: props }) });

        template.addEventListener('click', function () {
            Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["p" /* warn */])('button_pre_template_click');

            if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__["l" /* getDomainSetting */])('allow_full_page_fallback')) {
                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('pre_template_force_full_page');

                var checkout = __WEBPACK_IMPORTED_MODULE_5__checkout__["a" /* Checkout */].init({
                    onAuthorize: __WEBPACK_IMPORTED_MODULE_7__lib__["I" /* noop */]
                });

                // eslint-disable-next-line promise/catch-or-return
                checkout.openContainer().then(function () {
                    checkout.showContainer();
                    checkout.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__["a" /* CONSTANTS */].EVENTS.CLOSE);
                });

                _this.props.payment().then(function (token) {
                    window.top.location = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].checkoutUrl, { token: token });
                })['catch'](function (err) {
                    checkout.error(err);
                });
            }
        });

        return jsxDom(
            'html',
            null,
            jsxDom(
                'body',
                null,
                template
            )
        );
    },


    get version() {
        return Object(__WEBPACK_IMPORTED_MODULE_7__lib__["s" /* getScriptVersion */])();
    },

    get domain() {
        return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].paypalDomains;
    },

    attributes: {
        iframe: {
            allowpaymentrequest: 'allowpaymentrequest'
        }
    },

    validate: function validate() {
        if (!Object(__WEBPACK_IMPORTED_MODULE_7__lib__["z" /* isEligible */])()) {
            Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["p" /* warn */])('button_render_ineligible');
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__["C" /* isIEIntranet */])()) {
            throw new Error('Can not render button in IE intranet mode');
        }
    },


    props: {

        sessionID: {
            type: 'string',
            required: false,
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_7__lib__["t" /* getSessionID */])();
            },

            queryParam: true
        },

        buttonSessionID: {
            type: 'string',
            required: false,
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_7__lib__["X" /* uniqueID */])();
            },

            queryParam: true
        },

        env: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;
            },
            validate: function validate(env) {
                if (env) {
                    if (!__WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].paypalUrls[env]) {
                        throw new Error('Invalid env: ' + env);
                    }
                }
            }
        },

        client: {
            type: 'object',
            required: false,
            def: function def() {
                return {};
            },

            sendToChild: false,

            validate: function validate(client, props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

                if (!client[env]) {
                    throw new Error('Client ID not found for env: ' + env);
                }

                if (typeof client[env] === 'string') {
                    if (client[env].match(/^(.)\1+$/)) {
                        throw new Error('Invalid client ID: ' + client[env]);
                    }
                } else if (!__WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].isPromise(client[env])) {
                    throw new Error('Expected client token to be either a string or a promise');
                }
            },
            decorate: function decorate(client) {
                if (client && client.sandbox === 'demo_sandbox_client_id') {
                    client.sandbox = 'AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R';
                }

                if (client && client.production === 'demo_production_client_id') {
                    client.production = 'Aco85QiB9jk8Q3GdsidqKVCXuPAAVbnqm0agscHCL2-K2Lu2L6MxDU2AwTZa-ALMn_N0z-s2MXKJBxqJ';
                }

                return client;
            }
        },

        source: {
            type: 'string',
            required: false,
            def: function def() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["l" /* SOURCE */].MANUAL;
            }
        },

        prefetchLogin: {
            type: 'boolean',
            required: false
        },

        onRememberUser: {
            type: 'function',
            required: false,
            decorate: function decorate(original, props) {
                if (original) {
                    var source = Object(__WEBPACK_IMPORTED_MODULE_17__templates_config__["h" /* labelToFunding */])(props.style && props.style.label);
                    // eslint-disable-next-line promise/catch-or-return
                    Object(__WEBPACK_IMPORTED_MODULE_7__lib__["A" /* isFundingRemembered */])(source).then(function (result) {
                        if (result && original) {
                            original();
                        }
                    });
                    return original;
                }
            }
        },

        stage: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def(props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

                if (env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].STAGE || env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].LOCAL) {
                    return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].stage;
                }
            }
        },

        braintree: {
            type: 'object',
            required: false,
            validate: function validate(braintree, props) {

                if (!braintree.paypalCheckout) {
                    throw new Error('Expected Braintree paypal-checkout component to be loaded');
                }

                if (!props.client) {
                    throw new Error('Expected client prop to be passed with Braintree authorization keys');
                }
            },
            decorate: function decorate(braintree, props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;
                // $FlowFixMe
                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].hash(props.client).then(function (client) {
                    return Object(__WEBPACK_IMPORTED_MODULE_15__braintree__["a" /* awaitBraintreeClient */])(braintree, client[env]);
                });
            }
        },

        payment: {
            type: 'function',
            required: true,
            memoize: false,
            timeout:  false ? 500 : 10 * 1000,
            alias: 'billingAgreement',

            decorate: function decorate(original) {
                return function payment() {
                    var _this2 = this;

                    var data = {};

                    var actions = {
                        request: __WEBPACK_IMPORTED_MODULE_7__lib__["R" /* request */],
                        payment: {
                            create: function create(options) {
                                return _this2.props.braintree ? _this2.props.braintree.then(function (client) {
                                    return client.createPayment(Object(__WEBPACK_IMPORTED_MODULE_15__braintree__["b" /* mapPaymentToBraintree */])(options.payment || options));
                                }) : __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].hash(_this2.props.client).then(function (client) {
                                    return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* rest */].payment.create(_this2.props.env, client, options);
                                });
                            }
                        },
                        order: {
                            create: function create(options) {
                                return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].hash(_this2.props.client).then(function (client) {
                                    return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* rest */].order.create(_this2.props.env, client, options);
                                });
                            }
                        },
                        braintree: {
                            create: function create(options) {
                                if (!_this2.props.braintree) {
                                    throw new Error('Can not create using Braintree - no braintree client provided');
                                }

                                return _this2.props.braintree.then(function (client) {
                                    return client.createPayment(options);
                                });
                            }
                        }
                    };

                    var timeout =  false ? 500 : 10 * 1000;

                    if (Object(__WEBPACK_IMPORTED_MODULE_7__lib__["l" /* getDomainSetting */])('memoize_payment') && this.memoizedToken) {
                        return this.memoizedToken;
                    }

                    this.memoizedToken = __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](original, this, [data, actions]);

                    if (this.props.env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].PRODUCTION && !Object(__WEBPACK_IMPORTED_MODULE_7__lib__["l" /* getDomainSetting */])('disable_payment_timeout')) {
                        this.memoizedToken = this.memoizedToken.timeout(timeout, new Error('Timed out waiting ' + timeout + 'ms for payment'));
                    }

                    this.memoizedToken = this.memoizedToken.then(function (token) {
                        var _track;

                        if (!token) {
                            Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["f" /* error */])('no_token_passed_to_payment');
                            throw new Error('No value passed to payment');
                        }

                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.CHECKOUT, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.RECIEVE_PAYMENT, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].CONTEXT_TYPE[Object(__WEBPACK_IMPORTED_MODULE_11__checkout_util__["c" /* getPaymentType */])(token)], _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.CONTEXT_ID] = token, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = _this2.props.buttonSessionID, _track));

                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();

                        return token;
                    });

                    return this.memoizedToken;
                };
            }
        },

        funding: {
            type: 'object',
            required: false,
            queryParam: true,
            validate: function validate() {
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref2$allowed = _ref2.allowed,
                    allowed = _ref2$allowed === undefined ? [] : _ref2$allowed,
                    _ref2$disallowed = _ref2.disallowed,
                    disallowed = _ref2$disallowed === undefined ? [] : _ref2$disallowed;

                Object(__WEBPACK_IMPORTED_MODULE_16__templates_funding__["c" /* validateFunding */])({ allowed: allowed, disallowed: disallowed, remembered: [] });
            },
            def: function def() {
                return {};
            },
            decorate: function decorate() {
                var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                    _ref3$allowed = _ref3.allowed,
                    allowed = _ref3$allowed === undefined ? [] : _ref3$allowed,
                    _ref3$disallowed = _ref3.disallowed,
                    disallowed = _ref3$disallowed === undefined ? [] : _ref3$disallowed;

                if (allowed && allowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO) !== -1 && !Object(__WEBPACK_IMPORTED_MODULE_7__lib__["x" /* isDevice */])()) {
                    allowed.splice(allowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO), 1);
                }

                var remembered = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["p" /* getRememberedFunding */])(function (sources) {
                    return sources;
                });

                if (!Object(__WEBPACK_IMPORTED_MODULE_7__lib__["x" /* isDevice */])() || Object(__WEBPACK_IMPORTED_MODULE_7__lib__["l" /* getDomainSetting */])('disable_venmo')) {
                    if (remembered && remembered.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO) !== -1) {
                        remembered.splice(remembered.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO), 1);
                    }

                    if (disallowed && disallowed.indexOf(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO) === -1) {
                        disallowed.push(__WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].VENMO);
                    }
                }

                for (var _iterator = Object(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__["get"])(__WEBPACK_IMPORTED_MODULE_4_braintree_paypal_client_config__["KEY"].PAYPAL_FUNDING_DISALLOW, []), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref4;

                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref4 = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref4 = _i.value;
                    }

                    var source = _ref4;

                    if (disallowed.indexOf(source) === -1) {
                        disallowed.push(source);
                    }
                }

                return {
                    allowed: allowed,
                    disallowed: disallowed,
                    remembered: remembered,
                    remember: function remember(sources) {
                        Object(__WEBPACK_IMPORTED_MODULE_7__lib__["Q" /* rememberFunding */])(sources);
                    }
                };
            }
        },

        commit: {
            type: 'boolean',
            required: false
        },

        onRender: {
            type: 'function',
            promisify: true,
            required: false,
            noop: true,
            decorate: function decorate(original) {
                return function decorateOnRender() {
                    var _track2;

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.LOAD, _track2[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.BUTTON_RENDER, _track2[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].BUTTON_TYPE.IFRAME, _track2[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track2[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SOURCE] = this.props.source, _track2));
                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();

                    return original.apply(this, arguments);
                };
            }
        },

        onAuthorize: {
            type: 'function',
            required: true,

            decorate: function decorate(original) {
                return function decorateOnAuthorize(data, actions) {
                    var _track3,
                        _this3 = this;

                    if (data && !data.intent) {
                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["p" /* warn */])('button_authorize_no_intent', { paymentID: data.paymentID, token: data.paymentToken });
                    }

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('button_authorize');

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track3 = {}, _track3[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.CHECKOUT, _track3[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.CHECKOUT_AUTHORIZE, _track3[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track3));

                    if (!Object(__WEBPACK_IMPORTED_MODULE_7__lib__["z" /* isEligible */])()) {
                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('button_authorize_ineligible');
                    }

                    Object(__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* checkRecognizedBrowser */])('authorize');

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();

                    actions.order = {
                        get: function get() {
                            return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* rest */].order.get(_this3.props.env, _this3.props.client, data.orderID || data.paymentToken);
                        },
                        capture: function capture() {
                            return __WEBPACK_IMPORTED_MODULE_8__api__["a" /* rest */].order.capture(_this3.props.env, _this3.props.client, data.orderID || data.paymentToken);
                        }
                    };

                    var restart = actions.restart;
                    actions.restart = function () {
                        return restart().then(function () {
                            return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]();
                        });
                    };

                    actions.redirect = function (win, url) {
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([Object(__WEBPACK_IMPORTED_MODULE_7__lib__["P" /* redirect */])(win || window.top, url || data.returnUrl), actions.close()]);
                    };

                    actions.payment.tokenize = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["H" /* memoize */])(function () {
                        if (!_this3.props.braintree) {
                            throw new Error('Must pass in Braintree client to tokenize payment');
                        }

                        return _this3.props.braintree.then(function (client) {
                            return client.tokenizePayment(data);
                        }).then(function (res) {
                            return { nonce: res.nonce };
                        });
                    });

                    var execute = actions.payment.execute;
                    actions.payment.execute = function () {
                        return execute().then(function (result) {

                            if (!result || !result.id || !result.intent || !result.state) {
                                Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["p" /* warn */])('execute_result_missing_data');
                                return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]();
                            }

                            return result;
                        });
                    };

                    actions.request = __WEBPACK_IMPORTED_MODULE_7__lib__["R" /* request */];

                    __WEBPACK_IMPORTED_MODULE_9__experiments__["b" /* onAuthorizeListener */].trigger({
                        paymentToken: data.paymentToken
                    });

                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                        if (_this3.props.braintree) {
                            return actions.payment.tokenize().then(function (_ref5) {
                                var nonce = _ref5.nonce;

                                // $FlowFixMe
                                Object.defineProperty(data, 'nonce', {
                                    get: function get() {
                                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('nonce_getter');
                                        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();
                                        return nonce;
                                    }
                                });
                            });
                        }
                    }).then(function () {
                        return original.call(_this3, data, actions);
                    })['catch'](function (err) {
                        if (_this3.props.onError) {
                            return _this3.props.onError(err);
                        }
                        throw err;
                    });
                };
            }
        },

        onCancel: {
            type: 'function',
            required: false,
            noop: true,

            decorate: function decorate(original) {
                return function decorateOnCancel(data, actions) {
                    var _track4;

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('button_cancel');

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track4 = {}, _track4[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.CHECKOUT, _track4[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.CHECKOUT_CANCEL, _track4[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track4));

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();

                    var redirect = function redirect(win, url) {
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([Object(__WEBPACK_IMPORTED_MODULE_7__lib__["P" /* redirect */])(win || window.top, url || data.cancelUrl), actions.close()]);
                    };

                    return original.call(this, data, _extends({}, actions, { redirect: redirect }));
                };
            }
        },

        onClick: {
            type: 'function',
            required: false,
            noop: true,
            decorate: function decorate(original) {
                return function decorateOnClick(data) {
                    var _track5;

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["j" /* info */])('button_click');

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track5 = {}, _track5[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.BUTTON, _track5[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.BUTTON_CLICK, _track5[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].BUTTON_TYPE.IFRAME, _track5[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track5[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), _track5));

                    Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();

                    return original.apply(this, arguments);
                };
            }
        },

        locale: {
            type: 'string',
            required: false,
            queryParam: 'locale.x',

            def: function def() {
                var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["i" /* getBrowserLocale */])(),
                    lang = _getBrowserLocale.lang,
                    country = _getBrowserLocale.country;

                return lang + '_' + country;
            },


            validate: __WEBPACK_IMPORTED_MODULE_14__templates_component_validate__["a" /* validateButtonLocale */]
        },

        style: {
            type: 'object',
            required: false,
            queryParam: true,
            alias: 'buttonStyle',

            def: function def() {
                return {
                    color: __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* BUTTON_COLOR */].GOLD,
                    shape: __WEBPACK_IMPORTED_MODULE_12__constants__["h" /* BUTTON_SHAPE */].PILL,
                    size: __WEBPACK_IMPORTED_MODULE_12__constants__["i" /* BUTTON_SIZE */].SMALL,
                    label: __WEBPACK_IMPORTED_MODULE_12__constants__["c" /* BUTTON_LABEL */].CHECKOUT,
                    fundingicons: false
                };
            },
            validate: function validate() {
                var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                Object(__WEBPACK_IMPORTED_MODULE_14__templates_component_validate__["c" /* validateButtonStyle */])(style);
            }
        },

        displayTo: {
            type: 'string',
            required: false,
            def: function def() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["m" /* USERS */].ALL;
            }
        },

        validate: {
            type: 'function',
            required: false
        },

        logLevel: {
            type: 'string',
            required: false,
            get value() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].logLevel;
            }
        },

        popupBridge: {
            type: 'object',
            required: false,
            get value() {
                return {
                    open: Object(__WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__["b" /* getPopupBridgeOpener */])(),
                    awaitOpener: __WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__["a" /* awaitPopupBridgeOpener */]
                };
            }
        },

        test: {
            type: 'object',
            required: false,
            def: function def() {
                return { action: 'checkout' };
            }
        }
    }
});

if (Button.isChild()) {

    // eslint-disable-next-line promise/catch-or-return
    Object(__WEBPACK_IMPORTED_MODULE_7__lib__["n" /* getPageRenderTime */])().then(function (pageRenderTime) {
        var _track6;

        var fundingSources = Array.prototype.slice.call(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_6__config__["a" /* ATTRIBUTE */].FUNDING_SOURCE + ']')).map(function (el) {
            return el.getAttribute(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* ATTRIBUTE */].CARD) || el.getAttribute(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* ATTRIBUTE */].FUNDING_SOURCE);
        }).filter(function (source) {
            return source && source !== __WEBPACK_IMPORTED_MODULE_6__config__["f" /* FUNDING */].CARD;
        });

        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["o" /* track */])((_track6 = {}, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.BUTTON, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.BUTTON_LOAD, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].BUTTON_TYPE.IFRAME, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.FUNDING_LIST] = fundingSources.join(':'), _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.FUNDING_COUNT] = fundingSources.length, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.PAGE_LOAD_TIME] = pageRenderTime, _track6[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.BUTTON_LAYOUT] = window.xprops && window.xprops.style && window.xprops.style.layout || __WEBPACK_IMPORTED_MODULE_12__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL, _track6));

        Object(__WEBPACK_IMPORTED_MODULE_3_beaver_logger_client__["g" /* flush */])();
    });

    if (window.xprops.logLevel) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib__["T" /* setLogLevel */])(window.xprops.logLevel);
    }

    Object(__WEBPACK_IMPORTED_MODULE_10__checkout_popupBridge__["a" /* awaitPopupBridgeOpener */])();
}

/***/ }),

/***/ "./src/components/button/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BUTTON_STYLE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUTTON_LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUTTON_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUTTON_LOGO_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BUTTON_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BUTTON_TAGLINE_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BUTTON_SHAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON_BRANDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUTTON_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BUTTON_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUTTON_LOGO; });
var DEFAULT = 'default';

var BUTTON_STYLE_OPTIONS = {
    LABEL: 'label',
    SIZE: 'size',
    SHAPE: 'shape',
    COLOR: 'color',
    LAYOUT: 'layout',
    MAXBUTTONS: 'maxbuttons',
    FUNDINGICONS: 'fundingicons',
    BRANDING: 'branding',
    TAGLINE: 'tagline',
    HEIGHT: 'height'
};

var BUTTON_LABEL = {
    PAYPAL: 'paypal',
    CHECKOUT: 'checkout',
    PAY: 'pay',
    CREDIT: 'credit',
    CARD: 'card',
    BUYNOW: 'buynow',
    VENMO: 'venmo',
    IDEAL: 'ideal',
    ELV: 'elv'
};

var BUTTON_COLOR = {
    GOLD: 'gold',
    BLUE: 'blue',
    SILVER: 'silver',
    BLACK: 'black',
    DARKBLUE: 'darkblue',
    TRANSPARENT: 'transparent'
};

var BUTTON_LOGO_COLOR = {
    BLUE: 'blue',
    WHITE: 'white',
    BLACK: 'black',
    ANY: 'any'
};

var BUTTON_SIZE = {
    TINY: 'tiny',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    HUGE: 'huge',
    RESPONSIVE: 'responsive'
};

var BUTTON_TAGLINE_COLOR = {
    BLACK: 'black',
    BLUE: 'blue'
};

var BUTTON_SHAPE = {
    PILL: 'pill',
    RECT: 'rect'
};

var BUTTON_BRANDING = {
    BRANDED: 'branded',
    UNBRANDED: 'unbranded'
};

var BUTTON_LAYOUT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
};

var BUTTON_NUMBER = {
    SINGLE: 'single',
    MULTIPLE: 'multiple'
};

var BUTTON_LOGO = {
    PP: 'pp',
    PAYPAL: 'paypal',
    VENMO: 'venmo',
    CREDIT: 'credit',
    IDEAL: 'ideal',
    ELV: 'elv'
};

/***/ }),

/***/ "./src/components/button/hacks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("./src/api/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__login__ = __webpack_require__("./src/components/login/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__checkout__ = __webpack_require__("./src/components/checkout/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("./src/components/button/component.jsx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("./src/components/button/constants.js");














Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* rest */].payment, 'create', function (_ref) {
    var createOriginal = _ref.original,
        createContext = _ref.context,
        _ref$args = _ref.args,
        env = _ref$args[0],
        client = _ref$args[1],
        options = _ref$args[2],
        experience = _ref$args[3];

    if (!options.payment) {
        options = { payment: options, experience: experience };
    }
    return createOriginal.call(createContext, env, client, options);
});

Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* Button */].props.style, 'validate', function (_ref2) {
    var callOriginal = _ref2.callOriginal,
        _ref2$args = _ref2.args,
        style = _ref2$args[0];


    if (!style) {
        return callOriginal();
    }

    if (style && style.color === 'creditblue') {
        style.color = __WEBPACK_IMPORTED_MODULE_10__constants__["b" /* BUTTON_COLOR */].DARKBLUE;
    }

    if (style && style.label === 'generic') {
        style.label = __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* BUTTON_LABEL */].PAYPAL;
    }

    if (style && (!style.label || style.label === __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* BUTTON_LABEL */].CHECKOUT) && style.size === 'tiny') {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('unsupported_button_size_tiny');
        style.size = __WEBPACK_IMPORTED_MODULE_10__constants__["i" /* BUTTON_SIZE */].SMALL;
    }

    return callOriginal();
});

Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* Button */], 'render', function (_ref3) {
    var callOriginal = _ref3.callOriginal,
        _ref3$args = _ref3.args,
        props = _ref3$args[0];


    if (props.billingAgreement) {
        props.payment = props.billingAgreement;
        delete props.billingAgreement;
    }

    return callOriginal();
});

Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* Button */].props.payment, 'decorate', function (_ref4) {
    var original = _ref4.original,
        context = _ref4.context,
        _ref4$args = _ref4.args,
        originalPayment = _ref4$args[0];

    return original.call(context, function payment(data, actions) {
        var _this = this;

        return new __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(actions.payment, 'create', function (_ref5) {
                var createOriginal = _ref5.original,
                    createContext = _ref5.context,
                    _ref5$args = _ref5.args,
                    options = _ref5$args[0],
                    experience = _ref5$args[1];

                if (!options.payment) {
                    options = { payment: options, experience: experience };
                }
                return createOriginal.call(createContext, options);
            });

            function resolveData(token) {
                resolve(token);
            }

            function rejectActions(err) {
                reject(err);
            }

            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* extend */])(resolveData, data);
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* extend */])(resolveData, actions);
            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* extend */])(rejectActions, actions);

            var ctx = {
                props: {
                    env: _this.props.env,
                    client: _this.props.client
                }
            };

            var result = void 0;

            try {
                result = originalPayment.call(ctx, resolveData, rejectActions);
            } catch (err) {
                return reject(err);
            }

            if (result && typeof result.then === 'function') {
                return result.then(resolve, reject);
            }

            if (result !== undefined) {
                return resolve(result);
            }
        });
    });
});

if (__WEBPACK_IMPORTED_MODULE_9__component__["a" /* Button */].isChild()) {

    if (!window.Promise) {
        window.Promise = __WEBPACK_IMPORTED_MODULE_2_zalgo_promise_src__["a" /* ZalgoPromise */];
    }

    var debounce = false;

    Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */], 'renderTo', function (_ref6) {
        var callOriginal = _ref6.callOriginal,
            _ref6$args = _ref6.args,
            props = _ref6$args[1];


        if (debounce) {
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('button_mutliple_click_debounce');
            return;
        }

        debounce = true;

        var _arr = ['onAuthorize', 'onCancel', 'onError', 'onClose'];

        var _loop = function _loop() {
            var methodName = _arr[_i];
            var original = props[methodName];
            props[methodName] = function unDebounce() {
                debounce = false;
                if (original) {
                    return original.apply(this, arguments);
                }
            };
        };

        for (var _i = 0; _i < _arr.length; _i++) {
            _loop();
        }

        return callOriginal();
    });

    if (window.xprops.validate) {

        var enabled = true;

        window.xprops.validate({
            enable: function enable() {
                enabled = true;
            },
            disable: function disable() {
                enabled = false;
            }
        });

        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */], 'renderTo', function (_ref7) {
            var callOriginal = _ref7.callOriginal;

            if (enabled) {
                return callOriginal();
            }
        });
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* isIE */])() && Object(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* getDomainSetting */])('ie_full_page')) {
        // $FlowFixMe
        __WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */].renderTo = function (win) {
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('force_ie_full_page');
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */])();

            var checkout = __WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */].init({
                onAuthorize: __WEBPACK_IMPORTED_MODULE_6__lib__["I" /* noop */]
            });

            checkout.delegate(win);

            // eslint-disable-next-line promise/catch-or-return
            checkout.openContainer().then(function () {
                checkout.event.triggerOnce(__WEBPACK_IMPORTED_MODULE_1_xcomponent_src__["a" /* CONSTANTS */].EVENTS.CLOSE);
                checkout.showContainer();
            });

            window.xprops.payment().then(function (token) {
                window.top.location = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].checkoutUrl, { token: token });
            })['catch'](function (err) {
                checkout.error(err);
            });
        };
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_6__lib__["l" /* getDomainSetting */])('allow_full_page_fallback')) {
        Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */], 'renderTo', function (_ref8) {
            var callOriginal = _ref8.callOriginal,
                _ref8$args = _ref8.args,
                props = _ref8$args[1];

            var handleError = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["L" /* once */])(function (err) {
                try {
                    // eslint-disable-next-line no-console
                    console.error(err && err.stack);
                } catch (err2) {// eslint-disable-line unicorn/catch-error-name
                    // pass
                }
                return window.xprops.payment().then(function (token) {
                    window.top.location = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_5__config__["n" /* config */].checkoutUrl, { token: token });
                });
            });

            props.onError = handleError;
            return callOriginal()['catch'](handleError);
        });
    }

    Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_7__login__["a" /* Login */], 'prerender', function (_ref9) {
        var callOriginal = _ref9.callOriginal,
            _ref9$args = _ref9.args,
            props = _ref9$args[0];

        delete props.env;
        return callOriginal();
    });

    var parent = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__["l" /* getParent */])(window);
    var top = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__["m" /* getTop */])(window);

    if (top && parent) {
        var canRenderTop = top === parent;

        if (!canRenderTop) {
            // eslint-disable-next-line promise/catch-or-return
            __WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */].canRenderTo(top).then(function (result) {
                canRenderTop = result;
            });

            Object(__WEBPACK_IMPORTED_MODULE_6__lib__["N" /* patchMethod */])(__WEBPACK_IMPORTED_MODULE_8__checkout__["a" /* Checkout */], 'renderTo', function (_ref10) {
                var _ref10$args = _ref10.args,
                    win = _ref10$args[0],
                    props = _ref10$args[1],
                    el = _ref10$args[2],
                    original = _ref10.original,
                    context = _ref10.context;


                if (!canRenderTop) {
                    win = Object(__WEBPACK_IMPORTED_MODULE_3_cross_domain_utils_src__["l" /* getParent */])(window);
                }

                return original.call(context, win, props, el);
            });
        }
    }
}

/***/ }),

/***/ "./src/components/button/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hacks__ = __webpack_require__("./src/components/button/hacks.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./src/components/button/component.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__component__["a"]; });
 // eslint-disable-line import/no-unassigned-import



/***/ }),

/***/ "./src/components/button/templates/component/content.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content_json__ = __webpack_require__("./src/components/button/templates/component/content.json");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__content_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__content_json__);


var componentContent = typeof __WEBPACK_IMPORTED_MODULE_0__content_json___default.a === 'string' ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__content_json___default.a) : __WEBPACK_IMPORTED_MODULE_0__content_json___default.a;

/***/ }),

/***/ "./src/components/button/templates/component/content.json":
/***/ (function(module, exports) {

module.exports = "{\n    \"AD\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        },\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        }\n    },\n    \"AG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AL\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"AM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AN\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AO\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AR\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"AT\": {\n        \"de\": {\n            \"checkout\": \"Direkt zu {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Einfach schneller und sicherer bezahlen\",\n            \"later_tag\": \"Kaufen Sie jetzt und bezahlen Sie nach und nach.\",\n            \"pay\": \"Mit {logo:paypal} zahlen\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Jetzt kaufen\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"AU\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"AW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"AZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BB\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BE\": {\n        \"en\": {\n            \"checkout\": \"Pay with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, faster way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"nl\": {\n            \"checkout\": \"Betalen met {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"De veiligere en snellere manier om te betalen.\",\n\n            \"later_tag\": \"Koop nu. Betaal later.\",\n            \"pay\": \"Betalen met {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Nu kopen\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Le r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        }\n    },\n    \"BF\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BH\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BI\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BJ\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BN\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BO\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BR\": {\n        \"pt\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Finalizar\",\n            \"safer_tag\": \"A maneira f\\u00e1cil e segura de enviar pagamentos.\",\n            \"later_tag\": \"Compre agora e pague depois.\",\n            \"pay\": \"Pague com {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar agora\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BT\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"BY\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"BZ\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"C2\": {\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\\u3002\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"CA\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Payer\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer\",\n            \"later_tag\": \"Acheter. Payer plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        }\n    },\n    \"CD\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CH\": {\n        \"de\": {\n            \"checkout\": \"Direkt zu {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Einfach schneller und sicherer bezahlen\",\n            \"later_tag\": \"Kaufen Sie jetzt und bezahlen Sie nach und nach.\",\n            \"pay\": \"Mit {logo:paypal} zahlen\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Jetzt kaufen\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Le r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"CI\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"CK\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CL\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CM\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"CN\": {\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CO\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CR\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CV\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"CY\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"CZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"DE\": {\n        \"de\": {\n            \"checkout\": \"Direkt zu {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u00dcberall schnell und sicher bezahlen.\",\n            \"later_tag\": \"Kaufen Sie jetzt und bezahlen Sie nach und nach.\",\n            \"pay\": \"Mit {logo:paypal} zahlen\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Jetzt kaufen\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"DJ\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"DK\": {\n        \"da\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Betal\",\n            \"safer_tag\": \"Betal nemt og sikkert\",\n            \"later_tag\": \"K\\u00f8b nu, betal senere.\",\n            \"pay\": \"Betal med {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} K\\u00f8b nu\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"DM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"DO\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"DZ\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"EC\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"EE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"ru\": {\n            \"checkout\": \"\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.\",\n            \"later_tag\": \"\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.\",\n            \"pay\": \"\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"EG\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ER\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ES\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"ET\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"FI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"FJ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"FK\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"FM\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"FO\": {\n        \"da\": {\n            \"checkout\": \"Betal med {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Betal nemt og sikkert\",\n\n            \"later_tag\": \"K\\u00f8b nu, betal senere.\",\n            \"pay\": \"Betal med {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} K\\u00f8b nu\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"FR\": {\n        \"fr\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Payer\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pay\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"GA\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GB\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"GD\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GF\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GL\": {\n        \"da\": {\n            \"checkout\": \"Betal med {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Betal nemt og sikkert\",\n\n            \"later_tag\": \"K\\u00f8b nu, betal senere.\",\n            \"pay\": \"Betal med {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} K\\u00f8b nu\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GN\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GP\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GR\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GT\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"GY\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"HK\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} \\u7d50\\u5e33\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u65b9\\u4fbf\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u5148\\u8cfc\\u8cb7\\uff0c\\u5f8c\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u4f7f\\u7528 {logo:paypal} \\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8cb7\"\n        }\n    },\n    \"HN\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"HR\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"HU\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ID\": {\n        \"id\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"Cara yang lebih mudah dan aman untuk membayar.\",\n\n            \"later_tag\": \"Beli Sekarang. Bayar dalam Jangka Waktu Tertentu.\",\n            \"pay\": \"Bayar dengan {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Beli Sekarang\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"IE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"IL\": {\n        \"he\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} \\u05e9\\u05dc\\u05dd\",\n            \"safer_tag\": \".\\u05d4\\u05d3\\u05e8\\u05da \\u05d4\\u05e7\\u05dc\\u05d4 \\u05d5\\u05d4\\u05d1\\u05d8\\u05d5\\u05d7\\u05d4 \\u05d9\\u05d5\\u05ea\\u05e8 \\u05dc\\u05e9\\u05dc\\u05dd\",\n\n            \"later_tag\": \"\\u05e7\\u05e0\\u05d4 \\u05e2\\u05db\\u05e9\\u05d9\\u05d5. \\u05e9\\u05dc\\u05dd \\u05dc\\u05d0\\u05d5\\u05e8\\u05da \\u05d6\\u05de\\u05df.\",\n            \"pay\": \"\\u05e9\\u05dc\\u05dd \\u05d1\\u05d0\\u05de\\u05e6\\u05e2\\u05d5\\u05ea {logo:paypal}\\u200f\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u05e7\\u05e0\\u05d4 \\u05e2\\u05db\\u05e9\\u05d9\\u05d5\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"IN\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"IS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"IT\": {\n        \"it\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Paga adesso\",\n            \"safer_tag\": \"Il modo rapido e sicuro per pagare\",\n\n            \"later_tag\": \"Acquista ora. Paga pi\\u00f9 tardi.\",\n            \"pay\": \"Paga con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Paga adesso\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"JM\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"JO\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"JP\": {\n        \"ja\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u3067\\u652f\\u6255\\u3046\",\n            \"safer_tag\": \"\\u3088\\u308a\\u5b89\\u5168\\u30fb\\u7c21\\u5358\\u306b\\u304a\\u652f\\u6255\\u3044\",\n\n            \"later_tag\": \"\\u4eca\\u3059\\u3050\\u8cfc\\u5165\\u3057\\u3066\\u3001\\u5206\\u5272\\u3057\\u3066\\u304a\\u652f\\u6255\\u3044\\u3002\",\n            \"pay\": \"{logo:paypal}\\u3067\\u652f\\u6255\\u3046\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u8cfc\\u5165\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"KE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KH\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"KI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KM\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KN\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KR\": {\n        \"ko\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} \\uccb4\\ud06c \\uc544\\uc6c3\",\n            \"safer_tag\": \"\\ub354 \\uc548\\uc804\\ud558\\uace0 \\ube60\\ub978 \\uacb0\\uc81c \\ubc29\\ubc95\",\n\n            \"later_tag\": \"\\uc9c0\\uae08 \\uad6c\\ub9e4\\ud558\\uace0 \\ucc9c\\ucc9c\\ud788 \\uacb0\\uc81c\\ud558\\uc138\\uc694.\",\n            \"pay\": \"{logo:paypal}\\ub85c \\uc9c0\\ubd88\\ud558\\uae30\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\ubc14\\ub85c \\uad6c\\ub9e4\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"KW\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KY\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"KZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LA\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"LC\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LK\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"LS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LT\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"ru\": {\n            \"checkout\": \"\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.\",\n\n            \"later_tag\": \"\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.\",\n            \"pay\": \"\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LU\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"de\": {\n            \"checkout\": \"Direkt zu {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Einfach schneller und sicherer bezahlen\",\n\n            \"later_tag\": \"Kaufen Sie jetzt und bezahlen Sie nach und nach.\",\n            \"pay\": \"Mit {logo:paypal} zahlen\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Jetzt kaufen\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"LV\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"ru\": {\n            \"checkout\": \"\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.\",\n\n            \"later_tag\": \"\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.\",\n            \"pay\": \"\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MA\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MC\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MD\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"ME\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MH\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MK\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"ML\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MN\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MQ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MR\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MT\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MU\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MV\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"MX\": {\n        \"es\": {\n            \"checkout\": \"Pagar con {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MY\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"MZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NC\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NE\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NF\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"NI\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NL\": {\n        \"nl\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Betalen\",\n            \"safer_tag\": \"Een veilige en makkelijke manier om te betalen.\",\n\n            \"later_tag\": \"Koop nu. Betaal later.\",\n            \"pay\": \"Betalen met {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Nu kopen\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"NO\": {\n        \"no\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Betal\",\n            \"safer_tag\": \"En trygg og enkel betalingsmetode\",\n\n            \"later_tag\": \"Kj\\u00f8p n\\u00e5, betal senere.\",\n            \"pay\": \"Betal med {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Kj\\u00f8p n\\u00e5\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"NP\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"NR\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NU\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"NZ\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Payer\",\n            \"safer_tag\": \"Un r\\u00e9flexe s\\u00e9curit\\u00e9.\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar.\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\\u3002\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"OM\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PA\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PE\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PF\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PH\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"PL\": {\n        \"pl\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Do kasy\",\n            \"safer_tag\": \"P\\u0142a\\u0107 wygodnie i bezpiecznie\",\n\n            \"later_tag\": \"Kup teraz. P\\u0142a\\u0107 w ratach\",\n            \"pay\": \"Zap\\u0142a\\u0107 z {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Kup teraz\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"PM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PN\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PT\": {\n        \"pt\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A forma r\\u00e1pida e segura de pagar\",\n\n            \"later_tag\": \"Compre agora. V\\u00e1 pagando.\",\n            \"pay\": \"Pagar com {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar agora\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"PW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"PY\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"QA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        },\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        }\n    },\n    \"RE\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"RO\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"RS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"RU\": {\n        \"ru\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u043f\\u043e\\u043a\\u0443\\u043f\\u043a\\u0443\",\n            \"safer_tag\": \"\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.\",\n\n            \"later_tag\": \"\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.\",\n            \"pay\": \"\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"RW\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SA\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SB\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SC\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SE\": {\n        \"sv\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Betala\",\n            \"safer_tag\": \"Ett tryggt och smidigt s\\u00e4tt att betala\",\n            \"later_tag\": \"K\\u00f6p nu, betala senare\",\n            \"pay\": \"Betala med {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} K\\u00f6p nu\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"SG\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"SH\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SI\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SJ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SK\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SL\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SN\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SO\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SR\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ST\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SV\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"SZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TC\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TD\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TG\": {\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TH\": {\n        \"th\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} \\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19\",\n            \"safer_tag\": \"\\u0e27\\u0e34\\u0e18\\u0e35\\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19\\u0e17\\u0e35\\u0e48\\u0e1b\\u0e25\\u0e2d\\u0e14\\u0e20\\u0e31\\u0e22\\u0e41\\u0e25\\u0e30\\u0e07\\u0e48\\u0e32\\u0e22\\u0e01\\u0e27\\u0e48\\u0e32\",\n\n            \"later_tag\": \"\\u0e0b\\u0e37\\u0e49\\u0e2d\\u0e27\\u0e31\\u0e19\\u0e19\\u0e35\\u0e49 \\u0e41\\u0e25\\u0e49\\u0e27\\u0e04\\u0e48\\u0e2d\\u0e22\\u0e46 \\u0e08\\u0e48\\u0e32\\u0e22\\u0e17\\u0e35\\u0e2b\\u0e25\\u0e31\\u0e07\",\n            \"pay\": \"\\u0e0a\\u0e33\\u0e23\\u0e30\\u0e40\\u0e07\\u0e34\\u0e19\\u0e14\\u0e49\\u0e27\\u0e22 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0e0b\\u0e37\\u0e49\\u0e2d\\u0e17\\u0e31\\u0e19\\u0e17\\u0e35\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"TJ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TN\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TO\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"TR\": {\n        \"tr\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} ile Sat\\u0131n Al\\u0131n\",\n            \"safer_tag\": \"\\u00d6deme yapman\\u0131n daha g\\u00fcvenli ve kolay yolu\",\n\n            \"later_tag\": \"\\u015eimdi Al\\u0131n. Daha Sonra \\u00d6deyin.\",\n            \"pay\": \"{logo:paypal} ile \\u00d6de\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Hemen Sat\\u0131n Al\\u0131n\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"TT\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TV\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"TW\": {\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} \\u7d50\\u5e33\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u65b9\\u4fbf\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u5148\\u8cfc\\u8cb7\\uff0c\\u5f8c\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u4f7f\\u7528 {logo:paypal} \\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8cfc\"\n        },\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"TZ\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"UA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"ru\": {\n            \"checkout\": \"\\u041e\\u0444\\u043e\\u0440\\u043c\\u0438\\u0442\\u044c \\u0437\\u0430\\u043a\\u0430\\u0437 \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0411\\u043e\\u043b\\u0435\\u0435 \\u0431\\u0435\\u0437\\u043e\\u043f\\u0430\\u0441\\u043d\\u044b\\u0439 \\u0438 \\u043f\\u0440\\u043e\\u0441\\u0442\\u043e\\u0439 \\u0441\\u043f\\u043e\\u0441\\u043e\\u0431 \\u043e\\u043f\\u043b\\u0430\\u0442\\u044b.\",\n\n            \"later_tag\": \"\\u041f\\u043e\\u043a\\u0443\\u043f\\u0430\\u0439\\u0442\\u0435 \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441, \\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u0435 \\u043f\\u043e\\u0442\\u043e\\u043c.\",\n            \"pay\": \"\\u041e\\u043f\\u043b\\u0430\\u0442\\u0438\\u0442\\u044c \\u0447\\u0435\\u0440\\u0435\\u0437 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u041a\\u0443\\u043f\\u0438\\u0442\\u044c \\u0441\\u0435\\u0439\\u0447\\u0430\\u0441\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"UG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"US\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"dual_tag\": \"Two easy ways to pay\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Payer\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"Pagar con {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"\\u4f7f\\u7528{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"UY\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"VA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"VC\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"VE\": {\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"VG\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"VN\": {\n        \"en\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Checkout\",\n            \"safer_tag\": \"A safer, faster way to pay.\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"VU\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"WF\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"WS\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    },\n    \"YE\": {\n        \"ar\": {\n            \"checkout\": \"\\u0627\\u0644\\u0633\\u062f\\u0627\\u062f \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"\\u0627\\u0644\\u0637\\u0631\\u064a\\u0642\\u0629 \\u0627\\u0644\\u0623\\u0633\\u0647\\u0644 \\u0648\\u0627\\u0644\\u0623\\u0643\\u062b\\u0631 \\u0623\\u0645\\u0627\\u0646\\u0627\\u064b \\u0641\\u064a \\u0627\\u0644\\u062f\\u0641\\u0639\",\n            \"later_tag\": \"\\u0627\\u0634\\u062a\\u0631\\u0650 \\u0627\\u0644\\u0622\\u0646\\u060c \\u0648\\u0633\\u062f\\u0651\\u062f \\u0639\\u0644\\u0649 \\u062f\\u0641\\u0639\\u0627\\u062a\",\n            \"pay\": \"\\u062f\\u0641\\u0639 \\u0628\\u0648\\u0627\\u0633\\u0637\\u0629 {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u0634\\u0631\\u0627\\u0621 \\u0627\\u0644\\u0622\\u0646\"\n        },\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"YT\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ZA\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ZM\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        },\n        \"fr\": {\n            \"checkout\": \"Payer avec {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"Votre r\\u00e9flexe s\\u00e9curit\\u00e9 pour payer en ligne\",\n            \"later_tag\": \"Achetez maintenant et payez plus tard.\",\n            \"pay\": \"Payer avec {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Acheter\"\n        },\n        \"es\": {\n            \"checkout\": \"{logo:pp} {logo:paypal} Pagar\",\n            \"safer_tag\": \"La forma r\\u00e1pida y segura de pagar\",\n            \"later_tag\": \"Compre ahora y pague m\\u00e1s adelante.\",\n            \"pay\": \"Pagar con {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Comprar ahora\"\n        },\n        \"zh\": {\n            \"checkout\": \"{logo:pp} {logo:paypal}\\u7ed3\\u8d26\",\n            \"safer_tag\": \"\\u66f4\\u5b89\\u5168\\u3001\\u66f4\\u4fbf\\u6377\\u7684\\u4ed8\\u6b3e\\u65b9\\u5f0f\",\n            \"later_tag\": \"\\u7acb\\u5373\\u8d2d\\u4e70\\uff0c\\u5206\\u671f\\u4ed8\\u6b3e\\u3002\",\n            \"pay\": \"\\u7528{logo:paypal}\\u4ed8\\u6b3e\",\n            \"buynow\": \"{logo:pp} {logo:paypal} \\u7acb\\u5373\\u8d2d\\u4e70\"\n        }\n    },\n    \"ZW\": {\n        \"en\": {\n            \"checkout\": \"Check out with {logo:pp} {logo:paypal}\",\n            \"safer_tag\": \"The safer, easier way to pay\",\n            \"later_tag\": \"Buy Now. Pay Over Time.\",\n            \"pay\": \"Pay with {logo:paypal}\",\n            \"buynow\": \"{logo:pp} {logo:paypal} Buy Now\"\n        }\n    }\n}\n"

/***/ }),

/***/ "./src/components/button/templates/component/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/button/templates/component/template.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__template__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* unused harmony reexport FUNDING */



/***/ }),

/***/ "./src/components/button/templates/component/logos/amex.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: rgb(20, 119, 190);\"/>\n  <path d=\"M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z\" style=\"fill: rgb(255, 255, 255);\"/>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/credit_white.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"100\" height=\"32\" viewBox=\"0 0 95 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill=\"#ffffff\" d=\"M 52.732 6.347 C 52.83 5.963 53.122 5.675 53.512 5.675 L 60.626 5.675 C 66.571 5.675 70.664 10.187 69.69 15.851 C 68.813 21.515 63.16 25.931 57.313 25.931 L 50.004 25.931 C 49.711 25.931 49.516 25.739 49.614 25.451 L 52.732 6.347 Z M 55.753 21.515 L 57.02 21.515 C 60.236 21.515 63.355 19.787 64.037 15.851 C 64.622 12.203 62.478 10.187 58.97 10.187 L 57.995 10.187 C 57.8 10.187 57.605 10.283 57.605 10.475 L 55.753 21.515 Z\"/>\n  <path fill=\"#ffffff\" d=\"M 43.571 10.763 L 43.084 13.547 L 48.737 13.547 C 49.029 13.547 49.224 13.739 49.224 14.027 L 48.639 17.387 C 48.542 17.771 48.249 17.963 47.859 17.963 L 42.987 17.963 C 42.597 17.963 42.304 18.251 42.207 18.635 L 41.72 21.515 L 47.762 21.515 C 48.054 21.515 48.249 21.707 48.152 21.995 L 47.665 25.355 C 47.567 25.643 47.275 25.931 46.885 25.931 L 36.067 25.931 C 35.775 25.931 35.58 25.643 35.58 25.451 L 38.699 6.347 C 38.796 5.963 39.186 5.675 39.478 5.675 L 50.393 5.675 C 50.588 5.675 50.881 5.963 50.783 6.155 L 50.296 9.515 C 50.198 9.899 49.906 10.091 49.516 10.091 L 44.254 10.091 C 43.864 10.187 43.571 10.379 43.571 10.763 Z\"/>\n  <path fill=\"#ffffff\" d=\"M 74.563 25.931 L 70.274 25.931 C 69.982 25.931 69.787 25.739 69.787 25.451 L 73.003 6.347 C 73.003 5.963 73.393 5.675 73.685 5.675 L 78.071 5.675 C 78.266 5.675 78.558 5.963 78.461 6.251 L 75.342 25.355 C 75.245 25.643 74.952 25.931 74.563 25.931 Z\"/>\n  <path fill=\"#ffffff\" d=\"M 34.118 25.931 L 28.466 25.931 C 28.173 25.931 27.978 25.835 27.881 25.643 L 24.178 18.155 L 24.08 18.155 L 22.911 25.451 C 22.813 25.739 22.618 25.931 22.326 25.931 L 17.843 25.931 C 17.551 25.931 17.356 25.739 17.453 25.451 L 20.572 6.251 C 20.669 5.963 20.864 5.675 21.156 5.675 L 28.855 5.675 C 33.046 5.675 35.97 7.595 35.288 11.915 C 34.8 14.699 32.754 17.195 29.635 17.675 L 34.508 25.355 C 34.703 25.547 34.411 25.931 34.118 25.931 Z M 24.665 14.795 L 25.152 14.795 C 27.004 14.795 29.05 14.411 29.44 12.203 C 29.83 10.091 28.661 9.707 26.711 9.707 L 25.932 9.707 C 25.639 9.707 25.445 9.899 25.445 10.091 L 24.665 14.795 Z\"/>\n  <path fill=\"#ffffff\" d=\"M 86.16 25.931 L 81.872 25.931 C 81.579 25.931 81.384 25.739 81.482 25.451 L 83.918 10.187 L 79.923 10.187 C 79.63 10.187 79.435 9.899 79.533 9.611 L 80.02 6.347 C 80.118 5.963 80.41 5.675 80.8 5.675 L 94.249 5.675 C 94.444 5.675 94.736 5.963 94.639 6.251 L 94.054 9.515 C 94.054 9.899 93.761 10.187 93.372 10.187 L 89.473 10.187 L 86.939 25.355 C 86.939 25.643 86.647 25.931 86.16 25.931 Z\"/>\n  <path fill=\"#ffffff\" d=\"M 17.648 11.435 C 17.648 11.819 17.161 12.011 16.868 11.723 C 15.894 10.763 14.529 10.283 13.068 10.283 C 9.657 10.283 7.025 12.779 6.441 15.851 C 5.953 19.019 7.902 21.323 11.313 21.323 C 12.678 21.323 14.237 20.843 15.407 19.979 C 15.796 19.787 16.284 20.075 16.186 20.459 L 15.407 25.067 C 15.309 25.355 15.114 25.547 14.822 25.643 C 13.165 26.123 11.898 26.507 10.339 26.507 C 1.178 26.507 -0.284 19.019 0.203 15.851 C 1.47 6.923 9.072 4.907 13.652 5.195 C 15.114 5.195 16.479 5.387 17.745 5.867 C 18.233 6.059 18.428 6.443 18.33 6.923 L 17.648 11.435 Z\"/>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/discover.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: rgb(17, 49, 82);\"/>\n  <path d=\"M 5.498 13.349 C 5.16 13.654 4.722 13.787 4.028 13.787 L 3.738 13.787 L 3.738 10.141 L 4.028 10.141 C 4.722 10.141 5.143 10.265 5.498 10.587 C 5.868 10.917 6.093 11.431 6.093 11.959 C 6.093 12.489 5.869 13.019 5.498 13.349 Z M 4.243 9.206 L 2.666 9.206 L 2.666 14.721 L 4.236 14.721 C 5.069 14.721 5.671 14.524 6.199 14.084 C 6.829 13.564 7.199 12.779 7.199 11.968 C 7.199 10.34 5.985 9.206 4.243 9.206 Z M 7.696 14.721 L 8.77 14.721 L 8.77 9.207 L 7.696 9.207 M 11.393 11.323 C 10.748 11.083 10.559 10.926 10.559 10.628 C 10.559 10.281 10.897 10.018 11.359 10.018 C 11.681 10.018 11.946 10.15 12.226 10.464 L 12.788 9.727 C 12.326 9.322 11.773 9.115 11.17 9.115 C 10.195 9.115 9.452 9.793 9.452 10.695 C 9.452 11.455 9.798 11.845 10.807 12.208 C 11.227 12.356 11.442 12.455 11.55 12.522 C 11.765 12.662 11.872 12.862 11.872 13.092 C 11.872 13.54 11.518 13.872 11.038 13.872 C 10.528 13.872 10.114 13.614 9.868 13.136 L 9.173 13.806 C 9.668 14.532 10.263 14.856 11.08 14.856 C 12.196 14.856 12.98 14.111 12.98 13.044 C 12.98 12.168 12.617 11.771 11.395 11.324 Z M 13.316 11.968 C 13.316 13.588 14.586 14.845 16.223 14.845 C 16.685 14.845 17.081 14.755 17.57 14.525 L 17.57 13.258 C 17.14 13.688 16.76 13.862 16.273 13.862 C 15.191 13.862 14.423 13.077 14.423 11.962 C 14.423 10.902 15.215 10.067 16.223 10.067 C 16.735 10.067 17.123 10.25 17.57 10.687 L 17.57 9.421 C 17.098 9.181 16.71 9.081 16.248 9.081 C 14.621 9.081 13.316 10.364 13.316 11.968 Z M 26.088 12.911 L 24.62 9.206 L 23.446 9.206 L 25.783 14.862 L 26.361 14.862 L 28.741 9.207 L 27.576 9.207 M 29.226 14.721 L 32.272 14.721 L 32.272 13.787 L 30.299 13.787 L 30.299 12.299 L 32.199 12.299 L 32.199 11.365 L 30.299 11.365 L 30.299 10.141 L 32.272 10.141 L 32.272 9.206 L 29.226 9.206 M 34.373 11.745 L 34.059 11.745 L 34.059 10.075 L 34.389 10.075 C 35.059 10.075 35.423 10.355 35.423 10.893 C 35.423 11.447 35.059 11.745 34.373 11.745 Z M 36.528 10.835 C 36.528 9.802 35.818 9.207 34.578 9.207 L 32.986 9.207 L 32.986 14.721 L 34.059 14.721 L 34.059 12.506 L 34.199 12.506 L 35.686 14.721 L 37.006 14.721 L 35.273 12.398 C 36.083 12.233 36.528 11.678 36.528 10.835 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <g id=\"MarkingBase_1_\" transform=\"matrix(0.089776, 0, 0, 0.089776, 2.192296, 5.72498)\">\n    <linearGradient id=\"SVGID_1_\" gradientUnits=\"userSpaceOnUse\" x1=\"224.3917\" y1=\"44.1731\" x2=\"201.33\" y2=\"80.2807\" gradientTransform=\"matrix(1 0 0 -1 0 141.7323)\">\n      <stop offset=\"0\" style=\"stop-color:#F89F21\"/>\n      <stop offset=\"0.2502\" style=\"stop-color:#F79A23\"/>\n      <stop offset=\"0.5331\" style=\"stop-color:#F78E22\"/>\n      <stop offset=\"0.6196\" style=\"stop-color:#F68721\"/>\n      <stop offset=\"0.7232\" style=\"stop-color:#F48220\"/>\n      <stop offset=\"1\" style=\"stop-color:#F27623\"/>\n    </linearGradient>\n    <circle fill=\"url(#SVGID_1_)\" cx=\"207.343\" cy=\"70.866\" r=\"33.307\"/>\n    <linearGradient id=\"SVGID_2_\" gradientUnits=\"userSpaceOnUse\" x1=\"220.7487\" y1=\"44.664\" x2=\"187.0436\" y2=\"110.5426\" gradientTransform=\"matrix(1 0 0 -1 0 141.7323)\">\n      <stop offset=\"0\" style=\"stop-color:#F68721;stop-opacity:0\"/>\n      <stop offset=\"0.3587\" style=\"stop-color:#E27027;stop-opacity:0.2704\"/>\n      <stop offset=\"0.703\" style=\"stop-color:#D4612C;stop-opacity:0.5299\"/>\n      <stop offset=\"0.9816\" style=\"stop-color:#D15D2D;stop-opacity:0.74\"/>\n    </linearGradient>\n    <circle opacity=\"0.65\" fill=\"url(#SVGID_2_)\" cx=\"207.343\" cy=\"70.866\" r=\"33.307\"/>\n  </g>\n  <g id=\"Orange_1_\" enable-background=\"new    \" transform=\"matrix(0.469224, 0, 0, 0.469224, 13.785085, 6.199149)\">\n    <g id=\"Orange\">\n      <g>\n        <path d=\"M13,38c20.1,0,40,0,40,0c1.7,0,3-1.3,3-3V18C56,18,51.2,31.8,13,38z\" style=\"fill: rgb(255, 129, 38);\"/>\n      </g>\n    </g>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/elo.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: rgb(21, 21, 21);\"/>\n  <path class=\"st0\" d=\"M 9.229 8.55 C 9.592 8.431 9.977 8.365 10.382 8.365 C 12.14 8.365 13.602 9.613 13.939 11.268 L 16.427 10.762 C 15.855 7.946 13.365 5.824 10.379 5.824 C 9.693 5.824 9.037 5.935 8.42 6.142 L 9.229 8.55 Z\" style=\"fill: rgb(255, 205, 5);\"/>\n  <path class=\"st1\" d=\"M 6.292 16.616 L 7.973 14.716 C 7.221 14.052 6.749 13.08 6.749 11.999 C 6.749 10.917 7.221 9.945 7.973 9.279 L 6.292 7.38 C 5.015 8.51 4.209 10.16 4.209 11.999 C 4.209 13.836 5.019 15.488 6.292 16.616\" style=\"fill: rgb(0, 164, 224);\"/>\n  <path class=\"st2\" d=\"M 13.939 12.723 C 13.602 14.379 12.136 15.626 10.382 15.626 C 9.977 15.626 9.592 15.562 9.229 15.442 L 8.422 17.849 C 9.039 18.055 9.698 18.167 10.382 18.167 C 13.365 18.167 15.855 16.05 16.427 13.235 L 13.939 12.723 Z\" style=\"fill: rgb(239, 66, 35);\"/>\n  <path d=\"M 18.603 14.794 C 18.521 14.663 18.412 14.453 18.343 14.296 C 17.948 13.381 17.932 12.434 18.264 11.526 C 18.631 10.527 19.33 9.765 20.233 9.378 C 21.366 8.889 22.626 8.986 23.713 9.632 C 24.406 10.028 24.897 10.641 25.269 11.506 C 25.319 11.615 25.358 11.737 25.398 11.835 L 18.603 14.794 Z M 20.87 10.845 C 20.066 11.194 19.65 11.949 19.734 12.834 L 23.151 11.363 C 22.565 10.675 21.802 10.444 20.87 10.845 Z M 23.578 14.044 C 23.578 14.044 23.578 14.044 23.578 14.044 L 23.508 13.998 C 23.302 14.331 22.985 14.595 22.584 14.768 C 21.82 15.1 21.113 15.014 20.602 14.569 L 20.559 14.643 C 20.559 14.643 20.559 14.643 20.559 14.643 L 19.688 15.936 C 19.905 16.088 20.134 16.213 20.376 16.315 C 21.333 16.712 22.311 16.693 23.279 16.273 C 23.978 15.971 24.527 15.509 24.9 14.924 L 23.578 14.044 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 27.77 7.466 L 27.77 14.673 L 28.891 15.13 L 28.254 16.614 L 27.018 16.1 C 26.742 15.979 26.552 15.797 26.409 15.588 C 26.272 15.377 26.171 15.085 26.171 14.698 L 26.171 7.466 L 27.77 7.466 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <g transform=\"matrix(0.037801, 0, 0, 0.037801, 1.0913, 0.089785)\">\n    <path d=\"M782.7,337.2c0-16.2,7.2-30.8,18.5-40.7l-30.4-33.9c-20.6,18.2-33.6,44.9-33.6,74.6c0,29.7,12.9,56.4,33.6,74.7l30.4-34&#10;&#9;&#9;C789.8,367.9,782.6,353.4,782.7,337.2z\" style=\"fill: rgb(255, 255, 255);\"/>\n    <path d=\"M836.7,391.4c-6,0-11.8-1-17.1-2.8L805,431.7c9.9,3.3,20.6,5.1,31.6,5.2c48.2,0,88.4-34.1,97.7-79.6l-44.7-9.1&#10;&#9;&#9;C884.6,372.9,862.8,391.4,836.7,391.4z\" style=\"fill: rgb(255, 255, 255);\"/>\n    <path d=\"M836.8,237.6c-11,0-21.7,1.8-31.6,5.1l14.4,43.2c5.4-1.8,11.2-2.8,17.1-2.8c26.2,0,48,18.6,53,43.3l44.7-9.1&#10;&#9;&#9;C925.2,272,885,237.7,836.8,237.6z\" style=\"fill: rgb(255, 255, 255);\"/>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/elv.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"100\" height=\"32\" viewBox=\"0 0 100 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill=\"#005DA0\" d=\"M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z\"/>\n  <path fill=\"#005DA0\" d=\"M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z\"/>\n  <path fill=\"#AEB1BC\" d=\"M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z\"/>\n  <g transform=\"matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)\">\n    <path fill=\"#005DA0\" d=\"M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z\"/>\n    <path fill=\"#005DA0\" d=\"M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z\"/>\n    <polygon fill=\"#005DA0\" points=\"161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;\"/>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/elv_white.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"100\" height=\"32\" viewBox=\"0 0 100 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <path d=\"M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n  <g transform=\"matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)\">\n    <path d=\"M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z\" style=\"fill: rgb(255, 255, 255);\"/>\n    <path d=\"M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z\" style=\"fill: rgb(255, 255, 255);\"/>\n    <polygon points=\"161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;\" style=\"fill: rgb(255, 255, 255);\"/>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/hiper.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z\" style=\"fill: rgb(243, 97, 24);\"/>\n  <path id=\"path16\" style=\"fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;\" d=\"M 3.206 6.45 L 3.206 16.929 L 5.586 16.929 L 5.586 12.545 L 9.489 12.545 L 9.489 16.929 L 11.853 16.929 L 11.853 6.45 L 9.489 6.45 L 9.489 10.477 L 5.586 10.477 L 5.586 6.45 L 3.206 6.45\"/>\n  <path id=\"path18\" style=\"fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;\" d=\"M 32.319 13.882 C 32.351 13.71 32.397 13.353 32.397 12.949 C 32.397 11.068 31.464 9.155 29.008 9.155 C 26.364 9.155 25.167 11.285 25.167 13.213 C 25.167 15.592 26.644 17.085 29.225 17.085 C 30.251 17.085 31.2 16.929 31.977 16.618 L 31.666 15.017 C 31.029 15.219 30.376 15.328 29.567 15.328 C 28.463 15.328 27.499 14.861 27.422 13.882 Z M 27.406 12.265 C 27.468 11.628 27.873 10.725 28.868 10.725 C 29.956 10.725 30.205 11.689 30.205 12.265 L 27.406 12.265\"/>\n  <path id=\"path20\" style=\"fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;\" d=\"M 33.155 16.929 L 35.519 16.929 L 35.519 13.073 C 35.519 12.887 35.533 12.7 35.565 12.545 C 35.72 11.814 36.31 11.348 37.182 11.348 C 37.446 11.348 37.648 11.378 37.819 11.41 L 37.819 9.186 C 37.648 9.155 37.539 9.155 37.321 9.155 C 36.591 9.155 35.658 9.621 35.269 10.725 L 35.207 10.725 L 35.129 9.326 L 33.092 9.326 C 33.123 9.979 33.155 10.709 33.155 11.829 L 33.155 16.929\"/>\n  <path id=\"path22\" style=\"fill: rgb(254, 234, 1); fill-opacity: 1; fill-rule: evenodd; stroke: none;\" d=\"M 14.256 6.028 C 14.927 6.028 15.472 6.572 15.472 7.243 C 15.472 7.914 14.927 8.458 14.256 8.458 C 13.585 8.458 13.041 7.914 13.041 7.243 C 13.041 6.572 13.585 6.028 14.256 6.028\"/>\n  <path id=\"path24\" style=\"fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: evenodd; stroke: none;\" d=\"M 19.247 15.159 L 20.433 15.159 C 21.624 15.159 22.163 14.395 22.163 13.6 C 22.163 12.805 22.106 11.006 20.633 11.006 C 18.943 11.006 19.218 13.238 19.224 14.408 C 19.226 14.658 19.24 14.908 19.247 15.159 Z M 13.041 9.315 L 15.472 9.315 L 15.472 13.6 C 15.472 14.395 15.912 15.157 16.887 15.159 C 16.894 13.229 16.886 11.243 16.822 9.315 L 18.852 9.315 C 18.896 9.687 18.936 10.059 18.973 10.432 C 19.932 8.514 22.954 8.937 23.971 10.555 C 25.022 12.228 25.379 17.017 20.433 17.017 L 19.282 17.017 C 19.293 17.988 19.295 18.963 19.295 19.936 L 16.865 19.936 C 16.865 19.001 16.871 18.022 16.878 17.016 C 14.252 17.007 13.041 15.339 13.041 13.6 L 13.041 9.315\"/>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/ideal.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"38\" height=\"32\" viewBox=\"0 0 38 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon id=\"Fill-1\" fill=\"#000000\" points=\"4.47 27.632 10.452 27.632 10.452 17.982 4.47 17.982\"/>\n  <g id=\"Group-9\" transform=\"matrix(0.952642, 0, 0, 0.930979, 0.31993, 0.181113)\">\n    <path d=\"M11.1102604,13.937999 C11.1102604,15.8893766 9.51859887,17.4723289 7.55546104,17.4723289 C5.59238806,17.4723289 4.00066169,15.8893766 4.00066169,13.937999 C4.00066169,11.9865569 5.59238806,10.4043136 7.55546104,10.4043136 C9.51859887,10.4043136 11.1102604,11.9865569 11.1102604,13.937999\" id=\"Fill-2\" fill=\"#000000\"/>\n    <g id=\"Group-6\">\n      <mask id=\"mask-2\" fill=\"white\">\n        <polygon id=\"\" points=\"39.1898554 33.9678282 0 33.9678282 0 0.001572704 39.1898554 0.001572704\" transform=\"matrix(1, 0, 0, 1, 0, 0)\"/>\n      </mask>\n      <g id=\"Clip-5\"/>\n      <path d=\"M22.1049929,2.25750057 C26.4717361,2.25750057 30.1110886,3.433548 32.6296578,5.65853743 C35.476843,8.17370364 36.9204068,11.9843525 36.9204068,16.9847134 C36.9204068,26.8945533 32.0742264,31.7119261 22.1049929,31.7119261 L2.26942909,31.7119261 L2.26942909,2.25750057 L22.1049929,2.25750057 Z M22.531325,0.001572704 L-1.9452416e-05,0.001572704 L-1.9452416e-05,33.967854 L22.531325,33.967854 L22.531325,33.9614085 C27.4529808,33.8947619 31.3518934,32.6793969 34.1187402,30.3394196 C37.4837488,27.4935988 39.1898554,23.0003706 39.1898554,16.9847134 C39.1898554,14.1090499 38.7410881,11.5297509 37.8560681,9.31836144 C37.0093692,7.2028812 35.758125,5.40419768 34.13722,3.97219912 C31.2823834,1.45020067 27.2749912,0.0865245021 22.531325,0.00904949351 L22.531325,0.001572704 Z\" id=\"Fill-4\" fill=\"#000000\" mask=\"url(#mask-2)\"/>\n    </g>\n    <path d=\"M21.4851352,29.4975138 L13.5194356,29.4975138 L13.5194356,5.00387361 L21.4851352,5.00387361 L21.1636516,5.00387361 C27.8067813,5.00387361 34.8779291,7.60998594 34.8779291,17.282889 C34.8779291,27.5088167 27.8067813,29.4975138 21.1636516,29.4975138 L21.4851352,29.4975138 Z\" id=\"Fill-7\" fill=\"#CD0067\"/>\n  </g>\n  <g id=\"Group-30\" transform=\"matrix(0.952642, 0, 0, 0.930979, 11.685725, 10.562208)\" fill=\"#FFFFFF\">\n    <path d=\"M1.41115607,1.17495169 L1.41115607,5.07048794 L2.30681015,5.07048794 C2.64178075,5.07048794 2.88357428,5.05173151 3.03219074,5.0142831 C3.2267149,4.96613516 3.38810511,4.88459948 3.51649106,4.76961161 C3.64474732,4.65455929 3.749531,4.46538363 3.83058274,4.20189125 C3.91163447,3.93846333 3.95216034,3.57944852 3.95216034,3.12471792 C3.95216034,2.67005177 3.91163447,2.3210275 3.83058274,2.07764511 C3.749531,1.83426272 3.63605858,1.64437805 3.49016546,1.5079911 C3.34420749,1.37160414 3.15915018,1.27930447 2.93492866,1.23109207 C2.76737852,1.19370812 2.43915142,1.17495169 1.95018252,1.17495169 L1.41115607,1.17495169 Z M0.215675421,0.175897919 L2.40271056,0.175897919 C2.89589415,0.175897919 3.27190935,0.213410777 3.53069132,0.288436492 C3.878306,0.390275522 4.17612249,0.571265392 4.42407595,0.831212737 C4.67202941,1.09116008 4.86065301,1.40950373 4.99001157,1.78598587 C5.11937014,2.16253246 5.18408185,2.62686687 5.18408185,3.1789891 C5.18408185,3.66407805 5.12345515,4.08213371 5.00220176,4.433285 C4.85397434,4.86210466 4.6423969,5.20919527 4.36753426,5.47449239 C4.15997698,5.67552779 3.87966767,5.832347 3.52660632,5.94488558 C3.26244251,6.02796818 2.90938115,6.06954171 2.46742226,6.06954171 L0.215675421,6.06954171 L0.215675421,0.175897919 Z\" id=\"Fill-10\"/>\n    <path d=\"M2.40271056,0.337035624 C2.87825729,0.337035624 3.24247136,0.372743739 3.48523751,0.443128689 C3.80302515,0.536201827 4.07944398,0.704171771 4.30645367,0.942075479 C4.53702965,1.18384649 4.7154083,1.48530291 4.83666169,1.83813003 C4.95966581,2.19611355 5.02197838,2.64723467 5.02197838,3.1789891 C5.02197838,3.64390361 4.96375081,4.04829479 4.84885188,4.38094747 C4.70970226,4.78359837 4.50973142,5.11264156 4.25458057,5.35892443 C4.06589213,5.54165459 3.80438682,5.68712971 3.47713234,5.79148248 C3.23060538,5.86895749 2.89070683,5.908404 2.46742226,5.908404 L0.377778888,5.908404 L0.377778888,0.337035624 L2.40271056,0.337035624 Z M0.0535719538,0.0147602138 L0.0535719538,6.23067941 L2.46742226,6.23067941 C2.92390562,6.23067941 3.2967436,6.18614095 3.57549672,6.09848204 C3.95157676,5.97866004 4.25594223,5.80759625 4.48061764,5.58993144 C4.77246872,5.30819828 4.9996081,4.93661473 5.15548679,4.48562252 C5.28205718,4.11919538 5.34618531,3.67954727 5.34618531,3.1789891 C5.34618531,2.61178438 5.27797217,2.12559969 5.1434263,1.73390616 C5.00706486,1.33699177 4.80456521,0.995959927 4.54169823,0.720349996 C4.27494076,0.440679396 3.9502151,0.243317935 3.57646934,0.133873205 C3.29992083,0.0536910833 2.91612466,0.0147602138 2.40271056,0.0147602138 L0.0535719538,0.0147602138 Z\" id=\"Fill-12\"/>\n    <path d=\"M1.9501501,1.33608939 C2.54124418,1.33608939 2.79263424,1.36451409 2.899428,1.38836247 C3.09466542,1.43032272 3.25566658,1.50998921 3.37905974,1.6253638 C3.50439814,1.74254314 3.60457808,1.91180219 3.6766817,2.12824235 C3.75189771,2.35415741 3.79002445,2.68945275 3.79002445,3.12471792 C3.79002445,3.56127219 3.75150867,3.90784717 3.67551456,4.15477459 C3.60360546,4.38861762 3.51354078,4.55523401 3.40791416,4.64991853 C3.30014777,4.74647224 3.16054427,4.81647046 2.99299412,4.85797953 C2.85754047,4.89207627 2.62683481,4.90935023 2.30677773,4.90935023 L1.57329196,4.90935023 L1.57329196,1.33608939 L1.9501501,1.33608939 Z M1.24902018,1.01381398 L1.24902018,5.23162564 L2.30677773,5.23162564 C2.65860709,5.23162564 2.90889484,5.21158011 3.07203577,5.17052222 C3.29100514,5.1163155 3.47729444,5.02163098 3.62500312,4.88924025 C3.77699133,4.7529822 3.89493781,4.54356764 3.98558607,4.24900792 C4.07214932,3.96766148 4.11423138,3.59988078 4.11423138,3.12471792 C4.11423138,2.64833041 4.07176027,2.2893156 3.98441893,2.02698342 C3.89519718,1.75904364 3.76622766,1.54492386 3.60120633,1.39061839 C3.43423976,1.23450819 3.22162485,1.12789948 2.96919733,1.0736283 C2.78932733,1.03347278 2.45558871,1.01381398 1.9501501,1.01381398 L1.24902018,1.01381398 Z\" id=\"Fill-14\"/>\n    <polygon id=\"Fill-16\" points=\"6.53678989 6.06950948 6.53678989 0.175865691 10.9257088 0.175865691 10.9257088 1.17491946 7.73227054 1.17491946 7.73227054 2.48013487 10.702849 2.48013487 10.702849 3.47918864 7.73227054 3.47918864 7.73227054 5.07045571 11.0391813 5.07045571 11.0391813 6.06950948\"/>\n    <path d=\"M10.7636378,0.337035624 L10.7636378,1.01381398 L7.57019949,1.01381398 L7.57019949,2.64130481 L10.5407779,2.64130481 L10.5407779,3.31808317 L7.57019949,3.31808317 L7.57019949,5.23162564 L10.8771102,5.23162564 L10.8771102,5.908404 L6.69892578,5.908404 L6.69892578,0.337035624 L10.7636378,0.337035624 Z M6.37471884,0.0147602138 L6.37471884,6.23067941 L11.2013172,6.23067941 L11.2013172,4.90935023 L7.89440643,4.90935023 L7.89440643,3.64035858 L10.8649849,3.64035858 L10.8649849,2.3190294 L7.89440643,2.3190294 L7.89440643,1.33608939 L11.0878447,1.33608939 L11.0878447,0.0147602138 L6.37471884,0.0147602138 Z\" id=\"Fill-18\"/>\n    <path d=\"M15.5303032,3.73301276 L14.7130424,1.54959685 L13.9121864,3.73301276 L15.5303032,3.73301276 Z M17.7341971,6.06950948 L16.431793,6.06950948 L15.9144884,4.73206653 L13.5458326,4.73206653 L13.055113,6.06950948 L11.7849999,6.06950948 L14.0890089,0.175865691 L15.363207,0.175865691 L17.7341971,6.06950948 Z\" id=\"Fill-20\"/>\n    <path d=\"M15.2534629,0.337035624 C15.3291976,0.525244463 17.332991,5.50626875 17.4947703,5.908404 L16.5431581,5.908404 C16.4751395,5.73244163 16.0257887,4.57096105 16.0257887,4.57096105 L13.4323926,4.57096105 C13.4323926,4.57096105 13.0075518,5.72876769 12.9417378,5.908404 L12.0218979,5.908404 C12.1781008,5.50884695 14.1252876,0.527951577 14.1999201,0.337035624 L15.2534629,0.337035624 Z M13.9780328,0.0147602138 L11.5481019,6.23067941 L13.168553,6.23067941 C13.168553,6.23067941 13.5933289,5.07280832 13.6592077,4.89323646 L15.8031882,4.89323646 C15.871142,5.06913438 16.3204928,6.23067941 16.3204928,6.23067941 L17.9736239,6.23067941 L15.472951,0.0147602138 L13.9780328,0.0147602138 Z\" id=\"Fill-22\"/>\n    <path d=\"M14.7145337,2.01579402 C14.8921991,2.49044124 15.1926093,3.29290701 15.2970039,3.57186861 L14.1437998,3.57186861 C14.2457305,3.2940672 14.5401752,2.49134361 14.7145337,2.01579402 L14.7145337,2.01579402 Z M13.680573,3.89414402 L15.7636025,3.89414402 L14.7114862,1.0833868 L13.680573,3.89414402 Z\" id=\"Fill-24\"/>\n    <polygon id=\"Fill-26\" points=\"18.7343171 6.06950948 18.7343171 0.224207003 19.9297978 0.224207003 19.9297978 5.07045571 22.9084814 5.07045571 22.9084814 6.06950948\"/>\n    <path d=\"M19.7677267,0.385376935 L19.7677267,5.23162564 L22.7464104,5.23162564 L22.7464104,5.908404 L18.8963882,5.908404 L18.8963882,0.385376935 L19.7677267,0.385376935 Z M18.5722461,0.0631015253 L18.5722461,6.23067941 L23.0706173,6.23067941 L23.0706173,4.90935023 L20.0919337,4.90935023 L20.0919337,0.0631015253 L18.5722461,0.0631015253 Z\" id=\"Fill-28\"/>\n  </g>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return componentLogos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cardLogos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pp_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_white.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pp_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pp_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_blue.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pp_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pp_black_svg__ = __webpack_require__("./src/components/button/templates/component/logos/pp_black.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pp_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pp_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_white.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__paypal_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_blue.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg__ = __webpack_require__("./src/components/button/templates/component/logos/paypal_black.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__paypal_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__credit_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/credit_white.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__credit_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__credit_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/venmo_white.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__venmo_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg__ = __webpack_require__("./src/components/button/templates/component/logos/venmo_blue.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ideal_svg__ = __webpack_require__("./src/components/button/templates/component/logos/ideal.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ideal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ideal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elv_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elv.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elv_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__elv_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elv_white_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elv_white.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elv_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__elv_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__visa_svg__ = __webpack_require__("./src/components/button/templates/component/logos/visa.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__visa_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__visa_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amex_svg__ = __webpack_require__("./src/components/button/templates/component/logos/amex.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__amex_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__amex_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mastercard_svg__ = __webpack_require__("./src/components/button/templates/component/logos/mastercard.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mastercard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mastercard_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__discover_svg__ = __webpack_require__("./src/components/button/templates/component/logos/discover.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__discover_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__discover_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hiper_svg__ = __webpack_require__("./src/components/button/templates/component/logos/hiper.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hiper_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__hiper_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__elo_svg__ = __webpack_require__("./src/components/button/templates/component/logos/elo.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__elo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__elo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__jcb_svg__ = __webpack_require__("./src/components/button/templates/component/logos/jcb.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__jcb_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__jcb_svg__);
var _BUTTON_LOGO$PP, _BUTTON_LOGO$PAYPAL, _BUTTON_LOGO$CREDIT, _BUTTON_LOGO$VENMO, _BUTTON_LOGO$IDEAL, _BUTTON_LOGO$ELV, _componentLogos, _cardLogos;
























var componentLogos = (_componentLogos = {}, _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP] = (_BUTTON_LOGO$PP = {}, _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_2__pp_white_svg___default.a, _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_3__pp_blue_svg___default.a, _BUTTON_LOGO$PP[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_4__pp_black_svg___default.a, _BUTTON_LOGO$PP), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL] = (_BUTTON_LOGO$PAYPAL = {}, _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_5__paypal_white_svg___default.a, _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_6__paypal_blue_svg___default.a, _BUTTON_LOGO$PAYPAL[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_7__paypal_black_svg___default.a, _BUTTON_LOGO$PAYPAL), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].CREDIT] = (_BUTTON_LOGO$CREDIT = {}, _BUTTON_LOGO$CREDIT[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_8__credit_white_svg___default.a, _BUTTON_LOGO$CREDIT), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].VENMO] = (_BUTTON_LOGO$VENMO = {}, _BUTTON_LOGO$VENMO[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_9__venmo_white_svg___default.a, _BUTTON_LOGO$VENMO[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_10__venmo_blue_svg___default.a, _BUTTON_LOGO$VENMO), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].IDEAL] = (_BUTTON_LOGO$IDEAL = {}, _BUTTON_LOGO$IDEAL[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].ANY] = __WEBPACK_IMPORTED_MODULE_11__ideal_svg___default.a, _BUTTON_LOGO$IDEAL), _componentLogos[__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].ELV] = (_BUTTON_LOGO$ELV = {}, _BUTTON_LOGO$ELV[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].ANY] = __WEBPACK_IMPORTED_MODULE_12__elv_svg___default.a, _BUTTON_LOGO$ELV[__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_13__elv_white_svg___default.a, _BUTTON_LOGO$ELV), _componentLogos);

var cardLogos = (_cardLogos = {}, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].VISA] = __WEBPACK_IMPORTED_MODULE_14__visa_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].AMEX] = __WEBPACK_IMPORTED_MODULE_15__amex_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].MASTERCARD] = __WEBPACK_IMPORTED_MODULE_16__mastercard_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].DISCOVER] = __WEBPACK_IMPORTED_MODULE_17__discover_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].HIPER] = __WEBPACK_IMPORTED_MODULE_18__hiper_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].ELO] = __WEBPACK_IMPORTED_MODULE_19__elo_svg___default.a, _cardLogos[__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].JCB] = __WEBPACK_IMPORTED_MODULE_20__jcb_svg___default.a, _cardLogos);

/***/ }),

/***/ "./src/components/button/templates/component/logos/jcb.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <pattern id=\"pattern-0\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" patternUnits=\"userSpaceOnUse\" viewBox=\"0 0 100 100\">\n      <path d=\"M 0 0 L 50 0 L 50 100 L 0 100 Z\" style=\"fill: black;\"/>\n    </pattern>\n  </defs>\n  <path d=\"M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z\" style=\"fill: rgb(255, 255, 255); stroke: rgb(233, 234, 231);\"/>\n  <g transform=\"matrix(0.100306, 0, 0, 0.100306, 4.733743, 10.105099)\" id=\"g6321\">\n    <g transform=\"matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)\" id=\"g6323\">\n      <path style=\"fill:#ffffff\" id=\"path6325\" d=\"m 174,108.3 c 0,14 -11.4,25.4 -25.4,25.4 l -138.2,0 0,-100.6 c 0,-14 11.4,-25.4 25.4,-25.4 l 138.2,0 0,100.6 z\" class=\"st0\"/>\n      <g id=\"g6327\">\n        <linearGradient gradientTransform=\"matrix(1.125,0,0,1.125,-11.9755,-13.8615)\" y2=\"81.398598\" x2=\"157.3299\" y1=\"81.398598\" x1=\"117.3856\" gradientUnits=\"userSpaceOnUse\" id=\"SVGID_1_\">\n          <stop id=\"stop6330\" style=\"stop-color:#007940\" offset=\"0\"/>\n          <stop id=\"stop6332\" style=\"stop-color:#00873F\" offset=\"0.2285\"/>\n          <stop id=\"stop6334\" style=\"stop-color:#40A737\" offset=\"0.7433\"/>\n          <stop id=\"stop6336\" style=\"stop-color:#5CB531\" offset=\"1\"/>\n        </linearGradient>\n        <path style=\"fill:url(#SVGID_1_)\" id=\"path6338\" d=\"m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z\" class=\"st1\"/>\n        <linearGradient gradientTransform=\"matrix(1.125,0,0,1.125,-11.9755,-13.8615)\" y2=\"75.171402\" x2=\"157.3318\" y1=\"75.171402\" x1=\"117.3844\" gradientUnits=\"userSpaceOnUse\" id=\"SVGID_2_\">\n          <stop id=\"stop6341\" style=\"stop-color:#007940\" offset=\"0\"/>\n          <stop id=\"stop6343\" style=\"stop-color:#00873F\" offset=\"0.2285\"/>\n          <stop id=\"stop6345\" style=\"stop-color:#40A737\" offset=\"0.7433\"/>\n          <stop id=\"stop6347\" style=\"stop-color:#5CB531\" offset=\"1\"/>\n        </linearGradient>\n        <path style=\"fill:url(#SVGID_2_)\" id=\"path6349\" d=\"m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z\" class=\"st2\"/>\n        <linearGradient gradientTransform=\"matrix(1.125,0,0,1.125,-11.9755,-13.8615)\" y2=\"68.399101\" x2=\"157.33051\" y1=\"68.399101\" x1=\"117.3846\" gradientUnits=\"userSpaceOnUse\" id=\"SVGID_3_\">\n          <stop id=\"stop6352\" style=\"stop-color:#007940\" offset=\"0\"/>\n          <stop id=\"stop6354\" style=\"stop-color:#00873F\" offset=\"0.2285\"/>\n          <stop id=\"stop6356\" style=\"stop-color:#40A737\" offset=\"0.7433\"/>\n          <stop id=\"stop6358\" style=\"stop-color:#5CB531\" offset=\"1\"/>\n        </linearGradient>\n        <path style=\"fill:url(#SVGID_3_)\" id=\"path6360\" d=\"m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z\" class=\"st3\"/>\n      </g>\n      <linearGradient gradientTransform=\"matrix(1.125,0,0,1.125,-11.9755,-13.8615)\" y2=\"75.171402\" x2=\"68.522102\" y1=\"75.171402\" x1=\"27.9594\" gradientUnits=\"userSpaceOnUse\" id=\"SVGID_4_\">\n        <stop id=\"stop6363\" style=\"stop-color:#1F286F\" offset=\"0\"/>\n        <stop id=\"stop6365\" style=\"stop-color:#004E94\" offset=\"0.4751\"/>\n        <stop id=\"stop6367\" style=\"stop-color:#0066B1\" offset=\"0.8261\"/>\n        <stop id=\"stop6369\" style=\"stop-color:#006FBC\" offset=\"1\"/>\n      </linearGradient>\n      <path style=\"fill:url(#SVGID_4_)\" id=\"path6371\" d=\"m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z\" class=\"st4\"/>\n      <linearGradient gradientTransform=\"matrix(1.125,0,0,1.125,-11.9755,-13.8615)\" y2=\"75.171402\" x2=\"111.8553\" y1=\"75.171402\" x1=\"72.459503\" gradientUnits=\"userSpaceOnUse\" id=\"SVGID_5_\">\n        <stop id=\"stop6374\" style=\"stop-color:#6C2C2F\" offset=\"0\"/>\n        <stop id=\"stop6376\" style=\"stop-color:#882730\" offset=\"0.1735\"/>\n        <stop id=\"stop6378\" style=\"stop-color:#BE1833\" offset=\"0.5731\"/>\n        <stop id=\"stop6380\" style=\"stop-color:#DC0436\" offset=\"0.8585\"/>\n        <stop id=\"stop6382\" style=\"stop-color:#E60039\" offset=\"1\"/>\n      </linearGradient>\n      <path style=\"fill:url(#SVGID_5_)\" id=\"path6384\" d=\"m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z\" class=\"st5\"/>\n    </g>\n    <g id=\"g6386\"/>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/mastercard.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z\" style=\"fill: rgb(62, 57, 57);\"/>\n  <path style=\"fill: rgb(255, 95, 0);\" d=\"M 22.205 3.901 L 15.688 3.901 L 15.688 15.589 L 22.205 15.589\"/>\n  <path d=\"M 16.1 9.747 C 16.1 7.371 17.218 5.265 18.935 3.901 C 17.67 2.912 16.078 2.312 14.342 2.312 C 10.223 2.312 6.892 5.636 6.892 9.746 C 6.892 13.853 10.223 17.178 14.342 17.178 C 16.078 17.178 17.67 16.58 18.935 15.588 C 17.216 14.246 16.099 12.119 16.099 9.745 Z\" style=\"fill: rgb(235, 0, 27);\"/>\n  <path d=\"M 30.996 9.747 C 30.996 13.854 27.663 17.179 23.547 17.179 C 21.81 17.179 20.216 16.581 18.954 15.589 C 20.691 14.227 21.788 12.12 21.788 9.746 C 21.788 7.37 20.671 5.264 18.954 3.9 C 20.216 2.911 21.81 2.311 23.547 2.311 C 27.663 2.311 30.996 5.657 30.996 9.745 Z\" style=\"fill: rgb(247, 158, 27);\"/>\n  <path d=\"M 7.167 22.481 L 7.167 20.43 C 7.167 19.641 6.685 19.127 5.857 19.127 C 5.443 19.127 4.993 19.262 4.683 19.71 C 4.44 19.332 4.096 19.127 3.579 19.127 C 3.233 19.127 2.888 19.23 2.612 19.607 L 2.612 19.197 L 1.886 19.197 L 1.886 22.481 L 2.612 22.481 L 2.612 20.668 C 2.612 20.086 2.921 19.812 3.406 19.812 C 3.888 19.812 4.131 20.121 4.131 20.669 L 4.131 22.481 L 4.856 22.481 L 4.856 20.668 C 4.856 20.086 5.204 19.812 5.651 19.812 C 6.137 19.812 6.377 20.121 6.377 20.669 L 6.377 22.481 L 7.171 22.481 Z M 17.909 19.197 L 16.734 19.197 L 16.734 18.204 L 16.007 18.204 L 16.007 19.197 L 15.352 19.197 L 15.352 19.845 L 16.007 19.845 L 16.007 21.351 C 16.007 22.106 16.319 22.551 17.146 22.551 C 17.459 22.551 17.804 22.449 18.044 22.309 L 17.839 21.695 C 17.632 21.831 17.389 21.867 17.216 21.867 C 16.872 21.867 16.734 21.66 16.734 21.319 L 16.734 19.847 L 17.909 19.847 L 17.909 19.198 Z M 24.053 19.127 C 23.639 19.127 23.364 19.332 23.191 19.607 L 23.191 19.197 L 22.465 19.197 L 22.465 22.481 L 23.191 22.481 L 23.191 20.633 C 23.191 20.086 23.434 19.777 23.882 19.777 C 24.018 19.777 24.192 19.812 24.33 19.847 L 24.538 19.162 C 24.401 19.127 24.192 19.127 24.052 19.127 Z M 14.765 19.469 C 14.42 19.229 13.937 19.127 13.418 19.127 C 12.588 19.127 12.036 19.538 12.036 20.188 C 12.036 20.736 12.453 21.044 13.175 21.146 L 13.524 21.181 C 13.903 21.249 14.108 21.351 14.108 21.523 C 14.108 21.765 13.832 21.934 13.35 21.934 C 12.864 21.934 12.484 21.764 12.244 21.592 L 11.898 22.139 C 12.278 22.411 12.794 22.549 13.313 22.549 C 14.28 22.549 14.831 22.105 14.831 21.488 C 14.831 20.908 14.383 20.599 13.692 20.496 L 13.348 20.462 C 13.037 20.428 12.795 20.36 12.795 20.155 C 12.795 19.914 13.038 19.777 13.418 19.777 C 13.83 19.777 14.245 19.949 14.453 20.052 L 14.764 19.469 Z M 34.033 19.127 C 33.618 19.127 33.342 19.332 33.171 19.607 L 33.171 19.197 L 32.445 19.197 L 32.445 22.481 L 33.171 22.481 L 33.171 20.633 C 33.171 20.086 33.414 19.777 33.862 19.777 C 33.998 19.777 34.17 19.812 34.307 19.847 L 34.515 19.162 C 34.38 19.127 34.172 19.127 34.033 19.127 Z M 24.779 20.838 C 24.779 21.834 25.47 22.551 26.54 22.551 C 27.025 22.551 27.369 22.449 27.715 22.173 L 27.369 21.593 C 27.092 21.798 26.816 21.901 26.504 21.901 C 25.919 21.901 25.505 21.49 25.505 20.84 C 25.505 20.226 25.919 19.813 26.507 19.78 C 26.816 19.78 27.092 19.883 27.369 20.089 L 27.715 19.507 C 27.369 19.233 27.024 19.13 26.54 19.13 C 25.47 19.13 24.779 19.85 24.779 20.841 Z M 31.478 20.838 L 31.478 19.198 L 30.75 19.198 L 30.75 19.608 C 30.51 19.3 30.165 19.128 29.717 19.128 C 28.784 19.128 28.058 19.848 28.058 20.84 C 28.058 21.835 28.784 22.552 29.716 22.552 C 30.197 22.552 30.543 22.382 30.748 22.074 L 30.748 22.484 L 31.477 22.484 L 31.477 20.84 Z M 28.818 20.838 C 28.818 20.259 29.196 19.779 29.819 19.779 C 30.406 19.779 30.821 20.224 30.821 20.84 C 30.821 21.424 30.406 21.902 29.819 21.902 C 29.196 21.869 28.818 21.424 28.818 20.841 Z M 20.148 19.128 C 19.183 19.128 18.494 19.813 18.494 20.84 C 18.494 21.869 19.183 22.552 20.185 22.552 C 20.671 22.552 21.154 22.417 21.533 22.108 L 21.188 21.595 C 20.914 21.799 20.565 21.937 20.222 21.937 C 19.772 21.937 19.323 21.732 19.219 21.149 L 21.671 21.149 L 21.671 20.878 C 21.705 19.815 21.083 19.13 20.15 19.13 Z M 20.148 19.748 C 20.6 19.748 20.911 20.019 20.98 20.532 L 19.253 20.532 C 19.321 20.087 19.633 19.748 20.148 19.748 Z M 38.141 20.84 L 38.141 17.898 L 37.412 17.898 L 37.412 19.61 C 37.173 19.302 36.828 19.13 36.38 19.13 C 35.446 19.13 34.721 19.85 34.721 20.841 C 34.721 21.837 35.446 22.554 36.379 22.554 C 36.861 22.554 37.206 22.383 37.41 22.076 L 37.41 22.486 L 38.14 22.486 L 38.14 20.841 Z M 35.481 20.84 C 35.481 20.261 35.861 19.78 36.484 19.78 C 37.069 19.78 37.486 20.226 37.486 20.841 C 37.486 21.426 37.069 21.904 36.484 21.904 C 35.861 21.87 35.481 21.426 35.481 20.843 Z M 11.237 20.84 L 11.237 19.2 L 10.515 19.2 L 10.515 19.61 C 10.272 19.302 9.928 19.13 9.478 19.13 C 8.545 19.13 7.82 19.85 7.82 20.841 C 7.82 21.837 8.545 22.554 9.477 22.554 C 9.96 22.554 10.304 22.383 10.512 22.076 L 10.512 22.486 L 11.236 22.486 L 11.236 20.841 Z M 8.546 20.84 C 8.546 20.261 8.926 19.78 9.548 19.78 C 10.134 19.78 10.55 20.226 10.55 20.841 C 10.55 21.426 10.134 21.904 9.548 21.904 C 8.926 21.87 8.546 21.426 8.546 20.843 Z\" style=\"fill: rgb(255, 255, 255);\"/>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/paypal_black.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"100\" height=\"32\" viewBox=\"0 0 100 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 12 5.315 L 4.2 5.315 C 3.7 5.315 3.2 5.715 3.1 6.215 L 0 26.215 C -0.1 26.615 0.2 26.915 0.6 26.915 L 4.3 26.915 C 4.8 26.915 5.3 26.515 5.4 26.015 L 6.2 20.615 C 6.3 20.115 6.7 19.715 7.3 19.715 L 9.8 19.715 C 14.9 19.715 17.9 17.215 18.7 12.315 C 19 10.215 18.7 8.515 17.7 7.315 C 16.6 6.015 14.6 5.315 12 5.315 Z M 12.9 12.615 C 12.5 15.415 10.3 15.415 8.3 15.415 L 7.1 15.415 L 7.9 10.215 C 7.9 9.915 8.2 9.715 8.5 9.715 L 9 9.715 C 10.4 9.715 11.7 9.715 12.4 10.515 C 12.9 10.915 13.1 11.615 12.9 12.615 Z\" fill=\"#333030\"/>\n  <path d=\"M 35.2 12.515 L 31.5 12.515 C 31.2 12.515 30.9 12.715 30.9 13.015 L 30.7 14.015 L 30.4 13.615 C 29.6 12.415 27.8 12.015 26 12.015 C 21.9 12.015 18.4 15.115 17.7 19.515 C 17.3 21.715 17.8 23.815 19.1 25.215 C 20.2 26.515 21.9 27.115 23.8 27.115 C 27.1 27.115 29 25.015 29 25.015 L 28.8 26.015 C 28.7 26.415 29 26.815 29.4 26.815 L 32.8 26.815 C 33.3 26.815 33.8 26.415 33.9 25.915 L 35.9 13.115 C 36 12.915 35.6 12.515 35.2 12.515 Z M 30.1 19.815 C 29.7 21.915 28.1 23.415 25.9 23.415 C 24.8 23.415 24 23.115 23.4 22.415 C 22.8 21.715 22.6 20.815 22.8 19.815 C 23.1 17.715 24.9 16.215 27 16.215 C 28.1 16.215 28.9 16.615 29.5 17.215 C 30 17.815 30.2 18.715 30.1 19.815 Z\" fill=\"#333030\"/>\n  <path d=\"M 55.1 12.515 L 51.4 12.515 C 51 12.515 50.7 12.715 50.5 13.015 L 45.3 20.615 L 43.1 13.315 C 43 12.815 42.5 12.515 42.1 12.515 L 38.4 12.515 C 38 12.515 37.6 12.915 37.8 13.415 L 41.9 25.515 L 38 30.915 C 37.7 31.315 38 31.915 38.5 31.915 L 42.2 31.915 C 42.6 31.915 42.9 31.715 43.1 31.415 L 55.6 13.415 C 55.9 13.115 55.6 12.515 55.1 12.515 Z\" fill=\"#333030\"/>\n  <path d=\"M 67.5 5.315 L 59.7 5.315 C 59.2 5.315 58.7 5.715 58.6 6.215 L 55.5 26.115 C 55.4 26.515 55.7 26.815 56.1 26.815 L 60.1 26.815 C 60.5 26.815 60.8 26.515 60.8 26.215 L 61.7 20.515 C 61.8 20.015 62.2 19.615 62.8 19.615 L 65.3 19.615 C 70.4 19.615 73.4 17.115 74.2 12.215 C 74.5 10.115 74.2 8.415 73.2 7.215 C 72 6.015 70.1 5.315 67.5 5.315 Z M 68.4 12.615 C 68 15.415 65.8 15.415 63.8 15.415 L 62.6 15.415 L 63.4 10.215 C 63.4 9.915 63.7 9.715 64 9.715 L 64.5 9.715 C 65.9 9.715 67.2 9.715 67.9 10.515 C 68.4 10.915 68.5 11.615 68.4 12.615 Z\" fill=\"#636363\"/>\n  <path d=\"M 90.7 12.515 L 87 12.515 C 86.7 12.515 86.4 12.715 86.4 13.015 L 86.2 14.015 L 85.9 13.615 C 85.1 12.415 83.3 12.015 81.5 12.015 C 77.4 12.015 73.9 15.115 73.2 19.515 C 72.8 21.715 73.3 23.815 74.6 25.215 C 75.7 26.515 77.4 27.115 79.3 27.115 C 82.6 27.115 84.5 25.015 84.5 25.015 L 84.3 26.015 C 84.2 26.415 84.5 26.815 84.9 26.815 L 88.3 26.815 C 88.8 26.815 89.3 26.415 89.4 25.915 L 91.4 13.115 C 91.4 12.915 91.1 12.515 90.7 12.515 Z M 85.5 19.815 C 85.1 21.915 83.5 23.415 81.3 23.415 C 80.2 23.415 79.4 23.115 78.8 22.415 C 78.2 21.715 78 20.815 78.2 19.815 C 78.5 17.715 80.3 16.215 82.4 16.215 C 83.5 16.215 84.3 16.615 84.9 17.215 C 85.5 17.815 85.7 18.715 85.5 19.815 Z\" fill=\"#636363\"/>\n  <path d=\"M 95.1 5.915 L 91.9 26.215 C 91.8 26.615 92.1 26.915 92.5 26.915 L 95.7 26.915 C 96.2 26.915 96.7 26.515 96.8 26.015 L 100 6.115 C 100.1 5.715 99.8 5.415 99.4 5.415 L 95.8 5.415 C 95.4 5.315 95.2 5.515 95.1 5.915 Z\" fill=\"#636363\"/>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/paypal_blue.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"100\" height=\"32\" viewBox=\"0 0 100 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <path fill=\"#003087\" d=\"M 12 4.917 L 4.2 4.917 C 3.7 4.917 3.2 5.317 3.1 5.817 L 0 25.817 C -0.1 26.217 0.2 26.517 0.6 26.517 L 4.3 26.517 C 4.8 26.517 5.3 26.117 5.4 25.617 L 6.2 20.217 C 6.3 19.717 6.7 19.317 7.3 19.317 L 9.8 19.317 C 14.9 19.317 17.9 16.817 18.7 11.917 C 19 9.817 18.7 8.117 17.7 6.917 C 16.6 5.617 14.6 4.917 12 4.917 Z M 12.9 12.217 C 12.5 15.017 10.3 15.017 8.3 15.017 L 7.1 15.017 L 7.9 9.817 C 7.9 9.517 8.2 9.317 8.5 9.317 L 9 9.317 C 10.4 9.317 11.7 9.317 12.4 10.117 C 12.9 10.517 13.1 11.217 12.9 12.217 Z\"></path>\n    <path fill=\"#003087\" d=\"M 35.2 12.117 L 31.5 12.117 C 31.2 12.117 30.9 12.317 30.9 12.617 L 30.7 13.617 L 30.4 13.217 C 29.6 12.017 27.8 11.617 26 11.617 C 21.9 11.617 18.4 14.717 17.7 19.117 C 17.3 21.317 17.8 23.417 19.1 24.817 C 20.2 26.117 21.9 26.717 23.8 26.717 C 27.1 26.717 29 24.617 29 24.617 L 28.8 25.617 C 28.7 26.017 29 26.417 29.4 26.417 L 32.8 26.417 C 33.3 26.417 33.8 26.017 33.9 25.517 L 35.9 12.717 C 36 12.517 35.6 12.117 35.2 12.117 Z M 30.1 19.317 C 29.7 21.417 28.1 22.917 25.9 22.917 C 24.8 22.917 24 22.617 23.4 21.917 C 22.8 21.217 22.6 20.317 22.8 19.317 C 23.1 17.217 24.9 15.717 27 15.717 C 28.1 15.717 28.9 16.117 29.5 16.717 C 30 17.417 30.2 18.317 30.1 19.317 Z\"></path>\n    <path fill=\"#003087\" d=\"M 55.1 12.117 L 51.4 12.117 C 51 12.117 50.7 12.317 50.5 12.617 L 45.3 20.217 L 43.1 12.917 C 43 12.417 42.5 12.117 42.1 12.117 L 38.4 12.117 C 38 12.117 37.6 12.517 37.8 13.017 L 41.9 25.117 L 38 30.517 C 37.7 30.917 38 31.517 38.5 31.517 L 42.2 31.517 C 42.6 31.517 42.9 31.317 43.1 31.017 L 55.6 13.017 C 55.9 12.717 55.6 12.117 55.1 12.117 Z\"></path>\n    <path fill=\"#009cde\" d=\"M 67.5 4.917 L 59.7 4.917 C 59.2 4.917 58.7 5.317 58.6 5.817 L 55.5 25.717 C 55.4 26.117 55.7 26.417 56.1 26.417 L 60.1 26.417 C 60.5 26.417 60.8 26.117 60.8 25.817 L 61.7 20.117 C 61.8 19.617 62.2 19.217 62.8 19.217 L 65.3 19.217 C 70.4 19.217 73.4 16.717 74.2 11.817 C 74.5 9.717 74.2 8.017 73.2 6.817 C 72 5.617 70.1 4.917 67.5 4.917 Z M 68.4 12.217 C 68 15.017 65.8 15.017 63.8 15.017 L 62.6 15.017 L 63.4 9.817 C 63.4 9.517 63.7 9.317 64 9.317 L 64.5 9.317 C 65.9 9.317 67.2 9.317 67.9 10.117 C 68.4 10.517 68.5 11.217 68.4 12.217 Z\"></path>\n    <path fill=\"#009cde\" d=\"M 90.7 12.117 L 87 12.117 C 86.7 12.117 86.4 12.317 86.4 12.617 L 86.2 13.617 L 85.9 13.217 C 85.1 12.017 83.3 11.617 81.5 11.617 C 77.4 11.617 73.9 14.717 73.2 19.117 C 72.8 21.317 73.3 23.417 74.6 24.817 C 75.7 26.117 77.4 26.717 79.3 26.717 C 82.6 26.717 84.5 24.617 84.5 24.617 L 84.3 25.617 C 84.2 26.017 84.5 26.417 84.9 26.417 L 88.3 26.417 C 88.8 26.417 89.3 26.017 89.4 25.517 L 91.4 12.717 C 91.4 12.517 91.1 12.117 90.7 12.117 Z M 85.5 19.317 C 85.1 21.417 83.5 22.917 81.3 22.917 C 80.2 22.917 79.4 22.617 78.8 21.917 C 78.2 21.217 78 20.317 78.2 19.317 C 78.5 17.217 80.3 15.717 82.4 15.717 C 83.5 15.717 84.3 16.117 84.9 16.717 C 85.5 17.417 85.7 18.317 85.5 19.317 Z\"></path>\n    <path fill=\"#009cde\" d=\"M 95.1 5.417 L 91.9 25.717 C 91.8 26.117 92.1 26.417 92.5 26.417 L 95.7 26.417 C 96.2 26.417 96.7 26.017 96.8 25.517 L 100 5.617 C 100.1 5.217 99.8 4.917 99.4 4.917 L 95.8 4.917 C 95.4 4.917 95.2 5.117 95.1 5.417 Z\"></path>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/paypal_white.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"100\" height=\"32\" viewBox=\"0 0 100 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <path fill=\"#ffffff\" d=\"M 12 5.315 L 4.2 5.315 C 3.7 5.315 3.2 5.715 3.1 6.215 L 0 26.215 C -0.1 26.615 0.2 26.915 0.6 26.915 L 4.3 26.915 C 4.8 26.915 5.3 26.515 5.4 26.015 L 6.2 20.615 C 6.3 20.115 6.7 19.715 7.3 19.715 L 9.8 19.715 C 14.9 19.715 17.9 17.215 18.7 12.315 C 19 10.215 18.7 8.515 17.7 7.315 C 16.6 6.015 14.6 5.315 12 5.315 Z M 12.9 12.615 C 12.5 15.415 10.3 15.415 8.3 15.415 L 7.1 15.415 L 7.9 10.215 C 7.9 9.915 8.2 9.715 8.5 9.715 L 9 9.715 C 10.4 9.715 11.7 9.715 12.4 10.515 C 12.9 10.915 13.1 11.615 12.9 12.615 Z\"></path>\n    <path fill=\"#ffffff\" d=\"M 35.2 12.515 L 31.5 12.515 C 31.2 12.515 30.9 12.715 30.9 13.015 L 30.7 14.015 L 30.4 13.615 C 29.6 12.415 27.8 12.015 26 12.015 C 21.9 12.015 18.4 15.115 17.7 19.515 C 17.3 21.715 17.8 23.815 19.1 25.215 C 20.2 26.515 21.9 27.115 23.8 27.115 C 27.1 27.115 29 25.015 29 25.015 L 28.8 26.015 C 28.7 26.415 29 26.815 29.4 26.815 L 32.8 26.815 C 33.3 26.815 33.8 26.415 33.9 25.915 L 35.9 13.115 C 36 12.915 35.6 12.515 35.2 12.515 Z M 30.1 19.815 C 29.7 21.915 28.1 23.415 25.9 23.415 C 24.8 23.415 24 23.115 23.4 22.415 C 22.8 21.715 22.6 20.815 22.8 19.815 C 23.1 17.715 24.9 16.215 27 16.215 C 28.1 16.215 28.9 16.615 29.5 17.215 C 30 17.815 30.2 18.715 30.1 19.815 Z\"></path>\n    <path fill=\"#ffffff\" d=\"M 55.1 12.515 L 51.4 12.515 C 51 12.515 50.7 12.715 50.5 13.015 L 45.3 20.615 L 43.1 13.315 C 43 12.815 42.5 12.515 42.1 12.515 L 38.4 12.515 C 38 12.515 37.6 12.915 37.8 13.415 L 41.9 25.515 L 38 30.915 C 37.7 31.315 38 31.915 38.5 31.915 L 42.2 31.915 C 42.6 31.915 42.9 31.715 43.1 31.415 L 55.6 13.415 C 55.9 13.115 55.6 12.515 55.1 12.515 Z\"></path>\n    <path fill=\"#ffffff\" d=\"M 67.5 5.315 L 59.7 5.315 C 59.2 5.315 58.7 5.715 58.6 6.215 L 55.5 26.115 C 55.4 26.515 55.7 26.815 56.1 26.815 L 60.1 26.815 C 60.5 26.815 60.8 26.515 60.8 26.215 L 61.7 20.515 C 61.8 20.015 62.2 19.615 62.8 19.615 L 65.3 19.615 C 70.4 19.615 73.4 17.115 74.2 12.215 C 74.5 10.115 74.2 8.415 73.2 7.215 C 72 6.015 70.1 5.315 67.5 5.315 Z M 68.4 12.615 C 68 15.415 65.8 15.415 63.8 15.415 L 62.6 15.415 L 63.4 10.215 C 63.4 9.915 63.7 9.715 64 9.715 L 64.5 9.715 C 65.9 9.715 67.2 9.715 67.9 10.515 C 68.4 10.915 68.5 11.615 68.4 12.615 Z\"></path>\n    <path fill=\"#ffffff\" d=\"M 90.7 12.515 L 87 12.515 C 86.7 12.515 86.4 12.715 86.4 13.015 L 86.2 14.015 L 85.9 13.615 C 85.1 12.415 83.3 12.015 81.5 12.015 C 77.4 12.015 73.9 15.115 73.2 19.515 C 72.8 21.715 73.3 23.815 74.6 25.215 C 75.7 26.515 77.4 27.115 79.3 27.115 C 82.6 27.115 84.5 25.015 84.5 25.015 L 84.3 26.015 C 84.2 26.415 84.5 26.815 84.9 26.815 L 88.3 26.815 C 88.8 26.815 89.3 26.415 89.4 25.915 L 91.4 13.115 C 91.4 12.915 91.1 12.515 90.7 12.515 Z M 85.5 19.815 C 85.1 21.915 83.5 23.415 81.3 23.415 C 80.2 23.415 79.4 23.115 78.8 22.415 C 78.2 21.715 78 20.815 78.2 19.815 C 78.5 17.715 80.3 16.215 82.4 16.215 C 83.5 16.215 84.3 16.615 84.9 17.215 C 85.5 17.815 85.7 18.715 85.5 19.815 Z\"></path>\n    <path fill=\"#ffffff\" d=\"M 95.1 5.915 L 91.9 26.215 C 91.8 26.615 92.1 26.915 92.5 26.915 L 95.7 26.915 C 96.2 26.915 96.7 26.515 96.8 26.015 L 100 6.115 C 100.1 5.715 99.8 5.415 99.4 5.415 L 95.8 5.415 C 95.4 5.315 95.2 5.515 95.1 5.915 Z\"></path>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/pp_black.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"24\" height=\"32\" viewBox=\"0 0 24 32\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path opacity=\"0.7\" d=\"M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446\" style=\"fill: rgb(99, 99, 99);\"/>\n  <path opacity=\"0.7\" d=\"M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446\"/>\n  <path d=\"M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z\" style=\"fill: rgb(51, 48, 48);\"/>\n  <g transform=\"matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)\" opacity=\"0.2\">\n    <path fill=\"#231f20\" d=\"M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z\"/>\n    <path fill=\"#231f20\" d=\"M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z\"/>\n    <path fill=\"#231f20\" d=\"M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z\"/>\n  </g>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/logos/pp_blue.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"24\" height=\"32\" viewBox=\"0 0 24 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <path fill=\"#009cde\" d=\"M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 6.675 28.9 C 6.581 29.3 6.862 29.6 7.236 29.6 L 11.356 29.6 C 11.825 29.6 12.292 29.3 12.386 28.8 L 12.386 28.5 L 13.228 23.3 L 13.228 23.1 C 13.322 22.6 13.79 22.2 14.258 22.2 L 14.821 22.2 C 18.845 22.2 21.935 20.5 22.871 15.5 C 23.339 13.4 23.153 11.7 22.029 10.5 C 21.748 10.1 21.279 9.8 20.905 9.5 L 20.905 9.5\"></path>\n    <path fill=\"#012169\" d=\"M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 8.173 18.7 C 8.267 18.1 8.735 17.7 9.296 17.7 L 11.636 17.7 C 16.224 17.7 19.782 15.7 20.905 10.1 C 20.812 9.8 20.905 9.7 20.905 9.5\"></path>\n    <path fill=\"#003087\" d=\"M 9.485 9.5 C 9.577 9.2 9.765 8.9 10.046 8.7 C 10.232 8.7 10.326 8.6 10.513 8.6 L 16.692 8.6 C 17.442 8.6 18.189 8.7 18.753 8.8 C 18.939 8.8 19.127 8.8 19.314 8.9 C 19.501 9 19.688 9 19.782 9.1 C 19.875 9.1 19.968 9.1 20.063 9.1 C 20.343 9.2 20.624 9.4 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.6 C 18.658 3.2 16.506 2.6 13.79 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 9.485 9.5 Z\"></path>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/pp_white.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"24\" height=\"32\" viewBox=\"0 0 24 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <path fill=\"#ffffff\" opacity=\"0.7\" d=\"M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446\"></path>\n    <path fill=\"#ffffff\" opacity=\"0.7\" d=\"M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446\"></path>\n    <path fill=\"#ffffff\" d=\"M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z\"></path>\n    <g transform=\"matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)\" opacity=\"0.2\">\n        <path fill=\"#231f20\" d=\"M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z\"></path>\n        <path fill=\"#231f20\" d=\"M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z\"></path>\n        <path fill=\"#231f20\" d=\"M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z\"></path>\n    </g>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/venmo_blue.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"101\" height=\"32\" viewBox=\"0 0 101 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Blue\" fill=\"#3D93CE\">\n            <g id=\"Logo\" transform=\"translate(0.000000, 6.000000)\">\n                <path d=\"M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z\"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/venmo_white.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"101\" height=\"32\" viewBox=\"0 0 101 32\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\">\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"White\" fill=\"#FFFFFF\">\n            <g id=\"Logo\" transform=\"translate(0.000000, 6.000000)\">\n                <path d=\"M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z\"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),

/***/ "./src/components/button/templates/component/logos/visa.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"40\" height=\"24\" viewBox=\"0 0 40 24\" preserveAspectRatio=\"xMinYMin meet\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z\" style=\"fill: rgb(33, 86, 154);\"/>\n  <path d=\"M19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z\" style=\"fill: rgb(255, 255, 255);\"/>\n</svg>"

/***/ }),

/***/ "./src/components/button/templates/component/script.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComponentScript;
function getComponentScript() {

    /* istanbul ignore next */
    return function () {

        var STYLE = {
            BLOCK: 'block',
            INLINE_BLOCK: 'inline-block',
            NONE: 'none',
            VISIBLE: 'visible',
            HIDDEN: 'hidden'
        };

        function loop(method, delay, instances) {
            setTimeout(function () {
                method();
                instances -= 1;
                if (instances) {
                    loop(method, delay, instances);
                }
            }, delay);
        }

        function getElements(selector, parent) {
            parent = parent || document;
            return Array.prototype.slice.call(parent.querySelectorAll(selector));
        }

        function showElement(el) {
            var displayType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STYLE.INLINE_BLOCK;

            el.style.display = displayType;
        }

        function hideElement(el) {
            el.style.display = STYLE.NONE;
        }

        function makeElementVisible(el) {
            el.style.visibility = STYLE.VISIBLE;
        }

        function makeElementInvisible(el) {
            el.style.visibility = STYLE.HIDDEN;
        }

        function hasDimensions(el) {
            var rect = el.getBoundingClientRect();
            return Boolean(rect.height && rect.width);
        }

        function isHidden(el) {
            var computedStyle = window.getComputedStyle(el);
            return !computedStyle || computedStyle.display === STYLE.NONE;
        }

        function displayedElementsHaveDimensions(elements) {
            return elements.every(function (el) {
                return hasDimensions(el) || isHidden(el);
            });
        }

        function onDisplay(elements, method) {
            if (displayedElementsHaveDimensions(elements)) {
                method();
                return;
            }

            var interval = setInterval(function () {
                if (displayedElementsHaveDimensions(elements)) {
                    clearInterval(interval);
                    method();
                }
            }, 5);
        }

        function isOverflowing(el) {

            if (el.offsetWidth < el.scrollWidth || el.offsetHeight < el.scrollHeight) {
                return true;
            }

            var parent = el.parentNode;

            if (!parent) {
                return false;
            }

            var e = el.getBoundingClientRect();
            // $FlowFixMe
            var p = parent.getBoundingClientRect();

            if (e.top < p.top || e.left < p.left || e.right > p.right || e.bottom > p.bottom) {
                return true;
            }

            if (e.left < 0 || e.top < 0 || e.left + e.width > window.innerWidth || e.top + e.height > window.innerHeight) {
                return true;
            }

            return false;
        }

        var images = getElements('.{ CLASS.BUTTON } .{ CLASS.LOGO }');
        var text = getElements('.{ CLASS.BUTTON } .{ CLASS.TEXT }');
        var tagline = getElements('.{ CLASS.TAGLINE }');
        var cards = getElements('.{ CLASS.FUNDINGICONS } .{ CLASS.CARD }');
        var optionals = getElements('.{ CLASS.BUTTON }-label-credit .{ CLASS.BUTTON }-logo-paypal');

        function toggleOptionals() {

            if (tagline.some(isOverflowing)) {
                tagline.forEach(makeElementInvisible);
            } else {
                tagline.forEach(makeElementVisible);
            }

            cards.forEach(function (el) {
                return showElement(el);
            });
            cards.filter(isOverflowing).forEach(hideElement);

            text.forEach(function (el) {
                return showElement(el);
            });
            optionals.forEach(function (el) {
                return showElement(el);
            });

            if (images.some(isOverflowing) || text.some(isOverflowing)) {
                text.forEach(hideElement);
                optionals.forEach(hideElement);
            } else {
                text.forEach(makeElementVisible);
                optionals.forEach(function (el) {
                    return showElement(el);
                });
            }
        }

        toggleOptionals();

        onDisplay(images, function () {
            images.forEach(makeElementVisible);
            toggleOptionals();

            document.addEventListener('DOMContentLoaded', toggleOptionals);
            window.addEventListener('load', toggleOptionals);
            window.addEventListener('resize', toggleOptionals);
            loop(toggleOptionals, 10, 10);
        });
    };
}

/***/ }),

/***/ "./src/components/button/templates/component/style/base.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = componentStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page__ = __webpack_require__("./src/components/button/templates/component/style/page.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button__ = __webpack_require__("./src/components/button/templates/component/style/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout__ = __webpack_require__("./src/components/button/templates/component/style/layout.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__branding__ = __webpack_require__("./src/components/button/templates/component/style/branding.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__labels__ = __webpack_require__("./src/components/button/templates/component/style/labels.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__responsive__ = __webpack_require__("./src/components/button/templates/component/style/responsive.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__color__ = __webpack_require__("./src/components/button/templates/component/style/color.js");








function componentStyle(_ref) {
    var height = _ref.height,
        cardNumber = _ref.cardNumber;

    return '\n        ' + __WEBPACK_IMPORTED_MODULE_0__page__["a" /* pageStyle */] + '\n        ' + __WEBPACK_IMPORTED_MODULE_1__button__["a" /* buttonStyle */] + '\n        ' + __WEBPACK_IMPORTED_MODULE_6__color__["a" /* buttonColorStyle */] + '\n        ' + __WEBPACK_IMPORTED_MODULE_2__layout__["a" /* layoutStyle */] + '\n        ' + __WEBPACK_IMPORTED_MODULE_3__branding__["a" /* brandingStyle */] + '\n        ' + __WEBPACK_IMPORTED_MODULE_4__labels__["a" /* labelStyle */] + '\n        ' + Object(__WEBPACK_IMPORTED_MODULE_5__responsive__["a" /* buttonResponsiveStyle */])({ height: height, cardNumber: cardNumber }) + '\n    ';
}

/***/ }),

/***/ "./src/components/button/templates/component/style/branding.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return brandingStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");




var brandingStyle = '\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BRANDING + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BUTTON_BRANDING */].UNBRANDED + '  {\n        min-width: 60%;\n        width: auto;\n        font-weight: 900;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BRANDING + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BUTTON_BRANDING */].UNBRANDED + ' .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].LOGO + ' {\n        display: none;\n    }\n';

/***/ }),

/***/ "./src/components/button/templates/component/style/button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");





var buttonStyle = '\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CONTAINER + ' {\n        display: block;\n        white-space: nowrap;\n        margin: 0;\n        background: 0;\n        border: 0;\n        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n        text-transform: none;\n        font-weight: 500;R\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        z-index: 0;\n        font-size: 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ':not(.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CARD + ') {\n        border: 1px solid transparent;\n        border-radius: 0 3px 3px 0;\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        vertical-align: top;\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT + ' {\n        cursor: auto;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ' * {\n        cursor: pointer;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CONTAINER + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].ENV + '-' + __WEBPACK_IMPORTED_MODULE_0__config_constants__["e" /* ENV */].TEST + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TEXT + ' {\n        font-family: Arial !important;\n        background: rgba(0, 0, 0, 0.5) !important;\n        color: transparent  !important;\n        text-shadow: none  !important;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ':hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD + ':hover,\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER + ':hover {\n        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT + ':hover {\n        box-shadow: none;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CARD + ', .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CARD + ' * {\n        cursor: pointer;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CARD + ':hover {\n        filter: brightness(1.2);\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ':focus {\n        box-shadow: -1px -1px 18px 1px rgba(0, 0, 0, 0.25) inset;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT + ':focus {\n        box-shadow: none;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + ' {\n        padding: 0;\n        display: inline-block;\n        background: none;\n        border: none;\n        width: auto;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TEXT + ' {\n        display: inline-block;\n        white-space: pre;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + ',\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TEXT + ' {\n        vertical-align: top;\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n        text-align: left;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].CARD + ' {\n        border-radius: 4px;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TEXT + ' {\n        visibility: hidden;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TAGLINE + ' {\n        max-width: 100%;\n        font-weight: normal;\n        display: block;\n        text-align: center;\n        width: auto;\n        visibility: hidden;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].SEPARATOR + ' {\n        height: 80%;\n        border-left: 1px solid rgba(0, 0, 0, 0.15);\n        margin: 0 8px;\n        display: inline-block;\n        position: relative;\n        top: 10%;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].SEPARATOR + ' {\n        border-color: rgba(255, 255, 255, 0.45);\n    }\n';

/***/ }),

/***/ "./src/components/button/templates/component/style/class.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLASS; });
var CLASS = {
    CONTAINER: 'paypal-button-container',
    BUTTON: 'paypal-button',

    LABEL: 'paypal-button-label',
    COLOR: 'paypal-button-color',
    LOGO_COLOR: 'paypal-button-logo-color',
    SHAPE: 'paypal-button-shape',
    BRANDING: 'paypal-button-branding',
    LAYOUT: 'paypal-button-layout',
    NUMBER: 'paypal-button-number',
    ENV: 'paypal-button-env',

    TAGLINE: 'paypal-button-tagline',
    TAGLINE_COLOR: 'paypal-button-tagline-color',
    FUNDINGICONS: 'paypal-button-fundingicons',

    TEXT: 'paypal-button-text',
    LOGO: 'paypal-button-logo',
    CARD: 'paypal-button-card',

    SEPARATOR: 'paypal-separator'
};

/***/ }),

/***/ "./src/components/button/templates/component/style/color.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buttonColorStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");




var buttonColorStyle = '\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].GOLD + ' {\n        background: #ffc439;\n        color: #111;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].BLUE + ' {\n        background: #009cde;\n        color: #fff;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].SILVER + ' {\n        background: #eee;\n        color: #111;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].BLACK + ' {\n        background: #2C2E2F;\n        color: #fff;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].DARKBLUE + ' {\n        background: #003087;\n        color: #fff;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].COLOR + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* BUTTON_COLOR */].TRANSPARENT + ' {\n        background: transparent;\n        color: #111;\n    }\n';

/***/ }),

/***/ "./src/components/button/templates/component/style/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("./src/components/button/templates/component/style/base.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });


/***/ }),

/***/ "./src/components/button/templates/component/style/labels.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return labelStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__("./src/components/button/templates/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");





var labelStyle = '\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LABEL + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CARD + ' {\n        border-radius: 0 !important;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LABEL + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].TEXT + ' {\n        display: none !important;\n    }\n\n    .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LABEL + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' {\n        display: none;\n    }\n\n    @media only screen and (max-width : ' + __WEBPACK_IMPORTED_MODULE_0__style__["b" /* BUTTON_STYLE */][__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].SMALL].minWidth + 'px) {\n\n        .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LABEL + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' {\n            display: none;\n        }\n    }\n\n    @media only screen and (min-width : ' + __WEBPACK_IMPORTED_MODULE_0__style__["b" /* BUTTON_STYLE */][__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].SMALL].minWidth + 'px) {\n\n        .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LABEL + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT + ' .' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '.' + __WEBPACK_IMPORTED_MODULE_2__class__["a" /* CLASS */].LOGO + '-' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' {\n            display: inline-block;\n        }\n    }\n';

/***/ }),

/***/ "./src/components/button/templates/component/style/layout.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return layoutStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");




var layoutStyle = '\n\n    .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].CONTAINER + '.' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' .' + __WEBPACK_IMPORTED_MODULE_1__class__["a" /* CLASS */].TAGLINE + ' {\n        display: none;\n    }\n';

/***/ }),

/***/ "./src/components/button/templates/component/style/page.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pageStyle; });
var pageStyle = "\n    html, body {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n    }\n\n    * {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: default;\n    }\n";

/***/ }),

/***/ "./src/components/button/templates/component/style/responsive.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buttonResponsiveStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("./src/components/button/templates/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/components/button/templates/component/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");






var DUAL_BUTTON_MIN_RATIO = 2.8;

function buttonResponsiveStyle(_ref) {
    var height = _ref.height,
        _ref$cardNumber = _ref.cardNumber,
        cardNumber = _ref$cardNumber === undefined ? 4 : _ref$cardNumber;


    return Object.keys(__WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */]).map(function (size) {

        var style = __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][size];
        var buttonHeight = height || style.defaultHeight;
        var minDualWidth = Math.round(buttonHeight * DUAL_BUTTON_MIN_RATIO * 2);

        return '\n\n            @media only screen and (min-width: ' + style.minWidth + 'px) {\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CONTAINER + ' {\n                    min-width: ' + style.minWidth + 'px;\n                    max-width: ' + style.maxWidth + 'px;\n                    font-size: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* max */])(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 32), 10) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + ':not(.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ') {\n                    height: ' + buttonHeight + 'px;\n                    min-height: ' + (height || style.minHeight) + 'px;\n                    max-height: ' + (height || style.maxHeight) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BRANDING + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BUTTON_BRANDING */].UNBRANDED + ' {\n                    font-size: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* max */])(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 45), 10) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LOGO + ' {\n                    height: ' + (Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 35) + 5) + 'px;\n                    max-height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 60) + 'px;\n                    min-height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 40) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].SHAPE + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* BUTTON_SHAPE */].PILL + ' {\n                    border-radius: ' + Math.ceil(buttonHeight / 2) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].SHAPE + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* BUTTON_SHAPE */].RECT + ' {\n                    border-radius: 4px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' {\n                    margin-bottom: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].VERTICAL_MARGIN) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].SEPARATOR + ' {\n                    margin: 0 ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 5) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].TAGLINE + ' {\n                    height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].TAGLINE) + 'px;\n                    line-height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].TAGLINE) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].FUNDINGICONS + ' {\n                    height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].FUNDINGICONS) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ' {\n                    display: inline-block;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ' {\n                    width: ' + (90 / cardNumber).toFixed(2) + '%;\n                    max-width: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 160) + 'px;\n                    margin-top: 0;\n                    margin-left: ' + (5 / cardNumber).toFixed(2) + '%;\n                    margin-right: ' + (5 / cardNumber).toFixed(2) + '%;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ' img {\n                    width: 100%;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].FUNDINGICONS + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ' {\n                    height: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 70) + 'px;\n                    margin-top: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 15) + 'px;\n                    margin-left: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 7) + 'px;\n                    margin-right: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* perc */])(buttonHeight, 7) + 'px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].FUNDINGICONS + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CARD + ' img {\n                    height: 100%;\n                }\n            }\n\n            @media only screen and (min-width: ' + style.minWidth + 'px) and (max-width: ' + minDualWidth + 'px) {\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-0 {\n                    width: 100%;\n                    margin-right: 0;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-1 {\n                    display: none;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CONTAINER + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].TAGLINE + ' {\n                    display: none;\n                }\n            }\n\n            @media only screen and (min-width: ' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* max */])(style.minWidth, minDualWidth) + 'px) {\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-0 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                    margin-right: 4px;\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].BUTTON + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-1 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                }\n\n                .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].CONTAINER + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].LAYOUT + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL + '.' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].NUMBER + '-' + __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* BUTTON_NUMBER */].MULTIPLE + ' .' + __WEBPACK_IMPORTED_MODULE_3__class__["a" /* CLASS */].TAGLINE + ' {\n                    display: block;\n                }\n            }\n        ';
    }).join('\n');
}

/***/ }),

/***/ "./src/components/button/templates/component/template.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = componentTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Base64__ = __webpack_require__("./node_modules/Base64/base64.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/components/button/templates/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__funding__ = __webpack_require__("./src/components/button/templates/funding.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__props__ = __webpack_require__("./src/components/button/templates/props.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__logos__ = __webpack_require__("./src/components/button/templates/component/logos/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__("./src/components/button/templates/component/style/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__script__ = __webpack_require__("./src/components/button/templates/component/script.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__content__ = __webpack_require__("./src/components/button/templates/component/content.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_class__ = __webpack_require__("./src/components/button/templates/component/style/class.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__("./src/components/button/templates/component/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validate__ = __webpack_require__("./src/components/button/templates/component/validate.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* @jsx jsxToHTML */














 // eslint-disable-line no-unused-vars


function getCommonButtonClasses(_ref) {
    var layout = _ref.layout,
        shape = _ref.shape,
        branding = _ref.branding,
        multiple = _ref.multiple,
        env = _ref.env;

    return [__WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LAYOUT + '-' + layout, __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].SHAPE + '-' + shape, __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].BRANDING + '-' + (branding ? __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* BUTTON_BRANDING */].BRANDED : __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* BUTTON_BRANDING */].UNBRANDED), __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].NUMBER + '-' + (multiple ? __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* BUTTON_NUMBER */].MULTIPLE : __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* BUTTON_NUMBER */].SINGLE), __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].ENV + '-' + env].join(' ');
}

function getButtonClasses(_ref2) {
    var label = _ref2.label,
        color = _ref2.color,
        logoColor = _ref2.logoColor;

    return [__WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LABEL + '-' + label, __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].COLOR + '-' + color, __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LOGO_COLOR + '-' + logoColor].join(' ');
}

function getLocaleContent(locale) {
    var country = locale.country,
        lang = locale.lang;

    return __WEBPACK_IMPORTED_MODULE_9__content__["a" /* componentContent */][country][lang];
}

function determineButtons(_ref3) {
    var label = _ref3.label,
        color = _ref3.color,
        sources = _ref3.sources,
        multiple = _ref3.multiple;


    return sources.map(function (source, i) {

        var buttonLabel = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__["d" /* fundingToDefaultLabel */])(source) : label;

        var buttonColor = multiple && i > 0 ? Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(buttonLabel, 'secondaryColors')[color] : color;

        return {
            source: source,
            label: buttonLabel,
            color: buttonColor
        };
    });
}

function renderCards(_ref4) {
    var cards = _ref4.cards,
        button = _ref4.button;


    return cards.map(function (name) {
        var _ref5;

        var logo = __WEBPACK_IMPORTED_MODULE_6__logos__["a" /* cardLogos */][name];

        return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])('img', _extends({}, (_ref5 = {}, _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].BUTTON] = button || false, _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].FUNDING_SOURCE] = '' + __WEBPACK_IMPORTED_MODULE_1__config_constants__["g" /* FUNDING */].CARD, _ref5[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].CARD] = '' + name, _ref5), {
            'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].CARD + ' ' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].CARD + '-' + name + ' ' + (button ? __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].BUTTON : ''),
            src: 'data:image/svg+xml;base64,' + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__["btoa"])(logo),
            alt: name }));
    });
}

function renderFundingIcons(_ref6) {
    var cards = _ref6.cards,
        fundingicons = _ref6.fundingicons;


    if (!fundingicons) {
        return;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])(
        'div',
        { 'class': '' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].FUNDINGICONS },
        renderCards({ cards: cards, button: true })
    );
}

function renderContent(text, _ref7) {
    var locale = _ref7.locale,
        color = _ref7.color,
        branding = _ref7.branding,
        logoColor = _ref7.logoColor,
        funding = _ref7.funding,
        env = _ref7.env,
        _cards = _ref7.cards;


    var _content = getLocaleContent(locale);

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["e" /* render */])(text, {
        text: function text(value) {
            return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])(
                'span',
                { 'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].TEXT },
                value
            );
        },
        logo: function logo(name) {

            if (!branding) {
                return;
            }

            if (!logoColor) {
                throw new Error('Can not determine logo without logo color');
            }

            var logo = __WEBPACK_IMPORTED_MODULE_6__logos__["b" /* componentLogos */][name][logoColor] || __WEBPACK_IMPORTED_MODULE_6__logos__["b" /* componentLogos */][name][__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* BUTTON_LOGO_COLOR */].ANY];

            return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])('img', {
                'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LOGO + ' ' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LOGO + '-' + name + ' ' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].LOGO + '-' + color,
                src: 'data:image/svg+xml;base64,' + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__["btoa"])(logo),
                alt: name });
        },
        content: function content(name) {
            var contentString = void 0;

            for (var _iterator = name.split('|'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref8;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref8 = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref8 = _i.value;
                }

                var key = _ref8;

                if (_content[key]) {
                    contentString = _content[key];
                    break;
                }
            }

            if (!contentString && env === __WEBPACK_IMPORTED_MODULE_1__config_constants__["e" /* ENV */].TEST) {
                throw new Error('Could not find content ' + name + ' for ' + locale.lang + '_' + locale.country);
            }

            return renderContent(contentString || '', { locale: locale, color: color, branding: branding, logoColor: logoColor, funding: funding, env: env, cards: _cards });
        },
        cards: function cards() {
            if (!funding) {
                throw new Error('Can not determine card types without funding');
            }

            return renderCards({ cards: _cards, button: false });
        },
        separator: function separator() {
            return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])('span', { 'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].SEPARATOR });
        }
    });
}

function renderButton(_ref9) {
    var _ref10;

    var label = _ref9.label,
        color = _ref9.color,
        locale = _ref9.locale,
        branding = _ref9.branding,
        multiple = _ref9.multiple,
        layout = _ref9.layout,
        shape = _ref9.shape,
        source = _ref9.source,
        funding = _ref9.funding,
        i = _ref9.i,
        env = _ref9.env,
        cards = _ref9.cards;


    var logoColor = Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'logoColors')[color];

    var contentText = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'logoLabel') : Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'label');

    contentText = renderContent(contentText, { locale: locale, color: color, branding: branding, logoColor: logoColor, funding: funding, env: env, cards: cards });

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])(
        'div',
        _extends({}, (_ref10 = {}, _ref10[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].FUNDING_SOURCE] = source, _ref10[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].BUTTON] = true, _ref10), {
            'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].BUTTON + ' ' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].NUMBER + '-' + i + ' ' + getCommonButtonClasses({ layout: layout, shape: shape, branding: branding, multiple: multiple, env: env }) + ' ' + getButtonClasses({ label: label, color: color, logoColor: logoColor }),
            role: 'button',
            'aria-label': source,
            tabindex: '0' }),
        contentText
    );
}

function renderTagline(_ref11) {
    var label = _ref11.label,
        tagline = _ref11.tagline,
        color = _ref11.color,
        locale = _ref11.locale,
        multiple = _ref11.multiple,
        env = _ref11.env,
        cards = _ref11.cards;


    if (!tagline) {
        return;
    }

    var tag = multiple ? Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'dualTag') || Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'tag') : Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'tag');

    var text = renderContent(tag, { locale: locale, color: color, env: env, cards: cards });

    if (!text) {
        return;
    }

    var tagColor = Object(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* getButtonConfig */])(label, 'tagLineColors')[color];

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])(
        'div',
        { 'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].TAGLINE + ' ' + __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].TAGLINE_COLOR + '-' + tagColor },
        text
    );
}

function renderScript() {

    var script = Object(__WEBPACK_IMPORTED_MODULE_8__script__["a" /* getComponentScript */])().toString();

    script = script.replace(/\{\s*CLASS\.([A-Z0-9_]+)\s*\}/g, function (match, name) {
        return __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */][name];
    });

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])('script', { innerHTML: '(' + script + ')();' });
}

function renderStyle(_ref12) {
    var height = _ref12.height,
        cardNumber = _ref12.cardNumber;

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])('style', { innerHTML: Object(__WEBPACK_IMPORTED_MODULE_7__style__["a" /* componentStyle */])({ height: height, cardNumber: cardNumber }) });
}

function componentTemplate(_ref13) {
    var _ref14;

    var props = _ref13.props;


    if (props && props.style) {
        var style = props.style;

        if (style.label === 'generic') {
            style.label = 'paypal';
        }

        if (style.color === 'creditblue') {
            delete style.color;
        }

        if (style.maxbuttons === 1 && style.tagline === false && style.size === 'responsive' && style.layout === 'horizontal' && !style.height) {

            style.height = 44;
        }
    }

    Object(__WEBPACK_IMPORTED_MODULE_12__validate__["b" /* validateButtonProps */])(props);

    var _normalizeProps = Object(__WEBPACK_IMPORTED_MODULE_5__props__["a" /* normalizeProps */])(props),
        label = _normalizeProps.label,
        locale = _normalizeProps.locale,
        color = _normalizeProps.color,
        shape = _normalizeProps.shape,
        branding = _normalizeProps.branding,
        tagline = _normalizeProps.tagline,
        funding = _normalizeProps.funding,
        layout = _normalizeProps.layout,
        sources = _normalizeProps.sources,
        multiple = _normalizeProps.multiple,
        fundingicons = _normalizeProps.fundingicons,
        env = _normalizeProps.env,
        height = _normalizeProps.height,
        cards = _normalizeProps.cards;

    var buttonNodes = determineButtons({ label: label, color: color, sources: sources, multiple: multiple }).map(function (button, i) {
        return renderButton({
            label: button.label,
            color: button.color,
            source: button.source,
            env: env,
            i: i,
            funding: funding,
            multiple: multiple,
            locale: locale,
            branding: branding,
            layout: layout,
            shape: shape,
            cards: cards
        });
    });

    var taglineNode = renderTagline({ label: label, tagline: tagline, color: color, locale: locale, multiple: multiple, env: env, cards: cards });
    var fundingiconNode = renderFundingIcons({ cards: cards, fundingicons: fundingicons });

    var styleNode = renderStyle({ height: height, cardNumber: cards.length });
    var scriptNode = renderScript();

    return Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* jsxToHTML */])(
        'div',
        _extends({}, (_ref14 = {}, _ref14[__WEBPACK_IMPORTED_MODULE_1__config_constants__["a" /* ATTRIBUTE */].VERSION] = "4.0.173", _ref14), { 'class': __WEBPACK_IMPORTED_MODULE_10__style_class__["a" /* CLASS */].CONTAINER + ' ' + getCommonButtonClasses({ layout: layout, shape: shape, branding: branding, multiple: multiple, env: env }) }),
        styleNode,
        buttonNodes,
        taglineNode || fundingiconNode,
        scriptNode
    ).toString();
}

/***/ }),

/***/ "./src/components/button/templates/component/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export encode */
/* harmony export (immutable) */ __webpack_exports__["d"] = perc;
/* harmony export (immutable) */ __webpack_exports__["c"] = min;
/* harmony export (immutable) */ __webpack_exports__["b"] = max;
/* unused harmony export JsxHTMLNode */
/* unused harmony export JsxHTMLNodeContainer */
/* harmony export (immutable) */ __webpack_exports__["a"] = jsxToHTML;
/* harmony export (immutable) */ __webpack_exports__["e"] = render;
function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* @jsx jsxToHTML */

function encode() {
    var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
}

function perc(pixels, percentage) {
    return Math.round(pixels * percentage / 100);
}

function min() {
    return Math.min.apply(Math, arguments);
}

function max() {
    return Math.max.apply(Math, arguments);
}

// eslint-disable-next-line no-use-before-define


var JsxHTMLNode = function () {
    function JsxHTMLNode(name, props, children) {
        _classCallCheck(this, JsxHTMLNode);

        this.name = name;
        this.props = props;
        this.children = children;
    }

    JsxHTMLNode.prototype.toString = function toString() {
        return '<' + this.name + (this.props ? ' ' : '') + (this.props ? this.propsToString() : '') + '>' + this.childrenToString() + '</' + this.name + '>';
    };

    JsxHTMLNode.prototype.propsToString = function propsToString() {
        var props = this.props;

        if (!props) {
            return '';
        }

        return Object.keys(props).filter(function (key) {
            return key !== 'innerHTML' && props && props[key] !== false;
        }).map(function (key) {
            if (props && props[key] === true) {
                return '' + encode(key);
            }
            return props ? encode(key) + '="' + encode(props[key]) + '"' : '';
        }).join(' ');
    };

    JsxHTMLNode.prototype.childrenToString = function childrenToString() {

        if (this.props && this.props.innerHTML) {
            return this.props.innerHTML;
        }

        if (!this.children) {
            return '';
        }

        var result = '';

        function iterate(children) {
            for (var _iterator = children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var child = _ref;


                if (child === null || child === undefined) {
                    continue;
                }

                if (Array.isArray(child)) {
                    iterate(child);
                } else if (child instanceof JsxHTMLNode) {
                    result += child.toString();
                } else {
                    result += encode(child);
                }
            }
        }

        iterate(this.children);

        return result;
    };

    return JsxHTMLNode;
}();

var JsxHTMLNodeContainer = function (_JsxHTMLNode) {
    _inherits(JsxHTMLNodeContainer, _JsxHTMLNode);

    function JsxHTMLNodeContainer(children) {
        _classCallCheck(this, JsxHTMLNodeContainer);

        return _possibleConstructorReturn(this, _JsxHTMLNode.call(this, '', {}, children));
    }

    JsxHTMLNodeContainer.prototype.toString = function toString() {
        return this.childrenToString();
    };

    return JsxHTMLNodeContainer;
}(JsxHTMLNode);

function jsxToHTML(name, props) {
    for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        children[_key - 2] = arguments[_key];
    }

    return new JsxHTMLNode(name, props, children);
}

function regexMap(str, regex, handler) {
    var results = [];

    // $FlowFixMe
    str.replace(regex, function regexMapMatcher() {
        results.push(handler.apply(null, arguments));
    });

    return results;
}

function render(template, renderers) {

    // eslint-disable-next-line security/detect-unsafe-regex
    var nodes = regexMap(template, /\{\s*([a-z]+)(?::\s*([^} ]+))?\s*\}|([^${}]+)/g, function (match, type, value, text) {
        if (type) {
            if (!renderers[type]) {
                throw new Error('Can not render type: ' + type);
            }

            return renderers[type](value);
        } else if (text && text.trim()) {

            if (!renderers.text) {
                return text;
            }

            return renderers.text(text);
        } else {
            return text;
        }
    });

    return new JsxHTMLNodeContainer(nodes);
}

/***/ }),

/***/ "./src/components/button/templates/component/validate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateButtonLocale;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateButtonStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateButtonProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/components/button/templates/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("./src/components/button/templates/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__content__ = __webpack_require__("./src/components/button/templates/component/content.js");






function validateButtonLocale(locale) {

    if (!locale) {
        throw new Error('Expected props.locale to be set');
    }

    if (!locale.match(/^[a-z]{2}[_][A-Z][A-Z0-9]$/)) {
        throw new Error('Expected props.locale to be valid, got ' + locale);
    }

    var _locale$split = locale.split('_'),
        lang = _locale$split[0],
        country = _locale$split[1];

    if (!__WEBPACK_IMPORTED_MODULE_3__content__["a" /* componentContent */][country] || !__WEBPACK_IMPORTED_MODULE_3__content__["a" /* componentContent */][country][lang]) {
        throw new Error('Expected props.locale to be valid');
    }
}

function validateButtonStyle() {
    var style = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    if (!style) {
        throw new Error('Expected props.style to be set');
    }

    var label = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LABEL] || Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])('DEFAULT', style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LAYOUT] === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'defaultVerticalLabel' : 'defaultLabel');

    if (!__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BUTTON_CONFIG */][label]) {
        throw new Error('Invalid button label: ' + label + ', expected: ' + Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* BUTTON_CONFIG */][label]).join(', '));
    }

    var color = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].COLOR],
        shape = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SHAPE],
        size = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SIZE],
        branding = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].BRANDING],
        fundingicons = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].FUNDINGICONS],
        tagline = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].TAGLINE],
        layout = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LAYOUT],
        maxbuttons = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].MAXBUTTONS],
        height = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].HEIGHT];


    if (color && Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'colors').indexOf(color) === -1) {
        throw new Error('Unexpected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].COLOR + ' for ' + label + ' button: ' + color + ', expected ' + Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'colors').join(', '));
    }

    if (shape && Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'shapes').indexOf(shape) === -1) {
        throw new Error('Unexpected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SHAPE + ' for ' + label + ' button: ' + shape + ', expected ' + Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'shapes').join(', '));
    }

    if (size && Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'sizes').indexOf(size) === -1) {
        throw new Error('Unexpected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SIZE + ' for ' + label + ' button: ' + size + ', expected ' + Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'sizes').join(', '));
    }

    if (branding === false) {
        throw new Error('style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].BRANDING + ':false is not allowed');
    }

    if (fundingicons && !Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'allowFundingIcons')) {
        throw new Error('style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].FUNDINGICONS + ':true is not allowed for ' + label + ' button');
    }

    if (layout && Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'layouts').indexOf(layout) === -1) {
        throw new Error('Unexpected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LAYOUT + ' for ' + label + ' button: ' + layout + ', expected ' + Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'layouts').join(', '));
    }

    if (maxbuttons !== undefined) {
        if (typeof maxbuttons !== 'number') {
            throw new TypeError('Expected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].MAXBUTTONS + ' to be a number, got: ' + maxbuttons);
        }

        if (maxbuttons < 1) {
            throw new Error('Expected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].MAXBUTTONS + ' to be a at least 1, got: ' + maxbuttons);
        }

        var minButtons = layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'minVerticalButtons') : Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'minHorizontalButtons');

        if (maxbuttons < minButtons) {
            throw new Error('Expected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].MAXBUTTONS + ' to be no fewer than ' + minButtons + ', got ' + maxbuttons);
        }
    }

    if (height !== undefined) {
        if (typeof height !== 'number') {
            throw new TypeError('Expected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].HEIGHT + ' to be a number, got: ' + maxbuttons);
        }

        var buttonSize = size || Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'defaultVerticalSize' : 'defaultSize');

        var _ref = size === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE ? {
            minHeight: __WEBPACK_IMPORTED_MODULE_2__style__["b" /* BUTTON_STYLE */][__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].SMALL].minHeight,
            maxHeight: __WEBPACK_IMPORTED_MODULE_2__style__["b" /* BUTTON_STYLE */][__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].HUGE].maxHeight
        } : __WEBPACK_IMPORTED_MODULE_2__style__["b" /* BUTTON_STYLE */][buttonSize],
            minHeight = _ref.minHeight,
            maxHeight = _ref.maxHeight;

        if (height < minHeight || height > maxHeight) {
            throw new Error('Expected style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].HEIGHT + ' to be between ' + minHeight + 'px and ' + maxHeight + 'px - got ' + height + 'px');
        }
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'allowPrimary')) {
        throw new Error(label + ' can not be used as primary button label');
    }

    if (layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL) {

        if (size && [__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].MEDIUM, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].LARGE, __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE].indexOf(size) === -1) {
            throw new Error('Button must be at least ' + __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].MEDIUM + ' size for ' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' layout');
        }

        if (style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LABEL]) {
            throw new Error('style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LABEL + ' option is not allowed for ' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' layout - got ' + label);
        }

        if (fundingicons) {
            throw new Error('style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].FUNDINGICONS + ' not allowed for ' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' layout - got ' + fundingicons);
        }

        if (tagline) {
            throw new Error('style.' + __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].TAGLINE + ' is not allowed for ' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' layout - got ' + tagline);
        }
    }
}

function validateButtonProps(props) {

    if (!props) {
        throw new Error('Expected props');
    }

    var locale = props.locale,
        style = props.style;


    validateButtonLocale(locale);
    validateButtonStyle(style);
}

/***/ }),

/***/ "./src/components/button/templates/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON_CONFIG; });
/* unused harmony export FUNDING_TO_DEFAULT_LABEL */
/* unused harmony export LABEL_TO_FUNDING */
/* harmony export (immutable) */ __webpack_exports__["h"] = labelToFunding;
/* harmony export (immutable) */ __webpack_exports__["d"] = fundingToDefaultLabel;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FUNDING_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FUNDING_CONFIG; });
/* unused harmony export CARD_CONFIG */
/* harmony export (immutable) */ __webpack_exports__["e"] = getButtonConfig;
/* harmony export (immutable) */ __webpack_exports__["g"] = getFundingConfig;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCardConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js");
var _logoColors, _tagLineColors, _secondaryColors, _logoColors2, _secondaryColors2, _logoColors3, _secondaryColors3, _logoColors4, _secondaryColors4, _logoColors5, _secondaryColors5, _logoColors6, _secondaryColors6, _BUTTON_CONFIG, _FUNDING_TO_DEFAULT_L, _LABEL_TO_FUNDING, _FUNDING_CONFIG, _CARD_CONFIG;

/* eslint no-template-curly-in-string: off */




var BUTTON_CONFIG = (_BUTTON_CONFIG = {}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]] = {

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK],

    sizes: [__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].SMALL, __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].MEDIUM, __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].LARGE, __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].RESPONSIVE],

    shapes: [__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* BUTTON_SHAPE */].PILL, __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* BUTTON_SHAPE */].RECT],

    layouts: [__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL, __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BUTTON_LAYOUT */].VERTICAL],

    logoColors: (_logoColors = {}, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors),

    tagLineColors: (_tagLineColors = {}, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* BUTTON_TAGLINE_COLOR */].BLUE, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* BUTTON_TAGLINE_COLOR */].BLUE, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* BUTTON_TAGLINE_COLOR */].BLUE, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* BUTTON_TAGLINE_COLOR */].BLACK, _tagLineColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* BUTTON_TAGLINE_COLOR */].BLUE, _tagLineColors),

    secondaryColors: (_secondaryColors = {}, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK, _secondaryColors[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors),

    tag: '{ content: safer_tag }',
    dualTag: '{ content: dual_tag|safer_tag }',

    defaultLocale: 'en_US',
    defaultLabel: __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CHECKOUT,
    defaultVerticalLabel: __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAYPAL,
    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD,
    defaultSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].SMALL,
    defaultVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].MEDIUM,
    defaultShape: __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* BUTTON_SHAPE */].PILL,
    defaultLayout: __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL,
    defaultBranding: true,
    defaultVerticalBranding: true,
    defaultFundingIcons: false,
    defaultTagline: true,
    defaultDual: '',

    minimumSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].TINY,
    minimumVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].MEDIUM,

    maximumSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].HUGE,
    maximumVerticalSize: __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* BUTTON_SIZE */].HUGE,

    minHorizontalButtons: 1,
    minVerticalButtons: 1,

    maxHorizontalButtons: 2,
    maxVerticalButtons: 4,

    allowUnbranded: false,
    allowFundingIcons: true,

    allowPrimary: false,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: false,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: false
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAYPAL] = {
    label: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' }',

    allowPrimary: true,

    allowPrimaryVertical: true,
    allowPrimaryHorizontal: true,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: true
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CHECKOUT] = {
    label: '{ content: checkout }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' }',

    allowPrimary: true,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: true,

    allowSecondaryVertical: false,
    allowSecondaryHorizontal: false
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAY] = {
    label: '{ content: pay }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' }',

    allowPrimary: true,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: true,

    allowSecondaryVertical: false,
    allowSecondaryHorizontal: false
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].BUYNOW] = {
    label: '{ content: buynow }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' }',

    defaultBranding: undefined,

    allowPrimary: true,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: true,

    allowSecondaryVertical: false,
    allowSecondaryHorizontal: false,

    allowUnbranded: true
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT] = {
    label: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].CREDIT + ' }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PP + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].PAYPAL + ' } { logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].CREDIT + ' }',
    tag: '{ content: later_tag }',

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK],

    logoColors: (_logoColors2 = {}, _logoColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors2),

    secondaryColors: (_secondaryColors2 = {}, _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE, _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE, _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE, _secondaryColors2[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK, _secondaryColors2),

    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE,

    allowPrimary: true,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: false,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: true,

    allowFundingIcons: false
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].VENMO] = {
    label: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].VENMO + ' }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].VENMO + ' }',

    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER,

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK],

    logoColors: (_logoColors3 = {}, _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLUE, _logoColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors3),

    secondaryColors: (_secondaryColors3 = {}, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK, _secondaryColors3[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors3),

    allowPrimary: true,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: true,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: true
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].IDEAL] = {

    label: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].IDEAL + ' } Online betalen',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].IDEAL + ' } Online betalen',

    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER,

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK],

    logoColors: (_logoColors4 = {}, _logoColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLACK, _logoColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors4),

    secondaryColors: (_secondaryColors4 = {}, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK, _secondaryColors4[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors4),

    allowPrimary: false,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: false,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: true
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].ELV] = {

    label: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].ELV + ' }',
    logoLabel: '{ logo: ' + __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BUTTON_LOGO */].ELV + ' }',

    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER,

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK],

    logoColors: (_logoColors5 = {}, _logoColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLACK, _logoColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _logoColors5),

    secondaryColors: (_secondaryColors5 = {}, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK, _secondaryColors5[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER, _secondaryColors5),

    allowPrimary: false,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: false,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: true
}, _BUTTON_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CARD] = {

    label: '{ cards }',
    logoLabel: '{ cards }',

    defaultColor: __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER,

    colors: [__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT],

    logoColors: (_logoColors6 = {}, _logoColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT] = __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BUTTON_LOGO_COLOR */].BLACK, _logoColors6),

    secondaryColors: (_secondaryColors6 = {}, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].GOLD] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].SILVER] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT, _secondaryColors6[__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].DARKBLUE] = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BUTTON_COLOR */].TRANSPARENT, _secondaryColors6),

    allowPrimary: false,

    allowPrimaryVertical: false,
    allowPrimaryHorizontal: false,

    allowSecondaryVertical: true,
    allowSecondaryHorizontal: false
}, _BUTTON_CONFIG);

var FUNDING_TO_DEFAULT_LABEL = (_FUNDING_TO_DEFAULT_L = {}, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAYPAL, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].VENMO] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].VENMO, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CARD] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CARD, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CREDIT] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].IDEAL] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].IDEAL, _FUNDING_TO_DEFAULT_L[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].ELV] = __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].ELV, _FUNDING_TO_DEFAULT_L);

var LABEL_TO_FUNDING = (_LABEL_TO_FUNDING = {}, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAYPAL] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CHECKOUT] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].PAY] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].BUYNOW] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CARD] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CARD, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].CREDIT] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CREDIT, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].VENMO] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].VENMO, _LABEL_TO_FUNDING[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BUTTON_LABEL */].IDEAL] = __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].IDEAL, _LABEL_TO_FUNDING);

function labelToFunding(label) {
    return label ? LABEL_TO_FUNDING[label] : __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL;
}

function fundingToDefaultLabel(funding) {
    return FUNDING_TO_DEFAULT_LABEL[funding];
}

var FUNDING_PRIORITY = [__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL, __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].VENMO, __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CREDIT, __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].IDEAL, __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].ELV, __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CARD];

var FUNDING_CONFIG = (_FUNDING_CONFIG = {}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]] = {
    enabled: true,

    allowOptIn: true,
    allowOptOut: true,
    allowRemember: true
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].PAYPAL] = {
    'default': true,

    allowOptIn: false,
    allowOptOut: false
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CARD] = {
    'default': true
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].VENMO] = {
    allowOptOut: false,
    allowedCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].US]
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].CREDIT] = {
    allowedCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].US, __WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].GB, __WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].DE],
    defaultVerticalCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].US],
    platforms: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["l" /* PLATFORM */].MOBILE]
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].IDEAL] = {
    allowedCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].NL]
}, _FUNDING_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].ELV] = {
    allowedCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].DE, __WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].AT],
    defaultVerticalCountries: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].DE, __WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].AT]
}, _FUNDING_CONFIG);

var CARD_CONFIG = (_CARD_CONFIG = {}, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]] = {
    priority: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].AMEX]
}, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].US] = {
    priority: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].DISCOVER]
}, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].BR] = {
    priority: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].HIPER, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].ELO]
}, _CARD_CONFIG[__WEBPACK_IMPORTED_MODULE_0__config_constants__["d" /* COUNTRY */].JP] = {
    priority: [__WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].VISA, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].MASTERCARD, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].AMEX, __WEBPACK_IMPORTED_MODULE_0__config_constants__["b" /* CARD */].JCB]
}, _CARD_CONFIG);

function getConfig(conf, category, key, def) {
    var categoryConfig = conf[category];

    if (categoryConfig && categoryConfig.hasOwnProperty(key)) {
        return categoryConfig[key];
    }

    if (conf[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]] && conf[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]].hasOwnProperty(key)) {
        return conf[__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DEFAULT */]][key];
    }

    if (arguments.length >= 4) {
        // $FlowFixMe
        return def;
    }

    throw new Error('No value found for ' + category + ':' + key);
}

function getButtonConfig(label, key, def) {
    return getConfig(BUTTON_CONFIG, label, key, def);
}

function getFundingConfig(source, key, def) {
    return getConfig(FUNDING_CONFIG, source, key, def);
}

function getCardConfig(source, key, def) {
    return getConfig(CARD_CONFIG, source, key, def);
}

/***/ }),

/***/ "./src/components/button/templates/container/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/button/templates/container/template.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__template__["a"]; });


/***/ }),

/***/ "./src/components/button/templates/container/template.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containerTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("./src/components/button/templates/style.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/components/button/templates/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__props__ = __webpack_require__("./src/components/button/templates/props.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_util__ = __webpack_require__("./src/components/button/templates/component/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./src/lib/index.js");

/* @jsx jsxDom */








function determineResponsiveSize(_ref) {
    var label = _ref.label,
        layout = _ref.layout,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 0 : _ref$width;


    var minimumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* getButtonConfig */])(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'minimumVerticalSize' : 'minimumSize');
    var maximumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* getButtonConfig */])(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'maximumVerticalSize' : 'maximumSize');

    if (width < __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][minimumSize].minWidth) {
        return minimumSize;
    }

    if (width >= __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][maximumSize].maxWidth) {
        return maximumSize;
    }

    for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */]), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var size = _ref2;
        var _BUTTON_STYLE$size = __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][size],
            minWidth = _BUTTON_STYLE$size.minWidth,
            maxWidth = _BUTTON_STYLE$size.maxWidth,
            minResponsiveWidth = _BUTTON_STYLE$size.minResponsiveWidth;

        minWidth = minResponsiveWidth || minWidth;

        if (width >= minWidth && width < maxWidth) {
            return size;
        }
    }

    throw new Error('Unable to calculate responsive size for width: ' + width);
}

function getDimensions(_ref3) {
    var label = _ref3.label,
        size = _ref3.size,
        tagline = _ref3.tagline,
        fundingicons = _ref3.fundingicons,
        layout = _ref3.layout,
        number = _ref3.number,
        viewport = _ref3.viewport,
        buttonHeight = _ref3.height;


    if (size === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE) {
        size = determineResponsiveSize({ label: label, layout: layout, width: viewport.width, height: buttonHeight });
    }

    var _BUTTON_STYLE$size2 = __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][size],
        defaultWidth = _BUTTON_STYLE$size2.defaultWidth,
        defaultHeight = _BUTTON_STYLE$size2.defaultHeight,
        minHeight = _BUTTON_STYLE$size2.minHeight,
        maxHeight = _BUTTON_STYLE$size2.maxHeight,
        allowFunding = _BUTTON_STYLE$size2.allowFunding,
        allowTagline = _BUTTON_STYLE$size2.allowTagline;


    buttonHeight = buttonHeight || Object(__WEBPACK_IMPORTED_MODULE_4__component_util__["c" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_4__component_util__["b" /* max */])(defaultHeight, minHeight), maxHeight);

    var width = defaultWidth;
    var height = buttonHeight;

    if (fundingicons && allowFunding) {
        height += Object(__WEBPACK_IMPORTED_MODULE_4__component_util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].FUNDINGICONS);
    } else if (tagline && allowTagline) {
        height += Object(__WEBPACK_IMPORTED_MODULE_4__component_util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].TAGLINE);
    } else if (layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL) {
        height = buttonHeight * number + Object(__WEBPACK_IMPORTED_MODULE_4__component_util__["d" /* perc */])(buttonHeight, __WEBPACK_IMPORTED_MODULE_1__style__["a" /* BUTTON_RELATIVE_STYLE */].VERTICAL_MARGIN) * (number - 1);
    }

    return { width: width, height: height };
}

// eslint-disable-next-line no-unused-vars
function containerTemplate(_ref4) {
    var id = _ref4.id,
        props = _ref4.props,
        CLASS = _ref4.CLASS,
        on = _ref4.on,
        container = _ref4.container,
        tag = _ref4.tag,
        context = _ref4.context,
        outlet = _ref4.outlet,
        jsxDom = _ref4.jsxDom;

    var _normalizeProps = Object(__WEBPACK_IMPORTED_MODULE_3__props__["a" /* normalizeProps */])(props),
        size = _normalizeProps.size,
        label = _normalizeProps.label,
        fundingicons = _normalizeProps.fundingicons,
        tagline = _normalizeProps.tagline,
        layout = _normalizeProps.layout,
        sources = _normalizeProps.sources,
        buttonHeight = _normalizeProps.height;

    var getContainerDimensions = function getContainerDimensions() {
        return getDimensions({
            viewport: { width: container.offsetWidth, height: container.offsetHeight },
            number: sources.length,
            height: buttonHeight,
            label: label,
            size: size,
            fundingicons: fundingicons,
            tagline: tagline,
            layout: layout
        });
    };

    var _getContainerDimensio = getContainerDimensions(),
        width = _getContainerDimensio.width,
        height = _getContainerDimensio.height;

    if (size === __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE) {
        on('resize', function () {
            outlet.style.height = getContainerDimensions().height + 'px';
        });
    }

    var minimumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* getButtonConfig */])(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'minimumVerticalSize' : 'minimumSize');
    var maximumSize = Object(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* getButtonConfig */])(label, layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'maximumVerticalSize' : 'maximumSize');

    if (buttonHeight) {
        var possibleSizes = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["Z" /* values */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */]).filter(function (possibleSize) {
            return __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][possibleSize] && __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][possibleSize].minHeight <= buttonHeight && __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][possibleSize].maxHeight >= buttonHeight;
        });

        possibleSizes.sort(function (sizeA, sizeB) {
            return __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][sizeA].defaultWidth - __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][sizeB].defaultWidth;
        });

        minimumSize = possibleSizes[0];
        maximumSize = possibleSizes[possibleSizes.length - 1];
    }

    return jsxDom(
        'div',
        { id: id, 'class': tag + ' ' + tag + '-context-' + context + ' ' + tag + '-label-' + label + ' ' + tag + '-size-' + size + ' ' + tag + '-layout-' + layout },
        jsxDom(
            'style',
            null,
            '\n                    #' + id + ' {\n                        font-size: 0;\n                        width: 100%;\n                    }\n\n                    #' + id + '.' + tag + '-size-' + __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE + ' {\n                        text-align: center;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' {\n                        display: inline-block;\n                        min-width: ' + __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][minimumSize].minWidth + 'px;\n                        max-width: ' + __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][maximumSize].maxWidth + 'px;\n                        position: relative;\n                    }\n\n                    #' + id + '.' + tag + '-layout-' + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL + ' > .' + CLASS.OUTLET + ' {\n                        min-width: ' + __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][minimumSize].minWidth + 'px;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' {\n                        width:  ' + width + 'px;\n                        height: ' + height + 'px;\n                    }\n\n                     #' + id + '.' + tag + '-size-' + __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].RESPONSIVE + ' > .' + CLASS.OUTLET + ' {\n                        width: 100%;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe {\n                        min-width: 100%;\n                        max-width: 100%;\n                        width: ' + __WEBPACK_IMPORTED_MODULE_1__style__["b" /* BUTTON_STYLE */][minimumSize].minWidth + 'px;\n                        height: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.COMPONENT_FRAME + ' {\n                        z-index: 100;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.PRERENDER_FRAME + ' {\n                        transition: opacity .2s linear;\n                        z-index: 200;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.VISIBLE + ' {\n                        opacity: 1;\n                    }\n\n                    #' + id + ' > .' + CLASS.OUTLET + ' > iframe.' + CLASS.INVISIBLE + ' {\n                        opacity: 0;\n                        pointer-events: none;\n                    }\n                '
        ),
        outlet
    );
}

/***/ }),

/***/ "./src/components/button/templates/funding.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = determineEligibleFunding;
/* harmony export (immutable) */ __webpack_exports__["a"] = determineEligibleCards;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateFunding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/components/button/templates/config.js");





function isFundingEligible(source, _ref) {
    var locale = _ref.locale,
        funding = _ref.funding,
        env = _ref.env,
        layout = _ref.layout;


    if (!Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'enabled')) {
        if (!(env === __WEBPACK_IMPORTED_MODULE_0__config_constants__["e" /* ENV */].TEST && Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'test'))) {
            return false;
        }
    }

    var isVertical = layout === __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BUTTON_LAYOUT */].VERTICAL;

    var label = Object(__WEBPACK_IMPORTED_MODULE_2__config__["d" /* fundingToDefaultLabel */])(source);

    var allowSecondary = Object(__WEBPACK_IMPORTED_MODULE_2__config__["e" /* getButtonConfig */])(label, isVertical ? 'allowSecondaryVertical' : 'allowSecondaryHorizontal');

    if (!allowSecondary) {
        return false;
    }

    if (funding.disallowed.indexOf(source) !== -1 && Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'allowOptOut')) {
        return false;
    }

    if (funding.disallowed.indexOf(source) !== -1 && source === __WEBPACK_IMPORTED_MODULE_0__config_constants__["g" /* FUNDING */].VENMO) {
        return false;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'allowedCountries', [locale.country]).indexOf(locale.country) === -1) {
        return false;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'defaultCountries', []).indexOf(locale.country) !== -1) {
        return true;
    }

    if (isVertical && Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'defaultVerticalCountries', []).indexOf(locale.country) !== -1) {
        return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'default')) {
        return true;
    }

    if (funding.allowed.indexOf(source) !== -1 && Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'allowOptIn')) {
        return true;
    }

    if (funding.remembered.indexOf(source) !== -1 && Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'allowRemember')) {
        return true;
    }

    return false;
}

function determineEligibleFunding(_ref2) {
    var funding = _ref2.funding,
        selected = _ref2.selected,
        locale = _ref2.locale,
        env = _ref2.env,
        layout = _ref2.layout;


    var eligibleFunding = __WEBPACK_IMPORTED_MODULE_2__config__["c" /* FUNDING_PRIORITY */].filter(function (source) {
        return source !== selected && isFundingEligible(source, { locale: locale, funding: funding, env: env, layout: layout });
    });

    eligibleFunding.unshift(selected);

    return eligibleFunding;
}

function determineEligibleCards(_ref3) {
    var funding = _ref3.funding,
        locale = _ref3.locale;


    return Object(__WEBPACK_IMPORTED_MODULE_2__config__["f" /* getCardConfig */])(locale.country, 'priority').filter(function (card) {
        return funding.disallowed.indexOf(card) === -1;
    });
}

function validateFunding() {
    var funding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { allowed: [], disallowed: [], remembered: [] };


    if (funding.allowed) {
        for (var _iterator = funding.allowed, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref4;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref4 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref4 = _i.value;
            }

            var source = _ref4;

            if (__WEBPACK_IMPORTED_MODULE_0__config_constants__["c" /* CARD_PRIORITY */].indexOf(source) !== -1) {
                continue;
            }

            if (!__WEBPACK_IMPORTED_MODULE_2__config__["b" /* FUNDING_CONFIG */].hasOwnProperty(source)) {
                throw new Error('Invalid funding source: ' + source);
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(source, 'allowOptIn')) {
                throw new Error('Can not allow funding source: ' + source);
            }

            if (funding.disallowed && funding.disallowed.indexOf(source) !== -1) {
                throw new Error('Can not allow and disallow funding source: ' + source);
            }
        }
    }

    if (funding.disallowed) {
        for (var _iterator2 = funding.disallowed, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref5 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref5 = _i2.value;
            }

            var _source = _ref5;

            if (__WEBPACK_IMPORTED_MODULE_0__config_constants__["c" /* CARD_PRIORITY */].indexOf(_source) !== -1) {
                continue;
            }

            if (!__WEBPACK_IMPORTED_MODULE_2__config__["b" /* FUNDING_CONFIG */].hasOwnProperty(_source)) {
                throw new Error('Invalid funding source: ' + _source);
            }

            if (!Object(__WEBPACK_IMPORTED_MODULE_2__config__["g" /* getFundingConfig */])(_source, 'allowOptOut')) {
                throw new Error('Can not disallow funding source: ' + _source);
            }
        }
    }
}

/***/ }),

/***/ "./src/components/button/templates/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/button/templates/component/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./src/components/button/templates/container/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__container__["a"]; });



/***/ }),

/***/ "./src/components/button/templates/props.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export determineMaxButtons */
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/components/button/templates/config.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__funding__ = __webpack_require__("./src/components/button/templates/funding.js");





function parseLocale(locale) {
    var _locale$split = locale.split('_'),
        lang = _locale$split[0],
        country = _locale$split[1];

    return { country: country, lang: lang };
}

function determineMaxButtons(_ref) {
    var label = _ref.label,
        layout = _ref.layout,
        max = _ref.max;


    var allowed = layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'allowPrimaryHorizontal') : Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'allowPrimaryVertical');

    if (!allowed) {
        return 1;
    }

    var configMax = layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'maxHorizontalButtons') : Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'maxVerticalButtons');

    return max ? Math.min(configMax, max) : configMax;
}

function enableTagline(_ref2) {
    var tagline = _ref2.tagline,
        branding = _ref2.branding,
        fundingicons = _ref2.fundingicons,
        layout = _ref2.layout;

    return Boolean(tagline && branding && !fundingicons && layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].HORIZONTAL);
}

function normalizeProps(props) {
    var env = props.env,
        _props$locale = props.locale,
        locale = _props$locale === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])('DEFAULT', 'defaultLocale') : _props$locale,
        _props$style = props.style,
        style = _props$style === undefined ? {} : _props$style,
        funding = props.funding;


    locale = parseLocale(locale);

    var label = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LABEL] || Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])('DEFAULT', style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'defaultVerticalLabel' : 'defaultLabel');

    var _style$BUTTON_STYLE_O = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SIZE],
        size = _style$BUTTON_STYLE_O === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'defaultVerticalSize' : 'defaultSize') : _style$BUTTON_STYLE_O,
        _style$BUTTON_STYLE_O2 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].COLOR],
        color = _style$BUTTON_STYLE_O2 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'defaultColor') : _style$BUTTON_STYLE_O2,
        _style$BUTTON_STYLE_O3 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].SHAPE],
        shape = _style$BUTTON_STYLE_O3 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'defaultShape') : _style$BUTTON_STYLE_O3,
        _style$BUTTON_STYLE_O4 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].BRANDING],
        branding = _style$BUTTON_STYLE_O4 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, style.layout === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BUTTON_LAYOUT */].VERTICAL ? 'defaultVerticalBranding' : 'defaultBranding') : _style$BUTTON_STYLE_O4,
        _style$BUTTON_STYLE_O5 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].FUNDINGICONS],
        fundingicons = _style$BUTTON_STYLE_O5 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'defaultFundingIcons') : _style$BUTTON_STYLE_O5,
        _style$BUTTON_STYLE_O6 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].TAGLINE],
        tagline = _style$BUTTON_STYLE_O6 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'defaultTagline') : _style$BUTTON_STYLE_O6,
        _style$BUTTON_STYLE_O7 = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].LAYOUT],
        layout = _style$BUTTON_STYLE_O7 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1__config__["e" /* getButtonConfig */])(label, 'defaultLayout') : _style$BUTTON_STYLE_O7,
        max = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].MAXBUTTONS],
        height = style[__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* BUTTON_STYLE_OPTIONS */].HEIGHT];


    max = determineMaxButtons({ label: label, layout: layout, max: max });

    var selected = Object(__WEBPACK_IMPORTED_MODULE_1__config__["h" /* labelToFunding */])(label);
    var sources = Object(__WEBPACK_IMPORTED_MODULE_2__funding__["b" /* determineEligibleFunding */])({ funding: funding, selected: selected, locale: locale, env: env, layout: layout }).slice(0, max);
    var multiple = sources.length > 1;

    if (multiple) {
        branding = true;
    }

    tagline = enableTagline({ tagline: tagline, branding: branding, fundingicons: fundingicons, layout: layout });

    var cards = Object(__WEBPACK_IMPORTED_MODULE_2__funding__["a" /* determineEligibleCards */])({ funding: funding, locale: locale });

    return { size: size, label: label, locale: locale, color: color, shape: shape, branding: branding, fundingicons: fundingicons,
        tagline: tagline, funding: funding, layout: layout, sources: sources, max: max, multiple: multiple, env: env, height: height, cards: cards };
}

/***/ }),

/***/ "./src/components/button/templates/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUTTON_RELATIVE_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUTTON_STYLE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/button/constants.js");
var _BUTTON_STYLE;



var BUTTON_RELATIVE_STYLE = {
    FUNDINGICONS: 100,
    TAGLINE: 50,
    VERTICAL_MARGIN: 30
};

var BUTTON_STYLE = (_BUTTON_STYLE = {}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].TINY] = {
    defaultWidth: 75,
    defaultHeight: 25,
    minWidth: 75,
    maxWidth: 150,
    minHeight: 25,
    maxHeight: 30,
    allowFunding: true,
    allowTagline: false
}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].SMALL] = {
    defaultWidth: 150,
    defaultHeight: 25,
    minWidth: 150,
    maxWidth: 200,
    minHeight: 25,
    maxHeight: 55,
    allowFunding: true,
    allowTagline: true
}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].MEDIUM] = {
    defaultWidth: 250,
    defaultHeight: 35,
    minWidth: 200,
    maxWidth: 300,
    minHeight: 35,
    maxHeight: 55,
    allowFunding: true,
    allowTagline: true
}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].LARGE] = {
    defaultWidth: 350,
    defaultHeight: 45,
    minWidth: 300,
    maxWidth: 500,
    minHeight: 30,
    maxHeight: 55,
    allowFunding: true,
    allowTagline: true
}, _BUTTON_STYLE[__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* BUTTON_SIZE */].HUGE] = {
    defaultWidth: 500,
    defaultHeight: 55,
    minWidth: 500,
    maxWidth: 750,
    minHeight: 40,
    maxHeight: 55,
    allowFunding: true,
    allowTagline: true
}, _BUTTON_STYLE);

/***/ }),

/***/ "./src/components/checkout/component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = allowIframe;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkout; });
/* harmony export (immutable) */ __webpack_exports__["c"] = enableCheckoutIframe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xcomponent_src_component_component__ = __webpack_require__("./node_modules/xcomponent/src/component/component/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__compat__ = __webpack_require__("./src/compat/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__templates__ = __webpack_require__("./src/components/checkout/templates/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("./src/components/checkout/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popupBridge__ = __webpack_require__("./src/components/checkout/popupBridge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("./src/components/checkout/constants.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint max-lines: 0 */
















function addHeader(name, value) {

    if (!window.$Api) {
        return;
    }

    if (window.$Api.addHeader) {
        return window.$Api.addHeader(name, value);
    }
}

function allowIframe() {

    if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib__["W" /* supportsPopups */])()) {
        return true;
    }

    var parentWindow = Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["l" /* getParent */])(window);
    if (parentWindow && Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["u" /* isSameDomain */])(parentWindow)) {
        return true;
    }

    var parentComponentWindow = window.xchild && window.xchild.getParentComponentWindow();
    if (parentComponentWindow && Object(__WEBPACK_IMPORTED_MODULE_4_cross_domain_utils_src__["u" /* isSameDomain */])(parentComponentWindow)) {
        return true;
    }

    if (false) {
        return true;
    }

    return false;
}

function forceIframe() {

    if (!Object(__WEBPACK_IMPORTED_MODULE_5__lib__["W" /* supportsPopups */])()) {
        return true;
    }

    return false;
}

var Checkout = Object(__WEBPACK_IMPORTED_MODULE_2_xcomponent_src__["c" /* create */])({

    tag: 'paypal-checkout',
    name: 'ppcheckout',

    scrolling: true,

    buildUrl: function buildUrl(props) {
        var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

        if (!props.payment) {
            throw new Error('Can not build url without payment prop');
        }

        return props.payment().then(function (token) {
            if (!token) {
                throw new Error('Expected payment id or token to be passed, got ' + token);
            }

            return Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* determineUrl */])(env, props.fundingSource, token);
        });
    },


    get unsafeRenderTo() {
        return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].LOCAL;
    },

    get domain() {
        var _extends2;

        return _extends({}, __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].paypalDomains, (_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].LOCAL] = /^http:\/\/localhost.paypal.com:\d+$/, _extends2));
    },

    get bridgeUrl() {
        return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].metaFrameUrls;
    },

    get bridgeDomain() {
        return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].paypalDomains;
    },

    contexts: {
        iframe: forceIframe(),
        popup: true
    },

    get version() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["s" /* getScriptVersion */])();
    },

    prerenderTemplate: __WEBPACK_IMPORTED_MODULE_8__templates__["a" /* componentTemplate */],
    containerTemplate: __WEBPACK_IMPORTED_MODULE_8__templates__["b" /* containerTemplate */],

    props: {

        sessionID: {
            type: 'string',
            required: false,
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["t" /* getSessionID */])();
            },

            queryParam: true
        },

        buttonSessionID: {
            type: 'string',
            required: false,
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* getButtonSessionID */])();
            },

            queryParam: true
        },

        env: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;
            },
            validate: function validate(env) {
                if (!__WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].paypalUrls[env]) {
                    throw new Error('Invalid env: ' + env);
                }
            }
        },

        stage: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def(props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

                if (env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].STAGE || env === __WEBPACK_IMPORTED_MODULE_6__config__["d" /* ENV */].LOCAL) {
                    return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].stage;
                }
            }
        },

        locale: {
            type: 'string',
            required: false,
            queryParam: 'locale.x',
            allowDelegate: true,

            def: function def() {
                var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* getBrowserLocale */])(),
                    lang = _getBrowserLocale.lang,
                    country = _getBrowserLocale.country;

                return lang + '_' + country;
            }
        },

        client: {
            type: 'object',
            required: false,
            def: function def() {
                return {};
            },

            sendToChild: false,

            validate: function validate(client, props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].env;

                if (!client[env]) {
                    throw new Error('Client ID not found for env: ' + env);
                }

                if (client[env].match(/^(.)\1+$/)) {
                    throw new Error('Invalid client ID: ' + client[env]);
                }
            }
        },

        payment: {
            type: 'function',
            required: false,
            memoize: true,
            promisify: true,
            queryParam: function queryParam(payment) {
                return payment().then(function (token) {
                    return Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* determineParameterFromToken */])(token);
                });
            },
            queryValue: function queryValue(payment) {
                return payment();
            },
            childDecorate: function childDecorate(payment) {
                var token = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["o" /* getQueryParam */])('token');

                return token ? Object(__WEBPACK_IMPORTED_MODULE_5__lib__["H" /* memoize */])(function () {
                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(token);
                }) : payment;
            },
            validate: function validate(payment, props) {
                if (!payment && !props.url) {
                    throw new Error('Expected either props.payment or props.url to be passed');
                }
            },

            alias: 'billingAgreement'
        },

        style: {
            type: 'object',
            required: false,
            allowDelegate: true,
            def: function def() {
                return {};
            },
            validate: function validate(style) {
                if (style.overlayColor && style.overlayColor !== __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK && style.overlayColor !== __WEBPACK_IMPORTED_MODULE_11__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE) {
                    throw new Error('Invalid background color: ' + style.overlayColor);
                }
            }
        },

        commit: {
            type: 'boolean',
            required: false
        },

        experience: {
            type: 'object',
            required: false,
            def: function def() {
                return {};
            }
        },

        fundingSource: {
            type: 'string',
            required: false,
            queryParam: true
        },

        onAuthorize: {
            type: 'function',
            required: true,
            once: true,

            decorate: function decorate(original) {
                if (original) {
                    return function decorateOnAuthorize(data) {
                        var _this = this;

                        var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


                        if (data && !data.intent) {
                            Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */])('checkout_authorize_no_intent', { paymentID: data.paymentID, token: data.paymentToken });
                        }

                        Checkout.contexts.iframe = false;

                        var close = function close() {
                            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                                if (actions.close) {
                                    return actions.close();
                                }
                            }).then(function () {
                                return _this.closeComponent();
                            });
                        };

                        var redirect = function redirect(win, url) {
                            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([Object(__WEBPACK_IMPORTED_MODULE_5__lib__["P" /* redirect */])(win || window.top, url || data.returnUrl), close()]);
                        };

                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

                            try {
                                var isButton = window.location.href.indexOf('/webapps/hermes/button') !== -1;
                                var isGuest = _this.window.location.href.indexOf('/webapps/xoonboarding') !== -1;

                                if (isButton && isGuest) {
                                    return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["R" /* request */])({
                                        win: _this.window,
                                        method: 'get',
                                        url: '/webapps/hermes/api/auth'
                                    }).then(function (result) {
                                        if (result && result.data && result.data.access_token) {
                                            addHeader('x-paypal-internal-euat', result.data.access_token);
                                        }
                                    })['catch'](function () {
                                        // pass
                                    });
                                }
                            } catch (err) {
                                // pass
                            }
                        }).then(function () {
                            return original.call(_this, data, _extends({}, actions, { close: close, redirect: redirect }));
                        })['catch'](function (err) {
                            return _this.error(err);
                        })['finally'](function () {
                            return _this.close();
                        });
                    };
                }
            }
        },

        onAuth: {
            type: 'function',
            required: false,
            sameDomain: true
        },

        accessToken: {
            type: 'function',
            required: false
        },

        onCancel: {
            type: 'function',
            required: false,
            once: true,
            noop: true,

            decorate: function decorate(original) {
                return function decorateOnCancel(data) {
                    var _this2 = this;

                    var actions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


                    Checkout.contexts.iframe = false;

                    var close = function close() {
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                            if (actions.close) {
                                return actions.close();
                            }
                        }).then(function () {
                            return _this2.closeComponent();
                        });
                    };

                    var redirect = function redirect(win, url) {
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([Object(__WEBPACK_IMPORTED_MODULE_5__lib__["P" /* redirect */])(win || window.top, url || data.cancelUrl), close()]);
                    };

                    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                        return original.call(_this2, data, _extends({}, actions, { close: close, redirect: redirect }));
                    })['finally'](function () {
                        _this2.close();
                    });
                };
            }
        },

        init: {
            type: 'function',
            required: false,
            once: true,
            noop: true,

            decorate: function decorate(original) {
                return function decorateInit(data) {
                    var _track;

                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["j" /* info */])('checkout_init');

                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].STATE.CHECKOUT, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].TRANSITION.CHECKOUT_INIT, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.CONTEXT_TYPE] = __WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_6__config__["j" /* PAYMENT_TYPE */].EC_TOKEN], _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.TOKEN] = data.paymentToken, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.SELLER_ID] = data.merchantID, _track[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.CONTEXT_ID] = data.paymentToken, _track));

                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["g" /* flush */])();

                    this.paymentToken = data.paymentToken;
                    this.cancelUrl = data.cancelUrl;

                    return original.apply(this, arguments);
                };
            }
        },

        onClose: {
            type: 'function',
            required: false,
            once: true,
            promisify: true,
            noop: true,

            decorate: function decorate(original) {
                return function decorateOnClose(reason) {

                    var onClose = original.apply(this, arguments);

                    var CLOSE_REASONS = __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__["a" /* CONSTANTS */].CLOSE_REASONS;

                    var shouldCancel = this.props.onCancel && [CLOSE_REASONS.CLOSE_DETECTED, CLOSE_REASONS.USER_CLOSED].indexOf(reason) !== -1;

                    var hasDetails = this.paymentToken && this.cancelUrl;

                    if (shouldCancel && !hasDetails) {
                        Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */])('close_no_token_cancelurl');
                        return onClose;
                    }

                    if (shouldCancel) {
                        Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["j" /* info */])('close_trigger_cancel');
                        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].all([onClose, this.props.onCancel({
                            paymentToken: this.paymentToken,
                            cancelUrl: this.cancelUrl
                        })]).then(function () {
                            return onClose;
                        });
                    }

                    return onClose;
                };
            }
        },

        onError: {
            type: 'function',
            required: false,
            promisify: true,
            noop: true,
            once: true
        },

        fallback: {
            type: 'function',
            required: false,
            once: true,

            def: function def() {
                return function defaultFallback(url) {
                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */])('fallback', { url: url });

                    if (Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* getDomainSetting */])('allow_full_page_fallback')) {
                        window.top.location = url;
                        return this.close();
                    }

                    return Object(__WEBPACK_IMPORTED_MODULE_7__compat__["a" /* onLegacyPaymentAuthorize */])(this.props.onAuthorize);
                };
            }
        },

        logLevel: {
            type: 'string',
            required: false,
            get value() {
                return __WEBPACK_IMPORTED_MODULE_6__config__["n" /* config */].logLevel;
            }
        },

        popupBridge: {
            type: 'object',
            required: false,
            get value() {
                return {
                    open: Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__["b" /* getPopupBridgeOpener */])(),
                    awaitOpener: __WEBPACK_IMPORTED_MODULE_10__popupBridge__["a" /* awaitPopupBridgeOpener */]
                };
            }
        },

        test: {
            type: 'object',
            required: false,
            def: function def() {
                return { action: 'checkout' };
            }
        }
    },

    autoResize: {
        width: false,
        height: false
    },

    get dimensions() {

        if (Object(__WEBPACK_IMPORTED_MODULE_5__lib__["x" /* isDevice */])()) {
            return {
                width: '100%',
                height: '535px'
            };
        }

        return {
            width: '450px',
            height: '535px'
        };
    }
});

Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__["c" /* setupPopupBridgeProxy */])(Checkout);

function enableCheckoutIframe() {
    delete Checkout.contexts.iframe;
    Checkout.contexts.iframe = true;
}

if (Checkout.isChild()) {

    if (window.xprops.logLevel) {
        Object(__WEBPACK_IMPORTED_MODULE_5__lib__["T" /* setLogLevel */])(window.xprops.logLevel);
    }

    Object(__WEBPACK_IMPORTED_MODULE_10__popupBridge__["a" /* awaitPopupBridgeOpener */])();

    window.xchild.onProps(function () {
        Object(__WEBPACK_IMPORTED_MODULE_5__lib__["N" /* patchMethod */])(window.xprops, 'onAuthorize', function (_ref) {
            var callOriginal = _ref.callOriginal,
                _ref$args = _ref.args,
                data = _ref$args[0];

            if (data && !data.intent) {
                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */])('hermes_authorize_no_intent', { paymentID: data.paymentID, token: data.paymentToken });

                try {
                    var intent = window.injector.get('$CheckoutCartModel').instance(data.paymentToken).payment_action;
                    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["p" /* warn */])('hermes_intent', { paymentID: data.paymentID, token: data.paymentToken, intent: intent });
                } catch (err) {
                    // pass
                }

                Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["i" /* immediateFlush */])();
            }
            return callOriginal();
        });
    });

    if (!Object.assign) {
        try {
            // $FlowFixMe
            Object.assign = __WEBPACK_IMPORTED_MODULE_5__lib__["g" /* extend */];
        } catch (err) {
            // pass
        }
    }

    // eslint-disable-next-line promise/catch-or-return
    __WEBPACK_IMPORTED_MODULE_5__lib__["e" /* documentReady */].then(function () {

        if (!window.injector) {
            return;
        }

        var $event = window.injector.get('$event');

        if (!$event) {
            return;
        }

        var experimentActive = false;
        var loggedComplete = false;

        $event.on('allLoaded', function () {
            setTimeout(function () {
                var _throttle$logStart;

                var payButton = document.querySelector('.buttons.reviewButton');
                var topPayButton = document.querySelector('.buttons.reviewButton.topReviewButton');
                var reviewSection = document.querySelector('section.review');

                var throttle = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["v" /* getThrottle */])('top_pay_button', 5000);

                var hash = window.location.hash;

                var logComplete = function logComplete() {
                    if (experimentActive && !loggedComplete && hash && hash.indexOf('checkout/review') !== -1) {
                        var _throttle$logComplete;

                        throttle.logComplete((_throttle$logComplete = {}, _throttle$logComplete[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.FEED] = 'hermesnodeweb', _throttle$logComplete));
                        loggedComplete = true;
                    }
                };

                if (payButton) {
                    payButton.addEventListener('click', logComplete);
                }

                if (!reviewSection || !reviewSection.firstChild || !payButton || topPayButton) {
                    return;
                }

                if (payButton.getBoundingClientRect().bottom < window.innerHeight) {
                    return;
                }

                experimentActive = true;
                throttle.logStart((_throttle$logStart = {}, _throttle$logStart[__WEBPACK_IMPORTED_MODULE_6__config__["e" /* FPTI */].KEY.FEED] = 'hermesnodeweb', _throttle$logStart));

                if (!throttle.isEnabled()) {
                    return;
                }

                topPayButton = payButton.cloneNode(true);
                topPayButton.className += ' topReviewButton';
                reviewSection.insertBefore(topPayButton, reviewSection.firstChild);

                topPayButton.addEventListener('click', function () {
                    logComplete();
                    var button = payButton && payButton.querySelector('button, input');
                    if (button) {
                        button.click();
                    }
                });
            }, 200);
        });
    });
}

Object(__WEBPACK_IMPORTED_MODULE_5__lib__["N" /* patchMethod */])(Checkout, 'init', function (_ref2) {
    var _ref2$args = _ref2.args,
        props = _ref2$args[0],
        _context = _ref2$args[1],
        original = _ref2.original,
        context = _ref2.context;

    return original.call(context, props, _context, 'body');
});

Object(__WEBPACK_IMPORTED_MODULE_5__lib__["N" /* patchMethod */])(Checkout, 'render', function (_ref3) {
    var _ref3$args = _ref3.args,
        props = _ref3$args[0],
        original = _ref3.original,
        context = _ref3.context;

    return original.call(context, props, 'body');
});

Object(__WEBPACK_IMPORTED_MODULE_5__lib__["N" /* patchMethod */])(Checkout, 'renderTo', function (_ref4) {
    var _ref4$args = _ref4.args,
        win = _ref4$args[0],
        props = _ref4$args[1],
        original = _ref4.original,
        context = _ref4.context;


    var payment = props.payment();
    props.payment = function () {
        return payment;
    };

    return original.call(context, win, props, 'body')['catch'](function (err) {
        if (err instanceof __WEBPACK_IMPORTED_MODULE_2_xcomponent_src__["b" /* PopupOpenError */] && Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* isPayPalDomain */])()) {
            Checkout.contexts.iframe = true;
            return original.call(context, win, props, 'body');
        }
        throw err;
    });
});

/***/ }),

/***/ "./src/components/checkout/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECKOUT_OVERLAY_COLOR; });
var CHECKOUT_OVERLAY_COLOR = {
    BLACK: 'black',
    WHITE: 'white'
};

/***/ }),

/***/ "./src/components/checkout/hacks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefillSandboxLogin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__ = __webpack_require__("./node_modules/zalgo-promise/src/promise.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("./src/components/checkout/component.js");






function type(field, chars) {
    var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */]['try'](function () {
        field.value = field.value || '';
        field.value = field.value += chars.slice(0, 1);

        chars = chars.slice(1);

        if (chars) {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */].delay(interval).then(function () {
                return type(field, chars, interval);
            });
        }
    });
}

function waitForPageLoad() {
    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */](function (resolve) {

        var count = 1;

        var interval = setInterval(function () {

            count += 1;
            if (count >= 50) {
                return clearInterval(interval);
            }

            if (window.injector) {
                clearInterval(interval);
                return resolve(window.injector);
            }
        }, 500);
    }).then(function (injector) {

        if (!injector.get('$loader').isLoading()) {
            return;
        }

        return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */](function (resolve) {
            return injector.get('$event').on('allLoaded', resolve);
        });
    });
}

function prefillSandboxLogin(emailText, passwordText) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */]['try'](function () {

        if (!__WEBPACK_IMPORTED_MODULE_2__component__["a" /* Checkout */].isChild()) {
            return;
        }

        if (window.location.href.indexOf('sandbox.paypal.com') === -1) {
            return;
        }

        return waitForPageLoad().then(function () {

            if (!window.root || !window.root.token || !window.$CheckoutPayeeModel) {
                return;
            }

            if (window.$CheckoutPayeeModel.instance(window.root.token).merchant.id !== 'YQZCHTGHUK5P8') {
                return;
            }

            var win = window.injectedUl || window;

            var email = win.document.querySelector('#email');
            var password = win.document.querySelector('#password');

            if (!email || !password) {
                return;
            }

            email.value = '';
            password.value = '';

            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src_promise__["a" /* ZalgoPromise */]['try'](function () {
                return type(email, emailText);
            }).then(function () {
                return type(password, passwordText);
            })['catch'](__WEBPACK_IMPORTED_MODULE_1__lib__["I" /* noop */]);
        });
    });
}

try {
    prefillSandboxLogin('sandbox-user@paypal.com', 'passw0rd')['catch'](__WEBPACK_IMPORTED_MODULE_1__lib__["I" /* noop */]);
} catch (err) {
    // pass
}

/***/ }),

/***/ "./src/components/checkout/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/checkout/component.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hacks__ = __webpack_require__("./src/components/checkout/hacks.js");
/* unused harmony namespace reexport */



/***/ }),

/***/ "./src/components/checkout/popupBridge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getPopupBridgeOpener;
/* harmony export (immutable) */ __webpack_exports__["a"] = awaitPopupBridgeOpener;
/* harmony export (immutable) */ __webpack_exports__["c"] = setupPopupBridgeProxy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__ = __webpack_require__("./node_modules/xcomponent/src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__("./src/components/checkout/util.js");









function ternary(condition, truthyResult, falsyResult) {
    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(condition).then(function (result) {
        return result ? truthyResult() : falsyResult();
    });
}

function getPopupBridgeOpener() {
    var popupBridge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.popupBridge;


    if (popupBridge) {

        popupBridge.opener = popupBridge.opener || function (url, callback) {

            if (!popupBridge) {
                throw new Error('Popup Bridge not available');
            }

            popupBridge.onComplete = callback;
            popupBridge.open(Object(__WEBPACK_IMPORTED_MODULE_3__lib__["h" /* extendUrl */])(url, { redirect_uri: popupBridge.getReturnUrlPrefix() }));
        };

        return popupBridge.opener;
    }

    if (window.xprops && window.xprops.popupBridge && window.xprops.popupBridge.open) {
        return window.xprops.popupBridge.open;
    }
}

function awaitPopupBridgeOpener() {

    if (window.xprops && window.xprops.popupBridge) {
        return window.xprops.popupBridge.awaitOpener().then(function (opener) {

            window.popupBridge = window.popupBridge || {};
            window.popupBridge.opener = opener;

            return opener;
        });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["a" /* awaitKey */])(window, 'popupBridge').then(function (popupBridge) {
        var opener = getPopupBridgeOpener(popupBridge);

        if (opener) {
            return opener;
        }

        throw new Error('Expected opener to be present');
    });
}

function renderThroughPopupBridge(props, openBridge) {
    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!props.payment && !props.url) {
            throw new Error('Expected props.payment or props.url to be passed');
        }

        if (!props.onAuthorize) {
            throw new Error('Expected props.onAuthorize to be passed');
        }

        if (props.env && !__WEBPACK_IMPORTED_MODULE_4__config__["n" /* config */].checkoutUrls[props.env]) {
            throw new Error('Invalid props.env: ' + props.env);
        }

        var env = props.env = props.env || __WEBPACK_IMPORTED_MODULE_4__config__["n" /* config */].env;

        var onAuthorize = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__["L" /* once */])(props.onAuthorize);
        var onCancel = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__["L" /* once */])(props.onCancel || __WEBPACK_IMPORTED_MODULE_0_xcomponent_src_lib__["I" /* noop */]);

        var awaitUrl = ternary(props.url, function () {
            return props.url;
        }, function () {
            return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](props.payment, { props: props }).then(function (token) {
                if (token) {
                    var _extendUrl;

                    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["h" /* extendUrl */])(Object(__WEBPACK_IMPORTED_MODULE_5__util__["b" /* determineUrl */])(env, __WEBPACK_IMPORTED_MODULE_4__config__["f" /* FUNDING */].PAYPAL, token), (_extendUrl = {}, _extendUrl[Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* determineParameterFromToken */])(token)] = token, _extendUrl.useraction = props.commit ? 'commit' : '', _extendUrl.native_xo = '1', _extendUrl));
                }
            });
        });

        return awaitUrl.then(function (url) {

            return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
                openBridge(url, function (err, payload) {

                    if (err) {
                        return reject(err);
                    }

                    if (!payload) {
                        return reject(new Error('No payload passed in popupBridge.onComplete'));
                    }

                    var query = payload.queryItems;

                    var data = {
                        paymentToken: query.token,
                        billingToken: query.ba_token,
                        paymentID: query.paymentId,
                        payerID: query.payerId,
                        intent: query.intent
                    };

                    var actions = {
                        close: function close() {
                            // pass
                        },
                        closeComponent: function closeComponent() {
                            // pass
                        }
                    };

                    if (query.opType === 'payment') {

                        data.returnUrl = query.return_uri;

                        actions.redirect = function () {
                            var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
                            var redirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : data.returnUrl;

                            return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* redirect */])(win, redirectUrl);
                        };

                        onAuthorize(data, actions);
                        resolve();
                    } else if (query.opType === 'cancel') {

                        data.cancelUrl = query.cancel_uri;

                        actions.redirect = function () {
                            var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
                            var redirectUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : data.cancelUrl;

                            return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* redirect */])(win, redirectUrl);
                        };

                        onCancel(data, actions);
                        resolve();
                    } else {

                        return reject(new Error('Did not find opType in popup bridge returned query params'));
                    }
                });
            });
        });
    });
}

function setupPopupBridgeProxy(Checkout) {

    function doRender(props, original) {
        var openBridge = getPopupBridgeOpener();
        return openBridge ? renderThroughPopupBridge(props, openBridge)['catch'](function (err) {
            Object(__WEBPACK_IMPORTED_MODULE_2_beaver_logger_client__["f" /* error */])('popup_bridge_error', { err: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["U" /* stringifyError */])(err) });
            return original();
        }) : original();
    }

    var render = Checkout.render;
    Checkout.render = function popupBridgeRender(props) {
        var _this = this,
            _arguments = arguments;

        return doRender(props, function () {
            return render.apply(_this, _arguments);
        });
    };

    var renderTo = Checkout.renderTo;
    Checkout.renderTo = function popupBridgeRenderTo(win, props) {
        var _this2 = this,
            _arguments2 = arguments;

        return doRender(props, function () {
            return renderTo.apply(_this2, _arguments2);
        });
    };

    var init = Checkout.init;
    Checkout.init = function popupBridgeInit(props) {
        var instance = init.apply(this, arguments);

        var _render = instance.render;
        instance.render = function popupBridgeInstanceRender() {
            var _this3 = this,
                _arguments3 = arguments;

            return doRender(props, function () {
                return _render.apply(_this3, _arguments3);
            });
        };

        var _renderTo = instance.renderTo;
        instance.renderTo = function popupBridgeInstanceRenderTo() {
            var _this4 = this,
                _arguments4 = arguments;

            return doRender(props, function () {
                return _renderTo.apply(_this4, _arguments4);
            });
        };

        return instance;
    };
}

/***/ }),

/***/ "./src/components/checkout/templates/component/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/checkout/templates/component/template.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__template__["a"]; });


/***/ }),

/***/ "./src/components/checkout/templates/component/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkoutComponentStyle; });
var checkoutComponentStyle = "\n\n    body {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0;\n    }\n\n    .spinner {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        z-index: 10\n    }\n\n    .spinner .spinWrap {\n        width: 200px;\n        height: 100px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -100px;\n        margin-top: -50px\n    }\n\n    .spinner .loader,\n    .spinner .spinnerImage {\n        height: 100px;\n        width: 100px;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        opacity: 1;\n        filter: alpha(opacity=100)\n    }\n\n    .spinner .spinnerImage {\n        margin: 28px 0 0 -25px;\n        background: url(https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png) no-repeat\n    }\n\n    .spinner .loader {\n        margin: 0 0 0 -55px;\n        background-color: transparent;\n        -webkit-animation: rotation .7s infinite linear;\n        -moz-animation: rotation .7s infinite linear;\n        -o-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        border-left: 5px solid #cbcbca;\n        border-right: 5px solid #cbcbca;\n        border-bottom: 5px solid #cbcbca;\n        border-top: 5px solid #2380be;\n        border-radius: 100%\n    }\n\n    @-webkit-keyframes rotation {\n        from {\n            -webkit-transform: rotate(0deg)\n        }\n        to {\n            -webkit-transform: rotate(359deg)\n        }\n    }\n    @-moz-keyframes rotation {\n        from {\n            -moz-transform: rotate(0deg)\n        }\n        to {\n            -moz-transform: rotate(359deg)\n        }\n    }\n    @-o-keyframes rotation {\n        from {\n            -o-transform: rotate(0deg)\n        }\n        to {\n            -o-transform: rotate(359deg)\n        }\n    }\n    @keyframes rotation {\n        from {\n            transform: rotate(0deg)\n        }\n        to {\n            transform: rotate(359deg)\n        }\n    }\n";

/***/ }),

/***/ "./src/components/checkout/templates/component/template.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = componentTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__("./src/components/checkout/templates/component/style.js");

/* @jsx jsxDom */



// eslint-disable-next-line no-unused-vars
function componentTemplate(_ref) {
    var jsxDom = _ref.jsxDom;


    return jsxDom(
        "html",
        null,
        jsxDom(
            "head",
            null,
            jsxDom(
                "title",
                null,
                "PayPal"
            ),
            jsxDom("meta", { name: "viewport", content: "width=device-width, initial-scale=1" })
        ),
        jsxDom(
            "body",
            null,
            jsxDom(
                "div",
                { "class": "preloader spinner" },
                jsxDom(
                    "style",
                    null,
                    __WEBPACK_IMPORTED_MODULE_0__style__["a" /* checkoutComponentStyle */]
                ),
                jsxDom(
                    "div",
                    { "class": "spinWrap" },
                    jsxDom("p", { "class": "spinnerImage" }),
                    jsxDom("p", { "class": "loader" })
                )
            )
        )
    );
}

/***/ }),

/***/ "./src/components/checkout/templates/container/content.json":
/***/ (function(module, exports) {

module.exports = "\n{\n    \"AT\": {\n        \"de\": {\n            \"windowMessage\": \"Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.\",\n            \"continue\": \"Weiter\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ZW\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ZM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ZA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"YT\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"YE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"WS\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"WF\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"VU\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"VG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"VE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"VC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"VA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"UY\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"UG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TV\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TT\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TO\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"TM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TJ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"TD\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"TC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SV\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"ST\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SR\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"SM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SL\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SJ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SH\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"SB\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"RW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"RS\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"RE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"QA\": {\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        },\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PY\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"PW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PF\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"PA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"OM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"NU\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NR\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NP\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"NG\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NF\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"NC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MV\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MU\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MT\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MS\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MR\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MQ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MN\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ML\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"MK\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MH\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ME\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MD\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MC\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"MA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"LS\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LK\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LA\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KY\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"KN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"KI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KH\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"JO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"JM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"IS\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"HR\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"HN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"GY\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GT\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"GP\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"GM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GL\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"da\": {\n            \"windowMessage\": \"Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.\",\n            \"continue\": \"Forts\\u00E6t\"\n        }\n    },\n    \"GI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GF\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GD\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"FO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"da\": {\n            \"windowMessage\": \"Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.\",\n            \"continue\": \"Forts\\u00E6t\"\n        }\n    },\n    \"FM\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"FK\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"FJ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ET\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ER\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"EG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"EC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"DZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"DO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"DM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"DJ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"CY\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"CV\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"CR\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"CO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"CM\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"CL\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"CK\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"CI\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"CG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"CD\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"BZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"BY\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BT\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BS\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"BN\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BJ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"BI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"BH\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"BG\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BF\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        }\n    },\n    \"BB\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BA\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AL\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AG\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AE\": {\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        },\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AD\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"CN\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        }\n    },\n    \"GB\": {\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AR\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        }\n    },\n    \"US\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Click to Continue\"\n        }\n    },\n    \"VN\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"UA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 \",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TW\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u770B\\u4E0D\\u5230\\u5B89\\u5168\\u9023\\u7DDA\\u7684 PayPal \\u700F\\u89BD\\u5668\\uFF1F\\u6211\\u5011\\u5C07\\u6703\\u91CD\\u65B0\\u555F\\u52D5\\u8996\\u7A97\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 \",\n            \"continue\": \"\\u7E7C\\u7E8C\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TR\": {\n        \"tr\": {\n            \"windowMessage\": \"G\\u00FCvenli PayPal taray\\u0131c\\u0131s\\u0131n\\u0131 g\\u00F6rm\\u00FCyor musunuz? Al\\u0131\\u015Fveri\\u015Finizi tamamlamak i\\u00E7in pencereyi yeniden ba\\u015Flatman\\u0131za yard\\u0131mc\\u0131 olaca\\u011F\\u0131z.\\u00A0 \",\n            \"continue\": \"Devam\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"TH\": {\n        \"th\": {\n            \"windowMessage\": \"\\u0E16\\u0E49\\u0E32\\u0E04\\u0E38\\u0E13\\u0E44\\u0E21\\u0E48\\u0E40\\u0E2B\\u0E47\\u0E19\\u0E40\\u0E1A\\u0E23\\u0E32\\u0E27\\u0E4C\\u0E40\\u0E0B\\u0E2D\\u0E23\\u0E4C\\u0E17\\u0E35\\u0E48\\u0E21\\u0E35\\u0E23\\u0E30\\u0E1A\\u0E1A\\u0E04\\u0E27\\u0E32\\u0E21\\u0E1B\\u0E25\\u0E2D\\u0E14\\u0E20\\u0E31\\u0E22\\u0E02\\u0E2D\\u0E07 PayPal \\u0E40\\u0E23\\u0E32\\u0E08\\u0E30\\u0E0A\\u0E48\\u0E27\\u0E22\\u0E04\\u0E38\\u0E13\\u0E40\\u0E1B\\u0E34\\u0E14\\u0E2B\\u0E19\\u0E49\\u0E32\\u0E15\\u0E48\\u0E32\\u0E07\\u0E2D\\u0E35\\u0E01\\u0E04\\u0E23\\u0E31\\u0E49\\u0E07\\u0E40\\u0E1E\\u0E37\\u0E48\\u0E2D\\u0E0A\\u0E33\\u0E23\\u0E30\\u0E40\\u0E07\\u0E34\\u0E19\\u0E43\\u0E2B\\u0E49\\u0E40\\u0E23\\u0E35\\u0E22\\u0E1A\\u0E23\\u0E49\\u0E2D\\u0E22 \",\n            \"continue\": \"\\u0E14\\u0E33\\u0E40\\u0E19\\u0E34\\u0E19\\u0E01\\u0E32\\u0E23\\u0E15\\u0E48\\u0E2D\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SK\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SG\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"SE\": {\n        \"sv\": {\n            \"windowMessage\": \"Ser du inte den s\\u00E4kra PayPal-webbl\\u00E4saren? Vi hj\\u00E4lper dig att starta om f\\u00F6nstret f\\u00F6r att slutf\\u00F6ra ditt k\\u00F6p. \",\n            \"continue\": \"Forts\\u00E4tt\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"RU\": {\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"RO\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PT\": {\n        \"pt\": {\n            \"windowMessage\": \"N\\u00E3o v\\u00EA a indica\\u00E7\\u00E3o de sess\\u00E3o segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PL\": {\n        \"pl\": {\n            \"windowMessage\": \"Nie widzisz bezpiecznej przegl\\u0105darki PayPal? Pomo\\u017Cemy Ci ponownie uruchomi\\u0107 to okno w celu dokonania zakupu.\\u00A0 \",\n            \"continue\": \"Kontynuuj\"\n        },\n        \"en\": {\n            \"windowMessage\": \"You don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"PH\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre paiement.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar su pago.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NO\": {\n        \"no\": {\n            \"windowMessage\": \"Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med \\u00E5 starte vinduet p\\u00E5 nytt s\\u00E5 du kan fullf\\u00F8re kj\\u00F8pet.\\u00A0 \",\n            \"continue\": \"Fortsett\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"NL\": {\n        \"nl\": {\n            \"windowMessage\": \"Ziet u geen beveiligde PayPal-browser? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.\\u00A0 \",\n            \"continue\": \"Doorgaan\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MY\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"MX\": {\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LV\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 \",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"LU\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"de\": {\n            \"windowMessage\": \"Das PayPal-Fenster wird nicht angezeigt? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.\",\n            \"continue\": \"Weiter\"\n        }\n    },\n    \"LT\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 \",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"KR\": {\n        \"ko\": {\n            \"windowMessage\": \"\\uBCF4\\uC548 PayPal \\uBE0C\\uB77C\\uC6B0\\uC800\\uAC00 \\uBCF4\\uC774\\uC9C0 \\uC54A\\uC73C\\uC2E0\\uAC00\\uC694? \\uCC3D\\uC744 \\uB2E4\\uC2DC \\uC2E4\\uD589\\uD558\\uC5EC \\uACB0\\uC81C\\uB97C \\uC644\\uB8CC\\uD560 \\uC218 \\uC788\\uB3C4\\uB85D \\uB3C4\\uC640\\uB4DC\\uB9AC\\uACA0\\uC2B5\\uB2C8\\uB2E4.\\u00A0 \",\n            \"continue\": \"\\uACC4\\uC18D\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"JP\": {\n        \"ja\": {\n            \"windowMessage\": \"\\u30BB\\u30AD\\u30E5\\u30A2\\u306A\\u30D6\\u30E9\\u30A6\\u30B6\\u304C\\u8868\\u793A\\u3055\\u308C\\u306A\\u3044\\u5834\\u5408\\u306F\\u3001\\u30A6\\u30A3\\u30F3\\u30C9\\u30A6\\u3092\\u518D\\u8D77\\u52D5\\u3057\\u3066\\u3001\\u652F\\u6255\\u3044\\u3092\\u5B8C\\u4E86\\u3067\\u304D\\u308B\\u3088\\u3046\\u304A\\u624B\\u4F1D\\u3044\\u3044\\u305F\\u3057\\u307E\\u3059\\u3002\",\n            \"continue\": \"\\u7D9A\\u884C\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"IT\": {\n        \"it\": {\n            \"windowMessage\": \"Non vedi la pagina sicura di PayPal? Ti aiuteremo a riaprire la finestra per completare l'acquisto.\\u00A0 \",\n            \"continue\": \"Continua\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"IN\": {\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"IL\": {\n        \"he\": {\n            \"windowMessage\": \"\\u05DC\\u05D0 \\u05E8\\u05D5\\u05D0\\u05D4 \\u05D0\\u05EA \\u05D3\\u05E4\\u05D3\\u05E4\\u05DF PayPal \\u05D4\\u05DE\\u05D0\\u05D5\\u05D1\\u05D8\\u05D7? \\u05E0\\u05E2\\u05D6\\u05D5\\u05E8 \\u05DC\\u05DA \\u05DC\\u05E4\\u05EA\\u05D5\\u05D7 \\u05DE\\u05D7\\u05D3\\u05E9 \\u05D0\\u05EA \\u05D4\\u05D7\\u05DC\\u05D5\\u05DF \\u05DB\\u05D3\\u05D9 \\u05DC\\u05D4\\u05E9\\u05DC\\u05D9\\u05DD \\u05D0\\u05EA \\u05D4\\u05E7\\u05E0\\u05D9\\u05D9\\u05D4 \\u05E9\\u05DC\\u05DA.\\u00A0 \",\n            \"continue\": \"\\u05D4\\u05DE\\u05E9\\u05DA\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"IE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"HU\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ID\": {\n        \"id\": {\n            \"windowMessage\": \"Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembayaran Anda.\\u00A0 \",\n            \"continue\": \"Lanjutkan\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"HK\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u770B\\u4E0D\\u5230\\u5B89\\u5168\\u7684 PayPal \\u700F\\u89BD\\u5668\\u8996\\u7A97\\uFF1F\\u6211\\u5011\\u6703\\u52A9\\u4F60\\u91CD\\u65B0\\u958B\\u555F\\u8996\\u7A97\\uFF0C\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\",\n            \"continue\": \"\\u7E7C\\u7E8C\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GROUP-LATAM\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u770B\\u5230PayPal\\u4ED8\\u6B3E\\u9875\\u9762\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo puede ver la p\\u00E1gina de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the PayPal payment page? We\\u2019ll help you re-launch the window to complete your purchase.\",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GROUP-EMEA\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 \",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"pt\": {\n            \"windowMessage\": \"N\\u00E3o v\\u00EA a indica\\u00E7\\u00E3o de sess\\u00E3o segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.\",\n            \"continue\": \"Continuar\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"de\": {\n            \"windowMessage\": \"Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.\",\n            \"continue\": \"Weiter\"\n        },\n        \"da\": {\n            \"windowMessage\": \"Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.\",\n            \"continue\": \"Forts\\u00E6t\"\n        },\n        \"ar\": {\n            \"windowMessage\": \"\\u0644\\u0627 \\u062A\\u0631\\u0649 \\u0645\\u062A\\u0635\\u0641\\u062D PayPal \\u0627\\u0644\\u0622\\u0645\\u0646\\u061F \\u0633\\u0646\\u0633\\u0627\\u0639\\u062F\\u0643 \\u0641\\u064A \\u0625\\u0639\\u0627\\u062F\\u0629 \\u0641\\u062A\\u062D \\u0627\\u0644\\u0646\\u0627\\u0641\\u0630\\u0629 \\u0644\\u0627\\u0633\\u062A\\u0643\\u0645\\u0627\\u0644 \\u0645\\u0634\\u062A\\u0631\\u064A\\u0627\\u062A\\u0643. \\u00A0 \",\n            \"continue\": \"\\u0645\\u062A\\u0627\\u0628\\u0639\\u0629\"\n        }\n    },\n    \"GROUP-APAC\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ko\": {\n            \"windowMessage\": \"\\uBCF4\\uC548 PayPal \\uBE0C\\uB77C\\uC6B0\\uC800\\uAC00 \\uBCF4\\uC774\\uC9C0 \\uC54A\\uC73C\\uC2E0\\uAC00\\uC694? \\uCC3D\\uC744 \\uB2E4\\uC2DC \\uC2E4\\uD589\\uD558\\uC5EC \\uAD6C\\uB9E4\\uB97C \\uC644\\uB8CC\\uD560 \\uC218 \\uC788\\uB3C4\\uB85D \\uB3C4\\uC640\\uB4DC\\uB9AC\\uACA0\\uC2B5\\uB2C8\\uB2E4. \",\n            \"continue\": \"\\uACC4\\uC18D\"\n        },\n        \"id\": {\n            \"windowMessage\": \"Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembelian Anda. \",\n            \"continue\": \"Lanjutkan\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat. \",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don\\u2019t see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.  \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"GR\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"FR\": {\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"ES\": {\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el s\\u00EDmbolo de navegaci\\u00F3n segura de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar la compra. \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"FI\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"EE\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"ru\": {\n            \"windowMessage\": \"\\u041D\\u0435 \\u043E\\u0442\\u043E\\u0431\\u0440\\u0430\\u0436\\u0430\\u0435\\u0442\\u0441\\u044F \\u0431\\u0435\\u0437\\u043E\\u043F\\u0430\\u0441\\u043D\\u0430\\u044F \\u0441\\u0442\\u0440\\u0430\\u043D\\u0438\\u0446\\u0430 PayPal \\u0432 \\u0431\\u0440\\u0430\\u0443\\u0437\\u0435\\u0440\\u0435? \\u041C\\u044B \\u043F\\u043E\\u043C\\u043E\\u0436\\u0435\\u043C \\u0432\\u0430\\u043C \\u043F\\u043E\\u0432\\u0442\\u043E\\u0440\\u043D\\u043E \\u0437\\u0430\\u0433\\u0440\\u0443\\u0437\\u0438\\u0442\\u044C \\u043E\\u043A\\u043D\\u043E, \\u0447\\u0442\\u043E\\u0431\\u044B \\u0437\\u0430\\u0432\\u0435\\u0440\\u0448\\u0438\\u0442\\u044C \\u043F\\u043E\\u043A\\u0443\\u043F\\u043A\\u0443.\\u00A0 \",\n            \"continue\": \"\\u041F\\u0440\\u043E\\u0434\\u043E\\u043B\\u0436\\u0438\\u0442\\u044C\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"DK\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"da\": {\n            \"windowMessage\": \"Kan du ikke se PayPals sikre browser? Vi hj\\u00E6lper dig med at genstarte vinduet, s\\u00E5 du kan betale.\",\n            \"continue\": \"Forts\\u00E6t\"\n        }\n    },\n    \"CZ\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u8D2D\\u7269\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Le navigateur s\\u00E9curis\\u00E9 de PayPal n'appara\\u00EEt pas\\u00A0? Nous allons vous aider \\u00E0 rouvrir la fen\\u00EAtre pour finaliser votre achat.\",\n            \"continue\": \"Continuer\"\n        },\n        \"es\": {\n            \"windowMessage\": \"\\u00BFNo ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"DE\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"de\": {\n            \"windowMessage\": \"Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.\",\n            \"continue\": \"Weiter\"\n        }\n    },\n    \"CH\": {\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        },\n        \"de\": {\n            \"windowMessage\": \"Sie sehen das sichere Browserfenster von PayPal nicht? Hier k\\u00F6nnen Sie es wieder \\u00F6ffnen und Ihren Einkauf abschlie\\u00DFen.\",\n            \"continue\": \"Weiter\"\n        }\n    },\n    \"CA\": {\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 de PayPal\\u00A0? Nous vous aiderons \\u00E0 relancer la fen\\u00EAtre afin d'effectuer votre achat.\\u00A0 \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you relaunch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"C2\": {\n        \"zh\": {\n            \"windowMessage\": \"\\u6CA1\\u6709\\u627E\\u5230\\u5B89\\u5168\\u7684PayPal\\u6D4F\\u89C8\\u5668\\uFF1F\\u6211\\u4EEC\\u5C06\\u5E2E\\u52A9\\u60A8\\u91CD\\u542F\\u7A97\\u53E3\\u4EE5\\u5B8C\\u6210\\u4ED8\\u6B3E\\u3002\\u00A0 \",\n            \"continue\": \"\\u7EE7\\u7EED\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your payment.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BE\": {\n        \"nl\": {\n            \"windowMessage\": \"Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.\\u00A0 \",\n            \"continue\": \"Doorgaan\"\n        },\n        \"fr\": {\n            \"windowMessage\": \"Vous ne voyez pas le navigateur s\\u00E9curis\\u00E9 PayPal\\u00A0? Nous allons vous aider \\u00E0 relancer la fen\\u00EAtre pour effectuer votre achat.\\u00A0 \",\n            \"continue\": \"Continuer\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"BR\": {\n        \"pt\": {\n            \"windowMessage\": \"N\\u00E3o est\\u00E1 vendo o navegador seguro do PayPal? Ajudaremos voc\\u00EA a reabrir a janela para concluir a compra.\\u00A0 \",\n            \"continue\": \"Continuar\"\n        },\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We\\u2019ll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    },\n    \"AU\": {\n        \"en\": {\n            \"windowMessage\": \"Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.\\u00A0 \",\n            \"continue\": \"Continue\"\n        }\n    }\n}\n"

/***/ }),

/***/ "./src/components/checkout/templates/container/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template__ = __webpack_require__("./src/components/checkout/templates/container/template.jsx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__template__["a"]; });


/***/ }),

/***/ "./src/components/checkout/templates/container/style.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSandboxStyle;
/* harmony export (immutable) */ __webpack_exports__["a"] = getContainerStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/components/checkout/constants.js");


function getSandboxStyle(_ref) {
    var id = _ref.id,
        ANIMATION = _ref.ANIMATION;

    return '\n        #' + id + '.paypal-checkout-sandbox {\n            display: block;\n            position: fixed;\n            top: 0;\n            left: 0;\n\n            width: 100%;\n            height: 100%;\n            width: 100vw;\n            height: 100vh;\n            max-width: 100%;\n            max-height: 100%;\n            min-width: 100%;\n            min-height: 100%;\n\n            z-index: 2147483647;\n\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n\n            animation-fill-mode:forwards;\n            animation-iteration-count: 1;\n\n            -webkit-animation-fill-mode:forwards;\n            -webkit-animation-iteration-count: 1;\n        }\n\n        #' + id + '.paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes ' + ANIMATION.SHOW_CONTAINER + ' {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @keyframes ' + ANIMATION.SHOW_CONTAINER + ' {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes ' + ANIMATION.HIDE_CONTAINER + ' {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n\n        @keyframes ' + ANIMATION.HIDE_CONTAINER + ' {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n    ';
}

function getContainerStyle(_ref2) {
    var id = _ref2.id,
        tag = _ref2.tag,
        CONTEXT = _ref2.CONTEXT,
        CLASS = _ref2.CLASS,
        ANIMATION = _ref2.ANIMATION;

    return '\n        #' + id + ' {\n            position: absolute;\n            z-index: 2147483647;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            -webkit-transform: translate3d(0, 0, 0);\n            -moz-transform: translate3d(0, 0, 0);\n            -ms-transform: translate3d(0, 0, 0);\n            -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK + ' {\n            background-color: black;\n            background-color: rgba(0, 0, 0, 0.8);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,0.6) 1%, rgba(0,0,0,0.8) 100%);\n\n            color: #fff;\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE + ' {\n            background-color: white;\n            background-color: rgba(255, 255, 255, 0.4);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,0.65) 1%, rgba(255, 255, 255,0.4) 100%);\n\n            color: #333;\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK + ' a {\n            color: #fff;\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE + ' a {\n            color: #333;\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK + ' .paypal-checkout-close:before,\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK + ' .paypal-checkout-close:after {\n            background-color: #fff;\n        }\n\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE + ' .paypal-checkout-close:before,\n        #' + id + '.' + tag + '-background-color-' + __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE + ' .paypal-checkout-close:after {\n            background-color: #111;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.POPUP + ' {\n            cursor: pointer;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.POPUP + ' {\n            cursor: pointer;\n        }\n\n        #' + id + ' a {\n            text-decoration: none;\n        }\n\n        #' + id + ' .paypal-checkout-modal {\n            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;\n            font-size: 14px;\n            text-align: center;\n\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -ms-box-sizing: border-box;\n            box-sizing: border-box;\n            width: 350px;\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            margin-left: -165px;\n            margin-top: -80px;\n            cursor: pointer;\n            text-align: center;\n        }\n\n        #' + id + '.' + tag + '-loading .paypal-checkout-message, #' + id + '.' + tag + '-loading .paypal-checkout-continue {\n            display: none;\n        }\n\n        .paypal-checkout-loader {\n            display: none;\n        }\n\n        #' + id + '.' + tag + '-loading .paypal-checkout-loader {\n            display: block;\n        }\n\n        #' + id + ' .paypal-checkout-modal .paypal-checkout-logo {\n            cursor: pointer;\n            margin-bottom: 30px;\n            display: inline-block;\n        }\n\n        #' + id + ' .paypal-checkout-modal .paypal-checkout-logo img {\n            height: 36px;\n        }\n\n        #' + id + ' .paypal-checkout-modal .paypal-checkout-logo img.paypal-checkout-logo-pp {\n            margin-right: 10px;\n        }\n\n        #' + id + ' .paypal-checkout-modal .paypal-checkout-message {\n            font-size: 15px;\n            line-height: 1.5;\n            padding: 10px 0;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-message, #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-continue {\n            display: none;\n        }\n\n        #' + id + ' .paypal-checkout-modal .paypal-checkout-continue {\n            font-size: 15px;\n            line-height: 1.35;\n            padding: 10px 0;\n            font-weight: bold;\n        }\n\n        #' + id + ' .paypal-checkout-close {\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            width: 16px;\n            height: 16px;\n            opacity: 0.6;\n        }\n\n        #' + id + '.' + tag + '-loading .paypal-checkout-close {\n            display: none;\n        }\n\n        #' + id + ' .paypal-checkout-close:hover {\n            opacity: 1;\n        }\n\n        #' + id + ' .paypal-checkout-close:before, .paypal-checkout-close:after {\n            position: absolute;\n            left: 8px;\n            content: \' \';\n            height: 16px;\n            width: 2px;\n        }\n\n        #' + id + ' .paypal-checkout-close:before {\n            transform: rotate(45deg);\n            -webkit-transform: rotate(45deg);\n            -moz-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n        }\n\n        #' + id + ' .paypal-checkout-close:after {\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n            -moz-transform: rotate(-45deg);\n            -o-transform: rotate(-45deg);\n            -ms-transform: rotate(-45deg);\n        }\n\n        #' + id + ' .paypal-checkout-iframe-container {\n            display: none;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-iframe-container,\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-iframe-container > .' + CLASS.OUTLET + ',\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-iframe-container > .' + CLASS.OUTLET + ' > iframe {\n            max-height: 95vh;\n            max-width: 95vw;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-iframe-container {\n\n            display: block;\n\n            position: absolute;\n\n            top: 50%;\n            left: 50%;\n\n            min-width: 450px;\n\n            transform: translate(-50%, -50%);\n            -webkit-transform: translate(-50%, -50%);\n            -moz-transform: translate(-50%, -50%);\n            -o-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n\n            transform: translate3d(-50%, -50%, 0);\n            -webkit-transform: translate3d(-50%, -50%, 0);\n            -moz-transform: translate3d(-50%, -50%, 0);\n            -o-transform: translate3d(-50%, -50%, 0);\n            -ms-transform: translate3d(-50%, -50%, 0);\n\n            border-radius: 10px;\n            overflow: hidden;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' {\n\n            position: relative;\n\n            -webkit-transition: all 0.3s ease;\n            -moz-transition: all 0.3s ease;\n            -ms-transition: all 0.3s ease;\n            -o-transition: all 0.3 ease;\n            transition: all 0.3s ease;\n\n            -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n\n            min-width: 450px;\n            max-width: 450px;\n            width: 450px;\n            height: 535px;\n\n            background-color: white;\n\n            overflow: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' > iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: opacity .4s ease-in-out;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' > iframe.' + CLASS.COMPONENT_FRAME + ' {\n            z-index: 100;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' > iframe.' + CLASS.PRERENDER_FRAME + ' {\n            z-index: 200;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' > iframe.' + CLASS.VISIBLE + ' {\n            opacity: 1;\n            z-index: 200;\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' > iframe.' + CLASS.INVISIBLE + ' {\n            opacity: 0;\n            z-index: 100;\n        }\n\n        @media screen and (max-width: 470px) {\n\n            #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .paypal-checkout-iframe-container,\n            #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' {\n                min-width: 100%;\n                min-width: calc(100% - 20px);\n                min-width: -webkit-calc(100% - 20px);\n                min-width: -moz-calc(100% - 20px);\n                min-width: -o-calc(100% - 20px);\n                min-width: -ms-calc(100% - 20px);\n\n                max-width: 100%;\n                max-width: calc(100% - 20px);\n                max-width: -webkit-calc(100% - 20px);\n                max-width: -moz-calc(100% - 20px);\n                max-width: -o-calc(100% - 20px);\n                max-width: -ms-calc(100% - 20px);\n            }\n        }\n\n        #' + id + '.' + tag + '-context-' + CONTEXT.IFRAME + ' .' + CLASS.OUTLET + ' iframe {\n            width: 1px;\n            min-width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes ' + ANIMATION.SHOW_COMPONENT + ' {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @keyframes ' + ANIMATION.SHOW_COMPONENT + ' {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @-webkit-keyframes ' + ANIMATION.HIDE_COMPONENT + ' {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        @keyframes ' + ANIMATION.HIDE_COMPONENT + ' {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        .paypal-spinner {\n            height: 30px;\n            width: 30px;\n            display: inline-block;\n            box-sizing: content-box;\n            opacity: 1;\n            filter: alpha(opacity=100);\n            -webkit-animation: rotation .7s infinite linear;\n            -moz-animation: rotation .7s infinite linear;\n            -o-animation: rotation .7s infinite linear;\n            animation: rotation .7s infinite linear;\n            border-left: 8px solid rgba(0, 0, 0, .2);\n            border-right: 8px solid rgba(0, 0, 0, .2);\n            border-bottom: 8px solid rgba(0, 0, 0, .2);\n            border-top: 8px solid #fff;\n            border-radius: 100%\n        }\n\n        @-webkit-keyframes rotation {\n            from {\n                -webkit-transform: rotate(0deg)\n            }\n            to {\n                -webkit-transform: rotate(359deg)\n            }\n        }\n        @-moz-keyframes rotation {\n            from {\n                -moz-transform: rotate(0deg)\n            }\n            to {\n                -moz-transform: rotate(359deg)\n            }\n        }\n        @-o-keyframes rotation {\n            from {\n                -o-transform: rotate(0deg)\n            }\n            to {\n                -o-transform: rotate(359deg)\n            }\n        }\n        @keyframes rotation {\n            from {\n                transform: rotate(0deg)\n            }\n            to {\n                transform: rotate(359deg)\n            }\n        }\n    ';
}

/***/ }),

/***/ "./src/components/checkout/templates/container/template.jsx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = containerTemplate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Base64__ = __webpack_require__("./node_modules/Base64/base64.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_Base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__ = __webpack_require__("./src/components/button/templates/component/logos/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./src/components/checkout/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__content_json__ = __webpack_require__("./src/components/checkout/templates/container/content.json");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__content_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__content_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__("./src/components/checkout/templates/container/style.js");
var _LOGO_COLOR;

/* @jsx jsxDom */
/* eslint max-lines: 0 */











var componentContent = JSON.parse(__WEBPACK_IMPORTED_MODULE_5__content_json___default.a);

var LOGO_COLOR = (_LOGO_COLOR = {}, _LOGO_COLOR[__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK] = __WEBPACK_IMPORTED_MODULE_2__button_constants__["f" /* BUTTON_LOGO_COLOR */].WHITE, _LOGO_COLOR[__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].WHITE] = __WEBPACK_IMPORTED_MODULE_2__button_constants__["f" /* BUTTON_LOGO_COLOR */].BLACK, _LOGO_COLOR);

// eslint-disable-next-line no-unused-vars
function containerTemplate(_ref) {
    var id = _ref.id,
        props = _ref.props,
        CLASS = _ref.CLASS,
        ANIMATION = _ref.ANIMATION,
        CONTEXT = _ref.CONTEXT,
        EVENT = _ref.EVENT,
        on = _ref.on,
        tag = _ref.tag,
        context = _ref.context,
        actions = _ref.actions,
        outlet = _ref.outlet,
        jsxDom = _ref.jsxDom;

    var _props$locale$split = props.locale.split('_'),
        lang = _props$locale$split[0],
        country = _props$locale$split[1];

    var content = componentContent[country][lang];

    function close(event) {
        event.preventDefault();
        event.stopPropagation();
        actions.close();
    }

    function focus(event) {
        event.preventDefault();
        event.stopPropagation();

        if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* isIos */])()) {
            // eslint-disable-next-line no-alert
            window.alert('Please switch tabs to reactivate the PayPal window');
        } else {
            actions.focus();
        }
    }

    var style = props.style || {};
    var overlayColor = style.overlayColor || __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECKOUT_OVERLAY_COLOR */].BLACK;
    var logoColor = LOGO_COLOR[overlayColor];

    var el = jsxDom(
        'div',
        { id: id, onClick: focus, 'class': tag + '-context-' + context + ' paypal-checkout-overlay ' + tag + '-background-color-' + overlayColor + ' ' + tag + '-logo-color-' + logoColor },
        jsxDom('a', { href: '#', 'class': 'paypal-checkout-close', onClick: close }),
        jsxDom(
            'div',
            { 'class': 'paypal-checkout-modal' },
            jsxDom(
                'div',
                { 'class': 'paypal-checkout-logo' },
                jsxDom('img', {
                    'class': 'paypal-checkout-logo-pp', alt: 'pp',
                    src: 'data:image/svg+xml;base64,' + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__["btoa"])(__WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__["b" /* componentLogos */].pp[logoColor]) }),
                jsxDom('img', {
                    'class': 'paypal-checkout-logo-paypal', alt: 'paypal',
                    src: 'data:image/svg+xml;base64,' + Object(__WEBPACK_IMPORTED_MODULE_0_Base64__["btoa"])(__WEBPACK_IMPORTED_MODULE_1__button_templates_component_logos__["b" /* componentLogos */].paypal[logoColor]) })
            ),
            jsxDom(
                'div',
                { 'class': 'paypal-checkout-message' },
                content.windowMessage
            ),
            jsxDom(
                'div',
                { 'class': 'paypal-checkout-continue' },
                jsxDom(
                    'a',
                    { onClick: focus, href: '#' },
                    content['continue']
                )
            ),
            jsxDom(
                'div',
                { 'class': 'paypal-checkout-loader' },
                jsxDom('div', { 'class': 'paypal-spinner' })
            )
        ),
        jsxDom(
            'div',
            { 'class': 'paypal-checkout-iframe-container' },
            outlet
        ),
        jsxDom(
            'style',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_6__style__["a" /* getContainerStyle */])({ id: id, tag: tag, CONTEXT: CONTEXT, CLASS: CLASS, ANIMATION: ANIMATION })
        )
    );

    var container = jsxDom(
        'html',
        null,
        jsxDom(
            'body',
            null,
            el
        )
    );

    on(EVENT.CLOSE, function () {
        el.className += ' ' + tag + '-loading';
    });

    return jsxDom(
        'div',
        { id: id, 'class': 'paypal-checkout-sandbox' },
        jsxDom(
            'style',
            null,
            Object(__WEBPACK_IMPORTED_MODULE_6__style__["b" /* getSandboxStyle */])({ id: id, ANIMATION: ANIMATION })
        ),
        jsxDom(
            'iframe',
            { name: '__paypal_checkout_sandbox_' + id + '__', scrolling: 'no', 'class': 'paypal-checkout-sandbox-iframe' },
            container
        )
    );
}

/***/ }),

/***/ "./src/components/checkout/templates/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("./src/components/checkout/templates/component/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container__ = __webpack_require__("./src/components/checkout/templates/container/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__container__["a"]; });



/***/ }),

/***/ "./src/components/checkout/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = determineParameterFromToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = getPaymentType;
/* harmony export (immutable) */ __webpack_exports__["b"] = determineUrl;
/* unused harmony export parseParamsFromUrl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");



function determineParameterFromToken(token) {
    return token && token.indexOf('BA-') === 0 ? 'ba_token' : 'token';
}

function getPaymentType(payment) {
    if (payment.indexOf('BA-') === 0) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].BA_TOKEN;
    } else if (payment.indexOf('PAY-') === 0 || payment.indexOf('PAYID-') === 0) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].PAY_ID;
    } else if (payment.indexOf('EC-') === 0) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].EC_TOKEN;
    }

    return __WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].EC_TOKEN;
}

function determineUrl(env, fundingSource, payment) {

    var paymentType = getPaymentType(payment);

    if (paymentType === __WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].BA_TOKEN) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].billingUrls[env];
    }

    if (fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__["f" /* FUNDING */].CARD || fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__["f" /* FUNDING */].ELV) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].guestUrls[env];
    }

    if (fundingSource === __WEBPACK_IMPORTED_MODULE_1__config__["f" /* FUNDING */].IDEAL) {
        return __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].altpayUrls[env];
    }

    return __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].checkoutUrls[env];
}

function parseParamsFromUrl(url) {
    return {
        paymentToken: Object(__WEBPACK_IMPORTED_MODULE_0__lib__["G" /* match */])(url, /token=((EC-)?[A-Z0-9]+)/),
        billingToken: Object(__WEBPACK_IMPORTED_MODULE_0__lib__["G" /* match */])(url, /ba_token=((BA-)?[A-Z0-9]+)/),
        payerID: Object(__WEBPACK_IMPORTED_MODULE_0__lib__["G" /* match */])(url, /PayerID=([A-Z0-9]+)/),
        paymentID: Object(__WEBPACK_IMPORTED_MODULE_0__lib__["G" /* match */])(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
    };
}

/***/ }),

/***/ "./src/components/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__("./src/components/button/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__checkout__ = __webpack_require__("./src/components/checkout/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__checkout__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__checkout__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__checkout__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login__ = __webpack_require__("./src/components/login/index.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__login__["a"]; });




/***/ }),

/***/ "./src/components/login/component.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__checkout_templates__ = __webpack_require__("./src/components/checkout/templates/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js");







var Login = Object(__WEBPACK_IMPORTED_MODULE_0_xcomponent_src__["c" /* create */])({

    tag: 'paypal-checkout-login',

    scrolling: true,

    get url() {
        return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].loginUrls;
    },

    // allowedParentDomains: config.paypal_domain_regex,

    get bridgeUrl() {
        return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].metaFrameUrls;
    },

    get bridgeDomain() {
        return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalDomains;
    },

    defaultEnv: __WEBPACK_IMPORTED_MODULE_2__config__["d" /* ENV */].PRODUCTION,

    contexts: {
        iframe: false,
        popup: true
    },

    dimensions: {
        width: '450px',
        height: '535px'
    },

    get version() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__lib__["s" /* getScriptVersion */])();
    },

    sandboxContainer: true,

    prerenderTemplate: __WEBPACK_IMPORTED_MODULE_3__checkout_templates__["a" /* componentTemplate */],
    containerTemplate: __WEBPACK_IMPORTED_MODULE_3__checkout_templates__["b" /* containerTemplate */],

    props: {

        sessionID: {
            type: 'string',
            value: Object(__WEBPACK_IMPORTED_MODULE_4__lib__["t" /* getSessionID */])(),
            def: function def() {
                return Object(__WEBPACK_IMPORTED_MODULE_4__lib__["t" /* getSessionID */])();
            },

            queryParam: true
        },

        env: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def() {
                return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env;
            },
            validate: function validate(env) {
                if (!__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalUrls[env]) {
                    throw new Error('Invalid env: ' + env);
                }
            }
        },

        style: {
            type: 'object',
            required: false,
            def: function def() {
                return {};
            }
        },

        locale: {
            type: 'string',
            required: false,
            queryParam: 'locale.x',
            allowDelegate: true,

            def: function def() {
                var _getBrowserLocale = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* getBrowserLocale */])(),
                    lang = _getBrowserLocale.lang,
                    country = _getBrowserLocale.country;

                return lang + '_' + country;
            }
        },

        stage: {
            type: 'string',
            required: false,
            queryParam: true,

            def: function def(props) {
                var env = props.env || __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env;

                if (env === __WEBPACK_IMPORTED_MODULE_2__config__["d" /* ENV */].STAGE || env === __WEBPACK_IMPORTED_MODULE_2__config__["d" /* ENV */].LOCAL) {
                    return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].stage;
                }
            }
        },

        onAuthenticate: {
            type: 'function',
            required: true,
            // sameDomain: true,
            decorate: function decorate(original) {
                if (original) {
                    return function decorateOnAuthenticate(data) {
                        var _this = this;

                        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                            return original.call(_this, data);
                        })['catch'](function (err) {
                            return _this.error(err);
                        })['finally'](function () {
                            return _this.close();
                        });
                    };
                }
            }
        },

        onCancel: {
            type: 'function',
            required: false,
            once: true,
            noop: true,

            decorate: function decorate(original) {
                if (original) {
                    return function decorateOnCancel(data) {
                        var _this2 = this;

                        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
                            return original.call(_this2, data);
                        })['catch'](function (err) {
                            return _this2.error(err);
                        })['finally'](function () {
                            _this2.close();
                        });
                    };
                }
            }
        },

        logLevel: {
            type: 'string',
            required: false,
            get value() {
                return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].logLevel;
            }
        },

        test: {
            type: 'object',
            required: false,
            def: function def() {
                return { action: 'login' };
            }
        }
    },

    autoResize: {
        width: false,
        height: false
    }
});

/***/ }),

/***/ "./src/components/login/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__prerender__ = __webpack_require__("./src/components/login/prerender.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./src/components/login/component.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__component__["a"]; });
 // eslint-disable-line import/no-unassigned-import



/***/ }),

/***/ "./src/components/login/prerender.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("./src/components/login/component.js");




var prerender = __WEBPACK_IMPORTED_MODULE_1__component__["a" /* Login */].prerender;

// $FlowFixMe
__WEBPACK_IMPORTED_MODULE_1__component__["a" /* Login */].prerender = function loginPrerender(props) {
    var component = prerender.apply(this, arguments);

    var env = props && props.env || __WEBPACK_IMPORTED_MODULE_0__config__["n" /* config */].env;

    // $FlowFixMe
    component.html = component.html.then(function (html) {
        return '\n            ' + html + '\n\n            <script src="' + __WEBPACK_IMPORTED_MODULE_0__config__["n" /* config */].scriptUrl + '" async></script>\n\n            <script>\n                (function() {\n\n                    function ajaxifyForms() {\n                        Array.prototype.slice.call(document.querySelectorAll(\'form\')).forEach(function(form) {\n                            form.addEventListener(\'submit\', function(event) {\n                                event.preventDefault();\n\n                                var data = {};\n\n                                Array.prototype.slice.call(form.elements).forEach(function(el) {\n\n                                    if (el.disabled || !el.name) {\n                                        return;\n                                    }\n\n                                    if ([\'file\', \'reset\', \'submit\', \'button\'].indexOf(el.type) !== -1) {\n                                        return;\n                                    }\n\n                                    var value;\n\n                                    if ([\'checkbox\', \'radio\'].indexOf(el.type) !== -1 && el.checked) {\n                                        value = \'on\';\n                                    } else {\n                                        value = el.value;\n                                    }\n\n                                    data[el.name] = value;\n                                });\n\n                                var serializedData = Object.keys(data).map(function(key) {\n                                    return encodeURIComponent(key) + \'=\' + encodeURIComponent(data[key])\n                                }).join(\'&\').replace(/%20/g, \'+\');\n\n                                var req = new XMLHttpRequest();\n                                req.open(form.method || \'GET\', \'' + __WEBPACK_IMPORTED_MODULE_0__config__["n" /* config */].paypalUrls[env] + '\' + form.getAttribute(\'action\'));\n                                req.setRequestHeader(\'Accept\', \'application/json\');\n                                req.setRequestHeader(\'Content-Type\', \'application/x-www-form-urlencoded\');\n                                req.setRequestHeader(\'x-csrf-token\', data._csrf);\n                                req.setRequestHeader(\'is-inline-ul\', \'true\');\n                                req.setRequestHeader(\'X-Requested-With\', \'XMLHttpRequest\');\n                                req.send(serializedData);\n\n                                req.onload = function() {\n                                    if (req.status !== 200) {\n                                        return window.xchild.error(new Error(\'Login returned status: \' + req.status));\n                                    }\n\n                                    var data;\n\n                                    try {\n                                        data = JSON.parse(req.responseText);\n                                    } catch (err) {\n                                        return window.xchild.error(err + \'\\n\\n\' + req.responseText);\n                                    }\n\n                                    if (data.htmlResponse) {\n                                        document.write(data.htmlResponse);\n                                        return setTimeout(ajaxifyForms);\n                                    }\n\n                                    if (!data || !data.accessToken) {\n                                        return window.xchild.error(\'Could not find access token: \\n\\n\' + JSON.stringify(data, null, 2));\n                                    }\n\n                                    window.xprops.onAuthenticate({\n                                        accessToken: data.accessToken\n                                    });\n                                };\n\n                                req.onerror = function() {\n                                    return window.xchild.error(new Error(\'Login error\'));\n                                };\n                            });\n                        });\n                    }\n\n                    ajaxifyForms();\n\n                })();\n            </script>\n        ';
    });

    return component;
};

/***/ }),

/***/ "./src/config/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./src/config/constants.js");
var _checkoutUris, _altpayUris, _guestUris, _billingUris, _buttonUris, _postBridgeUris, _legacyCheckoutUris, _buttonJSUrls, _locales;

/*  weak */
/* eslint max-lines: 0 */



var config = {

    scriptUrl:  false ? '//' + window.location.host + '/base/src/load.js' : '//www.paypalobjects.com/api/' + "checkout.4.0.173.js",

    // eslint-disable-next-line security/detect-unsafe-regex
    paypal_domain_regex: /^(https?|mock):\/\/[a-zA-Z0-9_.-]+\.paypal\.com(:\d+)?$/,

    version: "4.0.173",

    cors: true,

    env:  false ? ENV.TEST : __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION,

    state: 'checkoutjs',

    locale: {
        country: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].US,
        lang: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN
    },

    stage: 'msmaster',

    merchantID: '',

    logLevel: "warn",

    throttles: {
        v4_mobile_device: 0
    },

    domain_settings: {
        'walmart.com': {
            log_domain_prefix: true,
            ie_full_page: false,
            allow_full_page_fallback: true,
            memoize_payment: true,
            force_bridge: true,
            log_authorize: true,
            disable_payment_timeout: true
        },

        'ulta.com': {
            disable_venmo: true
        },

        'barnesandnoble.com': {
            disable_venmo: true
        },

        'bn.com': {
            disable_venmo: true
        },

        'agoratix.com': {
            disable_venmo: true
        },

        'tractorsupply.com': {
            disable_venmo: true
        },

        'etsy.com': {
            log_domain_prefix: true,
            ie_full_page: false,
            allow_full_page_fallback: true,
            memoize_payment: true,
            force_bridge: true,
            log_authorize: true,
            disable_payment_timeout: true
        },

        'ticketmaster.com': {
            disable_venmo: true
        },

        'livenation.com': {
            disable_venmo: true
        },

        'frontgatetickets.com': {
            disable_venmo: true
        }
    },

    customCountry: false,

    SUPPORTED_BROWSERS: {
        msie: '9',
        firefox: '30',
        chrome: '27',
        safari: '5.1',
        opera: '16',
        msedge: '12',
        samsungBrowser: '2.1',
        silk: '59.3',
        ucbrowser: '10.0.0.488',
        vivaldi: '1.91'
    },

    session_uid_lifetime: 5 * 60 * 1000,

    _apiStage: '',

    get apiStage() {
        return config._apiStage || config.stage;
    },

    set apiStage(value) {
        config._apiStage = value;
    },

    ports: {
        'default': 8000,
        button: 8000,
        checkout: 8000,
        guest: 8001,
        altpay: 3000
    },

    get paypalUrls() {
        var _ref;

        return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = 'http://localhost.paypal.com:' + config.ports['default'], _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = 'https://www.' + config.stage + '.qa.paypal.com', _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = 'https://www.sandbox.paypal.com', _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = 'https://www.paypal.com', _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = window.location.protocol + '//' + window.location.host, _ref[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = window.location.protocol + '//localhost.paypal.com:' + window.location.port, _ref;
    },

    get paypalDomains() {
        var _ref2;

        return _ref2 = {}, _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = 'http://localhost.paypal.com:' + config.ports['default'], _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = 'https://www.' + config.stage + '.qa.paypal.com', _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = 'https://www.sandbox.paypal.com', _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = 'https://www.paypal.com', _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = 'mock://www.paypal.com', _ref2[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = window.location.protocol + '//localhost.paypal.com:' + window.location.port, _ref2;
    },

    get wwwApiUrls() {
        var _ref3;

        return _ref3 = {}, _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = 'https://www.' + config.stage + '.qa.paypal.com', _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = 'https://www.' + config.stage + '.qa.paypal.com', _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = 'https://www.sandbox.paypal.com', _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = 'https://www.paypal.com', _ref3[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = window.location.protocol + '//' + window.location.host, _ref3;
    },

    get corsApiUrls() {
        var _ref4;

        return _ref4 = {}, _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = 'https://' + config.apiStage + '.qa.paypal.com:11888', _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = 'https://' + config.apiStage + '.qa.paypal.com:11888', _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = 'https://cors.api.sandbox.paypal.com', _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = 'https://cors.api.paypal.com', _ref4[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = window.location.protocol + '//' + window.location.host, _ref4;
    },

    get apiUrls() {
        var _ref5;

        var domain = window.location.protocol + '//' + window.location.host;
        var corsApiUrls = config.corsApiUrls;
        var wwwApiUrls = config.wwwApiUrls;

        return _ref5 = {}, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = domain === wwwApiUrls.local ? wwwApiUrls.local : corsApiUrls.local, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = domain === wwwApiUrls.stage ? wwwApiUrls.stage : corsApiUrls.stage, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = domain === wwwApiUrls.sandbox ? wwwApiUrls.sandbox : corsApiUrls.sandbox, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = domain === wwwApiUrls.production ? wwwApiUrls.production : corsApiUrls.production, _ref5[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = domain === wwwApiUrls.test ? wwwApiUrls.test : corsApiUrls.test, _ref5;
    },

    checkoutUris: (_checkoutUris = {}, _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/webapps/hermes?ul=0', _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/webapps/hermes', _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/checkoutnow', _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/checkoutnow', _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/checkout/index.htm?checkouturl=true', _checkoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/checkout.htm', _checkoutUris),

    altpayUris: (_altpayUris = {}, _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/latinumcheckout', _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/latinumcheckout', _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/latinumcheckout', _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/latinumcheckout', _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/checkout/index.htm?checkouturl=true', _altpayUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/checkout.htm', _altpayUris),

    guestUris: (_guestUris = {}, _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/webapps/xoonboarding', _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/webapps/xoonboarding', _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/webapps/xoonboarding', _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/webapps/xoonboarding', _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/checkout/index.htm?guesturl=true', _guestUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/guest.htm', _guestUris),

    billingUris: (_billingUris = {}, _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/webapps/hermes/agreements?ul=0', _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/webapps/hermes/agreements', _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/agreements/approve', _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/agreements/approve', _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/checkout/index.htm?billingurl=true', _billingUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/checkout.htm', _billingUris),

    buttonUris: (_buttonUris = {}, _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/webapps/hermes/button', _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/webapps/hermes/button', _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/webapps/hermes/button', _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/webapps/hermes/button', _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/button/index.htm', _buttonUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/button.htm', _buttonUris),

    postBridgeUris: (_postBridgeUris = {}, _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/webapps/hermes/component-meta', _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/webapps/hermes/component-meta', _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/webapps/hermes/component-meta', _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/webapps/hermes/component-meta', _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/windows/component-meta/index.htm', _postBridgeUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '/demo/dev/bridge.htm', _postBridgeUris),

    legacyCheckoutUris: (_legacyCheckoutUris = {}, _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true', _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true', _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true', _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true', _legacyCheckoutUris[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '#fallback', _legacyCheckoutUris),

    buttonJSUrls: (_buttonJSUrls = {}, _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = 'https://www.paypalobjects.com/api/button.js', _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = 'https://www.paypalobjects.com/api/button.js', _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = 'https://www.paypalobjects.com/api/button.js', _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = 'https://www.paypalobjects.com/api/button.js', _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '/base/test/lib/button.js', _buttonJSUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = 'https://www.paypalobjects.com/api/button.js', _buttonJSUrls),

    get buttonJSUrl() {
        return config.buttonJSUrls[config.env];
    },

    loginUri: '/signin/',

    loggerUri: '/webapps/hermes/api/logger',

    pptmUri: '/tagmanager/pptm.js',

    get postBridgeUri() {
        return config.postBridgeUris[config.env] + '?xcomponent=1';
    },

    paymentStandardUri: '/webapps/xorouter?cmd=_s-xclick',

    authApiUri: '/v1/oauth2/token',
    paymentApiUri: '/v1/payments/payment',
    orderApiUri: '/v1/checkout/orders',
    billingApiUri: '/v1/billing-agreements/agreement-tokens',
    experienceApiUri: '/v1/payment-experience/web-profiles',

    get checkoutUrls() {
        var _ref6;

        var paypalUrls = config.paypalUrls;

        return _ref6 = {}, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local + config.checkoutUris.local.replace(':' + config.ports['default'], ':' + config.ports.checkout), _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.checkoutUris.stage, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.checkoutUris.sandbox, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.checkoutUris.production, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.checkoutUris.test, _ref6[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.test + config.checkoutUris.demo, _ref6;
    },

    get guestUrls() {
        var _ref7;

        var paypalUrls = config.paypalUrls;

        return _ref7 = {}, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local.replace(':' + config.ports['default'], ':' + config.ports.guest) + config.guestUris.local, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.guestUris.stage, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.guestUris.sandbox, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.guestUris.production, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.guestUris.test, _ref7[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.test + config.guestUris.demo, _ref7;
    },

    get altpayUrls() {
        var _ref8;

        var paypalUrls = config.paypalUrls;

        return _ref8 = {}, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local.replace(':' + config.ports['default'], ':' + config.ports.altpay) + config.altpayUris.local, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.altpayUris.stage, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.altpayUris.sandbox, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.altpayUris.production, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.altpayUris.test, _ref8[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.test + config.altpayUris.demo, _ref8;
    },

    get billingUrls() {
        var _ref9;

        var paypalUrls = config.paypalUrls;

        return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local.replace(':' + config.ports['default'], ':' + config.ports.checkout) + config.billingUris.local, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.billingUris.stage, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.billingUris.sandbox, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.billingUris.production, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.billingUris.test, _ref9[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.test + config.billingUris.demo, _ref9;
    },

    get buttonUrls() {
        var _ref10;

        var paypalUrls = config.paypalUrls;

        return _ref10 = {}, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local.replace(':' + config.ports['default'], ':' + config.ports.button) + config.buttonUris.local, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.buttonUris.stage, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.buttonUris.sandbox, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.buttonUris.production, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.buttonUris.test, _ref10[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.demo + config.buttonUris.demo, _ref10;
    },

    get loginUrls() {
        var _ref11;

        var paypalUrls = config.paypalUrls;

        return _ref11 = {}, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.stage + config.loginUri, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.loginUri, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.loginUri, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.loginUri, _ref11[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.loginUri, _ref11;
    },

    get paymentsStandardUrls() {
        var _ref12;

        var paypalUrls = config.paypalUrls;

        return _ref12 = {}, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local + config.paymentStandardUri, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.paymentStandardUri, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.paymentStandardUri, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.paymentStandardUri, _ref12[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.paymentStandardUri, _ref12;
    },

    get metaFrameUrls() {
        var _ref13;

        var paypalUrls = config.paypalUrls;

        return _ref13 = {}, _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.local + config.postBridgeUri + '&env=local', _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.postBridgeUri + '&env=stage&stage=' + config.stage, _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.postBridgeUri + '&env=sandbox', _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.postBridgeUri + '&env=production', _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.postBridgeUri + '&env=test', _ref13[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].DEMO] = '' + paypalUrls.demo + config.postBridgeUri + '&env=demo', _ref13;
    },

    get legacyCheckoutUrls() {
        var _ref14;

        var paypalUrls = config.paypalUrls;

        return _ref14 = {}, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + paypalUrls.stage + config.legacyCheckoutUris.local, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + paypalUrls.stage + config.legacyCheckoutUris.stage, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + paypalUrls.sandbox + config.legacyCheckoutUris.sandbox, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + paypalUrls.production + config.legacyCheckoutUris.production, _ref14[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + paypalUrls.test + config.legacyCheckoutUris.test, _ref14;
    },

    get authApiUrls() {
        var _ref15;

        var apiUrls = config.apiUrls;
        var authApiUri = config.authApiUri;

        return _ref15 = {}, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + apiUrls.local + authApiUri, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + apiUrls.stage + authApiUri, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + apiUrls.sandbox + authApiUri, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + apiUrls.production + authApiUri, _ref15[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + apiUrls.test + authApiUri, _ref15;
    },

    get paymentApiUrls() {
        var _ref16;

        var apiUrls = config.apiUrls;
        var paymentApiUri = config.paymentApiUri;

        return _ref16 = {}, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + apiUrls.local + paymentApiUri, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + apiUrls.stage + paymentApiUri, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + apiUrls.sandbox + paymentApiUri, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + apiUrls.production + paymentApiUri, _ref16[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + apiUrls.test + paymentApiUri, _ref16;
    },

    get orderApiUrls() {
        var _ref17;

        var apiUrls = config.apiUrls;
        var orderApiUri = config.orderApiUri;

        return _ref17 = {}, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + apiUrls.local + orderApiUri, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + apiUrls.stage + orderApiUri, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + apiUrls.sandbox + orderApiUri, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + apiUrls.production + orderApiUri, _ref17[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + apiUrls.test + orderApiUri, _ref17;
    },

    get billingApiUrls() {
        var _ref18;

        var apiUrls = config.apiUrls;
        var billingApiUri = config.billingApiUri;

        return _ref18 = {}, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + apiUrls.local + billingApiUri, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + apiUrls.stage + billingApiUri, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + apiUrls.sandbox + billingApiUri, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + apiUrls.production + billingApiUri, _ref18[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + apiUrls.test + billingApiUri, _ref18;
    },

    get experienceApiUrls() {
        var _ref19;

        var apiUrls = config.apiUrls;
        var experienceApiUri = config.experienceApiUri;

        return _ref19 = {}, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL] = '' + apiUrls.local + experienceApiUri, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] = '' + apiUrls.stage + experienceApiUri, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].SANDBOX] = '' + apiUrls.sandbox + experienceApiUri, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].PRODUCTION] = '' + apiUrls.production + experienceApiUri, _ref19[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].TEST] = '' + apiUrls.test + experienceApiUri, _ref19;
    },

    _paypalUrl: '',

    get paypalUrl() {
        return this._paypalUrl || config.paypalUrls[config.env];
    },

    set paypalUrl(value) {
        this._paypalUrl = value;
    },

    get paypalDomain() {
        return config.paypalDomains[config.env];
    },

    get corsApiUrl() {
        return config.corsApiUrls[config.env];
    },

    get wwwApiUrl() {
        return config.wwwApiUrls[config.env];
    },

    get apiUrl() {

        var domain = window.location.protocol + '//' + window.location.host;
        var corsApiUrl = config.corsApiUrl;
        var wwwApiUrl = config.wwwApiUrl;

        return domain === wwwApiUrl ? wwwApiUrl : corsApiUrl;
    },

    get checkoutUrl() {
        return '' + config.paypalUrl + config.checkoutUris[config.env];
    },

    get billingUrl() {
        return '' + config.paypalUrl + config.billingUris[config.env];
    },

    get buttonUrl() {
        return '' + config.paypalUrl + config.buttonUris[config.env];
    },

    get legacyCheckoutUrl() {
        return config.legacyCheckoutUrls[config.env];
    },

    get postBridgeUrl() {
        return '' + config.paypalUrl + config.postBridgeUri;
    },

    get postBridgeDomain() {
        return '' + config.paypalDomain;
    },

    get loggerUrl() {
        return '' + config.paypalUrl + config.loggerUri;
    },

    get pptmUrl() {

        var paypalUrl = config.env === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].LOCAL ? config.paypalUrls[__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* ENV */].STAGE] : config.paypalUrl;

        return '' + paypalUrl + config.pptmUri;
    },

    get authApiUrl() {
        return '' + config.apiUrl + config.authApiUri;
    },

    get paymentApiUrl() {
        return '' + config.apiUrl + config.paymentApiUri;
    },

    get orderApiUrl() {
        return '' + config.apiUrl + config.orderApiUri;
    },

    get billingApiUrl() {
        return '' + config.apiUrl + config.billingApiUri;
    },

    get experienceApiUrl() {
        return '' + config.apiUrl + config.experienceApiUri;
    },

    defaultLocale: {
        country: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].US,
        lang: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN
    },

    locales: (_locales = {}, _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AD] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DE, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].AZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BB] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].NL, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BF] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BJ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].PT, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].BZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].C2] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CD] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DE, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CV] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].CZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DE, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DJ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DA, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].DZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].EC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].EE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].RU, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].EG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ER] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ES] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ET] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FJ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DA, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].FR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GB] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GD] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GF] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DA, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GP] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].GY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].HK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].HN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].HR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].HU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ID] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ID, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].IE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].IL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].HE, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].IN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].IS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].IT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].IT, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].JM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].JO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].JP] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].JA, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].KO, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].KZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].RU, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].DE, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].LV] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].RU, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MD] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ME] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ML] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MQ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MV] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MX] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].MZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NF] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].NL, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].NO, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NP] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].NZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].OM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PF] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].PL, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].PT, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].PY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].QA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].RE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].RO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].RS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].RU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].RU, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].RW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SB] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].SV, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SI] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SJ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SK] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SL] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ST] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SV] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].SZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TD] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TH] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].TH, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TJ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TO] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TR] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].TR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TV] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].TZ] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].UA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].RU, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].UG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].US] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].UY] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VC] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VG] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VN] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].VU] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].WF] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].WS] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].YE] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].AR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].YT] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ZA] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ZM] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].FR, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ES, __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].ZH], _locales[__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COUNTRY */].ZW] = [__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* LANG */].EN], _locales)
};

/***/ }),

/***/ "./src/config/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOG_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PAYMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FPTI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PPTM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FUNDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CARD_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PLATFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LANG_TO_DEFAULT_COUNTRY; });
var _CONTEXT_TYPE, _LANG_TO_DEFAULT_COUN;

var ENV = {
    LOCAL: 'local',
    STAGE: 'stage',
    SANDBOX: 'sandbox',
    PRODUCTION: 'production',
    TEST: 'test',
    DEMO: 'demo'
};

var USERS = {
    ALL: 'all',
    REMEMBERED: 'remembered'
};

var SOURCE = {
    MANUAL: 'manual',
    BUTTON_FACTORY: 'button_factory'
};

var LOG_LEVEL = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
};

var PAYMENT_TYPE = {
    EC_TOKEN: 'ec_token',
    BA_TOKEN: 'ba_token',
    PAY_ID: 'pay_id'
};

var FPTI = {

    KEY: {
        FEED: 'feed_name',
        STATE: 'state_name',
        TRANSITION: 'transition_name',
        BUTTON_TYPE: 'button_type',
        SESSION_UID: 'page_session_id',
        BUTTON_SESSION_UID: 'button_session_id',
        TOKEN: 'token',
        CONTEXT_ID: 'context_id',
        CONTEXT_TYPE: 'context_type',
        REFERER: 'referer_url',
        PAY_ID: 'pay_id',
        SELLER_ID: 'seller_id',
        DATA_SOURCE: 'serverside_data_source',
        BUTTON_SOURCE: 'button_source',
        ERROR_CODE: 'ext_error_code',
        ERROR_DESC: 'ext_error_desc',
        PAGE_LOAD_TIME: 'page_load_time',
        EXPERIMENT_NAME: 'pxp_exp_id',
        TREATMENT_NAME: 'pxp_trtmnt_id',
        TRANSITION_TIME: 'transition_time',
        FUNDING_LIST: 'eligible_payment_methods',
        FUNDING_COUNT: 'eligible_payment_count',
        CHOSEN_FUNDING: 'selected_payment_method',
        BUTTON_LAYOUT: 'button_layout',
        VERSION: 'checkoutjs_version'
    },

    BUTTON_TYPE: {
        IFRAME: 'iframe',
        HTML: 'html',
        CUSTOM: 'custom'
    },

    DATA_SOURCE: {
        CHECKOUT: 'checkout'
    },

    CONTEXT_TYPE: (_CONTEXT_TYPE = {
        BUTTON_SESSION_ID: 'button_session_id'
    }, _CONTEXT_TYPE[PAYMENT_TYPE.PAY_ID] = 'Pay-ID', _CONTEXT_TYPE[PAYMENT_TYPE.EC_TOKEN] = 'EC-Token', _CONTEXT_TYPE[PAYMENT_TYPE.BA_TOKEN] = 'EC-Token', _CONTEXT_TYPE),

    FEED: {
        CHECKOUTJS: 'checkoutjs'
    },

    STATE: {
        LOAD: 'checkoutjs_load',
        BUTTON: 'checkoutjs_button',
        CHECKOUT: 'checkoutjs_checkout',
        PPTM: 'checkoutjs_pptm',
        PXP: 'PXP_CHECK'
    },

    TRANSITION: {
        SCRIPT_LOAD: 'process_script_load',

        BUTTON_RENDER: 'process_button_render',
        BUTTON_LOAD: 'process_button_load',
        BUTTON_CLICK: 'process_button_click',

        CREATE_PAYMENT: 'process_create_payment',
        RECIEVE_PAYMENT: 'process_recieve_payment',

        CHECKOUT_INIT: 'process_checkout_init',
        CHECKOUT_AUTHORIZE: 'process_checkout_authorize',
        CHECKOUT_CANCEL: 'process_checkout_cancel',
        CHECKOUT_ERROR: 'process_checkout_error',

        EXTERNAL_EXPERIMENT: 'process_external_experiment',
        EXTERNAL_EXPERIMENT_COMPLETE: 'process_external_experiment_complete',

        PPTM_LOAD: 'process_pptm_load',
        PPTM_LOADED: 'process_pptm_loaded',

        PXP: 'process_pxp_check'
    }
};

var PPTM_ID = 'xo-pptm';

var FUNDING = {
    PAYPAL: 'paypal',
    VENMO: 'venmo',
    CREDIT: 'credit',
    CARD: 'card',
    IDEAL: 'ideal',
    ELV: 'elv'
};

var CARD = {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    AMEX: 'amex',
    DISCOVER: 'discover',
    SWITCH: 'switch',
    MAESTRO: 'maestro',
    HIPER: 'hiper',
    ELO: 'elo',
    JCB: 'jcb',
    CUP: 'cup',
    COFINOGA: 'cofinoga',
    COFIDIS: 'cofidis',
    CETELEM: 'cetelem',
    CBNATIONALE: 'cbnationale'
};

var CARD_PRIORITY = [CARD.VISA, CARD.MASTERCARD, CARD.AMEX, CARD.DISCOVER, CARD.SWITCH, CARD.MAESTRO, CARD.HIPER, CARD.ELO, CARD.JCB, CARD.CUP, CARD.COFINOGA, CARD.COFIDIS, CARD.CETELEM, CARD.CBNATIONALE];

var ATTRIBUTE = {
    BUTTON: 'data-button',
    FUNDING_SOURCE: 'data-funding-source',
    CARD: 'data-card',
    VERSION: 'data-version'
};

var PLATFORM = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
};

var COUNTRY = {
    AD: 'AD',
    AE: 'AE',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AN: 'AN',
    AO: 'AO',
    AR: 'AR',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    C2: 'C2',
    CA: 'CA',
    CD: 'CD',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CV: 'CV',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GR: 'GR',
    GT: 'GT',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HN: 'HN',
    HR: 'HR',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IN: 'IN',
    IS: 'IS',
    IT: 'IT',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MN: 'MN',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    ST: 'ST',
    SV: 'SV',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    US: 'US',
    UY: 'UY',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
};

var LANG = {
    EN: 'en',
    FR: 'fr',
    ES: 'es',
    ZH: 'zh',
    AR: 'ar',
    DE: 'de',
    NL: 'nl',
    PT: 'pt',
    DA: 'da',
    RU: 'ru',
    ID: 'id',
    HE: 'he',
    IT: 'it',
    JA: 'ja',
    KO: 'ko',
    NO: 'no',
    PL: 'pl',
    SV: 'sv',
    TH: 'th',
    TR: 'tr'
};

var LANG_TO_DEFAULT_COUNTRY = (_LANG_TO_DEFAULT_COUN = {}, _LANG_TO_DEFAULT_COUN[LANG.EN] = COUNTRY.US, _LANG_TO_DEFAULT_COUN[LANG.FR] = COUNTRY.FR, _LANG_TO_DEFAULT_COUN[LANG.ES] = COUNTRY.ES, _LANG_TO_DEFAULT_COUN[LANG.ZH] = COUNTRY.CN, _LANG_TO_DEFAULT_COUN[LANG.DE] = COUNTRY.DE, _LANG_TO_DEFAULT_COUN[LANG.NL] = COUNTRY.NL, _LANG_TO_DEFAULT_COUN[LANG.PT] = COUNTRY.PT, _LANG_TO_DEFAULT_COUN[LANG.DA] = COUNTRY.DK, _LANG_TO_DEFAULT_COUN[LANG.RU] = COUNTRY.RU, _LANG_TO_DEFAULT_COUN[LANG.ID] = COUNTRY.ID, _LANG_TO_DEFAULT_COUN[LANG.HE] = COUNTRY.IL, _LANG_TO_DEFAULT_COUN[LANG.IT] = COUNTRY.IT, _LANG_TO_DEFAULT_COUN[LANG.JA] = COUNTRY.JP, _LANG_TO_DEFAULT_COUN[LANG.KO] = COUNTRY.KR, _LANG_TO_DEFAULT_COUN[LANG.NO] = COUNTRY.NO, _LANG_TO_DEFAULT_COUN[LANG.PL] = COUNTRY.PL, _LANG_TO_DEFAULT_COUN[LANG.SV] = COUNTRY.SE, _LANG_TO_DEFAULT_COUN[LANG.TH] = COUNTRY.TH, _LANG_TO_DEFAULT_COUN[LANG.TR] = COUNTRY.TR, _LANG_TO_DEFAULT_COUN);

/***/ }),

/***/ "./src/config/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/config.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./src/config/constants.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__["o"]; });



/***/ }),

/***/ "./src/experiments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onAuthorizeListener; });
/* harmony export (immutable) */ __webpack_exports__["a"] = logExperimentTreatment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js");





var onAuthorizeListener = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["f" /* eventEmitter */])();

function log(experiment, treatment, token, state) {

    Object(__WEBPACK_IMPORTED_MODULE_2__lib__["u" /* getSessionState */])(function (session) {

        var event = experiment + '_' + treatment + '_' + state;
        var loggedEvents = session.loggedExperimentEvents = session.loggedExperimentEvents || [];
        var duplicate = loggedEvents.indexOf(event) !== -1;

        if (duplicate) {
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('duplicate_' + event);
        } else {
            var _track;

            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])(event);
            loggedEvents.push(event);

            var edge = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/Edge\/[0-9]{2}/);

            if (edge) {
                event = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])(edge[0].toLowerCase().replace('/', '_') + '_' + event);
            }

            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].STATE.CHECKOUT, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TRANSITION] = state, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.EXPERIMENT_NAME] = experiment, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TREATMENT_NAME] = treatment, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TOKEN] = token, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.CONTEXT_ID] = token, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.CONTEXT_TYPE] = token ? __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_1__config__["j" /* PAYMENT_TYPE */].EC_TOKEN] : __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].CONTEXT_TYPE.BUTTON_SESSION_ID, _track));

            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["i" /* immediateFlush */])();
        }
    });
}

function logExperimentTreatment(_ref) {
    var experiment = _ref.experiment,
        treatment = _ref.treatment,
        state = _ref.state,
        token = _ref.token;


    if (!experiment || !treatment) {
        return;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2__lib__["u" /* getSessionState */])(function (session) {
        session.externalExperiment = experiment;
        session.externalExperimentTreatment = treatment;

        if (token) {
            session.externalExperimentToken = token;
        }
    });

    log(experiment, treatment, token, state);
}

function logReturn(token) {
    var _getSessionState = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["u" /* getSessionState */])(function (session) {
        return session;
    }),
        externalExperiment = _getSessionState.externalExperiment,
        externalExperimentTreatment = _getSessionState.externalExperimentTreatment,
        externalExperimentToken = _getSessionState.externalExperimentToken;

    if (externalExperiment && externalExperimentTreatment && externalExperimentToken === token) {
        log(externalExperiment, externalExperimentTreatment, token, 'complete');
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('experiment_mismatch', {
            token: token,
            externalExperiment: externalExperiment,
            externalExperimentTreatment: externalExperimentTreatment,
            externalExperimentToken: externalExperimentToken
        });
    }
}

if (Object(__WEBPACK_IMPORTED_MODULE_2__lib__["l" /* getDomainSetting */])('log_authorize')) {

    onAuthorizeListener.once(function (_ref2) {
        var paymentToken = _ref2.paymentToken;

        setTimeout(function () {
            logReturn(paymentToken);
        }, 1);
    });

    var returnToken = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getReturnToken */])();

    if (returnToken) {
        setTimeout(function () {
            if (returnToken) {
                logReturn(returnToken);
            }
        }, 1);
    }
}

/***/ }),

/***/ "./src/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interface__ = __webpack_require__("./src/interface.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "postRobot", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["postRobot"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Promise"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["PopupOpenError"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["rest"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Button"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceIframe", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["forceIframe"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWebView", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["isWebView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "allowIframe", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["allowIframe"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setup", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["setup"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["config"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ENV", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["ENV"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "USERS", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["USERS"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SOURCE", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["SOURCE"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FUNDING", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["FUNDING"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CARD", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["CARD"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["request"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEligible", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["isEligible"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFundingRemembered", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["isFundingRemembered"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["logExperimentTreatment"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["onPossiblyUnhandledException"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["version"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "checkout", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["checkout"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "apps", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["apps"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Checkout", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Checkout"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "PayPalCheckout", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["PayPalCheckout"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Login", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["Login"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "destroyAll", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["destroyAll"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", function() { return __WEBPACK_IMPORTED_MODULE_0__interface__["enableCheckoutIframe"]; });
 // eslint-disable-line import/no-namespace


/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__interface__);

/***/ }),

/***/ "./src/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postRobot", function() { return postRobot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", function() { return onPossiblyUnhandledException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkout", function() { return checkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apps", function() { return apps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Checkout", function() { return Checkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PayPalCheckout", function() { return PayPalCheckout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Login", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyAll", function() { return destroyAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", function() { return enableCheckoutIframe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__ = __webpack_require__("./node_modules/xcomponent/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__("./src/components/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Promise", function() { return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopupOpenError", function() { return __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("./src/api/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "rest", function() { return __WEBPACK_IMPORTED_MODULE_5__api__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_4__components__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceIframe", function() { return __WEBPACK_IMPORTED_MODULE_4__components__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWebView", function() { return __WEBPACK_IMPORTED_MODULE_4__components__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "allowIframe", function() { return __WEBPACK_IMPORTED_MODULE_4__components__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setup__ = __webpack_require__("./src/setup.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setup", function() { return __WEBPACK_IMPORTED_MODULE_6__setup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("./src/config/index.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ENV", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "USERS", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SOURCE", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FUNDING", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CARD", function() { return __WEBPACK_IMPORTED_MODULE_7__config__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return __WEBPACK_IMPORTED_MODULE_3__lib__["R"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEligible", function() { return __WEBPACK_IMPORTED_MODULE_3__lib__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isFundingRemembered", function() { return __WEBPACK_IMPORTED_MODULE_3__lib__["A"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__experiments__ = __webpack_require__("./src/experiments.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", function() { return __WEBPACK_IMPORTED_MODULE_8__experiments__["a"]; });


 // eslint-disable-line import/no-namespace




var postRobot = __WEBPACK_IMPORTED_MODULE_2_post_robot_src__;










var onPossiblyUnhandledException = __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].onPossiblyUnhandledException;

var version = "4.0.173";

var checkout = void 0;
var apps = void 0;

if (true) {
    var legacy = __webpack_require__("./src/legacy/index.js");
    checkout = legacy.checkout;
    apps = legacy.apps;
}

// -------------------------------------------------------------

var Checkout = void 0;
var PayPalCheckout = void 0;
var Login = void 0;
var destroyAll = void 0;
var enableCheckoutIframe = void 0;

if (Object(__WEBPACK_IMPORTED_MODULE_3__lib__["E" /* isPayPalDomain */])() || false) {
    Checkout = __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Checkout */];
    PayPalCheckout = __WEBPACK_IMPORTED_MODULE_4__components__["b" /* Checkout */];
    Login = __WEBPACK_IMPORTED_MODULE_4__components__["c" /* Login */];
    enableCheckoutIframe = __WEBPACK_IMPORTED_MODULE_4__components__["e" /* enableCheckoutIframe */];
    destroyAll = __WEBPACK_IMPORTED_MODULE_0_xcomponent_src__["d" /* destroyAll */];
}

/***/ }),

/***/ "./src/legacy/button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = renderButtons;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHijackTargetElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_button_constants__ = __webpack_require__("./src/components/button/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("./src/legacy/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__("./src/legacy/common.js");










var _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LOG_PREFIX */]),
    info = _prefix.info,
    debug = _prefix.debug,
    error = _prefix.error;

var loadButtonJS = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["H" /* memoize */])(function () {

    debug('buttonjs_load');

    return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["F" /* loadScript */])(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].buttonJSUrl)['catch'](function (err) {
        info('buttonjs_load_error_retry', { error: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["U" /* stringifyError */])(err) });
        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["F" /* loadScript */])(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].buttonJSUrl);
    }).then(function (result) {
        debug('buttonjs_load_success');
        return result;
    })['catch'](function (err) {
        error('buttonjs_load_error', { error: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["U" /* stringifyError */])(err) });
        throw err;
    });
});

function renderButton(id, _ref) {
    var container = _ref.container,
        locale = _ref.locale,
        type = _ref.type,
        color = _ref.color,
        shape = _ref.shape,
        size = _ref.size;


    return loadButtonJS().then(function () {

        if (locale) {
            var _normalizeLocale = Object(__WEBPACK_IMPORTED_MODULE_6__common__["a" /* normalizeLocale */])(locale),
                country = _normalizeLocale.country,
                lang = _normalizeLocale.lang;

            locale = lang + '_' + country;
        }

        locale = locale || __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].locale.lang + '_' + __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].locale.country;
        color = color || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__["b" /* BUTTON_COLOR */].GOLD;
        shape = shape || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__["h" /* BUTTON_SHAPE */].PILL;
        size = size || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__["i" /* BUTTON_SIZE */].SMALL;
        type = type || __WEBPACK_IMPORTED_MODULE_4__components_button_constants__["c" /* BUTTON_LABEL */].CHECKOUT;

        debug('render_button_lc_' + locale);
        debug('render_button_color_' + color);
        debug('render_button_shape_' + shape);
        debug('render_button_size_' + size);
        debug('render_button_label_' + type);

        var el = window.paypal.button.create(id, { lc: locale, color: color, shape: shape, size: size }, { type: 'button', label: type }).el;
        container.appendChild(el);

        try {
            info('in_page_button_' + (Object(__WEBPACK_IMPORTED_MODULE_3__lib__["y" /* isElementVisible */])(el) ? 'visible' : 'not_visible'));
        } catch (err) {
            // pass
        }

        return el.childNodes[0];
    });
}

function renderButtons(id, buttons) {

    return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].map(buttons, function (button) {
        return __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

            if (button.container) {
                return renderButton(id, button);
            } else {
                return button.button;
            }
        }).then(function (element) {

            var container = void 0;
            var type = void 0;
            var condition = button.condition;
            var click = button.click;

            if (button.container) {
                container = button.container;
                type = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].BUTTON_TYPE.HTML;
            } else {
                container = button.button;
                type = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].BUTTON_TYPE.CUSTOM;
            }

            return { container: container, element: element, type: type, condition: condition, click: click };
        });
    });
}

function getHijackTargetElement(button) {

    // $FlowFixMe
    var form = button.form;

    if (form) {
        debug('target_element_button_form');
        return form;
    }

    var tagName = button.tagName && button.tagName.toLowerCase();

    if (tagName === 'a') {
        debug('target_element_link');
        return button;
    }

    var parentElement = button.parentElement;
    var parentTagName = parentElement && parentElement.tagName && parentElement.tagName.toLowerCase();

    if ((tagName === 'img' || tagName === 'button') && parentTagName === 'a') {
        debug('target_element_parent_link');
        return parentElement;
    }

    var grandparentElement = parentElement && parentElement.parentElement;
    var grandparentTagName = grandparentElement && grandparentElement.tagName && grandparentElement.tagName.toLowerCase();

    if (tagName === 'button' && grandparentTagName === 'a') {
        debug('target_element_grandparent_link');
        return button.parentElement && button.parentElement.parentElement;
    }
}

/***/ }),

/***/ "./src/legacy/common.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/legacy/constants.js");






var _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* LOG_PREFIX */]),
    warn = _prefix.warn;

var DEFAULT_COUNTRY = __WEBPACK_IMPORTED_MODULE_1__config__["c" /* COUNTRY */].US;
var DEFAULT_LANG = __WEBPACK_IMPORTED_MODULE_1__config__["g" /* LANG */].EN;

function normalizeLocale(locale) {
    var _locale$split = locale.split('_'),
        lang = _locale$split[0],
        country = _locale$split[1];

    if (!country) {
        if (__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locales[lang]) {
            country = lang;
            lang = null;
        } else {
            country = DEFAULT_COUNTRY;
        }
    }

    if (!__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locales[country]) {
        warn('invalid_user_country', { country: country });
        country = DEFAULT_COUNTRY;
    }

    if (!lang) {
        lang = DEFAULT_LANG;
    }

    if (__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locales[country].indexOf(lang) === -1) {
        warn('invalid_user_lang', { lang: lang });

        if (__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locales[country].indexOf(DEFAULT_LANG) !== -1) {
            lang = DEFAULT_LANG;
        } else {
            lang = __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locales[country][0];
        }
    }

    return { country: country, lang: lang };
}

/***/ }),

/***/ "./src/legacy/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOG_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLASSES; });
var LOG_PREFIX = 'paypal_legacy';

var ATTRIBUTES = {
    BUTTON: 'data-paypal-button',
    MERCHANT_ID: 'data-paypal-id',
    ENV: 'data-env',
    SANDBOX: 'data-sandbox'
};

var CLASSES = {
    HIDDEN_BUTTON: 'paypal-button-hidden'
};

/***/ }),

/***/ "./src/legacy/eligibility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLegacyEligible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib__ = __webpack_require__("./src/lib/index.js");


function isLegacyEligible() {

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__lib__["z" /* isEligible */])()) {
        return false;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_0__lib__["W" /* supportsPopups */])()) {
        return false;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__lib__["x" /* isDevice */])()) {
        return false;
    }

    return true;
}

/***/ }),

/***/ "./src/legacy/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ready__ = __webpack_require__("./src/legacy/ready.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button__ = __webpack_require__("./src/legacy/button.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "renderButtons", function() { return __WEBPACK_IMPORTED_MODULE_1__button__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHijackTargetElement", function() { return __WEBPACK_IMPORTED_MODULE_1__button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("./src/legacy/constants.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LOG_PREFIX", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CLASSES", function() { return __WEBPACK_IMPORTED_MODULE_2__constants__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interface__ = __webpack_require__("./src/legacy/interface.js");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "checkout", function() { return __WEBPACK_IMPORTED_MODULE_3__interface__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "apps", function() { return __WEBPACK_IMPORTED_MODULE_3__interface__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return __WEBPACK_IMPORTED_MODULE_3__interface__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setup", function() { return __WEBPACK_IMPORTED_MODULE_3__interface__["d"]; });
 // eslint-disable-line import/no-unassigned-import





/***/ }),

/***/ "./src/legacy/interface.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apps; });
/* harmony export (immutable) */ __webpack_exports__["c"] = reset;
/* harmony export (immutable) */ __webpack_exports__["d"] = setup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__("./src/components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__postBridge__ = __webpack_require__("./src/legacy/postBridge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eligibility__ = __webpack_require__("./src/legacy/eligibility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("./src/legacy/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__button__ = __webpack_require__("./src/legacy/button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__("./src/legacy/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__options__ = __webpack_require__("./src/legacy/options.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint max-lines: 0 */















var _prefix = Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* LOG_PREFIX */]),
    info = _prefix.info,
    debug = _prefix.debug,
    warn = _prefix.warn,
    error = _prefix.error,
    track = _prefix.track;

var checkout = {};
var apps = { checkout: checkout, Checkout: checkout };

function reset() {

    debug('reset');

    // Once our callback has been called, we can set the global methods to their original values

    checkout.initXO = initXO; // eslint-disable-line no-use-before-define
    checkout.startFlow = startFlow; // eslint-disable-line no-use-before-define
    checkout.closeFlow = closeFlow; // eslint-disable-line no-use-before-define
}

checkout.reset = reset;

// $FlowFixMe
Object.defineProperty(checkout, 'urlPrefix', {
    get: function get() {
        return '' + __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].checkoutUrl + (__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].checkoutUrl.indexOf('?') === -1 ? '?' : '&') + 'token=';
    }
});

if (window.xchild && !window.paypalCheckout) {
    window.paypalCheckout = window.xchild;
}

function matchUrlAndPaymentToken(item) {

    if (!item || !item.trim()) {
        error('startflow_no_url_or_token', { item: item });
        throw new Error('startflow_no_url_or_token');
    }

    var paymentToken = Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* parseToken */])(item);
    var url = paymentToken && paymentToken === item ? '' : item;

    if (url) {

        if (!url.match(/^https?:\/\/|^\//)) {
            if (paymentToken) {
                info('startflow_relative_url_with_token', { url: url });
            } else {
                info('startflow_relative_url_no_token', { url: url });
            }

            if (url.toLowerCase().indexOf('ec-') === 0 && paymentToken) {
                url = '' + __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].checkoutUrl + url;
            }
        } else if (paymentToken) {
            if (url.indexOf('.paypal.com') !== -1) {
                debug('startflow_paypalurl_with_token', { url: url });
            } else {
                debug('startflow_url_with_token', { url: url });
            }
        } else {
            debug('startflow_url_no_token', { url: url });
        }
    } else {

        if (paymentToken) {
            url = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].checkoutUrl, { token: paymentToken });
            debug('startflow_with_token', { url: url });
        } else {
            error('startflow_no_url_or_token', { url: url });
            throw new Error('Could not determine url or token from "' + item + '"');
        }
    }

    return { paymentToken: paymentToken, url: url };
}

function checkUrlAgainstEnv(url) {

    var paypalUrls = __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].paypalUrls;

    for (var _iterator = Object.keys(paypalUrls), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var env = _ref;

        var paypalUrl = paypalUrls[env];

        if (env === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* ENV */].TEST || env === __WEBPACK_IMPORTED_MODULE_3__config__["d" /* ENV */].DEMO) {
            continue;
        }

        if (env !== __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env) {
            if (url.indexOf(paypalUrl) === 0 || url.indexOf(paypalUrl.replace('//www.', '//')) === 0) {
                warn('mismatched_env_startflow_url', { env: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env, url: url });
                Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(url);
                throw new Error(url + ' is not a ' + __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env + ' url');
            }
        }
    }
}

/*  Get Token
    ---------

    Normally in the component world, getToken would be a user-provided function which passes a callback, and expects
    that callback to be called with either an error, or an EC token.

    In our case, we can emulate these callback calls by setting over the startFlow and closeFlow globals, and using
    them as our success and failure cases.

    Note: this method is set to `precall: true` mode. This means that it will be called the moment the component is
    inited on the page. This means that the moment we initialize, we're ready to start accepting a token via one of the
    global methods.
*/

function awaitPaymentTokenAndUrl() {

    var paymentTokenAndUrl = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        checkout.initXO = function () {
            warn('gettoken_initxo');
        };

        // startFlow is our 'success' case - we get a token, and we can pass it back to the caller

        checkout.startFlow = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["L" /* once */])(function (item) {
            debug('gettoken_startflow', { item: item });

            var _matchUrlAndPaymentTo = matchUrlAndPaymentToken(item),
                url = _matchUrlAndPaymentTo.url,
                paymentToken = _matchUrlAndPaymentTo.paymentToken;

            checkUrlAgainstEnv(url);

            return resolve({ url: url, paymentToken: paymentToken });
        });
    });

    var url = paymentTokenAndUrl.then(function (result) {
        return result.url;
    });
    var paymentToken = paymentTokenAndUrl.then(function (result) {
        return result.paymentToken;
    });

    return { url: url, paymentToken: paymentToken };
}

/*  Init PayPal Checkout
    --------------------

    Initialize the Checkout component with some standard props:

    - Pass in env from global state (saved during setup() call)
    - Return to success url on payment authorize
    - Return to cancel url on cancel
*/

var paypalCheckoutInited = false;
var closeFlowCalled = false;

function initPayPalCheckout() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    info('init_checkout');

    if (paypalCheckoutInited && __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env !== __WEBPACK_IMPORTED_MODULE_3__config__["d" /* ENV */].TEST) {
        warn('multiple_init_paypal_checkout');
    }

    if (closeFlowCalled) {
        debug('init_after_closeflow');
    }

    paypalCheckoutInited = true;

    var paypalCheckout = __WEBPACK_IMPORTED_MODULE_2__components__["b" /* Checkout */].init(_extends({
        onAuthorize: function onAuthorize(data, actions) {
            info('payment_authorized');
            Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* logRedirect */])(data.returnUrl);
            return actions.redirect(window);
        },
        onCancel: function onCancel(data, actions) {
            info('payment_canceled');
            Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* logRedirect */])(data.cancelUrl);
            return actions.redirect(window);
        },
        fallback: function fallback(url) {
            error('fallback_handler', { url: url });
            this.destroy();
            return Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(url);
        }
    }, props));

    checkout.closeFlow = function (closeUrl) {
        warn('closeflow');

        closeFlowCalled = true;

        reset();

        paypalCheckout.destroy();

        if (closeUrl) {
            warn('closeflow_with_url', { closeUrl: closeUrl });
            return Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(closeUrl);
        }
    };

    return paypalCheckout;
}

function renderPayPalCheckout() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var hijackTarget = arguments[1];


    var urlProp = __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(props.url);

    var paymentToken = new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        props.init = function (data) {
            resolve(data.paymentToken);
        };
    });

    var errorHandler = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["L" /* once */])(function (err) {

        error('component_error', { error: err.stack || err.toString() });

        if (hijackTarget) {
            warn('render_error_hijack_revert_target');
            hijackTarget.removeAttribute('target');
        }

        // eslint-disable-next-line promise/catch-or-return, promise/no-promise-in-callback
        urlProp.then(function (url) {
            warn('render_error_redirect_using_url');
            return Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(url);
        });

        // eslint-disable-next-line promise/catch-or-return, promise/no-promise-in-callback
        paymentToken.then(function (token) {
            warn('render_error_redirect_using_token');
            return Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].checkoutUrl, { token: token }));
        });
    });

    props.onError = errorHandler;

    var paypalCheckout = void 0;

    if (hijackTarget) {

        delete props.url;

        paypalCheckout = initPayPalCheckout(props);

        paypalCheckout.hijack(hijackTarget);
        paypalCheckout.runTimeout();

        // eslint-disable-next-line promise/catch-or-return
        urlProp.then(function (url) {
            warn('hijack_then_url_passed');
            paypalCheckout.loadUrl(url);
        });
    } else {

        paypalCheckout = initPayPalCheckout(props);
    }

    var render = paypalCheckout.render(null, !hijackTarget);

    checkout.win = paypalCheckout.window;

    return render['catch'](errorHandler);
}

function handleClick(clickHandler, event) {
    debug('button_click_handler');

    try {
        clickHandler(event);
    } catch (err) {
        error('click_handler_error', { error: err.stack || err.toString() });
    }
}

function handleClickHijack(element) {

    var targetElement = Object(__WEBPACK_IMPORTED_MODULE_8__button__["a" /* getHijackTargetElement */])(element);

    if (!targetElement) {
        return error('target_element_not_found');
    }

    info('init_paypal_checkout_hijack');

    var _awaitPaymentTokenAnd = awaitPaymentTokenAndUrl(),
        url = _awaitPaymentTokenAnd.url,
        paymentToken = _awaitPaymentTokenAnd.paymentToken;

    var token = void 0;

    // eslint-disable-next-line promise/catch-or-return
    paymentToken.then(function (result) {
        token = result;
    });

    renderPayPalCheckout({ url: url, payment: function payment() {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(token);
        } }, targetElement);
}

function listenClick(container, button, clickHandler, condition, tracker) {

    var element = container.tagName.toLowerCase() === 'a' ? container : button;

    var isClick = clickHandler instanceof Function;

    if (element.hasAttribute('data-paypal-click-listener')) {
        return warn('button_already_has_paypal_click_listener');
    }

    element.setAttribute('data-paypal-click-listener', '');

    var targetElement = Object(__WEBPACK_IMPORTED_MODULE_8__button__["a" /* getHijackTargetElement */])(element);

    if (targetElement && isClick) {
        info('button_link_or_form');
    }

    element.addEventListener('click', function (event) {

        tracker();

        var eligible = Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__["a" /* isLegacyEligible */])();

        if (Object(__WEBPACK_IMPORTED_MODULE_4__lib__["W" /* supportsPopups */])()) {
            debug('click_popups_supported');

            if (!eligible) {
                debug('click_popups_supported_but_ineligible');
            }
        } else {
            debug('click_popups_not_supported');

            if (eligible) {
                debug('click_popups_not_supported_but_eligible');
            }
        }

        if (!isClick) {

            if (!eligible) {
                return debug('ineligible_listenclick');
            }
        }

        info('button_click');

        if (condition instanceof Function) {
            if (condition.call()) {
                info('button_click_condition_enabled');
            } else {
                return info('button_click_condition_disabled');
            }
        }

        if (isClick) {
            return handleClick(clickHandler, event);
        } else {
            return handleClickHijack(element);
        }
    });
}

function instrumentButtonRender(type) {
    var _track;

    info('render_' + type + '_button');

    track((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].STATE.LOAD, _track[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].TRANSITION.BUTTON_RENDER, _track[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.BUTTON_TYPE] = type, _track));

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["g" /* flush */])();
}

function instrumentButtonClick(type) {
    var _track2;

    track((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].STATE.LOAD, _track2[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].TRANSITION.BUTTON_CLICK, _track2[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.BUTTON_TYPE] = type, _track2));
    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["g" /* flush */])();
}

/*  Setup
    -----

    Emulate window.paypal.checkout.setup.

    The purpose of this method is to:

    - Set up configuration for the incontext flow
    - Render a button to initiate the checkout window
*/

var setupCalled = false;

function setup(id) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    id = id || 'merchant';

    info('setup', {
        id: id,
        env: options.environment,
        options: Object(__WEBPACK_IMPORTED_MODULE_4__lib__["S" /* safeJSON */])(options)
    });

    if (setupCalled) {
        debug('setup_called_multiple_times');
    }

    setupCalled = true;

    Object(__WEBPACK_IMPORTED_MODULE_10__options__["a" /* normalizeOptions */])(options);
    Object(__WEBPACK_IMPORTED_MODULE_10__options__["b" /* setupConfig */])(options);

    Object(__WEBPACK_IMPORTED_MODULE_5__postBridge__["a" /* setupPostBridge */])(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env);

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        // If there are no buttons passed, can only assume there's a custom paypal button with a custom listener

        if (!options.buttons.length) {
            return instrumentButtonRender(__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].BUTTON_TYPE.CUSTOM);
        }

        // Otherwise render whatever buttons we were asked to, and listen for them to be clicked

        return Object(__WEBPACK_IMPORTED_MODULE_8__button__["b" /* renderButtons */])(id, options.buttons).then(function (buttons) {

            buttons.forEach(function (button) {
                instrumentButtonRender(button.type);

                listenClick(button.container, button.element, button.click, button.condition, function () {
                    instrumentButtonClick(button.type);
                });
            });
        });
    });
}

checkout.setup = setup;

/*  Init XO
    -------

    Emulate paypal.checkout.initXO

    Normally this would be used only to open the checkout page. But here we can just kick off the whole flow, since
    getToken will handle loading the token into the window for us.
*/

function initXO() {

    debug('initxo');

    if (!Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__["a" /* isLegacyEligible */])()) {
        return debug('ineligible_initxo');
    }

    var _awaitPaymentTokenAnd2 = awaitPaymentTokenAndUrl(),
        url = _awaitPaymentTokenAnd2.url,
        paymentToken = _awaitPaymentTokenAnd2.paymentToken;

    info('init_paypal_checkout_initxo');

    renderPayPalCheckout({ url: url, payment: function payment() {
            return paymentToken;
        } });
}

checkout.initXO = initXO;

/*  Start Flow
    ----------

    Emulate paypal.checkout.startFlow

    Normally this would be used to load the url into the browser after the window has already been opened. Again, we
    can just kick off the whole flow here, on the off chance that a merchant calls us on button click. Normally this
    method will have been patched over in getToken.
*/

function startFlow(item) {
    debug('startflow', { item: item });

    var _matchUrlAndPaymentTo2 = matchUrlAndPaymentToken(item),
        paymentToken = _matchUrlAndPaymentTo2.paymentToken,
        url = _matchUrlAndPaymentTo2.url;

    checkUrlAgainstEnv(url);

    if (!Object(__WEBPACK_IMPORTED_MODULE_6__eligibility__["a" /* isLegacyEligible */])()) {
        debug('ineligible_startflow_global', { url: url });
        Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(url);
        return;
    }

    info('init_paypal_checkout_startflow');

    renderPayPalCheckout({ url: url, payment: function payment() {
            return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve(paymentToken);
        } });
}

checkout.startFlow = startFlow;

/*  Close Flow
    ----------

    Emulate paypal.checkout.closeFlow

    Close the component in case of any error on the merchant side.
*/

function closeFlow(closeUrl) {
    warn('closeflow_not_opened');

    if (closeUrl) {
        warn('closeflow_with_url', { closeUrl: closeUrl });
        Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* redirect */])(closeUrl);
    }
}

checkout.closeFlow = closeFlow;

/***/ }),

/***/ "./src/legacy/options.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeOptions;
/* harmony export (immutable) */ __webpack_exports__["b"] = setupConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common__ = __webpack_require__("./src/legacy/common.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./src/legacy/constants.js");








var _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* LOG_PREFIX */]),
    info = _prefix.info,
    warn = _prefix.warn;

function normalizeOptions(options) {

    // Normalize environment

    if (options.environment) {

        if (options.environment === 'live') {
            options.environment = __WEBPACK_IMPORTED_MODULE_1__config__["d" /* ENV */].PRODUCTION;
        }

        if (!__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].paypalUrls[options.environment]) {
            warn('invalid_env', { badenv: options.environment });
            options.environment = __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].env;
        }
    }

    // If we're passed a single button in options.button, turn it into an array

    if (options.button && !Array.isArray(options.button)) {
        info('options_button_single_button_passed');

        options.button = [options.button];
    }

    // If we're passed an array of elements in options.buttons, switch it over to options.button

    if (options.buttons && Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* getElements */])(options.buttons).length) {
        info('options_buttons_with_elements_passed');

        options.button = options.buttons;
        delete options.buttons;
    }

    // If we're passed an empty options.button array, clear the value

    if (options.button && options.button.length === 0) {
        info('options_button_empty');

        delete options.button;
    }

    // If we're passed options.button and options.container, concat both under button

    if (options.button && options.container) {
        info('options_button_and_container_passed', { button: options.button, container: options.container });

        options.button = options.button.concat(options.container);
        delete options.container;
    }

    // Normalize button selectors to elements

    if (options.button) {
        var button = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* getElements */])(options.button);

        if (button.length) {
            options.button = button;
        } else {
            warn('options_button_element_not_found', { element: JSON.stringify(options.button) });
            delete options.button;
        }
    }

    // Normalize options.button to options.buttons

    if (options.button) {

        options.buttons = options.button.map(function (button) {
            return {
                button: button,
                click: options.click,
                condition: options.condition
            };
        });

        delete options.click;
        delete options.condition;
        delete options.button;
    }

    // Normalize array of buttons

    else if (options.buttons && Array.isArray(options.buttons)) {

            var buttons = [];

            options.buttons.forEach(function (button) {

                if (!button) {
                    return;
                }

                if (button.container && button.container !== options.container) {
                    warn('mismatched_container_and_button_passed', { options: options.container, button: button.container });
                }

                Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* getElements */])(button.container || button.button).forEach(function (element) {
                    var _buttons$push;

                    buttons.push((_buttons$push = {}, _buttons$push[button.container ? 'container' : 'button'] = element, _buttons$push.click = button.click || options.click, _buttons$push.condition = button.condition || options.condition, _buttons$push.type = button.type || options.type, _buttons$push.locale = button.locale || options.locale, _buttons$push.color = button.color || options.color, _buttons$push.shape = button.shape || options.shape, _buttons$push.size = button.size || options.size, _buttons$push));
                });
            });

            delete options.buttons;
            delete options.click;
            delete options.condition;
            delete options.button;
            delete options.type;
            delete options.locale;
            delete options.color;
            delete options.shape;
            delete options.size;

            if (buttons.length) {
                options.buttons = buttons;
            }
        }

        // Otherwise normalize container into array of buttons

        else if (options.container && !Array.isArray(options.buttons)) {

                var _buttons = [];

                Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* getElements */])(options.container).forEach(function (container, i) {
                    _buttons.push({
                        container: container,
                        click: options.click,
                        condition: options.condition,
                        type: Array.isArray(options.type) ? options.type[i] : options.type,
                        locale: Array.isArray(options.locale) ? options.locale[i] : options.locale,
                        color: Array.isArray(options.color) ? options.color[i] : options.color,
                        shape: Array.isArray(options.shape) ? options.shape[i] : options.shape,
                        size: Array.isArray(options.size) ? options.size[i] : options.size
                    });
                });

                delete options.container;
                delete options.buttons;
                delete options.click;
                delete options.condition;
                delete options.button;
                delete options.type;
                delete options.locale;
                delete options.color;
                delete options.shape;
                delete options.size;

                if (_buttons.length) {
                    options.buttons = _buttons;
                }
            }

    if (!options.buttons) {
        options.buttons = [];
    }
}

function setupConfig(options) {

    if (options.environment && __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].paypalUrls[options.environment]) {
        __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].env = options.environment;
    }

    if (options.locale) {
        __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].locale = Object(__WEBPACK_IMPORTED_MODULE_3__common__["a" /* normalizeLocale */])(options.locale);
        __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].customCountry = true;
    }
}

/***/ }),

/***/ "./src/legacy/postBridge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setupPostBridge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__("./src/lib/index.js");







function setupPostBridge(env) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        var metaFrameDomain = __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].paypalDomains[env];

        if (!__WEBPACK_IMPORTED_MODULE_2_post_robot_src__["bridge"] || !__WEBPACK_IMPORTED_MODULE_2_post_robot_src__["bridge"].needsBridge({ domain: metaFrameDomain })) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["e" /* debug */])('post_bridge_not_required', { env: env });
        }

        Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["e" /* debug */])('setup_post_bridge', { env: env });

        return Object(__WEBPACK_IMPORTED_MODULE_4__lib__["M" /* openMetaFrame */])(env).then(__WEBPACK_IMPORTED_MODULE_4__lib__["I" /* noop */]);
    });
}

/***/ }),

/***/ "./src/legacy/ready.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("./src/legacy/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__interface__ = __webpack_require__("./src/legacy/interface.js");








var _prefix = Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LOG_PREFIX */]),
    error = _prefix.error,
    debug = _prefix.debug;

/*  PayPal Checkout Ready
    ---------------------

    Call window.paypalCheckoutReady on document ready, if it has been defined by the merchant
*/

function invokeReady(method) {

    Object(__WEBPACK_IMPORTED_MODULE_1__lib__["J" /* onDocumentReady */])(function () {
        debug('paypal_checkout_ready');
        setTimeout(function () {

            if (!window.paypal) {
                error('paypal_checkout_ready_no_window_paypal');
            }

            method();
        }, 1);
    });
}

Object(__WEBPACK_IMPORTED_MODULE_1__lib__["K" /* onKey */])(window, 'paypalCheckoutReady', function (method) {

    if (typeof method === 'function') {

        var oneTimeReady = function oneTimeReady() {
            if (!method.called) {
                method.called = true;
                return method.apply(this, arguments);
            }
        };

        invokeReady(oneTimeReady);

        return oneTimeReady;
    }
});

/*  Scan for buttons
    ----------------

    Scan for any buttons on the page with a data-paypal-button attribute and auto-attach the PaypalCheckout component to them
*/

Object(__WEBPACK_IMPORTED_MODULE_1__lib__["J" /* onDocumentReady */])(function () {

    var buttons = Array.prototype.slice.call(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ATTRIBUTES */].BUTTON + ']'));

    if (buttons && buttons.length) {
        debug('data_paypal_button', { number: buttons.length });

        for (var _iterator = buttons, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var button = _ref;


            var id = button.getAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ATTRIBUTES */].MERCHANT_ID);

            var environment = void 0;

            if (button.hasAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ATTRIBUTES */].ENV)) {
                environment = button.getAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ATTRIBUTES */].ENV);
            } else if (button.hasAttribute(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ATTRIBUTES */].SANDBOX)) {
                environment = __WEBPACK_IMPORTED_MODULE_2__config__["d" /* ENV */].SANDBOX;
            }

            Object(__WEBPACK_IMPORTED_MODULE_4__interface__["d" /* setup */])(id, { environment: environment, button: button });
        }
    }

    // Show hidden buttons

    Array.prototype.slice.call(document.getElementsByClassName(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CLASSES */].HIDDEN_BUTTON)).forEach(function (el) {
        el.className = el.className.replace(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CLASSES */].HIDDEN_BUTTON, '');
    });
});

/***/ }),

/***/ "./src/legacy/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logRedirect;
/* harmony export (immutable) */ __webpack_exports__["c"] = redirect;
/* unused harmony export isToken */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseToken;
/* unused harmony export hasToken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("./src/legacy/constants.js");








var _prefix = Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["m" /* prefix */])(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* LOG_PREFIX */]),
    warn = _prefix.warn;

var redirected = false;

function logRedirect(location) {

    if (redirected) {
        warn('multiple_redirects');
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* urlWillRedirectPage */])(location)) {
        redirected = true;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["g" /* flush */])();
}

function redirect(url) {
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (!url) {
            throw new Error('Redirect url undefined');
        }

        if (__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env === __WEBPACK_IMPORTED_MODULE_2__config__["d" /* ENV */].TEST && Object(__WEBPACK_IMPORTED_MODULE_3__lib__["Y" /* urlWillRedirectPage */])(url)) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* redirect */])(window, '#fullpageRedirect?url=' + url);
        }

        logRedirect(url);

        return Object(__WEBPACK_IMPORTED_MODULE_3__lib__["P" /* redirect */])(window, url);
    });
}

function isToken(item) {
    return Boolean(item && item.match(/^(EC-)?[A-Z0-9]{17}$/));
}

/*  Parse Token
    -----------

    We are passed either a token, or a url containing the token. In order to run the new checkout component we need to
    strip out the token from the url in order to pass it down as a prop
*/

function parseToken(token) {

    if (!token) {
        return;
    }

    token = decodeURIComponent(decodeURIComponent(token));

    // We may get lucky and be passed a token straight off the bar

    if (token.match(/^(EC-)?[A-Z0-9]{17}$/)) {
        return token;
    }

    // Otherwise strip the token from the url we're sent

    var match = token.match(/token=((EC-)?[A-Z0-9]{17})/);

    if (match) {
        return match[1];
    }

    match = token.match(/(EC-[A-Z0-9]{17})/);

    if (match) {
        return match[1];
    }
}

function hasToken(item) {
    return Boolean(parseToken(item));
}

/***/ }),

/***/ "./src/lib/beacon.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = beacon;
/* unused harmony export checkpoint */
/* unused harmony export fpti */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__("./src/lib/session.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var BEACON_URL = 'https://www.paypal.com/webapps/hermes/api/logger';

function beacon(event) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {

        payload.event = 'ppxo_' + event;
        payload.version = "4.0.173";
        payload.host = window.location.host;
        payload.uid = Object(__WEBPACK_IMPORTED_MODULE_1__session__["c" /* getSessionID */])();

        var query = [];

        for (var key in payload) {
            if (payload.hasOwnProperty(key)) {
                query.push(encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]));
            }
        }

        query = query.join('&');

        if (true) {
            var beaconImage = new window.Image();
            beaconImage.src = BEACON_URL + '?' + query;
        }

        setTimeout(function () {
            if (__WEBPACK_IMPORTED_MODULE_0__config__["n" /* config */].logLevel === __WEBPACK_IMPORTED_MODULE_0__config__["i" /* LOG_LEVEL */].DEBUG) {
                if (window.console && window.console.log) {
                    window.console.log('*', event, payload);
                }
            }
        }, 1);
    } catch (err) {
        // pass
    }
}

function isCheckpointUnique(name) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__session__["d" /* getSessionState */])(function (state) {
        state.loggedBeacons = state.loggedBeacons || [];

        if (state.loggedBeacons.indexOf(name) === -1) {
            state.loggedBeacons.push(name);
            return true;
        }

        return false;
    });
}

function checkpoint(name) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    try {
        var checkpointName = name;

        if (options.version) {
            var version = "4.0.173".replace(/[^0-9]+/g, '_');
            checkpointName = version + '_' + checkpointName;
        }

        if (!isCheckpointUnique(checkpointName)) {
            return;
        }

        return beacon(checkpointName, payload);
    } catch (err) {

        // pass
    }
}

var FPTI_URL = 'https://t.paypal.com/ts';

function buildPayload() {
    return {
        v: 'checkout.js.' + "4.0.173",
        t: Date.now(),
        g: new Date().getTimezoneOffset(),
        flnm: 'ec:hermes:',
        shir: 'main_ec_hermes_',
        pgrp: 'main:ec:hermes::incontext-merchant',
        page: 'main:ec:hermes::incontext-merchant',
        vers: 'member:hermes:',
        qual: 'incontext',
        tmpl: 'merchant:incontext'
    };
}

function fpti() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    var query = [];

    payload = _extends({}, buildPayload(), payload);

    for (var key in payload) {
        if (payload.hasOwnProperty(key)) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]));
        }
    }

    query = query.join('&');

    try {
        var beaconImage = new window.Image();
        beaconImage.src = FPTI_URL + '?' + query;
    } catch (err) {
        // pass
    }
}

/***/ }),

/***/ "./src/lib/device.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserAgent;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDevice;
/* unused harmony export isWebView */
/* unused harmony export isFacebookWebView */
/* unused harmony export isFirefoxIOS */
/* unused harmony export isOperaMini */
/* unused harmony export isAndroid */
/* harmony export (immutable) */ __webpack_exports__["f"] = isIos;
/* unused harmony export isGoogleSearchApp */
/* unused harmony export isQQBrowser */
/* unused harmony export isIosWebview */
/* unused harmony export isAndroidWebview */
/* harmony export (immutable) */ __webpack_exports__["c"] = isIE;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIECompHeader;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIEIntranet;
/* harmony export (immutable) */ __webpack_exports__["g"] = supportsPopups;
function getUserAgent() {
    return window.navigator.mockUserAgent || window.navigator.userAgent;
}

function isDevice() {
    var userAgent = getUserAgent();
    if (userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i)) {
        return true;
    }

    return false;
}

function isWebView() {
    var userAgent = getUserAgent();
    return (/(iPhone|iPod|iPad|Macintosh).*AppleWebKit(?!.*Safari)/i.test(userAgent) || /\bwv\b/.test(userAgent) || /Android.*Version\/(\d)\.(\d)/i.test(userAgent)
    );
}

function isFacebookWebView() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return ua.indexOf('FBAN') !== -1 || ua.indexOf('FBAV') !== -1;
}

function isFirefoxIOS() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return (/FxiOS/i.test(ua)
    );
}

function isOperaMini() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return ua.indexOf('Opera Mini') > -1;
}

function isAndroid() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return (/Android/.test(ua)
    );
}

function isIos() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return (/iPhone|iPod|iPad/.test(ua)
    );
}

function isGoogleSearchApp() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return (/\bGSA\b/.test(ua)
    );
}

function isQQBrowser() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return (/QQBrowser/.test(ua)
    );
}

function isIosWebview() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    if (isIos(ua)) {
        if (isGoogleSearchApp(ua)) {
            return true;
        }
        return (/.+AppleWebKit(?!.*Safari)/.test(ua)
        );
    }
    return false;
}

function isAndroidWebview() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    if (isAndroid(ua)) {
        return (/Version\/[\d.]+/.test(ua) && !isOperaMini(ua)
        );
    }
    return false;
}

function isIE() {

    if (window.document.documentMode) {
        return true;
    }

    return Boolean(window.navigator && window.navigator.userAgent && /Edge|MSIE/i.test(window.navigator.userAgent));
}

function isIECompHeader() {
    var mHttp = window.document.querySelector('meta[http-equiv="X-UA-Compatible"]');
    var mContent = window.document.querySelector('meta[content="IE=edge"]');
    if (mHttp && mContent) {
        return true;
    }
    return false;
}

function isIEIntranet() {

    // This status check only works for older versions of IE with document.documentMode set

    if (window.document.documentMode) {
        try {
            var status = window.status;

            window.status = 'testIntranetMode';

            if (window.status === 'testIntranetMode') {
                window.status = status;

                return true;
            }

            return false;
        } catch (err) {

            return false;
        }
    }

    return false;
}

function supportsPopups() {
    var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUserAgent();

    return !(isIosWebview(ua) || isAndroidWebview(ua) || isOperaMini(ua) || isFirefoxIOS(ua) || isFacebookWebView(ua) || isQQBrowser(ua));
}

/***/ }),

/***/ "./src/lib/dom.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return documentReady; });
/* unused harmony export documentBody */
/* harmony export (immutable) */ __webpack_exports__["j"] = loadScript;
/* unused harmony export isNodeList */
/* unused harmony export isElement */
/* harmony export (immutable) */ __webpack_exports__["d"] = getElement;
/* harmony export (immutable) */ __webpack_exports__["e"] = getElements;
/* harmony export (immutable) */ __webpack_exports__["k"] = onDocumentReady;
/* unused harmony export parseQuery */
/* harmony export (immutable) */ __webpack_exports__["g"] = getQueryParam;
/* harmony export (immutable) */ __webpack_exports__["m"] = urlWillRedirectPage;
/* harmony export (immutable) */ __webpack_exports__["b"] = extendUrl;
/* harmony export (immutable) */ __webpack_exports__["l"] = redirect;
/* unused harmony export hasMetaViewPort */
/* unused harmony export normalizeLocale */
/* unused harmony export normalizeLang */
/* harmony export (immutable) */ __webpack_exports__["c"] = getBrowserLocale;
/* harmony export (immutable) */ __webpack_exports__["i"] = isElementVisible;
/* unused harmony export enablePerformance */
/* harmony export (immutable) */ __webpack_exports__["f"] = getPageRenderTime;
/* harmony export (immutable) */ __webpack_exports__["h"] = getResourceLoadTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__device__ = __webpack_require__("./src/lib/device.js");








function isDocumentReady() {
    return Boolean(document.body) && document.readyState === 'complete';
}

var documentReady = new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

    if (isDocumentReady()) {
        return resolve();
    }

    var interval = setInterval(function () {
        if (isDocumentReady()) {
            clearInterval(interval);
            return resolve();
        }
    }, 10);
});

var documentBody = documentReady.then(function () {
    if (document.body) {
        return document.body;
    }

    throw new Error('Document ready but document.body not present');
});

function loadScript(src) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {
        var script = document.createElement('script');

        script.onload = function scriptOnLoad() {
            resolve();
        };

        // For Internet explorer 8 support
        script.onreadystatechange = function scriptOnReadyStateChange() {
            if (this.readyState === 'complete' || this.readyState === 'loaded') {
                resolve();
            }
        };

        var scriptLoadError = new Error('script_loading_error');

        script.onerror = function () {
            return reject(scriptLoadError);
        };

        if (timeout) {
            setTimeout(function () {
                return reject(new Error('script_loading_timed_out'));
            }, timeout);
        }

        for (var _iterator = Object.keys(attrs), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var attr = _ref;

            script.setAttribute(attr, attrs[attr]);
        }

        script.setAttribute('src', src);

        var head = document.getElementsByTagName('head')[0];

        head.appendChild(script);
    });
}

function isNodeList(nodes) {

    var result = Object.prototype.toString.call(nodes);

    if (result === '[object HTMLCollection]' || result === '[object NodeList]') {
        return true;
    }

    return false;
}

function isElement(item) {
    return item instanceof HTMLElement;
}

function getElement(item) {

    if (!item) {
        return;
    }

    if (item instanceof HTMLElement) {
        return item;
    }

    if (typeof item === 'string') {

        if (document.querySelector) {
            var result = document.querySelector(item);

            if (result) {
                return result;
            }
        }

        return document.getElementById(item);
    }
}

function getElements(collection) {

    if (!collection) {
        return [];
    }

    if (collection instanceof HTMLElement || typeof collection === 'string') {
        var element = getElement(collection);
        if (element) {
            return [element];
        }
        return [];
    }

    if (Array.isArray(collection) || collection instanceof NodeList || collection instanceof HTMLCollection) {
        var result = [];

        for (var i = 0; i < collection.length; i++) {
            var el = getElement(collection[i]);
            if (el) {
                result.push(el);
            }
        }

        return result;
    }

    return [];
}

function onDocumentReady(method) {
    return documentReady.then(method);
}

var parseQuery = Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* memoize */])(function (queryString) {

    var params = {};

    if (!queryString) {
        return params;
    }

    if (queryString.indexOf('=') === -1) {
        return params;
    }

    for (var _iterator2 = queryString.split('&'), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var pair = _ref2;

        pair = pair.split('=');

        if (pair[0] && pair[1]) {
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
    }

    return params;
});

function getQueryParam(name) {
    return parseQuery(window.location.search.slice(1))[name];
}

function urlWillRedirectPage(url) {

    if (url.indexOf('#') === -1) {
        return true;
    }

    if (url.indexOf('#') === 0) {
        return false;
    }

    if (url.split('#')[0] === window.location.href.split('#')[0]) {
        return false;
    }

    return true;
}

function extendUrl(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var hasHash = url.indexOf('#') > 0;

    var _url$split = url.split('#'),
        serverUrl = _url$split[0],
        hash = _url$split[1];

    if (hash && !serverUrl) {
        var _ref3 = ['#' + hash, ''];
        serverUrl = _ref3[0];
        hash = _ref3[1];
    }

    var _serverUrl$split = serverUrl.split('?'),
        originalUrl = _serverUrl$split[0],
        originalQueryString = _serverUrl$split[1];

    if (originalQueryString) {
        var originalQuery = parseQuery(originalQueryString);

        for (var _key in originalQuery) {
            if (!params.hasOwnProperty(_key)) {
                params[_key] = originalQuery[_key];
            }
        }
    }

    var newQueryString = Object.keys(params).filter(function (key) {
        return key && params[key];
    }).sort().map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    var newUrl = originalUrl;

    if (newQueryString) {
        newUrl = newUrl + '?' + newQueryString;
    }

    if (hasHash) {
        newUrl = newUrl + '#' + (hash || '');
    }

    return newUrl;
}

function redirect() {
    var win = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
    var url = arguments[1];

    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('redirect', { url: url });

        setTimeout(function () {
            win.location = url;
            if (!urlWillRedirectPage(url)) {
                resolve();
            }
        }, 1);
    });
}

function hasMetaViewPort() {
    var meta = document.querySelector('meta[name=viewport]');

    if (Object(__WEBPACK_IMPORTED_MODULE_4__device__["b" /* isDevice */])() && window.screen.width < 660 && !meta) {
        return false;
    }

    return true;
}

function normalizeLocale(locale) {

    if (locale && locale.match(/^[a-z]{2}[-_][A-Z]{2}$/)) {
        var _locale$split = locale.split(/[-_]/),
            lang = _locale$split[0],
            country = _locale$split[1];

        if (__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].locales[country] && __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].locales[country].indexOf(lang) !== -1) {
            return { country: country, lang: lang };
        }
    }
}

function normalizeLang(lang) {

    if (lang && lang.match(/^[a-z]{2}$/)) {
        if (__WEBPACK_IMPORTED_MODULE_2__config__["h" /* LANG_TO_DEFAULT_COUNTRY */][lang]) {
            return { country: __WEBPACK_IMPORTED_MODULE_2__config__["h" /* LANG_TO_DEFAULT_COUNTRY */][lang], lang: lang };
        }
    }
}

function getBrowserLocale() {

    var nav = window.navigator;

    var locales = nav.languages ? Array.prototype.slice.apply(nav.languages) : [];

    if (nav.language) {
        locales.push(nav.language);
    }

    if (nav.userLanguage) {
        locales.push(nav.userLanguage);
    }

    for (var _iterator3 = locales, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref4 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref4 = _i3.value;
        }

        var locale = _ref4;

        var loc = normalizeLocale(locale);
        if (loc) {
            return loc;
        }
    }

    for (var _iterator4 = locales, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref5 = _iterator4[_i4++];
        } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref5 = _i4.value;
        }

        var _locale = _ref5;

        var _loc = normalizeLang(_locale);
        if (_loc) {
            return _loc;
        }
    }

    return __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].defaultLocale;
}

function isElementVisible(el) {
    return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

var enablePerformance = Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* memoize */])(function () {
    return Boolean(window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1000 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0);
});

function getPageRenderTime() {
    return documentReady.then(function () {

        if (!enablePerformance()) {
            return;
        }

        var timing = window.performance.timing;

        if (timing.connectEnd && timing.domInteractive) {
            return timing.domInteractive - timing.connectEnd;
        }
    });
}

function getResourceLoadTime(url) {

    if (!enablePerformance()) {
        return;
    }

    if (!window.performance || typeof window.performance.getEntries !== 'function') {
        return;
    }

    var entries = window.performance.getEntries();

    for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];

        if (entry && entry.name === url && entry.duration && entry.duration >= 0 && entry.duration <= 60000) {
            return Math.floor(entry.duration);
        }
    }
}

/***/ }),

/***/ "./src/lib/eligibility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isEligible;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkRecognizedBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__device__ = __webpack_require__("./src/lib/device.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js");







var bowserCache = {};

function getBowser() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$clearCache = _ref.clearCache,
        clearCache = _ref$clearCache === undefined ? false : _ref$clearCache;

    var userAgent = Object(__WEBPACK_IMPORTED_MODULE_2__device__["a" /* getUserAgent */])();

    if (bowserCache[userAgent]) {
        return bowserCache[userAgent];
    }

    if (clearCache) {
        delete __webpack_require__.c[/*require.resolve*/("./node_modules/bowser/bowser.min.js")];
    }

    var bowser = __webpack_require__("./node_modules/bowser/bowser.min.js");

    bowserCache[userAgent] = bowser;

    return bowser;
}

function isBrowserEligible() {

    if (Object(__WEBPACK_IMPORTED_MODULE_2__device__["e" /* isIEIntranet */])()) {
        return false;
    }

    var bowser = getBowser({ clearCache: true });

    for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].SUPPORTED_BROWSERS), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var browser = _ref2;

        if (bowser[browser] && bowser.version) {
            if (bowser[browser] && bowser.compareVersions([bowser.version, __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].SUPPORTED_BROWSERS[browser]]) === -1) {
                return false;
            }
        }
    }

    return true;
}

var eligibilityResults = {};

function isEligible() {

    if (Object(__WEBPACK_IMPORTED_MODULE_2__device__["e" /* isIEIntranet */])()) {
        return false;
    }

    var userAgent = window.navigator.userAgent;

    if (userAgent && eligibilityResults.hasOwnProperty(userAgent)) {
        return eligibilityResults[userAgent];
    }

    var result = isBrowserEligible();

    eligibilityResults[userAgent] = result;

    return result;
}

var checkRecognizedBrowser = Object(__WEBPACK_IMPORTED_MODULE_3__util__["l" /* once */])(function (state) {

    var bowser = getBowser();

    for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].SUPPORTED_BROWSERS), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref3 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref3 = _i2.value;
        }

        var browser = _ref3;

        if (bowser[browser]) {
            return;
        }
    }

    var name = bowser.name,
        version = bowser.version,
        mobile = bowser.mobile,
        android = bowser.android,
        ios = bowser.ios;

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('unrecognized_browser_' + state, { name: name, version: version, mobile: mobile, android: android, ios: ios });
    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */])();
});

/***/ }),

/***/ "./src/lib/errors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = checkForDeprecatedIntegration;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkForCommonErrors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device__ = __webpack_require__("./src/lib/device.js");




function logWarn(err) {
    if (window.console) {
        if (window.console.warn) {
            return window.console.warn(err);
        }

        if (window.console.log) {
            return window.console.log(err);
        }
    }
}

function checkForDeprecatedIntegration() {
    var scripts = Array.prototype.slice.call(document.getElementsByTagName('script'));

    for (var _iterator = scripts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var script = _ref;

        if (script.attributes.type && script.attributes.type.value === 'application/x-component') {
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('deprecated_integration_application_xcomponent');

            // eslint-disable-next-line no-console
            console.error('\n                This integration pattern using \'<script type="application/x-component">\' is no longer supported.\n                Please visit https://developer.paypal.com/demo/checkout-v4/\n                for an example of the new recommended integration pattern.\n            ');
        }
    }
}

function checkForCommonErrors() {

    if (JSON.stringify([]) !== '[]') {
        if (Array.prototype.toJSON) {
            logWarn('Custom Array.prototype.toJSON is causing incorrect json serialization of arrays. This is likely to cause issues. Probable cause is Prototype.js');
        } else {
            logWarn('JSON.stringify is doing incorrect serialization of arrays. This is likely to cause issues.');
        }

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('json_stringify_array_broken');
    }

    if (JSON.stringify({}) !== '{}') {
        logWarn('JSON.stringify is doing incorrect serialization of objects. This is likely to cause issues.');

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('json_stringify_object_broken');
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__device__["e" /* isIEIntranet */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('ie_intranet_mode');
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__device__["c" /* isIE */])() && !Object(__WEBPACK_IMPORTED_MODULE_1__device__["d" /* isIECompHeader */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('ie_meta_compatibility_header_missing', {
            message: 'Drop tag: <meta http-equiv="X-UA-Compatible" content="IE=edge">' });
    }

    // eslint-disable-next-line no-unused-vars
    function foo(bar, baz, zomg) {
        // pass;
    }

    if (foo.bind({ a: 1 }).length !== 3) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('function_bind_arrity_overwritten');
    }

    if (window.opener && window.parent !== window) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('window_has_opener_and_parent');
    }

    if (window.name && window.name.indexOf('__prerender') === 0) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('prerender_running_checkoutjs');
    }
}

/***/ }),

/***/ "./src/lib/funding.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRememberedFunding;
/* harmony export (immutable) */ __webpack_exports__["d"] = rememberFunding;
/* harmony export (immutable) */ __webpack_exports__["b"] = isFundingRemembered;
/* harmony export (immutable) */ __webpack_exports__["c"] = precacheRememberedFunding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_constants__ = __webpack_require__("./src/config/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__session__ = __webpack_require__("./src/lib/session.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__device__ = __webpack_require__("./src/lib/device.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__meta__ = __webpack_require__("./src/lib/meta.js");








function getRememberedFunding(handler) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__session__["e" /* getStorageState */])(function (storage) {
        storage.rememberedFunding = storage.rememberedFunding || [];
        return handler(storage.rememberedFunding);
    });
}

function hasRememberedFunding(source) {

    if (getRememberedFunding(function (rememberedFunding) {
        return rememberedFunding.indexOf(source) !== -1;
    })) {
        return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2__session__["d" /* getSessionState */])(function (session) {
        return session.recentlyCheckedRemembered;
    })) {
        return true;
    }

    return false;
}

function isRememberedFunding(source) {

    if (getRememberedFunding(function (rememberedFunding) {
        return rememberedFunding.indexOf(source) !== -1;
    })) {
        return true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2__session__["d" /* getSessionState */])(function (session) {
        return session.recentlyCheckedRemembered;
    })) {
        return false;
    }

    throw new Error('Can not find remembered funding result');
}

function getRememberedFundingPromises() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__session__["b" /* getGlobalState */])(function (global) {
        global.rememberFundingPromises = global.rememberFundingPromises || {};
        return global.rememberFundingPromises;
    });
}

function getRememberedFundingPromise(source) {
    var promises = getRememberedFundingPromises();
    var promise = promises[source] = promises[source] || new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]();
    if (hasRememberedFunding(source)) {
        promise.resolve(isRememberedFunding(source));
    }
    return promise;
}

function flushRememberedFundingPromises() {
    var promises = getRememberedFundingPromises();
    var rememberedFunding = getRememberedFunding(function (sources) {
        return sources;
    });

    for (var _iterator = Object.keys(promises), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var source = _ref;

        promises[source].resolve(rememberedFunding.indexOf(source) !== -1);
    }
}

function rememberFunding(sources) {
    getRememberedFunding(function (rememberedFunding) {
        for (var _iterator2 = sources, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var source = _ref2;


            if (source === __WEBPACK_IMPORTED_MODULE_1__config_constants__["g" /* FUNDING */].VENMO && !Object(__WEBPACK_IMPORTED_MODULE_3__device__["b" /* isDevice */])()) {
                continue;
            }

            if (rememberedFunding.indexOf(source) === -1) {
                rememberedFunding.push(source);
            }

            flushRememberedFundingPromises();
        }
    });

    Object(__WEBPACK_IMPORTED_MODULE_2__session__["d" /* getSessionState */])(function (session) {
        session.recentlyCheckedRemembered = true;
    });
}

function loadMeta() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__meta__["a" /* openMetaFrame */])().then(function (_ref3) {
        var rememberedFunding = _ref3.rememberedFunding;

        rememberFunding(rememberedFunding || []);
    });
}

function isFundingRemembered() {
    var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__config_constants__["g" /* FUNDING */].PAYPAL;


    if (hasRememberedFunding(source)) {
        return getRememberedFundingPromise(source);
    }

    return loadMeta().then(function () {
        return getRememberedFundingPromise(source);
    });
}

function precacheRememberedFunding() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__session__["d" /* getSessionState */])(function (session) {
        return session.recentlyCheckedRemembered;
    })) {
        return loadMeta();
    }
    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve();
}

/***/ }),

/***/ "./src/lib/http.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




var HEADERS = {
    CONTENT_TYPE: 'content-type',
    ACCEPT: 'accept'
};

var headerBuilders = [];
var corrids = [];

Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["b" /* addPayloadBuilder */])(function () {
    return {
        prev_corr_ids: corrids.join(',')
    };
});

function parseHeaders() {
    var rawHeaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var result = {};
    for (var _iterator = rawHeaders.trim().split('\n'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var line = _ref;

        var _line$split = line.split(':'),
            _key = _line$split[0],
            values = _line$split.slice(1);

        result[_key.toLowerCase()] = values.join(':').trim();
    }
    return result;
}

function request(_ref2) {
    var url = _ref2.url,
        _ref2$method = _ref2.method,
        method = _ref2$method === undefined ? 'get' : _ref2$method,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === undefined ? {} : _ref2$headers,
        json = _ref2.json,
        data = _ref2.data,
        body = _ref2.body,
        _ref2$win = _ref2.win,
        win = _ref2$win === undefined ? window : _ref2$win,
        _ref2$timeout = _ref2.timeout,
        timeout = _ref2$timeout === undefined ? 0 : _ref2$timeout;


    if (url === '/demo/checkout/api/braintree/client-token/') {
        // $FlowFixMe
        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */].resolve('eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJjMDFhZmRkM2Y1OTJmNWVhNTNlMzE5MWQwYmIyMWVjYjM5NzNlZGM1MzkwNDZiMjJmNTA2ODEyNzIzZmRlMTJifGNsaWVudF9pZD1jbGllbnRfaWQkc2FuZGJveCQ0ZHByYmZjNnBoNTk1Y2NqXHUwMDI2Y3JlYXRlZF9hdD0yMDE3LTA0LTI2VDIzOjI2OjU5Ljg3OTA3ODYwNiswMDAwXHUwMDI2bWVyY2hhbnRfaWQ9M3cydHR2d2QyNDY1NDhoZCIsImNvbmZpZ1VybCI6Imh0dHBzOi8vYXBpLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb206NDQzL21lcmNoYW50cy8zdzJ0dHZ3ZDI0NjU0OGhkL2NsaWVudF9hcGkvdjEvY29uZmlndXJhdGlvbiIsImNoYWxsZW5nZXMiOltdLCJlbnZpcm9ubWVudCI6InNhbmRib3giLCJjbGllbnRBcGlVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvM3cydHR2d2QyNDY1NDhoZC9jbGllbnRfYXBpIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9jbGllbnQtYW5hbHl0aWNzLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20vM3cydHR2d2QyNDY1NDhoZCJ9LCJ0aHJlZURTZWN1cmVFbmFibGVkIjpmYWxzZSwicGF5cGFsRW5hYmxlZCI6dHJ1ZSwicGF5cGFsIjp7ImRpc3BsYXlOYW1lIjoiYmFyY28uMDMtZmFjaWxpdGF0b3JAZ21haWwuY29tIiwiY2xpZW50SWQiOiJBV3VZdnFnMGtaN2Y5S0V4TVpqZU53T3RjQV8yZVhnOWpMZy1QSnBGX0pnYk44M0YyVml5aEdnV2JCNDg4RGU3MFpucGRBZEI2TUNqekNqSyIsInByaXZhY3lVcmwiOiJodHRwczovL2V4YW1wbGUuY29tIiwidXNlckFncmVlbWVudFVybCI6Imh0dHBzOi8vZXhhbXBsZS5jb20iLCJiYXNlVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhc3NldHNVcmwiOiJodHRwczovL2NoZWNrb3V0LnBheXBhbC5jb20iLCJkaXJlY3RCYXNlVXJsIjpudWxsLCJhbGxvd0h0dHAiOnRydWUsImVudmlyb25tZW50Tm9OZXR3b3JrIjpmYWxzZSwiZW52aXJvbm1lbnQiOiJvZmZsaW5lIiwidW52ZXR0ZWRNZXJjaGFudCI6ZmFsc2UsImJyYWludHJlZUNsaWVudElkIjoibWFzdGVyY2xpZW50MyIsImJpbGxpbmdBZ3JlZW1lbnRzRW5hYmxlZCI6dHJ1ZSwibWVyY2hhbnRBY2NvdW50SWQiOiJVU0QiLCJjdXJyZW5jeUlzb0NvZGUiOiJVU0QifSwiY29pbmJhc2VFbmFibGVkIjpmYWxzZSwibWVyY2hhbnRJZCI6IjN3MnR0dndkMjQ2NTQ4aGQiLCJ2ZW5tbyI6Im9mZiJ9');
    }

    return new __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve, reject) {

        if (json && data || json && body || data && json) {
            throw new Error('Only options.json or options.data or options.body should be passed');
        }

        var normalizedHeaders = {};

        for (var _iterator2 = Object.keys(headers), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref3 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref3 = _i2.value;
            }

            var _key3 = _ref3;

            normalizedHeaders[_key3.toLowerCase()] = headers[_key3];
        }

        if (json) {
            normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || 'application/json';
        } else if (data || body) {
            normalizedHeaders[HEADERS.CONTENT_TYPE] = normalizedHeaders[HEADERS.CONTENT_TYPE] || 'application/x-www-form-urlencoded; charset=utf-8';
        }

        normalizedHeaders[HEADERS.ACCEPT] = normalizedHeaders[HEADERS.ACCEPT] || 'application/json';

        for (var _iterator3 = headerBuilders, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref4;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref4 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref4 = _i3.value;
            }

            var headerBuilder = _ref4;

            var builtHeaders = headerBuilder();

            for (var _iterator4 = Object.keys(builtHeaders), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref5;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref5 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref5 = _i4.value;
                }

                var _key4 = _ref5;

                normalizedHeaders[_key4.toLowerCase()] = builtHeaders[_key4];
            }
        }

        var xhr = new win.XMLHttpRequest();

        xhr.addEventListener('load', function xhrLoad() {

            var responseHeaders = parseHeaders(this.getAllResponseHeaders());
            var corrID = responseHeaders['paypal-debug-id'] || 'unknown';

            if (responseHeaders['paypal-debug-id']) {
                corrids.push(responseHeaders['paypal-debug-id']);
            }

            if (!this.status) {
                return reject(new Error('Request to ' + method.toLowerCase() + ' ' + url + ' failed: no response status code. Correlation id: ' + corrID));
            }

            var contentType = responseHeaders['content-type'];
            var isJSON = contentType && (contentType.indexOf('application/json') === 0 || contentType.indexOf('text/json') === 0);
            var res = this.responseText;

            try {
                res = JSON.parse(this.responseText);
            } catch (err) {
                if (isJSON) {
                    return reject(new Error('Invalid json: ' + this.responseText + '. Correlation id: ' + corrID));
                }
            }

            if (this.status >= 400) {
                var message = 'Request to ' + method.toLowerCase() + ' ' + url + ' failed with ' + this.status + ' error. Correlation id: ' + corrID;

                if (res) {
                    if ((typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && res !== null) {
                        res = JSON.stringify(res, null, 4);
                    }

                    message = message + '\n\n' + res + '\n';
                }

                return reject(new Error(message));
            }

            return resolve(res);
        }, false);

        xhr.addEventListener('error', function xhrError(evt) {
            var corrID = this.getResponseHeader('paypal-debug-id');
            reject(new Error('Request to ' + method.toLowerCase() + ' ' + url + ' failed: ' + evt.toString() + '. Correlation id: ' + corrID));
        }, false);

        xhr.open(method, url, true);

        for (var _key2 in normalizedHeaders) {
            if (normalizedHeaders.hasOwnProperty(_key2)) {
                xhr.setRequestHeader(_key2, normalizedHeaders[_key2]);
            }
        }

        if (json) {
            body = JSON.stringify(json);
        } else if (data) {
            body = Object.keys(data).map(function (key) {
                return encodeURIComponent(key) + '=' + (data ? encodeURIComponent(data[key]) : '');
            }).join('&');
        }

        xhr.timeout = timeout;
        xhr.ontimeout = function xhrTimeout() {
            reject(new Error('Request to ' + method.toLowerCase() + ' ' + url + ' has timed out'));
        };

        xhr.send(body);
    });
}

request.get = function (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return request(_extends({ method: 'get', url: url }, options));
};

request.post = function (url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return request(_extends({ method: 'post', url: url, data: data }, options));
};

request.addHeaderBuilder = function (method) {
    headerBuilders.push(method);
};

/***/ }),

/***/ "./src/lib/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__device__ = __webpack_require__("./src/lib/device.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__device__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__device__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__device__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__device__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__device__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/lib/util.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_1__util__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__("./src/lib/logger.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2__logger__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_2__logger__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eligibility__ = __webpack_require__("./src/lib/eligibility.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__eligibility__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__eligibility__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__("./src/lib/errors.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__errors__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__errors__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom__ = __webpack_require__("./src/lib/dom.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_5__dom__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__http__ = __webpack_require__("./src/lib/http.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_6__http__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__beacon__ = __webpack_require__("./src/lib/beacon.js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__throttle__ = __webpack_require__("./src/lib/throttle.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__throttle__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__throttle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__namespace__ = __webpack_require__("./src/lib/namespace.js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__session__ = __webpack_require__("./src/lib/session.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__session__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_10__session__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_10__session__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__proxy__ = __webpack_require__("./src/lib/proxy.js");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__meta__ = __webpack_require__("./src/lib/meta.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_12__meta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__funding__ = __webpack_require__("./src/lib/funding.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__funding__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__funding__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_13__funding__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_13__funding__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__script__ = __webpack_require__("./src/lib/script.js");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_14__script__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_14__script__["b"]; });
















/***/ }),

/***/ "./src/lib/logger.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initLogger;
/* harmony export (immutable) */ __webpack_exports__["b"] = setLogLevel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__("./src/lib/session.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__proxy__ = __webpack_require__("./src/lib/proxy.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dom__ = __webpack_require__("./src/lib/dom.js");











function getRefererDomain() {
    return window.xchild && window.xchild.getParentDomain ? window.xchild.getParentDomain() : window.location.host;
}

var setupProxyLogTransport = Object(__WEBPACK_IMPORTED_MODULE_6__util__["l" /* once */])(function () {
    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["n" /* setTransport */])(Object(__WEBPACK_IMPORTED_MODULE_5__proxy__["a" /* proxyMethod */])('log', Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["l" /* getParent */])(window), Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["h" /* getTransport */])()));
});

function getToken() {
    if (window.root && window.root.token) {
        return window.root.token;
    }

    var queryToken = Object(__WEBPACK_IMPORTED_MODULE_7__dom__["g" /* getQueryParam */])('token');

    if (queryToken) {
        return queryToken;
    }
}

function initLogger() {

    setupProxyLogTransport();

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["b" /* addPayloadBuilder */])(function () {
        return {
            referer: getRefererDomain(),
            host: window.location.host,
            path: window.location.pathname,
            env: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].env,
            country: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].locale.country,
            lang: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].locale.lang,
            uid: Object(__WEBPACK_IMPORTED_MODULE_4__session__["c" /* getSessionID */])(),
            ver: "4.0.173"
        };
    });

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["a" /* addMetaBuilder */])(function () {
        return {
            state: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].state
        };
    });

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["c" /* addTrackingBuilder */])(function () {
        var _ref;

        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        var sessionID = Object(__WEBPACK_IMPORTED_MODULE_4__session__["c" /* getSessionID */])();
        var paymentToken = getToken();
        var buttonSessionID = payload[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] || Object(__WEBPACK_IMPORTED_MODULE_4__session__["a" /* getButtonSessionID */])();

        var contextType = void 0;
        var contextID = void 0;

        if (paymentToken) {
            contextType = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].CONTEXT_TYPE[__WEBPACK_IMPORTED_MODULE_3__config__["j" /* PAYMENT_TYPE */].EC_TOKEN];
            contextID = paymentToken;
        } else if (buttonSessionID) {
            contextType = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].CONTEXT_TYPE.BUTTON_SESSION_ID;
            contextID = buttonSessionID;
        } else {
            contextType = payload[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.CONTEXT_TYPE];
            contextID = payload[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.CONTEXT_ID];
        }

        return _ref = {}, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.FEED] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].FEED.CHECKOUTJS, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.DATA_SOURCE] = __WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].DATA_SOURCE.CHECKOUT, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.CONTEXT_TYPE] = contextType, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.CONTEXT_ID] = contextID, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.SELLER_ID] = __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].merchantID, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.SESSION_UID] = sessionID, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.BUTTON_SESSION_UID] = buttonSessionID, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.VERSION] = __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].version, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.TOKEN] = paymentToken, _ref[__WEBPACK_IMPORTED_MODULE_3__config__["e" /* FPTI */].KEY.REFERER] = getRefererDomain(), _ref;
    });

    var prefix = 'ppxo';

    if (Object(__WEBPACK_IMPORTED_MODULE_6__util__["d" /* getDomainSetting */])('log_domain_prefix')) {
        prefix = prefix + '_' + window.location.host.replace(/[^a-zA-Z0-9_]/g, '_').replace(/^www_/, '').replace(/_com$/, '');
    }

    Object(__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["k" /* init */])({
        uri: __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].loggerUrl,
        heartbeat: false,
        logPerformance: false,
        prefix: prefix,
        logLevel: "warn"
    });
}

function setLogLevel(logLevel) {

    if (__WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["l" /* logLevels */].indexOf(logLevel) === -1) {
        throw new Error('Invalid logLevel: ' + logLevel);
    }

    __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].logLevel = logLevel;
    __WEBPACK_IMPORTED_MODULE_1_beaver_logger_client__["d" /* config */].logLevel = logLevel;
    __WEBPACK_IMPORTED_MODULE_0_post_robot_src__["CONFIG"].LOG_LEVEL = logLevel;
    window.LOG_LEVEL = logLevel;
}

/***/ }),

/***/ "./src/lib/meta.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openMetaFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__device__ = __webpack_require__("./src/lib/device.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__script__ = __webpack_require__("./src/lib/script.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom__ = __webpack_require__("./src/lib/dom.js");










var openMetaFrame = Object(__WEBPACK_IMPORTED_MODULE_4__util__["i" /* memoize */])(function () {
    var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env;

    return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {

        if (Object(__WEBPACK_IMPORTED_MODULE_3__device__["e" /* isIEIntranet */])()) {
            return {
                iframeEligible: false,
                iframeEligibleReason: 'ie_intranet',
                rememberedFunding: []
            };
        }

        var metaFrameUrl = __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].metaFrameUrls[env];
        var metaFrameDomain = __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalDomains[env];

        return __WEBPACK_IMPORTED_MODULE_0_zalgo_promise_src__["a" /* ZalgoPromise */]['try'](function () {
            if (__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"]) {
                return __WEBPACK_IMPORTED_MODULE_1_post_robot_src__["bridge"].openBridge(Object(__WEBPACK_IMPORTED_MODULE_6__dom__["b" /* extendUrl */])(metaFrameUrl, { version: Object(__WEBPACK_IMPORTED_MODULE_5__script__["b" /* getScriptVersion */])() }), metaFrameDomain).then(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* noop */]);
            } else {
                throw new Error('Opening meta window without bridge support is not currently supported');
            }
        }).then(function (win) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_post_robot_src__["once"])('meta', { domain: metaFrameDomain, window: win });
        }).then(function (_ref) {
            var data = _ref.data;

            return data;
        });
    });
});

/***/ }),

/***/ "./src/lib/namespace.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extendNamespace;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function extendNamespace(xports) {
    var namespaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var childnamespaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];


    for (var _iterator = namespaces, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var name = _ref;

        var namespace = window[name];

        if (!namespace) {
            continue;
        }

        for (var _iterator3 = childnamespaces, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _extends2;

            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var childname = _ref3;

            var childnamespace = xports[childname];

            if (namespace[childname]) {
                childnamespace = _extends({}, namespace[childname], childnamespace);
            }

            xports = _extends({}, namespace, xports, (_extends2 = {}, _extends2[childname] = childnamespace, _extends2));
        }
    }

    for (var _iterator2 = namespaces, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var _name = _ref2;

        window[_name] = xports;
    }

    return xports;
}

/***/ }),

/***/ "./src/lib/pptm.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPptmScript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom__ = __webpack_require__("./src/lib/dom.js");







function createPptmScript() {
    var _track;

    var id = window.location.hostname;

    if (!id) {
        return;
    }

    var alreadyDownloaded = Boolean(Object(__WEBPACK_IMPORTED_MODULE_3__dom__["d" /* getElement */])(__WEBPACK_IMPORTED_MODULE_1__config__["k" /* PPTM_ID */]));

    if (alreadyDownloaded) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('pptm_tried_loading_twice');
        return;
    }

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].STATE.PPTM, _track[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].TRANSITION.PPTM_LOAD, _track));

    // Works essentially as a NOOP until opt-in
    var fullUrl = Object(__WEBPACK_IMPORTED_MODULE_3__dom__["b" /* extendUrl */])(__WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].pptmUrl, {
        t: 'xo',
        id: window.location.hostname,
        mrid: __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].merchantID
    });

    Object(__WEBPACK_IMPORTED_MODULE_3__dom__["j" /* loadScript */])(fullUrl, 0, { async: true, id: __WEBPACK_IMPORTED_MODULE_1__config__["k" /* PPTM_ID */] }).then(function () {
        var _track2;

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].STATE.PPTM, _track2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].TRANSITION.PPTM_LOADED, _track2));
    })['catch'](function (err) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["f" /* error */])('pptm_script_error', { error: Object(__WEBPACK_IMPORTED_MODULE_2__util__["o" /* stringifyError */])(err) });
    });
}

/***/ }),

/***/ "./src/lib/proxy.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = proxyMethod;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_post_robot_src__ = __webpack_require__("./node_modules/post-robot/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./src/lib/util.js");







function proxyMethod(name, win, originalMethod) {

    if (win && Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["f" /* getDomain */])() === __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalDomain && !Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["u" /* isSameDomain */])(win)) {

        if (win) {
            Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["send"])(win, 'proxy_' + name, { originalMethod: originalMethod })['catch'](__WEBPACK_IMPORTED_MODULE_3__util__["j" /* noop */]);
        }

        return originalMethod;
    }

    var methods = [];

    Object(__WEBPACK_IMPORTED_MODULE_0_post_robot_src__["on"])('proxy_' + name, { domain: __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypal_domain_regex }, function (_ref) {
        var data = _ref.data;

        methods.push(data.originalMethod);
    });

    return function postMessageProxy() {
        var _this = this,
            _arguments = arguments;

        methods = methods.filter(function (method) {
            return !Object(__WEBPACK_IMPORTED_MODULE_1_cross_domain_utils_src__["y" /* isWindowClosed */])(method.source);
        });

        if (methods.length) {
            return methods[methods.length - 1].apply(this, arguments)['catch'](function () {
                return originalMethod.apply(_this, _arguments);
            });
        }

        return originalMethod.apply(this, arguments);
    };
}

/***/ }),

/***/ "./src/lib/script.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentScript; });
/* unused harmony export isPayPalObjects */
/* harmony export (immutable) */ __webpack_exports__["b"] = getScriptVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js");






var getCurrentScript = Object(__WEBPACK_IMPORTED_MODULE_2__util__["i" /* memoize */])(function () {

    var scripts = Array.prototype.slice.call(document.getElementsByTagName('script'));

    for (var _iterator = scripts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var script = _ref;

        if (script.src && (script.src.replace(/^https?:/, '').split('?')[0] === __WEBPACK_IMPORTED_MODULE_1__config__["n" /* config */].scriptUrl || script.hasAttribute('data-paypal-checkout'))) {
            return script;
        }

        if (script.src && script.src.indexOf('paypal.checkout.v4.js') !== -1) {
            return script;
        }
    }

    if (document.currentScript) {
        // eslint-disable-line compat/compat
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_not_recognized', { src: document.currentScript.src }); // eslint-disable-line compat/compat
    }
});

function isPayPalObjects() {
    return Boolean(getCurrentScript());
}

function getScriptVersion() {
    if (isPayPalObjects() && true) {
        return  false ? 'min' : "4";
    } else {
        return  false ? __MINOR_VERSION__ + '.min' : "4.0.173";
    }
}

/***/ }),

/***/ "./src/lib/session.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getStorageState;
/* unused harmony export getSession */
/* harmony export (immutable) */ __webpack_exports__["d"] = getSessionState;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSessionID;
/* harmony export (immutable) */ __webpack_exports__["a"] = getButtonSessionID;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGlobalState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__("./src/lib/dom.js");





var LOCAL_STORAGE_KEY = '__paypal_storage__';
var SESSION_KEY = '__paypal_session__';
var GLOBAL_KEY = '__paypal_global__';

var accessedStorage = void 0;

function getStorageState(handler) {

    var enabled = Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isLocalStorageEnabled */])();
    var storage = void 0;

    if (accessedStorage) {
        storage = accessedStorage;
    } else {

        if (enabled) {
            var rawStorage = window.localStorage.getItem(LOCAL_STORAGE_KEY);

            if (rawStorage) {
                storage = JSON.parse(rawStorage);
            } else {
                storage = {};
            }
        } else {
            storage = window[LOCAL_STORAGE_KEY] = window.__pp_localstorage__ || {};
        }
    }

    accessedStorage = storage;

    var result = handler(storage);

    if (enabled) {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
    } else {
        window[LOCAL_STORAGE_KEY] = storage;
    }

    accessedStorage = null;

    return result;
}

function getSession(handler) {
    return getStorageState(function (storage) {

        var session = storage[SESSION_KEY];
        var now = Date.now();

        if (session && now - session.created > __WEBPACK_IMPORTED_MODULE_0__config__["n" /* config */].session_uid_lifetime) {
            session = null;
        }

        if (!session) {
            session = {
                guid: Object(__WEBPACK_IMPORTED_MODULE_1__util__["q" /* uniqueID */])(),
                created: now
            };
        }

        storage[SESSION_KEY] = session;

        return handler(session);
    });
}

function getSessionState(handler) {
    return getSession(function (session) {
        session.state = session.state || {};
        return handler(session.state);
    });
}

function getSessionID() {

    if (window.xprops && window.xprops.sessionID) {
        return window.xprops.sessionID;
    }

    var querySessionID = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["g" /* getQueryParam */])('sessionID');

    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* isPayPalDomain */])() && querySessionID) {
        return querySessionID;
    }

    return getSession(function (session) {
        return session.guid;
    });
}

function getButtonSessionID() {

    if (window.xprops && window.xprops.buttonSessionID) {
        return window.xprops.buttonSessionID;
    }

    var querySessionID = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["g" /* getQueryParam */])('buttonSessionID');

    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* isPayPalDomain */])() && querySessionID) {
        return querySessionID;
    }

    return getSessionID();
}

function getGlobalState(handler) {
    window[GLOBAL_KEY] = window[GLOBAL_KEY] || {};
    return handler(window[GLOBAL_KEY]);
}

/***/ }),

/***/ "./src/lib/throttle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getThrottle;
/* harmony export (immutable) */ __webpack_exports__["a"] = getReturnToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./src/lib/util.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__("./src/lib/session.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function isCheckpointUnique(name) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__session__["d" /* getSessionState */])(function (state) {
        state.loggedBeacons = state.loggedBeacons || [];

        if (state.loggedBeacons.indexOf(name) === -1) {
            state.loggedBeacons.push(name);
            return true;
        }

        return false;
    });
}

function getThrottle(name, sample) {

    var uid = Object(__WEBPACK_IMPORTED_MODULE_3__session__["c" /* getSessionID */])();

    var throttle = Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* hashStr */])(name + '_' + uid) % 10000;

    var group = void 0;

    if (throttle < sample) {
        group = 'test';
    } else if (sample >= 5000 || sample <= throttle && throttle < sample * 2) {
        group = 'control';
    } else {
        group = 'throttle';
    }

    var treatment = name + '_' + group;

    var started = false;
    var forced = false;

    try {
        if (window.localStorage && window.localStorage.getItem(name)) {
            forced = true;
        }
    } catch (err) {
        // pass
    }

    return {
        isEnabled: function isEnabled() {
            return group === 'test' || forced;
        },
        isDisabled: function isDisabled() {
            return group !== 'test' && !forced;
        },
        getTreatment: function getTreatment() {
            return treatment;
        },
        log: function log(checkpointName) {
            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


            if (isCheckpointUnique(name + '_' + treatment)) {
                var _extends2;

                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])(_extends((_extends2 = {}, _extends2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].STATE.PXP, _extends2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].TRANSITION.PXP, _extends2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.EXPERIMENT_NAME] = name, _extends2[__WEBPACK_IMPORTED_MODULE_1__config__["e" /* FPTI */].KEY.TREATMENT_NAME] = treatment, _extends2), payload));
            }

            var event = name + '_' + treatment + '_' + checkpointName;

            if (isCheckpointUnique(event)) {
                Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])(event, _extends({}, payload, { expuid: uid }));
            }

            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */])();

            return this;
        },
        logStart: function logStart() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            started = true;
            return this.log('start', payload);
        },
        logComplete: function logComplete() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (started) {
                return this.log('complete', payload);
            }

            return this;
        }
    };
}

function getReturnToken() {

    var token = Object(__WEBPACK_IMPORTED_MODULE_2__util__["h" /* match */])(window.location.href, /token=((EC-)?[A-Z0-9]+)/);
    var payer = Object(__WEBPACK_IMPORTED_MODULE_2__util__["h" /* match */])(window.location.href, /PayerID=([A-Z0-9]+)/);

    if (token && payer) {
        return token;
    }
}

/***/ }),

/***/ "./src/lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isPayPalDomain;
/* harmony export (immutable) */ __webpack_exports__["i"] = memoize;
/* harmony export (immutable) */ __webpack_exports__["j"] = noop;
/* harmony export (immutable) */ __webpack_exports__["l"] = once;
/* harmony export (immutable) */ __webpack_exports__["q"] = uniqueID;
/* harmony export (immutable) */ __webpack_exports__["e"] = hashStr;
/* unused harmony export strHashStr */
/* harmony export (immutable) */ __webpack_exports__["h"] = match;
/* harmony export (immutable) */ __webpack_exports__["n"] = safeJSON;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventEmitter;
/* harmony export (immutable) */ __webpack_exports__["k"] = onKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = awaitKey;
/* harmony export (immutable) */ __webpack_exports__["o"] = stringifyError;
/* harmony export (immutable) */ __webpack_exports__["p"] = stringifyErrorMessage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isLocalStorageEnabled; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDomainSetting;
/* harmony export (immutable) */ __webpack_exports__["m"] = patchMethod;
/* harmony export (immutable) */ __webpack_exports__["c"] = extend;
/* unused harmony export hasValue */
/* unused harmony export contains */
/* unused harmony export sortBy */
/* unused harmony export reverseMap */
/* unused harmony export arrayRemove */
/* unused harmony export identity */
/* harmony export (immutable) */ __webpack_exports__["r"] = values;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hi_base32__ = __webpack_require__("./node_modules/hi-base32/src/base32.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hi_base32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hi_base32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__ = __webpack_require__("./node_modules/cross-domain-utils/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("./src/config/index.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







function isPayPalDomain() {
    return Boolean((window.location.protocol + '//' + window.location.host).match(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].paypal_domain_regex)) || window.mockDomain === 'mock://www.paypal.com';
}

// eslint-disable-next-line flowtype/no-weak-types
function memoize(method) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var cache = {};

    // eslint-disable-next-line no-unused-vars, flowtype/no-weak-types
    return function memoizedFunction() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var key = void 0;

        try {
            key = JSON.stringify(Array.prototype.slice.call(arguments));
        } catch (err) {
            throw new Error('Arguments not serializable -- can not be used to memoize');
        }

        var time = options.time;

        if (cache[key] && time && Date.now() - cache[key].time < time) {
            delete cache[key];
        }

        if (window.__CACHE_START_TIME__ && cache[key] && cache[key].time < window.__CACHE_START_TIME__) {
            delete cache[key];
        }

        if (cache[key]) {
            return cache[key].value;
        }

        cache[key] = {
            time: Date.now(),
            value: method.apply(this, arguments)
        };

        return cache[key].value;
    };
}

// eslint-disable-next-line no-unused-vars
function noop() {
    // pass
}

function once(method) {
    var called = false;

    return function onceFunction() {
        if (!called) {
            called = true;
            return method.apply(this, arguments);
        }
    };
}

function uniqueID() {

    var chars = '0123456789abcdef';

    var randomID = 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });

    var timeID = __WEBPACK_IMPORTED_MODULE_0_hi_base32___default.a.encode(new Date().toISOString().slice(11, 19).replace('T', '.')).replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    return randomID + '_' + timeID;
}

function hashStr(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash += str[i].charCodeAt(0) * Math.pow(i % 10 + 1, 5);
    }
    return Math.floor(Math.pow(Math.sqrt(hash), 5));
}

function strHashStr(str) {
    var hash = '';

    for (var i = 0; i < str.length; i++) {
        var total = str[i].charCodeAt(0) * i;

        if (str[i + 1]) {
            total += str[i + 1].charCodeAt(0) * (i - 1);
        }

        hash += String.fromCharCode(97 + Math.abs(total) % 26);
    }

    return hash;
}

function match(str, pattern) {
    var regmatch = str.match(pattern);
    if (regmatch) {
        return regmatch[1];
    }
}

function safeJSON(item) {
    return JSON.stringify(item, function (key, val) {

        if (typeof val === 'function') {
            return '<' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '>';
        }

        try {
            JSON.stringify(val);
        } catch (err) {
            return '<' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '>';
        }

        return val;
    });
}

function eventEmitter() {

    var listeners = [];

    return {
        listen: function listen(method) {
            listeners.push(method);

            return {
                cancel: function cancel() {
                    listeners.splice(listeners.indexOf(method), 1);
                }
            };
        },
        once: function once(method) {
            var listener = this.listen(function onceListener() {
                method.apply(null, arguments);
                listener.cancel();
            });
        },
        trigger: function trigger() {
            for (var _iterator = listeners, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var listener = _ref;

                listener.apply(undefined, arguments);
            }
        }
    };
}

function onKey(obj, key, callback) {

    if (!obj) {
        return;
    }

    var value = obj[key];

    if (value) {
        value = callback(value) || value;
    }

    try {

        delete obj[key];

        Object.defineProperty(obj, key, {

            configurable: true,

            set: function set(item) {
                value = item;

                if (value) {
                    value = callback(value) || value;
                }
            },
            get: function get() {
                return value;
            }
        });
    } catch (err) {
        // pass
    }
}

function awaitKey(obj, key) {
    return new __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */](function (resolve) {
        return onKey(obj, key, resolve);
    });
}

function stringifyError(err) {

    if (!err) {
        return '<unknown error: ' + Object.prototype.toString.call(err) + '>';
    }

    if (err instanceof Error) {
        return err.stack;
    }

    if (typeof err.toString === 'function') {
        return err.toString();
    }

    return Object.prototype.toString.call(err);
}

function stringifyErrorMessage(err) {

    var defaultMessage = '<unknown error: ' + Object.prototype.toString.call(err) + '>';

    if (!err) {
        return defaultMessage;
    }

    if (err instanceof Error) {
        return err.message || defaultMessage;
    }

    if (typeof err.message === 'string') {
        return err.message || defaultMessage;
    }

    return defaultMessage;
}

var isLocalStorageEnabled = memoize(function () {
    try {
        if (window.localStorage) {
            var _value = Math.random().toString();
            window.localStorage.setItem('__test__localStorage__', _value);
            var result = window.localStorage.getItem('__test__localStorage__');
            window.localStorage.removeItem('__test__localStorage__');
            if (_value === result) {
                return true;
            }
        }
    } catch (err) {
        // pass
    }
    return false;
});

function getDomainSetting(name, def) {

    var hostname = window.xchild ? window.xchild.getParentDomain() : Object(__WEBPACK_IMPORTED_MODULE_2_cross_domain_utils_src__["f" /* getDomain */])();

    hostname = hostname.split('://')[1];

    if (__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].domain_settings) {
        for (var _iterator2 = Object.keys(__WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].domain_settings), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }

            var domain = _ref2;

            var index = hostname.indexOf(domain);
            if (index !== -1 && hostname.slice(index) === domain) {
                return __WEBPACK_IMPORTED_MODULE_3__config__["n" /* config */].domain_settings[domain][name];
            }
        }
    }

    return def;
}

function patchMethod(obj, name, handler) {
    var original = obj[name];

    obj[name] = function patchedMethod() {
        var _this = this,
            _arguments = arguments;

        return handler({
            context: this,
            args: arguments,
            original: original,
            callOriginal: function callOriginal() {
                return original.apply(_this, _arguments);
            }
        });
    };
}

function extend(obj, source) {
    if (!source) {
        return obj;
    }

    for (var _key2 in source) {
        if (source.hasOwnProperty(_key2)) {
            obj[_key2] = source[_key2];
        }
    }

    return obj;
}

function hasValue(obj, value) {
    for (var _key3 in obj) {
        if (obj.hasOwnProperty(_key3) && obj[_key3] === value) {
            return true;
        }
    }
    return false;
}

function contains(arr, value) {
    return arr.indexOf(value) !== -1;
}

function sortBy(arr, order) {
    return arr.sort(function (a, b) {
        return order.indexOf(a) - order.indexOf(b);
    });
}

function reverseMap(obj) {
    var result = {};
    for (var _key4 in obj) {
        if (obj.hasOwnProperty(_key4)) {
            result[obj[_key4]] = _key4;
        }
    }
    return result;
}

function arrayRemove(arr, item) {
    arr.splice(arr.indexOf(item), 1);
}

function identity(item) {
    return item;
}

function values(obj) {
    var result = [];
    for (var _key5 in obj) {
        if (obj.hasOwnProperty(_key5)) {
            result.push(obj[_key5]);
        }
    }
    return result;
}

/***/ }),

/***/ "./src/load.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_beacon__ = __webpack_require__("./src/lib/beacon.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_namespace__ = __webpack_require__("./src/lib/namespace.js");



if (window.paypal && window.paypal.version === "4.0.173") {

    var error = 'PayPal Checkout Integration Script already loaded on page';

    if (window.console) {
        if (window.console.warn) {
            window.console.warn(error);
        } else {
            window.console.log(error);
        }
    }
} else {

    try {
        var _interface = __webpack_require__("./src/index.js");
        Object(__WEBPACK_IMPORTED_MODULE_1__lib_namespace__["a" /* extendNamespace */])(_interface, ['paypal', 'PAYPAL', 'ppxo'], ['apps']);
    } catch (err) {

        Object(__WEBPACK_IMPORTED_MODULE_0__lib_beacon__["a" /* beacon */])('bootstrap_error', {
            message: err ? err.toString() : 'undefined',
            stack: err.stack || err.toString(),
            errtype: {}.toString.call(err)
        });

        throw err;
    }
}

/***/ }),

/***/ "./src/setup.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* harmony export (immutable) */ __webpack_exports__["a"] = setup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__ = __webpack_require__("./node_modules/beaver-logger/client/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__ = __webpack_require__("./node_modules/zalgo-promise/src/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("./src/config/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__("./src/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_pptm__ = __webpack_require__("./src/lib/pptm.js");







function domainToEnv(domain) {
    for (var _iterator = Object.keys(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalUrls), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var _env = _ref;

        if (__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalUrls[_env] === domain) {
            return _env;
        }
    }
}

function setDomainEnv(domain) {
    var currentDomainEnv = domainToEnv(domain);

    if (currentDomainEnv && currentDomainEnv !== 'test') {
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env = currentDomainEnv;
    }
}

setDomainEnv(window.location.protocol + '//' + window.location.host);

__WEBPACK_IMPORTED_MODULE_1_zalgo_promise_src__["a" /* ZalgoPromise */].onPossiblyUnhandledException(function (err) {
    var _track;

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["f" /* error */])('unhandled_error', {
        stack: Object(__WEBPACK_IMPORTED_MODULE_3__lib__["U" /* stringifyError */])(err),
        errtype: {}.toString.call(err)
    });

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track = {}, _track[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.ERROR_CODE] = 'checkoutjs_error', _track[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.ERROR_DESC] = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["V" /* stringifyErrorMessage */])(err), _track));

    return Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["g" /* flush */])()['catch'](function (err2) {
        if (window.console) {
            try {
                if (window.console.error) {
                    window.console.error('Error flushing:', err2.stack || err2.toString());
                } else if (window.console.log) {
                    window.console.log('Error flushing:', err2.stack || err2.toString());
                }
            } catch (err3) {
                setTimeout(function () {
                    throw err3;
                }, 1);
            }
        }
    });
});

var currentScript = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["k" /* getCurrentScript */])();
var currentProtocol = window.location.protocol.split(':')[0];

function configure() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        env = _ref2.env,
        stage = _ref2.stage,
        apiStage = _ref2.apiStage,
        state = _ref2.state,
        logLevel = _ref2.logLevel,
        merchantID = _ref2.merchantID;

    if (env) {
        if (!__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].paypalUrls[env]) {
            throw new Error('Invalid env: ' + env);
        }

        delete __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env;
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env = env;
    }

    if (stage) {
        delete __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].stage;
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].stage = stage;
    }

    if (apiStage) {
        delete __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].apiStage;
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].apiStage = apiStage;
    }

    if (state) {
        delete __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].state;
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].state = state;
    }

    if (merchantID) {
        __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].merchantID = merchantID;
    }

    if (logLevel) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["T" /* setLogLevel */])(logLevel);
    } else {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["T" /* setLogLevel */])(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].logLevel);
    }
}

var init = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["L" /* once */])(function (_ref3) {
    var precacheRemembered = _ref3.precacheRemembered;


    if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib__["z" /* isEligible */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["p" /* warn */])('ineligible');
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* checkForCommonErrors */])();

    Object(__WEBPACK_IMPORTED_MODULE_3__lib__["w" /* initLogger */])();

    if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib__["E" /* isPayPalDomain */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_4__lib_pptm__["a" /* createPptmScript */])();
    }

    window.addEventListener('load', __WEBPACK_IMPORTED_MODULE_3__lib__["c" /* checkForDeprecatedIntegration */]);

    if (precacheRemembered) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["O" /* precacheRememberedFunding */])();
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__lib__["l" /* getDomainSetting */])('force_bridge') && !Object(__WEBPACK_IMPORTED_MODULE_3__lib__["E" /* isPayPalDomain */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_3__lib__["M" /* openMetaFrame */])(__WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["j" /* info */])('setup_' + __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].env);

    Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_protocol_' + currentProtocol);
});

function setup() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    configure(options);
    init(options);
}

if (currentScript) {
    setup({
        env: currentScript.getAttribute('data-env'),
        stage: currentScript.getAttribute('data-stage'),
        apiStage: currentScript.getAttribute('data-api-stage'),
        state: currentScript.getAttribute('data-state'),
        logLevel: currentScript.getAttribute('data-log-level'),
        merchantID: currentScript.getAttribute('data-merchant-id'),
        precacheRemembered: currentScript.hasAttribute('data-precache-remembered-funding')
    });
} else {
    setup();
}

if (!Object(__WEBPACK_IMPORTED_MODULE_3__lib__["E" /* isPayPalDomain */])()) {

    if (currentScript) {
        var _track2;

        var scriptProtocol = currentScript.src.split(':')[0];
        var loadTime = Object(__WEBPACK_IMPORTED_MODULE_3__lib__["q" /* getResourceLoadTime */])(currentScript.src);

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_protocol_' + scriptProtocol);
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_protocol_' + (currentProtocol === scriptProtocol ? 'match' : 'mismatch'));
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_version_' + __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].version.replace(/[^0-9a-zA-Z]+/g, '_'));

        if (loadTime) {
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_time', { loadTime: loadTime });
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_time_' + Math.floor(loadTime / 1000));
        }

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track2 = {}, _track2[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].STATE.LOAD, _track2[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].TRANSITION.SCRIPT_LOAD, _track2[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.TRANSITION_TIME] = loadTime, _track2));
    } else {
        var _track3;

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('no_current_script');
        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('no_current_script_version_' + __WEBPACK_IMPORTED_MODULE_2__config__["n" /* config */].version.replace(/[^0-9a-zA-Z]+/g, '_'));

        if (document.currentScript) {
            // eslint-disable-line compat/compat
            Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["e" /* debug */])('current_script_not_recognized', { src: document.currentScript.src }); // eslint-disable-line compat/compat
        }

        Object(__WEBPACK_IMPORTED_MODULE_0_beaver_logger_client__["o" /* track */])((_track3 = {}, _track3[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.STATE] = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].STATE.LOAD, _track3[__WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].KEY.TRANSITION] = __WEBPACK_IMPORTED_MODULE_2__config__["e" /* FPTI */].TRANSITION.SCRIPT_LOAD, _track3));
    }
}

/***/ })

/******/ })));


// WEBPACK FOOTER //
// checkout.4.0.173.js